"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * vis-network
 * https://visjs.github.io/vis-network/
 *
 * A dynamic, browser-based visualization library.
 *
 * @version 9.1.9
 * @date    2023-11-03T01:44:38.007Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).vis = t.vis || {});
}(void 0, function (t) {
  "use strict";

  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
  function i(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t["default"] : t;
  }
  var n = function n(t) {
      return t && t.Math === Math && t;
    },
    o = n("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis) || n("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window) || n("object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self) || n("object" == _typeof(e) && e) || function () {
      return this;
    }() || e || Function("return this")(),
    r = function r(t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    },
    s = !r(function () {
      var t = function () {}.bind();
      return "function" != typeof t || t.hasOwnProperty("prototype");
    }),
    a = s,
    h = Function.prototype,
    l = h.apply,
    d = h.call,
    c = "object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && Reflect.apply || (a ? d.bind(l) : function () {
      return d.apply(l, arguments);
    }),
    u = s,
    f = Function.prototype,
    p = f.call,
    v = u && f.bind.bind(p, p),
    g = u ? v : function (t) {
      return function () {
        return p.apply(t, arguments);
      };
    },
    y = g,
    m = y({}.toString),
    b = y("".slice),
    w = function w(t) {
      return b(m(t), 8, -1);
    },
    k = w,
    _ = g,
    x = function x(t) {
      if ("Function" === k(t)) return _(t);
    },
    E = "object" == (typeof document === "undefined" ? "undefined" : _typeof(document)) && document.all,
    O = {
      all: E,
      IS_HTMLDDA: void 0 === E && void 0 !== E
    },
    C = O.all,
    S = O.IS_HTMLDDA ? function (t) {
      return "function" == typeof t || t === C;
    } : function (t) {
      return "function" == typeof t;
    },
    T = {},
    M = !r(function () {
      return 7 !== Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    }),
    P = s,
    D = Function.prototype.call,
    I = P ? D.bind(D) : function () {
      return D.apply(D, arguments);
    },
    B = {},
    N = {}.propertyIsEnumerable,
    F = Object.getOwnPropertyDescriptor,
    z = F && !N.call({
      1: 2
    }, 1);
  B.f = z ? function (t) {
    var e = F(this, t);
    return !!e && e.enumerable;
  } : N;
  var A,
    j,
    R = function R(t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    },
    L = r,
    H = w,
    W = Object,
    q = g("".split),
    V = L(function () {
      return !W("z").propertyIsEnumerable(0);
    }) ? function (t) {
      return "String" === H(t) ? q(t, "") : W(t);
    } : W,
    U = function U(t) {
      return null == t;
    },
    Y = U,
    X = TypeError,
    G = function G(t) {
      if (Y(t)) throw new X("Can't call method on " + t);
      return t;
    },
    K = V,
    $ = G,
    Z = function Z(t) {
      return K($(t));
    },
    Q = S,
    J = O.all,
    tt = O.IS_HTMLDDA ? function (t) {
      return "object" == _typeof(t) ? null !== t : Q(t) || t === J;
    } : function (t) {
      return "object" == _typeof(t) ? null !== t : Q(t);
    },
    et = {},
    it = et,
    nt = o,
    ot = S,
    rt = function rt(t) {
      return ot(t) ? t : void 0;
    },
    st = function st(t, e) {
      return arguments.length < 2 ? rt(it[t]) || rt(nt[t]) : it[t] && it[t][e] || nt[t] && nt[t][e];
    },
    at = g({}.isPrototypeOf),
    ht = "undefined" != typeof navigator && String(navigator.userAgent) || "",
    lt = o,
    dt = ht,
    ct = lt.process,
    ut = lt.Deno,
    ft = ct && ct.versions || ut && ut.version,
    pt = ft && ft.v8;
  pt && (j = (A = pt.split("."))[0] > 0 && A[0] < 4 ? 1 : +(A[0] + A[1])), !j && dt && (!(A = dt.match(/Edge\/(\d+)/)) || A[1] >= 74) && (A = dt.match(/Chrome\/(\d+)/)) && (j = +A[1]);
  var vt = j,
    gt = vt,
    yt = r,
    mt = o.String,
    bt = !!Object.getOwnPropertySymbols && !yt(function () {
      var t = Symbol("symbol detection");
      return !mt(t) || !(Object(t) instanceof Symbol) || !Symbol.sham && gt && gt < 41;
    }),
    wt = bt && !Symbol.sham && "symbol" == _typeof(Symbol.iterator),
    kt = st,
    _t = S,
    xt = at,
    Et = Object,
    Ot = wt ? function (t) {
      return "symbol" == _typeof(t);
    } : function (t) {
      var e = kt("Symbol");
      return _t(e) && xt(e.prototype, Et(t));
    },
    Ct = String,
    St = function St(t) {
      try {
        return Ct(t);
      } catch (t) {
        return "Object";
      }
    },
    Tt = S,
    Mt = St,
    Pt = TypeError,
    Dt = function Dt(t) {
      if (Tt(t)) return t;
      throw new Pt(Mt(t) + " is not a function");
    },
    It = Dt,
    Bt = U,
    Nt = function Nt(t, e) {
      var i = t[e];
      return Bt(i) ? void 0 : It(i);
    },
    Ft = I,
    zt = S,
    At = tt,
    jt = TypeError,
    Rt = {
      exports: {}
    },
    Lt = o,
    Ht = Object.defineProperty,
    Wt = function Wt(t, e) {
      try {
        Ht(Lt, t, {
          value: e,
          configurable: !0,
          writable: !0
        });
      } catch (i) {
        Lt[t] = e;
      }
      return e;
    },
    qt = "__core-js_shared__",
    Vt = o[qt] || Wt(qt, {}),
    Ut = Vt;
  (Rt.exports = function (t, e) {
    return Ut[t] || (Ut[t] = void 0 !== e ? e : {});
  })("versions", []).push({
    version: "3.33.0",
    mode: "pure",
    copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
  });
  var Yt = Rt.exports,
    Xt = G,
    Gt = Object,
    Kt = function Kt(t) {
      return Gt(Xt(t));
    },
    $t = Kt,
    Zt = g({}.hasOwnProperty),
    Qt = Object.hasOwn || function (t, e) {
      return Zt($t(t), e);
    },
    Jt = g,
    te = 0,
    ee = Math.random(),
    ie = Jt(1..toString),
    ne = function ne(t) {
      return "Symbol(" + (void 0 === t ? "" : t) + ")_" + ie(++te + ee, 36);
    },
    oe = Yt,
    re = Qt,
    se = ne,
    ae = bt,
    he = wt,
    le = o.Symbol,
    de = oe("wks"),
    ce = he ? le["for"] || le : le && le.withoutSetter || se,
    ue = function ue(t) {
      return re(de, t) || (de[t] = ae && re(le, t) ? le[t] : ce("Symbol." + t)), de[t];
    },
    fe = I,
    pe = tt,
    ve = Ot,
    ge = Nt,
    ye = function ye(t, e) {
      var i, n;
      if ("string" === e && zt(i = t.toString) && !At(n = Ft(i, t))) return n;
      if (zt(i = t.valueOf) && !At(n = Ft(i, t))) return n;
      if ("string" !== e && zt(i = t.toString) && !At(n = Ft(i, t))) return n;
      throw new jt("Can't convert object to primitive value");
    },
    me = TypeError,
    be = ue("toPrimitive"),
    we = function we(t, e) {
      if (!pe(t) || ve(t)) return t;
      var i,
        n = ge(t, be);
      if (n) {
        if (void 0 === e && (e = "default"), i = fe(n, t, e), !pe(i) || ve(i)) return i;
        throw new me("Can't convert object to primitive value");
      }
      return void 0 === e && (e = "number"), ye(t, e);
    },
    ke = Ot,
    _e = function _e(t) {
      var e = we(t, "string");
      return ke(e) ? e : e + "";
    },
    xe = tt,
    Ee = o.document,
    Oe = xe(Ee) && xe(Ee.createElement),
    Ce = function Ce(t) {
      return Oe ? Ee.createElement(t) : {};
    },
    Se = Ce,
    Te = !M && !r(function () {
      return 7 !== Object.defineProperty(Se("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    }),
    Me = M,
    Pe = I,
    De = B,
    Ie = R,
    Be = Z,
    Ne = _e,
    Fe = Qt,
    ze = Te,
    Ae = Object.getOwnPropertyDescriptor;
  T.f = Me ? Ae : function (t, e) {
    if (t = Be(t), e = Ne(e), ze) try {
      return Ae(t, e);
    } catch (t) {}
    if (Fe(t, e)) return Ie(!Pe(De.f, t, e), t[e]);
  };
  var je = r,
    Re = S,
    Le = /#|\.prototype\./,
    He = function He(t, e) {
      var i = qe[We(t)];
      return i === Ue || i !== Ve && (Re(e) ? je(e) : !!e);
    },
    We = He.normalize = function (t) {
      return String(t).replace(Le, ".").toLowerCase();
    },
    qe = He.data = {},
    Ve = He.NATIVE = "N",
    Ue = He.POLYFILL = "P",
    Ye = He,
    Xe = Dt,
    Ge = s,
    Ke = x(x.bind),
    $e = function $e(t, e) {
      return Xe(t), void 0 === e ? t : Ge ? Ke(t, e) : function () {
        return t.apply(e, arguments);
      };
    },
    Ze = {},
    Qe = M && r(function () {
      return 42 !== Object.defineProperty(function () {}, "prototype", {
        value: 42,
        writable: !1
      }).prototype;
    }),
    Je = tt,
    ti = String,
    ei = TypeError,
    ii = function ii(t) {
      if (Je(t)) return t;
      throw new ei(ti(t) + " is not an object");
    },
    ni = M,
    oi = Te,
    ri = Qe,
    si = ii,
    ai = _e,
    hi = TypeError,
    li = Object.defineProperty,
    di = Object.getOwnPropertyDescriptor,
    ci = "enumerable",
    ui = "configurable",
    fi = "writable";
  Ze.f = ni ? ri ? function (t, e, i) {
    if (si(t), e = ai(e), si(i), "function" == typeof t && "prototype" === e && "value" in i && fi in i && !i[fi]) {
      var n = di(t, e);
      n && n[fi] && (t[e] = i.value, i = {
        configurable: ui in i ? i[ui] : n[ui],
        enumerable: ci in i ? i[ci] : n[ci],
        writable: !1
      });
    }
    return li(t, e, i);
  } : li : function (t, e, i) {
    if (si(t), e = ai(e), si(i), oi) try {
      return li(t, e, i);
    } catch (t) {}
    if ("get" in i || "set" in i) throw new hi("Accessors not supported");
    return "value" in i && (t[e] = i.value), t;
  };
  var pi = Ze,
    vi = R,
    gi = M ? function (t, e, i) {
      return pi.f(t, e, vi(1, i));
    } : function (t, e, i) {
      return t[e] = i, t;
    },
    yi = o,
    mi = c,
    bi = x,
    wi = S,
    ki = T.f,
    _i = Ye,
    xi = et,
    Ei = $e,
    Oi = gi,
    Ci = Qt,
    Si = function Si(t) {
      var e = function e(i, n, o) {
        if (this instanceof e) {
          switch (arguments.length) {
            case 0:
              return new t();
            case 1:
              return new t(i);
            case 2:
              return new t(i, n);
          }
          return new t(i, n, o);
        }
        return mi(t, this, arguments);
      };
      return e.prototype = t.prototype, e;
    },
    Ti = function Ti(t, e) {
      var i,
        n,
        o,
        r,
        s,
        a,
        h,
        l,
        d,
        c = t.target,
        u = t.global,
        f = t.stat,
        p = t.proto,
        v = u ? yi : f ? yi[c] : (yi[c] || {}).prototype,
        g = u ? xi : xi[c] || Oi(xi, c, {})[c],
        y = g.prototype;
      for (r in e) n = !(i = _i(u ? r : c + (f ? "." : "#") + r, t.forced)) && v && Ci(v, r), a = g[r], n && (h = t.dontCallGetSet ? (d = ki(v, r)) && d.value : v[r]), s = n && h ? h : e[r], n && _typeof(a) == _typeof(s) || (l = t.bind && n ? Ei(s, yi) : t.wrap && n ? Si(s) : p && wi(s) ? bi(s) : s, (t.sham || s && s.sham || a && a.sham) && Oi(l, "sham", !0), Oi(g, r, l), p && (Ci(xi, o = c + "Prototype") || Oi(xi, o, {}), Oi(xi[o], r, s), t.real && y && (i || !y[r]) && Oi(y, r, s)));
    },
    Mi = Math.ceil,
    Pi = Math.floor,
    Di = Math.trunc || function (t) {
      var e = +t;
      return (e > 0 ? Pi : Mi)(e);
    },
    Ii = function Ii(t) {
      var e = +t;
      return e != e || 0 === e ? 0 : Di(e);
    },
    Bi = Ii,
    Ni = Math.max,
    Fi = Math.min,
    zi = function zi(t, e) {
      var i = Bi(t);
      return i < 0 ? Ni(i + e, 0) : Fi(i, e);
    },
    Ai = Ii,
    ji = Math.min,
    Ri = function Ri(t) {
      return t > 0 ? ji(Ai(t), 9007199254740991) : 0;
    },
    Li = function Li(t) {
      return Ri(t.length);
    },
    Hi = Z,
    Wi = zi,
    qi = Li,
    Vi = function Vi(t) {
      return function (e, i, n) {
        var o,
          r = Hi(e),
          s = qi(r),
          a = Wi(n, s);
        if (t && i != i) {
          for (; s > a;) if ((o = r[a++]) != o) return !0;
        } else for (; s > a; a++) if ((t || a in r) && r[a] === i) return t || a || 0;
        return !t && -1;
      };
    },
    Ui = {
      includes: Vi(!0),
      indexOf: Vi(!1)
    },
    Yi = {},
    Xi = Qt,
    Gi = Z,
    Ki = Ui.indexOf,
    $i = Yi,
    Zi = g([].push),
    Qi = function Qi(t, e) {
      var i,
        n = Gi(t),
        o = 0,
        r = [];
      for (i in n) !Xi($i, i) && Xi(n, i) && Zi(r, i);
      for (; e.length > o;) Xi(n, i = e[o++]) && (~Ki(r, i) || Zi(r, i));
      return r;
    },
    Ji = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
    tn = Qi,
    en = Ji,
    nn = Object.keys || function (t) {
      return tn(t, en);
    },
    on = {};
  on.f = Object.getOwnPropertySymbols;
  var rn = M,
    sn = g,
    an = I,
    hn = r,
    ln = nn,
    dn = on,
    cn = B,
    un = Kt,
    fn = V,
    pn = Object.assign,
    vn = Object.defineProperty,
    gn = sn([].concat),
    yn = !pn || hn(function () {
      if (rn && 1 !== pn({
        b: 1
      }, pn(vn({}, "a", {
        enumerable: !0,
        get: function get() {
          vn(this, "b", {
            value: 3,
            enumerable: !1
          });
        }
      }), {
        b: 2
      })).b) return !0;
      var t = {},
        e = {},
        i = Symbol("assign detection"),
        n = "abcdefghijklmnopqrst";
      return t[i] = 7, n.split("").forEach(function (t) {
        e[t] = t;
      }), 7 !== pn({}, t)[i] || ln(pn({}, e)).join("") !== n;
    }) ? function (t, e) {
      for (var i = un(t), n = arguments.length, o = 1, r = dn.f, s = cn.f; n > o;) for (var a, h = fn(arguments[o++]), l = r ? gn(ln(h), r(h)) : ln(h), d = l.length, c = 0; d > c;) a = l[c++], rn && !an(s, h, a) || (i[a] = h[a]);
      return i;
    } : pn,
    mn = yn;
  Ti({
    target: "Object",
    stat: !0,
    arity: 2,
    forced: Object.assign !== mn
  }, {
    assign: mn
  });
  var bn = i(et.Object.assign),
    wn = g([].slice),
    kn = g,
    _n = Dt,
    xn = tt,
    En = Qt,
    On = wn,
    Cn = s,
    Sn = Function,
    Tn = kn([].concat),
    Mn = kn([].join),
    Pn = {},
    Dn = Cn ? Sn.bind : function (t) {
      var e = _n(this),
        i = e.prototype,
        n = On(arguments, 1),
        o = function o() {
          var i = Tn(n, On(arguments));
          return this instanceof o ? function (t, e, i) {
            if (!En(Pn, e)) {
              for (var n = [], o = 0; o < e; o++) n[o] = "a[" + o + "]";
              Pn[e] = Sn("C,a", "return new C(" + Mn(n, ",") + ")");
            }
            return Pn[e](t, i);
          }(e, i.length, i) : e.apply(t, i);
        };
      return xn(i) && (o.prototype = i), o;
    },
    In = Dn;
  Ti({
    target: "Function",
    proto: !0,
    forced: Function.bind !== In
  }, {
    bind: In
  });
  var Bn = et,
    Nn = function Nn(t) {
      return Bn[t + "Prototype"];
    },
    Fn = Nn("Function").bind,
    zn = at,
    An = Fn,
    jn = Function.prototype,
    Rn = function Rn(t) {
      var e = t.bind;
      return t === jn || zn(jn, t) && e === jn.bind ? An : e;
    },
    Ln = Rn,
    Hn = i(Ln);
  function Wn(t, e, i, n) {
    t.beginPath(), t.arc(e, i, n, 0, 2 * Math.PI, !1), t.closePath();
  }
  function qn(t, e, i, n, o, r) {
    var s = Math.PI / 180;
    n - 2 * r < 0 && (r = n / 2), o - 2 * r < 0 && (r = o / 2), t.beginPath(), t.moveTo(e + r, i), t.lineTo(e + n - r, i), t.arc(e + n - r, i + r, r, 270 * s, 360 * s, !1), t.lineTo(e + n, i + o - r), t.arc(e + n - r, i + o - r, r, 0, 90 * s, !1), t.lineTo(e + r, i + o), t.arc(e + r, i + o - r, r, 90 * s, 180 * s, !1), t.lineTo(e, i + r), t.arc(e + r, i + r, r, 180 * s, 270 * s, !1), t.closePath();
  }
  function Vn(t, e, i, n, o) {
    var r = .5522848,
      s = n / 2 * r,
      a = o / 2 * r,
      h = e + n,
      l = i + o,
      d = e + n / 2,
      c = i + o / 2;
    t.beginPath(), t.moveTo(e, c), t.bezierCurveTo(e, c - a, d - s, i, d, i), t.bezierCurveTo(d + s, i, h, c - a, h, c), t.bezierCurveTo(h, c + a, d + s, l, d, l), t.bezierCurveTo(d - s, l, e, c + a, e, c), t.closePath();
  }
  function Un(t, e, i, n, o) {
    var r = o * (1 / 3),
      s = .5522848,
      a = n / 2 * s,
      h = r / 2 * s,
      l = e + n,
      d = i + r,
      c = e + n / 2,
      u = i + r / 2,
      f = i + (o - r / 2),
      p = i + o;
    t.beginPath(), t.moveTo(l, u), t.bezierCurveTo(l, u + h, c + a, d, c, d), t.bezierCurveTo(c - a, d, e, u + h, e, u), t.bezierCurveTo(e, u - h, c - a, i, c, i), t.bezierCurveTo(c + a, i, l, u - h, l, u), t.lineTo(l, f), t.bezierCurveTo(l, f + h, c + a, p, c, p), t.bezierCurveTo(c - a, p, e, f + h, e, f), t.lineTo(e, u);
  }
  function Yn(t, e, i, n, o, r) {
    t.beginPath(), t.moveTo(e, i);
    for (var s = r.length, a = n - e, h = o - i, l = h / a, d = Math.sqrt(a * a + h * h), c = 0, u = !0, f = 0, p = +r[0]; d >= .1;) (p = +r[c++ % s]) > d && (p = d), f = Math.sqrt(p * p / (1 + l * l)), e += f = a < 0 ? -f : f, i += l * f, !0 === u ? t.lineTo(e, i) : t.moveTo(e, i), d -= p, u = !u;
  }
  var Xn = {
    circle: Wn,
    dashedLine: Yn,
    database: Un,
    diamond: function diamond(t, e, i, n) {
      t.beginPath(), t.lineTo(e, i + n), t.lineTo(e + n, i), t.lineTo(e, i - n), t.lineTo(e - n, i), t.closePath();
    },
    ellipse: Vn,
    ellipse_vis: Vn,
    hexagon: function hexagon(t, e, i, n) {
      t.beginPath();
      var o = 2 * Math.PI / 6;
      t.moveTo(e + n, i);
      for (var r = 1; r < 6; r++) t.lineTo(e + n * Math.cos(o * r), i + n * Math.sin(o * r));
      t.closePath();
    },
    roundRect: qn,
    square: function square(t, e, i, n) {
      t.beginPath(), t.rect(e - n, i - n, 2 * n, 2 * n), t.closePath();
    },
    star: function star(t, e, i, n) {
      t.beginPath(), i += .1 * (n *= .82);
      for (var o = 0; o < 10; o++) {
        var r = o % 2 == 0 ? 1.3 * n : .5 * n;
        t.lineTo(e + r * Math.sin(2 * o * Math.PI / 10), i - r * Math.cos(2 * o * Math.PI / 10));
      }
      t.closePath();
    },
    triangle: function triangle(t, e, i, n) {
      t.beginPath(), i += .275 * (n *= 1.15);
      var o = 2 * n,
        r = o / 2,
        s = Math.sqrt(3) / 6 * o,
        a = Math.sqrt(o * o - r * r);
      t.moveTo(e, i - (a - s)), t.lineTo(e + r, i + s), t.lineTo(e - r, i + s), t.lineTo(e, i - (a - s)), t.closePath();
    },
    triangleDown: function triangleDown(t, e, i, n) {
      t.beginPath(), i -= .275 * (n *= 1.15);
      var o = 2 * n,
        r = o / 2,
        s = Math.sqrt(3) / 6 * o,
        a = Math.sqrt(o * o - r * r);
      t.moveTo(e, i + (a - s)), t.lineTo(e + r, i - s), t.lineTo(e - r, i - s), t.lineTo(e, i + (a - s)), t.closePath();
    }
  };
  var Gn = {
    exports: {}
  };
  !function (t) {
    function e(t) {
      if (t) return function (t) {
        for (var i in e.prototype) t[i] = e.prototype[i];
        return t;
      }(t);
    }
    t.exports = e, e.prototype.on = e.prototype.addEventListener = function (t, e) {
      return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this;
    }, e.prototype.once = function (t, e) {
      function i() {
        this.off(t, i), e.apply(this, arguments);
      }
      return i.fn = e, this.on(t, i), this;
    }, e.prototype.off = e.prototype.removeListener = e.prototype.removeAllListeners = e.prototype.removeEventListener = function (t, e) {
      if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
      var i,
        n = this._callbacks["$" + t];
      if (!n) return this;
      if (1 == arguments.length) return delete this._callbacks["$" + t], this;
      for (var o = 0; o < n.length; o++) if ((i = n[o]) === e || i.fn === e) {
        n.splice(o, 1);
        break;
      }
      return 0 === n.length && delete this._callbacks["$" + t], this;
    }, e.prototype.emit = function (t) {
      this._callbacks = this._callbacks || {};
      for (var e = new Array(arguments.length - 1), i = this._callbacks["$" + t], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
      if (i) {
        n = 0;
        for (var o = (i = i.slice(0)).length; n < o; ++n) i[n].apply(this, e);
      }
      return this;
    }, e.prototype.listeners = function (t) {
      return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [];
    }, e.prototype.hasListeners = function (t) {
      return !!this.listeners(t).length;
    };
  }(Gn);
  var Kn = i(Gn.exports),
    $n = {};
  $n[ue("toStringTag")] = "z";
  var Zn,
    Qn,
    Jn,
    to = "[object z]" === String($n),
    eo = to,
    io = S,
    no = w,
    oo = ue("toStringTag"),
    ro = Object,
    so = "Arguments" === no(function () {
      return arguments;
    }()),
    ao = eo ? no : function (t) {
      var e, i, n;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (i = function (t, e) {
        try {
          return t[e];
        } catch (t) {}
      }(e = ro(t), oo)) ? i : so ? no(e) : "Object" === (n = no(e)) && io(e.callee) ? "Arguments" : n;
    },
    ho = ao,
    lo = String,
    co = function co(t) {
      if ("Symbol" === ho(t)) throw new TypeError("Cannot convert a Symbol value to a string");
      return lo(t);
    },
    uo = g,
    fo = Ii,
    po = co,
    vo = G,
    go = uo("".charAt),
    yo = uo("".charCodeAt),
    mo = uo("".slice),
    bo = function bo(t) {
      return function (e, i) {
        var n,
          o,
          r = po(vo(e)),
          s = fo(i),
          a = r.length;
        return s < 0 || s >= a ? t ? "" : void 0 : (n = yo(r, s)) < 55296 || n > 56319 || s + 1 === a || (o = yo(r, s + 1)) < 56320 || o > 57343 ? t ? go(r, s) : n : t ? mo(r, s, s + 2) : o - 56320 + (n - 55296 << 10) + 65536;
      };
    },
    wo = {
      codeAt: bo(!1),
      charAt: bo(!0)
    },
    ko = S,
    _o = o.WeakMap,
    xo = ko(_o) && /native code/.test(String(_o)),
    Eo = ne,
    Oo = Yt("keys"),
    Co = function Co(t) {
      return Oo[t] || (Oo[t] = Eo(t));
    },
    So = xo,
    To = o,
    Mo = tt,
    Po = gi,
    Do = Qt,
    Io = Vt,
    Bo = Co,
    No = Yi,
    Fo = "Object already initialized",
    zo = To.TypeError,
    Ao = To.WeakMap;
  if (So || Io.state) {
    var jo = Io.state || (Io.state = new Ao());
    jo.get = jo.get, jo.has = jo.has, jo.set = jo.set, Zn = function Zn(t, e) {
      if (jo.has(t)) throw new zo(Fo);
      return e.facade = t, jo.set(t, e), e;
    }, Qn = function Qn(t) {
      return jo.get(t) || {};
    }, Jn = function Jn(t) {
      return jo.has(t);
    };
  } else {
    var Ro = Bo("state");
    No[Ro] = !0, Zn = function Zn(t, e) {
      if (Do(t, Ro)) throw new zo(Fo);
      return e.facade = t, Po(t, Ro, e), e;
    }, Qn = function Qn(t) {
      return Do(t, Ro) ? t[Ro] : {};
    }, Jn = function Jn(t) {
      return Do(t, Ro);
    };
  }
  var Lo = {
      set: Zn,
      get: Qn,
      has: Jn,
      enforce: function enforce(t) {
        return Jn(t) ? Qn(t) : Zn(t, {});
      },
      getterFor: function getterFor(t) {
        return function (e) {
          var i;
          if (!Mo(e) || (i = Qn(e)).type !== t) throw new zo("Incompatible receiver, " + t + " required");
          return i;
        };
      }
    },
    Ho = M,
    Wo = Qt,
    qo = Function.prototype,
    Vo = Ho && Object.getOwnPropertyDescriptor,
    Uo = Wo(qo, "name"),
    Yo = {
      EXISTS: Uo,
      PROPER: Uo && "something" === function () {}.name,
      CONFIGURABLE: Uo && (!Ho || Ho && Vo(qo, "name").configurable)
    },
    Xo = {},
    Go = M,
    Ko = Qe,
    $o = Ze,
    Zo = ii,
    Qo = Z,
    Jo = nn;
  Xo.f = Go && !Ko ? Object.defineProperties : function (t, e) {
    Zo(t);
    for (var i, n = Qo(e), o = Jo(e), r = o.length, s = 0; r > s;) $o.f(t, i = o[s++], n[i]);
    return t;
  };
  var tr,
    er = st("document", "documentElement"),
    ir = ii,
    nr = Xo,
    or = Ji,
    rr = Yi,
    sr = er,
    ar = Ce,
    hr = "prototype",
    lr = "script",
    dr = Co("IE_PROTO"),
    cr = function cr() {},
    ur = function ur(t) {
      return "<" + lr + ">" + t + "</" + lr + ">";
    },
    fr = function fr(t) {
      t.write(ur("")), t.close();
      var e = t.parentWindow.Object;
      return t = null, e;
    },
    _pr = function pr() {
      try {
        tr = new ActiveXObject("htmlfile");
      } catch (t) {}
      var t, e, i;
      _pr = "undefined" != typeof document ? document.domain && tr ? fr(tr) : (e = ar("iframe"), i = "java" + lr + ":", e.style.display = "none", sr.appendChild(e), e.src = String(i), (t = e.contentWindow.document).open(), t.write(ur("document.F=Object")), t.close(), t.F) : fr(tr);
      for (var n = or.length; n--;) delete _pr[hr][or[n]];
      return _pr();
    };
  rr[dr] = !0;
  var vr,
    gr,
    yr,
    mr = Object.create || function (t, e) {
      var i;
      return null !== t ? (cr[hr] = ir(t), i = new cr(), cr[hr] = null, i[dr] = t) : i = _pr(), void 0 === e ? i : nr.f(i, e);
    },
    br = !r(function () {
      function t() {}
      return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
    }),
    wr = Qt,
    kr = S,
    _r = Kt,
    xr = br,
    Er = Co("IE_PROTO"),
    Or = Object,
    Cr = Or.prototype,
    Sr = xr ? Or.getPrototypeOf : function (t) {
      var e = _r(t);
      if (wr(e, Er)) return e[Er];
      var i = e.constructor;
      return kr(i) && e instanceof i ? i.prototype : e instanceof Or ? Cr : null;
    },
    Tr = gi,
    Mr = function Mr(t, e, i, n) {
      return n && n.enumerable ? t[e] = i : Tr(t, e, i), t;
    },
    Pr = r,
    Dr = S,
    Ir = tt,
    Br = mr,
    Nr = Sr,
    Fr = Mr,
    zr = ue("iterator"),
    Ar = !1;
  [].keys && ("next" in (yr = [].keys()) ? (gr = Nr(Nr(yr))) !== Object.prototype && (vr = gr) : Ar = !0);
  var jr = !Ir(vr) || Pr(function () {
    var t = {};
    return vr[zr].call(t) !== t;
  });
  Dr((vr = jr ? {} : Br(vr))[zr]) || Fr(vr, zr, function () {
    return this;
  });
  var Rr = {
      IteratorPrototype: vr,
      BUGGY_SAFARI_ITERATORS: Ar
    },
    Lr = ao,
    Hr = to ? {}.toString : function () {
      return "[object " + Lr(this) + "]";
    },
    Wr = to,
    qr = Ze.f,
    Vr = gi,
    Ur = Qt,
    Yr = Hr,
    Xr = ue("toStringTag"),
    Gr = function Gr(t, e, i, n) {
      if (t) {
        var o = i ? t : t.prototype;
        Ur(o, Xr) || qr(o, Xr, {
          configurable: !0,
          value: e
        }), n && !Wr && Vr(o, "toString", Yr);
      }
    },
    Kr = {},
    $r = Rr.IteratorPrototype,
    Zr = mr,
    Qr = R,
    Jr = Gr,
    ts = Kr,
    es = function es() {
      return this;
    },
    is = g,
    ns = Dt,
    os = S,
    rs = String,
    ss = TypeError,
    as = function as(t, e, i) {
      try {
        return is(ns(Object.getOwnPropertyDescriptor(t, e)[i]));
      } catch (t) {}
    },
    hs = ii,
    ls = function ls(t) {
      if ("object" == _typeof(t) || os(t)) return t;
      throw new ss("Can't set " + rs(t) + " as a prototype");
    },
    ds = Object.setPrototypeOf || ("__proto__" in {} ? function () {
      var t,
        e = !1,
        i = {};
      try {
        (t = as(Object.prototype, "__proto__", "set"))(i, []), e = i instanceof Array;
      } catch (t) {}
      return function (i, n) {
        return hs(i), ls(n), e ? t(i, n) : i.__proto__ = n, i;
      };
    }() : void 0),
    cs = Ti,
    us = I,
    fs = Yo,
    ps = function ps(t, e, i, n) {
      var o = e + " Iterator";
      return t.prototype = Zr($r, {
        next: Qr(+!n, i)
      }), Jr(t, o, !1, !0), ts[o] = es, t;
    },
    vs = Sr,
    gs = Gr,
    ys = Mr,
    ms = Kr,
    bs = Rr,
    ws = fs.PROPER,
    ks = bs.BUGGY_SAFARI_ITERATORS,
    _s = ue("iterator"),
    xs = "keys",
    Es = "values",
    Os = "entries",
    Cs = function Cs() {
      return this;
    },
    Ss = function Ss(t, e, i, n, o, r, s) {
      ps(i, e, n);
      var a,
        h,
        l,
        d = function d(t) {
          if (t === o && v) return v;
          if (!ks && t && t in f) return f[t];
          switch (t) {
            case xs:
            case Es:
            case Os:
              return function () {
                return new i(this, t);
              };
          }
          return function () {
            return new i(this);
          };
        },
        c = e + " Iterator",
        u = !1,
        f = t.prototype,
        p = f[_s] || f["@@iterator"] || o && f[o],
        v = !ks && p || d(o),
        g = "Array" === e && f.entries || p;
      if (g && (a = vs(g.call(new t()))) !== Object.prototype && a.next && (gs(a, c, !0, !0), ms[c] = Cs), ws && o === Es && p && p.name !== Es && (u = !0, v = function v() {
        return us(p, this);
      }), o) if (h = {
        values: d(Es),
        keys: r ? v : d(xs),
        entries: d(Os)
      }, s) for (l in h) (ks || u || !(l in f)) && ys(f, l, h[l]);else cs({
        target: e,
        proto: !0,
        forced: ks || u
      }, h);
      return s && f[_s] !== v && ys(f, _s, v, {
        name: o
      }), ms[e] = v, h;
    },
    Ts = function Ts(t, e) {
      return {
        value: t,
        done: e
      };
    },
    Ms = wo.charAt,
    Ps = co,
    Ds = Lo,
    Is = Ss,
    Bs = Ts,
    Ns = "String Iterator",
    Fs = Ds.set,
    zs = Ds.getterFor(Ns);
  Is(String, "String", function (t) {
    Fs(this, {
      type: Ns,
      string: Ps(t),
      index: 0
    });
  }, function () {
    var t,
      e = zs(this),
      i = e.string,
      n = e.index;
    return n >= i.length ? Bs(void 0, !0) : (t = Ms(i, n), e.index += t.length, Bs(t, !1));
  });
  var As = I,
    js = ii,
    Rs = Nt,
    Ls = function Ls(t, e, i) {
      var n, o;
      js(t);
      try {
        if (!(n = Rs(t, "return"))) {
          if ("throw" === e) throw i;
          return i;
        }
        n = As(n, t);
      } catch (t) {
        o = !0, n = t;
      }
      if ("throw" === e) throw i;
      if (o) throw n;
      return js(n), i;
    },
    Hs = ii,
    Ws = Ls,
    qs = Kr,
    Vs = ue("iterator"),
    Us = Array.prototype,
    Ys = function Ys(t) {
      return void 0 !== t && (qs.Array === t || Us[Vs] === t);
    },
    Xs = S,
    Gs = Vt,
    Ks = g(Function.toString);
  Xs(Gs.inspectSource) || (Gs.inspectSource = function (t) {
    return Ks(t);
  });
  var $s = Gs.inspectSource,
    Zs = g,
    Qs = r,
    Js = S,
    ta = ao,
    ea = $s,
    ia = function ia() {},
    na = [],
    oa = st("Reflect", "construct"),
    ra = /^\s*(?:class|function)\b/,
    sa = Zs(ra.exec),
    aa = !ra.test(ia),
    ha = function ha(t) {
      if (!Js(t)) return !1;
      try {
        return oa(ia, na, t), !0;
      } catch (t) {
        return !1;
      }
    },
    la = function la(t) {
      if (!Js(t)) return !1;
      switch (ta(t)) {
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
          return !1;
      }
      try {
        return aa || !!sa(ra, ea(t));
      } catch (t) {
        return !0;
      }
    };
  la.sham = !0;
  var da = !oa || Qs(function () {
      var t;
      return ha(ha.call) || !ha(Object) || !ha(function () {
        t = !0;
      }) || t;
    }) ? la : ha,
    ca = _e,
    ua = Ze,
    fa = R,
    pa = function pa(t, e, i) {
      var n = ca(e);
      n in t ? ua.f(t, n, fa(0, i)) : t[n] = i;
    },
    va = ao,
    ga = Nt,
    ya = U,
    ma = Kr,
    ba = ue("iterator"),
    wa = function wa(t) {
      if (!ya(t)) return ga(t, ba) || ga(t, "@@iterator") || ma[va(t)];
    },
    ka = I,
    _a = Dt,
    xa = ii,
    Ea = St,
    Oa = wa,
    Ca = TypeError,
    Sa = function Sa(t, e) {
      var i = arguments.length < 2 ? Oa(t) : e;
      if (_a(i)) return xa(ka(i, t));
      throw new Ca(Ea(t) + " is not iterable");
    },
    Ta = $e,
    Ma = I,
    Pa = Kt,
    Da = function Da(t, e, i, n) {
      try {
        return n ? e(Hs(i)[0], i[1]) : e(i);
      } catch (e) {
        Ws(t, "throw", e);
      }
    },
    Ia = Ys,
    Ba = da,
    Na = Li,
    Fa = pa,
    za = Sa,
    Aa = wa,
    ja = Array,
    Ra = ue("iterator"),
    La = !1;
  try {
    var Ha = 0,
      Wa = {
        next: function next() {
          return {
            done: !!Ha++
          };
        },
        "return": function _return() {
          La = !0;
        }
      };
    Wa[Ra] = function () {
      return this;
    }, Array.from(Wa, function () {
      throw 2;
    });
  } catch (t) {}
  var qa = function qa(t, e) {
      try {
        if (!e && !La) return !1;
      } catch (t) {
        return !1;
      }
      var i = !1;
      try {
        var n = {};
        n[Ra] = function () {
          return {
            next: function next() {
              return {
                done: i = !0
              };
            }
          };
        }, t(n);
      } catch (t) {}
      return i;
    },
    Va = function Va(t) {
      var e = Pa(t),
        i = Ba(this),
        n = arguments.length,
        o = n > 1 ? arguments[1] : void 0,
        r = void 0 !== o;
      r && (o = Ta(o, n > 2 ? arguments[2] : void 0));
      var s,
        a,
        h,
        l,
        d,
        c,
        u = Aa(e),
        f = 0;
      if (!u || this === ja && Ia(u)) for (s = Na(e), a = i ? new this(s) : ja(s); s > f; f++) c = r ? o(e[f], f) : e[f], Fa(a, f, c);else for (d = (l = za(e, u)).next, a = i ? new this() : []; !(h = Ma(d, l)).done; f++) c = r ? Da(l, o, [h.value, f], !0) : h.value, Fa(a, f, c);
      return a.length = f, a;
    };
  Ti({
    target: "Array",
    stat: !0,
    forced: !qa(function (t) {
      Array.from(t);
    })
  }, {
    from: Va
  });
  var Ua = et.Array.from,
    Ya = i(Ua),
    Xa = Z,
    Ga = Kr,
    Ka = Lo;
  Ze.f;
  var $a = Ss,
    Za = Ts,
    Qa = "Array Iterator",
    Ja = Ka.set,
    th = Ka.getterFor(Qa);
  $a(Array, "Array", function (t, e) {
    Ja(this, {
      type: Qa,
      target: Xa(t),
      index: 0,
      kind: e
    });
  }, function () {
    var t = th(this),
      e = t.target,
      i = t.kind,
      n = t.index++;
    if (!e || n >= e.length) return t.target = void 0, Za(void 0, !0);
    switch (i) {
      case "keys":
        return Za(n, !1);
      case "values":
        return Za(e[n], !1);
    }
    return Za([n, e[n]], !1);
  }, "values"), Ga.Arguments = Ga.Array;
  var eh = wa,
    ih = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    },
    nh = o,
    oh = ao,
    rh = gi,
    sh = Kr,
    ah = ue("toStringTag");
  for (var hh in ih) {
    var lh = nh[hh],
      dh = lh && lh.prototype;
    dh && oh(dh) !== ah && rh(dh, ah, hh), sh[hh] = sh.Array;
  }
  var ch = eh,
    uh = i(ch),
    fh = i(ch);
  function ph(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  var vh = {
      exports: {}
    },
    gh = Ti,
    yh = M,
    mh = Ze.f;
  gh({
    target: "Object",
    stat: !0,
    forced: Object.defineProperty !== mh,
    sham: !yh
  }, {
    defineProperty: mh
  });
  var bh = et.Object,
    wh = vh.exports = function (t, e, i) {
      return bh.defineProperty(t, e, i);
    };
  bh.defineProperty.sham && (wh.sham = !0);
  var kh = vh.exports,
    _h = kh,
    xh = i(_h),
    Eh = w,
    Oh = Array.isArray || function (t) {
      return "Array" === Eh(t);
    },
    Ch = TypeError,
    Sh = function Sh(t) {
      if (t > 9007199254740991) throw Ch("Maximum allowed index exceeded");
      return t;
    },
    Th = Oh,
    Mh = da,
    Ph = tt,
    Dh = ue("species"),
    Ih = Array,
    Bh = function Bh(t) {
      var e;
      return Th(t) && (e = t.constructor, (Mh(e) && (e === Ih || Th(e.prototype)) || Ph(e) && null === (e = e[Dh])) && (e = void 0)), void 0 === e ? Ih : e;
    },
    Nh = function Nh(t, e) {
      return new (Bh(t))(0 === e ? 0 : e);
    },
    Fh = r,
    zh = vt,
    Ah = ue("species"),
    jh = function jh(t) {
      return zh >= 51 || !Fh(function () {
        var e = [];
        return (e.constructor = {})[Ah] = function () {
          return {
            foo: 1
          };
        }, 1 !== e[t](Boolean).foo;
      });
    },
    Rh = Ti,
    Lh = r,
    Hh = Oh,
    Wh = tt,
    qh = Kt,
    Vh = Li,
    Uh = Sh,
    Yh = pa,
    Xh = Nh,
    Gh = jh,
    Kh = vt,
    $h = ue("isConcatSpreadable"),
    Zh = Kh >= 51 || !Lh(function () {
      var t = [];
      return t[$h] = !1, t.concat()[0] !== t;
    }),
    Qh = function Qh(t) {
      if (!Wh(t)) return !1;
      var e = t[$h];
      return void 0 !== e ? !!e : Hh(t);
    };
  Rh({
    target: "Array",
    proto: !0,
    arity: 1,
    forced: !Zh || !Gh("concat")
  }, {
    concat: function concat(t) {
      var e,
        i,
        n,
        o,
        r,
        s = qh(this),
        a = Xh(s, 0),
        h = 0;
      for (e = -1, n = arguments.length; e < n; e++) if (Qh(r = -1 === e ? s : arguments[e])) for (o = Vh(r), Uh(h + o), i = 0; i < o; i++, h++) i in r && Yh(a, h, r[i]);else Uh(h + 1), Yh(a, h++, r);
      return a.length = h, a;
    }
  });
  var Jh = {},
    tl = Qi,
    el = Ji.concat("length", "prototype");
  Jh.f = Object.getOwnPropertyNames || function (t) {
    return tl(t, el);
  };
  var il = {},
    nl = zi,
    ol = Li,
    rl = pa,
    sl = Array,
    al = Math.max,
    hl = function hl(t, e, i) {
      for (var n = ol(t), o = nl(e, n), r = nl(void 0 === i ? n : i, n), s = sl(al(r - o, 0)), a = 0; o < r; o++, a++) rl(s, a, t[o]);
      return s.length = a, s;
    },
    ll = w,
    dl = Z,
    cl = Jh.f,
    ul = hl,
    fl = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
  il.f = function (t) {
    return fl && "Window" === ll(t) ? function (t) {
      try {
        return cl(t);
      } catch (t) {
        return ul(fl);
      }
    }(t) : cl(dl(t));
  };
  var pl = Ze,
    vl = function vl(t, e, i) {
      return pl.f(t, e, i);
    },
    gl = {},
    yl = ue;
  gl.f = yl;
  var ml = et,
    bl = Qt,
    wl = gl,
    kl = Ze.f,
    _l = function _l(t) {
      var e = ml.Symbol || (ml.Symbol = {});
      bl(e, t) || kl(e, t, {
        value: wl.f(t)
      });
    },
    xl = I,
    El = st,
    Ol = ue,
    Cl = Mr,
    Sl = function Sl() {
      var t = El("Symbol"),
        e = t && t.prototype,
        i = e && e.valueOf,
        n = Ol("toPrimitive");
      e && !e[n] && Cl(e, n, function (t) {
        return xl(i, this);
      }, {
        arity: 1
      });
    },
    Tl = $e,
    Ml = V,
    Pl = Kt,
    Dl = Li,
    Il = Nh,
    Bl = g([].push),
    Nl = function Nl(t) {
      var e = 1 === t,
        i = 2 === t,
        n = 3 === t,
        o = 4 === t,
        r = 6 === t,
        s = 7 === t,
        a = 5 === t || r;
      return function (h, l, d, c) {
        for (var u, f, p = Pl(h), v = Ml(p), g = Tl(l, d), y = Dl(v), m = 0, b = c || Il, w = e ? b(h, y) : i || s ? b(h, 0) : void 0; y > m; m++) if ((a || m in v) && (f = g(u = v[m], m, p), t)) if (e) w[m] = f;else if (f) switch (t) {
          case 3:
            return !0;
          case 5:
            return u;
          case 6:
            return m;
          case 2:
            Bl(w, u);
        } else switch (t) {
          case 4:
            return !1;
          case 7:
            Bl(w, u);
        }
        return r ? -1 : n || o ? o : w;
      };
    },
    Fl = {
      forEach: Nl(0),
      map: Nl(1),
      filter: Nl(2),
      some: Nl(3),
      every: Nl(4),
      find: Nl(5),
      findIndex: Nl(6),
      filterReject: Nl(7)
    },
    zl = Ti,
    Al = o,
    jl = I,
    Rl = g,
    Ll = M,
    Hl = bt,
    Wl = r,
    ql = Qt,
    Vl = at,
    Ul = ii,
    Yl = Z,
    Xl = _e,
    Gl = co,
    Kl = R,
    $l = mr,
    Zl = nn,
    Ql = Jh,
    Jl = il,
    td = on,
    ed = T,
    id = Ze,
    nd = Xo,
    od = B,
    rd = Mr,
    sd = vl,
    ad = Yt,
    hd = Yi,
    ld = ne,
    dd = ue,
    cd = gl,
    ud = _l,
    fd = Sl,
    pd = Gr,
    vd = Lo,
    gd = Fl.forEach,
    yd = Co("hidden"),
    md = "Symbol",
    bd = "prototype",
    wd = vd.set,
    kd = vd.getterFor(md),
    _d = Object[bd],
    xd = Al.Symbol,
    Ed = xd && xd[bd],
    Od = Al.RangeError,
    Cd = Al.TypeError,
    Sd = Al.QObject,
    Td = ed.f,
    Md = id.f,
    Pd = Jl.f,
    Dd = od.f,
    Id = Rl([].push),
    Bd = ad("symbols"),
    Nd = ad("op-symbols"),
    Fd = ad("wks"),
    zd = !Sd || !Sd[bd] || !Sd[bd].findChild,
    Ad = function Ad(t, e, i) {
      var n = Td(_d, e);
      n && delete _d[e], Md(t, e, i), n && t !== _d && Md(_d, e, n);
    },
    jd = Ll && Wl(function () {
      return 7 !== $l(Md({}, "a", {
        get: function get() {
          return Md(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? Ad : Md,
    Rd = function Rd(t, e) {
      var i = Bd[t] = $l(Ed);
      return wd(i, {
        type: md,
        tag: t,
        description: e
      }), Ll || (i.description = e), i;
    },
    Ld = function Ld(t, e, i) {
      t === _d && Ld(Nd, e, i), Ul(t);
      var n = Xl(e);
      return Ul(i), ql(Bd, n) ? (i.enumerable ? (ql(t, yd) && t[yd][n] && (t[yd][n] = !1), i = $l(i, {
        enumerable: Kl(0, !1)
      })) : (ql(t, yd) || Md(t, yd, Kl(1, {})), t[yd][n] = !0), jd(t, n, i)) : Md(t, n, i);
    },
    Hd = function Hd(t, e) {
      Ul(t);
      var i = Yl(e),
        n = Zl(i).concat(Ud(i));
      return gd(n, function (e) {
        Ll && !jl(Wd, i, e) || Ld(t, e, i[e]);
      }), t;
    },
    Wd = function Wd(t) {
      var e = Xl(t),
        i = jl(Dd, this, e);
      return !(this === _d && ql(Bd, e) && !ql(Nd, e)) && (!(i || !ql(this, e) || !ql(Bd, e) || ql(this, yd) && this[yd][e]) || i);
    },
    qd = function qd(t, e) {
      var i = Yl(t),
        n = Xl(e);
      if (i !== _d || !ql(Bd, n) || ql(Nd, n)) {
        var o = Td(i, n);
        return !o || !ql(Bd, n) || ql(i, yd) && i[yd][n] || (o.enumerable = !0), o;
      }
    },
    Vd = function Vd(t) {
      var e = Pd(Yl(t)),
        i = [];
      return gd(e, function (t) {
        ql(Bd, t) || ql(hd, t) || Id(i, t);
      }), i;
    },
    Ud = function Ud(t) {
      var e = t === _d,
        i = Pd(e ? Nd : Yl(t)),
        n = [];
      return gd(i, function (t) {
        !ql(Bd, t) || e && !ql(_d, t) || Id(n, Bd[t]);
      }), n;
    };
  Hl || (xd = function xd() {
    if (Vl(Ed, this)) throw new Cd("Symbol is not a constructor");
    var t = arguments.length && void 0 !== arguments[0] ? Gl(arguments[0]) : void 0,
      e = ld(t),
      i = function i(t) {
        this === _d && jl(i, Nd, t), ql(this, yd) && ql(this[yd], e) && (this[yd][e] = !1);
        var n = Kl(1, t);
        try {
          jd(this, e, n);
        } catch (t) {
          if (!(t instanceof Od)) throw t;
          Ad(this, e, n);
        }
      };
    return Ll && zd && jd(_d, e, {
      configurable: !0,
      set: i
    }), Rd(e, t);
  }, rd(Ed = xd[bd], "toString", function () {
    return kd(this).tag;
  }), rd(xd, "withoutSetter", function (t) {
    return Rd(ld(t), t);
  }), od.f = Wd, id.f = Ld, nd.f = Hd, ed.f = qd, Ql.f = Jl.f = Vd, td.f = Ud, cd.f = function (t) {
    return Rd(dd(t), t);
  }, Ll && sd(Ed, "description", {
    configurable: !0,
    get: function get() {
      return kd(this).description;
    }
  })), zl({
    global: !0,
    constructor: !0,
    wrap: !0,
    forced: !Hl,
    sham: !Hl
  }, {
    Symbol: xd
  }), gd(Zl(Fd), function (t) {
    ud(t);
  }), zl({
    target: md,
    stat: !0,
    forced: !Hl
  }, {
    useSetter: function useSetter() {
      zd = !0;
    },
    useSimple: function useSimple() {
      zd = !1;
    }
  }), zl({
    target: "Object",
    stat: !0,
    forced: !Hl,
    sham: !Ll
  }, {
    create: function create(t, e) {
      return void 0 === e ? $l(t) : Hd($l(t), e);
    },
    defineProperty: Ld,
    defineProperties: Hd,
    getOwnPropertyDescriptor: qd
  }), zl({
    target: "Object",
    stat: !0,
    forced: !Hl
  }, {
    getOwnPropertyNames: Vd
  }), fd(), pd(xd, md), hd[yd] = !0;
  var Yd = bt && !!Symbol["for"] && !!Symbol.keyFor,
    Xd = Ti,
    Gd = st,
    Kd = Qt,
    $d = co,
    Zd = Yt,
    Qd = Yd,
    Jd = Zd("string-to-symbol-registry"),
    tc = Zd("symbol-to-string-registry");
  Xd({
    target: "Symbol",
    stat: !0,
    forced: !Qd
  }, {
    "for": function _for(t) {
      var e = $d(t);
      if (Kd(Jd, e)) return Jd[e];
      var i = Gd("Symbol")(e);
      return Jd[e] = i, tc[i] = e, i;
    }
  });
  var ec = Ti,
    ic = Qt,
    nc = Ot,
    oc = St,
    rc = Yd,
    sc = Yt("symbol-to-string-registry");
  ec({
    target: "Symbol",
    stat: !0,
    forced: !rc
  }, {
    keyFor: function keyFor(t) {
      if (!nc(t)) throw new TypeError(oc(t) + " is not a symbol");
      if (ic(sc, t)) return sc[t];
    }
  });
  var ac = Oh,
    hc = S,
    lc = w,
    dc = co,
    cc = g([].push),
    uc = Ti,
    fc = st,
    pc = c,
    vc = I,
    gc = g,
    yc = r,
    mc = S,
    bc = Ot,
    wc = wn,
    kc = function kc(t) {
      if (hc(t)) return t;
      if (ac(t)) {
        for (var e = t.length, i = [], n = 0; n < e; n++) {
          var o = t[n];
          "string" == typeof o ? cc(i, o) : "number" != typeof o && "Number" !== lc(o) && "String" !== lc(o) || cc(i, dc(o));
        }
        var r = i.length,
          s = !0;
        return function (t, e) {
          if (s) return s = !1, e;
          if (ac(this)) return e;
          for (var n = 0; n < r; n++) if (i[n] === t) return e;
        };
      }
    },
    _c = bt,
    xc = String,
    Ec = fc("JSON", "stringify"),
    Oc = gc(/./.exec),
    Cc = gc("".charAt),
    Sc = gc("".charCodeAt),
    Tc = gc("".replace),
    Mc = gc(1..toString),
    Pc = /[\uD800-\uDFFF]/g,
    Dc = /^[\uD800-\uDBFF]$/,
    Ic = /^[\uDC00-\uDFFF]$/,
    Bc = !_c || yc(function () {
      var t = fc("Symbol")("stringify detection");
      return "[null]" !== Ec([t]) || "{}" !== Ec({
        a: t
      }) || "{}" !== Ec(Object(t));
    }),
    Nc = yc(function () {
      return "\"\\udf06\\ud834\"" !== Ec("\uDF06\uD834") || "\"\\udead\"" !== Ec("\uDEAD");
    }),
    Fc = function Fc(t, e) {
      var i = wc(arguments),
        n = kc(e);
      if (mc(n) || void 0 !== t && !bc(t)) return i[1] = function (t, e) {
        if (mc(n) && (e = vc(n, this, xc(t), e)), !bc(e)) return e;
      }, pc(Ec, null, i);
    },
    zc = function zc(t, e, i) {
      var n = Cc(i, e - 1),
        o = Cc(i, e + 1);
      return Oc(Dc, t) && !Oc(Ic, o) || Oc(Ic, t) && !Oc(Dc, n) ? "\\u" + Mc(Sc(t, 0), 16) : t;
    };
  Ec && uc({
    target: "JSON",
    stat: !0,
    arity: 3,
    forced: Bc || Nc
  }, {
    stringify: function stringify(t, e, i) {
      var n = wc(arguments),
        o = pc(Bc ? Fc : Ec, null, n);
      return Nc && "string" == typeof o ? Tc(o, Pc, zc) : o;
    }
  });
  var Ac = on,
    jc = Kt;
  Ti({
    target: "Object",
    stat: !0,
    forced: !bt || r(function () {
      Ac.f(1);
    })
  }, {
    getOwnPropertySymbols: function getOwnPropertySymbols(t) {
      var e = Ac.f;
      return e ? e(jc(t)) : [];
    }
  }), _l("asyncIterator"), _l("hasInstance"), _l("isConcatSpreadable"), _l("iterator"), _l("match"), _l("matchAll"), _l("replace"), _l("search"), _l("species"), _l("split");
  var Rc = Sl;
  _l("toPrimitive"), Rc();
  var Lc = st,
    Hc = Gr;
  _l("toStringTag"), Hc(Lc("Symbol"), "Symbol"), _l("unscopables"), Gr(o.JSON, "JSON", !0);
  var Wc = et.Symbol,
    qc = ue,
    Vc = Ze.f,
    Uc = qc("metadata"),
    Yc = Function.prototype;
  void 0 === Yc[Uc] && Vc(Yc, Uc, {
    value: null
  }), _l("asyncDispose"), _l("dispose"), _l("metadata");
  var Xc = Wc,
    Gc = g,
    Kc = st("Symbol"),
    $c = Kc.keyFor,
    Zc = Gc(Kc.prototype.valueOf),
    Qc = Kc.isRegisteredSymbol || function (t) {
      try {
        return void 0 !== $c(Zc(t));
      } catch (t) {
        return !1;
      }
    };
  Ti({
    target: "Symbol",
    stat: !0
  }, {
    isRegisteredSymbol: Qc
  });
  for (var Jc = Yt, tu = st, eu = g, iu = Ot, nu = ue, ou = tu("Symbol"), ru = ou.isWellKnownSymbol, su = tu("Object", "getOwnPropertyNames"), au = eu(ou.prototype.valueOf), hu = Jc("wks"), lu = 0, du = su(ou), cu = du.length; lu < cu; lu++) try {
    var uu = du[lu];
    iu(ou[uu]) && nu(uu);
  } catch (t) {}
  var fu = function fu(t) {
    if (ru && ru(t)) return !0;
    try {
      for (var e = au(t), i = 0, n = su(hu), o = n.length; i < o; i++) if (hu[n[i]] == e) return !0;
    } catch (t) {}
    return !1;
  };
  Ti({
    target: "Symbol",
    stat: !0,
    forced: !0
  }, {
    isWellKnownSymbol: fu
  }), _l("matcher"), _l("observable"), Ti({
    target: "Symbol",
    stat: !0,
    name: "isRegisteredSymbol"
  }, {
    isRegistered: Qc
  }), Ti({
    target: "Symbol",
    stat: !0,
    name: "isWellKnownSymbol",
    forced: !0
  }, {
    isWellKnown: fu
  }), _l("metadataKey"), _l("patternMatch"), _l("replaceAll");
  var pu = Xc,
    vu = i(pu),
    gu = gl.f("iterator"),
    yu = gu,
    mu = i(yu);
  function bu(t) {
    return bu = "function" == typeof vu && "symbol" == _typeof(mu) ? function (t) {
      return _typeof(t);
    } : function (t) {
      return t && "function" == typeof vu && t.constructor === vu && t !== vu.prototype ? "symbol" : _typeof(t);
    }, bu(t);
  }
  var wu = i(gl.f("toPrimitive"));
  function ku(t) {
    var e = function (t, e) {
      if ("object" !== bu(t) || null === t) return t;
      var i = t[wu];
      if (void 0 !== i) {
        var n = i.call(t, e || "default");
        if ("object" !== bu(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === e ? String : Number)(t);
    }(t, "string");
    return "symbol" === bu(e) ? e : String(e);
  }
  function _u(t, e) {
    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), xh(t, ku(n.key), n);
    }
  }
  function xu(t, e, i) {
    return e && _u(t.prototype, e), i && _u(t, i), xh(t, "prototype", {
      writable: !1
    }), t;
  }
  Ti({
    target: "Array",
    stat: !0
  }, {
    isArray: Oh
  });
  var Eu = et.Array.isArray,
    Ou = i(Eu);
  var Cu = M,
    Su = Oh,
    Tu = TypeError,
    Mu = Object.getOwnPropertyDescriptor,
    Pu = Cu && !function () {
      if (void 0 !== this) return !0;
      try {
        Object.defineProperty([], "length", {
          writable: !1
        }).length = 1;
      } catch (t) {
        return t instanceof TypeError;
      }
    }() ? function (t, e) {
      if (Su(t) && !Mu(t, "length").writable) throw new Tu("Cannot set read only .length");
      return t.length = e;
    } : function (t, e) {
      return t.length = e;
    },
    Du = Kt,
    Iu = Li,
    Bu = Pu,
    Nu = Sh;
  Ti({
    target: "Array",
    proto: !0,
    arity: 1,
    forced: r(function () {
      return 4294967297 !== [].push.call({
        length: 4294967296
      }, 1);
    }) || !function () {
      try {
        Object.defineProperty([], "length", {
          writable: !1
        }).push();
      } catch (t) {
        return t instanceof TypeError;
      }
    }()
  }, {
    push: function push(t) {
      var e = Du(this),
        i = Iu(e),
        n = arguments.length;
      Nu(i + n);
      for (var o = 0; o < n; o++) e[i] = arguments[o], i++;
      return Bu(e, i), i;
    }
  });
  var Fu = Nn("Array").push,
    zu = at,
    Au = Fu,
    ju = Array.prototype,
    Ru = function Ru(t) {
      var e = t.push;
      return t === ju || zu(ju, t) && e === ju.push ? Au : e;
    },
    Lu = Ru,
    Hu = i(Lu);
  var Wu = Ti,
    qu = Oh,
    Vu = da,
    Uu = tt,
    Yu = zi,
    Xu = Li,
    Gu = Z,
    Ku = pa,
    $u = ue,
    Zu = wn,
    Qu = jh("slice"),
    Ju = $u("species"),
    tf = Array,
    ef = Math.max;
  Wu({
    target: "Array",
    proto: !0,
    forced: !Qu
  }, {
    slice: function slice(t, e) {
      var i,
        n,
        o,
        r = Gu(this),
        s = Xu(r),
        a = Yu(t, s),
        h = Yu(void 0 === e ? s : e, s);
      if (qu(r) && (i = r.constructor, (Vu(i) && (i === tf || qu(i.prototype)) || Uu(i) && null === (i = i[Ju])) && (i = void 0), i === tf || void 0 === i)) return Zu(r, a, h);
      for (n = new (void 0 === i ? tf : i)(ef(h - a, 0)), o = 0; a < h; a++, o++) a in r && Ku(n, o, r[a]);
      return n.length = o, n;
    }
  });
  var nf = Nn("Array").slice,
    of = at,
    rf = nf,
    sf = Array.prototype,
    af = function af(t) {
      var e = t.slice;
      return t === sf || of(sf, t) && e === sf.slice ? rf : e;
    },
    hf = af,
    lf = hf,
    df = i(lf),
    cf = i(Ua);
  function uf(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
    return n;
  }
  function ff(t, e) {
    var i;
    if (t) {
      if ("string" == typeof t) return uf(t, e);
      var n = df(i = Object.prototype.toString.call(t)).call(i, 8, -1);
      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? cf(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? uf(t, e) : void 0;
    }
  }
  function pf(t, e) {
    return function (t) {
      if (Ou(t)) return t;
    }(t) || function (t, e) {
      var i = null == t ? null : void 0 !== vu && uh(t) || t["@@iterator"];
      if (null != i) {
        var n,
          o,
          r,
          s,
          a = [],
          h = !0,
          l = !1;
        try {
          if (r = (i = i.call(t)).next, 0 === e) {
            if (Object(i) !== i) return;
            h = !1;
          } else for (; !(h = (n = r.call(i)).done) && (Hu(a).call(a, n.value), a.length !== e); h = !0);
        } catch (t) {
          l = !0, o = t;
        } finally {
          try {
            if (!h && null != i["return"] && (s = i["return"](), Object(s) !== s)) return;
          } finally {
            if (l) throw o;
          }
        }
        return a;
      }
    }(t, e) || ff(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function vf(t) {
    return function (t) {
      if (Ou(t)) return uf(t);
    }(t) || function (t) {
      if (void 0 !== vu && null != uh(t) || null != t["@@iterator"]) return cf(t);
    }(t) || ff(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  var gf = i(Wc),
    yf = Nn("Array").concat,
    mf = at,
    bf = yf,
    wf = Array.prototype,
    kf = function kf(t) {
      var e = t.concat;
      return t === wf || mf(wf, t) && e === wf.concat ? bf : e;
    },
    _f = i(kf),
    xf = i(hf),
    Ef = st,
    Of = Jh,
    Cf = on,
    Sf = ii,
    Tf = g([].concat),
    Mf = Ef("Reflect", "ownKeys") || function (t) {
      var e = Of.f(Sf(t)),
        i = Cf.f;
      return i ? Tf(e, i(t)) : e;
    };
  Ti({
    target: "Reflect",
    stat: !0
  }, {
    ownKeys: Mf
  });
  var Pf = i(et.Reflect.ownKeys),
    Df = i(Eu),
    If = Fl.map;
  Ti({
    target: "Array",
    proto: !0,
    forced: !jh("map")
  }, {
    map: function map(t) {
      return If(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var Bf = Nn("Array").map,
    Nf = at,
    Ff = Bf,
    zf = Array.prototype,
    Af = function Af(t) {
      var e = t.map;
      return t === zf || Nf(zf, t) && e === zf.map ? Ff : e;
    },
    jf = i(Af),
    Rf = Kt,
    Lf = nn;
  Ti({
    target: "Object",
    stat: !0,
    forced: r(function () {
      Lf(1);
    })
  }, {
    keys: function keys(t) {
      return Lf(Rf(t));
    }
  });
  var Hf = i(et.Object.keys),
    Wf = Ti,
    qf = Date,
    Vf = g(qf.prototype.getTime);
  Wf({
    target: "Date",
    stat: !0
  }, {
    now: function now() {
      return Vf(new qf());
    }
  });
  var Uf = i(et.Date.now),
    Yf = r,
    Xf = function Xf(t, e) {
      var i = [][t];
      return !!i && Yf(function () {
        i.call(null, e || function () {
          return 1;
        }, 1);
      });
    },
    Gf = Fl.forEach,
    Kf = Xf("forEach") ? [].forEach : function (t) {
      return Gf(this, t, arguments.length > 1 ? arguments[1] : void 0);
    };
  Ti({
    target: "Array",
    proto: !0,
    forced: [].forEach !== Kf
  }, {
    forEach: Kf
  });
  var $f = Nn("Array").forEach,
    Zf = ao,
    Qf = Qt,
    Jf = at,
    tp = $f,
    ep = Array.prototype,
    ip = {
      DOMTokenList: !0,
      NodeList: !0
    },
    np = function np(t) {
      var e = t.forEach;
      return t === ep || Jf(ep, t) && e === ep.forEach || Qf(ip, Zf(t)) ? tp : e;
    },
    op = i(np),
    rp = Ti,
    sp = Oh,
    ap = g([].reverse),
    hp = [1, 2];
  rp({
    target: "Array",
    proto: !0,
    forced: String(hp) === String(hp.reverse())
  }, {
    reverse: function reverse() {
      return sp(this) && (this.length = this.length), ap(this);
    }
  });
  var lp = Nn("Array").reverse,
    dp = at,
    cp = lp,
    up = Array.prototype,
    fp = function fp(t) {
      var e = t.reverse;
      return t === up || dp(up, t) && e === up.reverse ? cp : e;
    },
    pp = fp,
    vp = i(pp),
    gp = St,
    yp = TypeError,
    mp = function mp(t, e) {
      if (!delete t[e]) throw new yp("Cannot delete property " + gp(e) + " of " + gp(t));
    },
    bp = Ti,
    wp = Kt,
    kp = zi,
    _p = Ii,
    xp = Li,
    Ep = Pu,
    Op = Sh,
    Cp = Nh,
    Sp = pa,
    Tp = mp,
    Mp = jh("splice"),
    Pp = Math.max,
    Dp = Math.min;
  bp({
    target: "Array",
    proto: !0,
    forced: !Mp
  }, {
    splice: function splice(t, e) {
      var i,
        n,
        o,
        r,
        s,
        a,
        h = wp(this),
        l = xp(h),
        d = kp(t, l),
        c = arguments.length;
      for (0 === c ? i = n = 0 : 1 === c ? (i = 0, n = l - d) : (i = c - 2, n = Dp(Pp(_p(e), 0), l - d)), Op(l + i - n), o = Cp(h, n), r = 0; r < n; r++) (s = d + r) in h && Sp(o, r, h[s]);
      if (o.length = n, i < n) {
        for (r = d; r < l - n; r++) a = r + i, (s = r + n) in h ? h[a] = h[s] : Tp(h, a);
        for (r = l; r > l - n + i; r--) Tp(h, r - 1);
      } else if (i > n) for (r = l - n; r > d; r--) a = r + i - 1, (s = r + n - 1) in h ? h[a] = h[s] : Tp(h, a);
      for (r = 0; r < i; r++) h[r + d] = arguments[r + 2];
      return Ep(h, l - n + i), o;
    }
  });
  var Ip = Nn("Array").splice,
    Bp = at,
    Np = Ip,
    Fp = Array.prototype,
    zp = function zp(t) {
      var e = t.splice;
      return t === Fp || Bp(Fp, t) && e === Fp.splice ? Np : e;
    },
    Ap = i(zp),
    jp = Ui.includes;
  Ti({
    target: "Array",
    proto: !0,
    forced: r(function () {
      return !Array(1).includes();
    })
  }, {
    includes: function includes(t) {
      return jp(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var Rp = Nn("Array").includes,
    Lp = tt,
    Hp = w,
    Wp = ue("match"),
    qp = function qp(t) {
      var e;
      return Lp(t) && (void 0 !== (e = t[Wp]) ? !!e : "RegExp" === Hp(t));
    },
    Vp = TypeError,
    Up = ue("match"),
    Yp = Ti,
    Xp = function Xp(t) {
      if (qp(t)) throw new Vp("The method doesn't accept regular expressions");
      return t;
    },
    Gp = G,
    Kp = co,
    $p = function $p(t) {
      var e = /./;
      try {
        "/./"[t](e);
      } catch (i) {
        try {
          return e[Up] = !1, "/./"[t](e);
        } catch (t) {}
      }
      return !1;
    },
    Zp = g("".indexOf);
  Yp({
    target: "String",
    proto: !0,
    forced: !$p("includes")
  }, {
    includes: function includes(t) {
      return !!~Zp(Kp(Gp(this)), Kp(Xp(t)), arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var Qp = Nn("String").includes,
    Jp = at,
    tv = Rp,
    ev = Qp,
    iv = Array.prototype,
    nv = String.prototype,
    ov = function ov(t) {
      var e = t.includes;
      return t === iv || Jp(iv, t) && e === iv.includes ? tv : "string" == typeof t || t === nv || Jp(nv, t) && e === nv.includes ? ev : e;
    },
    rv = i(ov),
    sv = Kt,
    av = Sr,
    hv = br;
  Ti({
    target: "Object",
    stat: !0,
    forced: r(function () {
      av(1);
    }),
    sham: !hv
  }, {
    getPrototypeOf: function getPrototypeOf(t) {
      return av(sv(t));
    }
  });
  var lv = et.Object.getPrototypeOf,
    dv = i(lv),
    cv = Fl.filter;
  Ti({
    target: "Array",
    proto: !0,
    forced: !jh("filter")
  }, {
    filter: function filter(t) {
      return cv(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var uv = Nn("Array").filter,
    fv = at,
    pv = uv,
    vv = Array.prototype,
    gv = function gv(t) {
      var e = t.filter;
      return t === vv || fv(vv, t) && e === vv.filter ? pv : e;
    },
    yv = i(gv),
    mv = M,
    bv = r,
    wv = g,
    kv = Sr,
    _v = nn,
    xv = Z,
    Ev = wv(B.f),
    Ov = wv([].push),
    Cv = mv && bv(function () {
      var t = Object.create(null);
      return t[2] = 2, !Ev(t, 2);
    }),
    Sv = function Sv(t) {
      return function (e) {
        for (var i, n = xv(e), o = _v(n), r = Cv && null === kv(n), s = o.length, a = 0, h = []; s > a;) i = o[a++], mv && !(r ? i in n : Ev(n, i)) || Ov(h, t ? [i, n[i]] : n[i]);
        return h;
      };
    },
    Tv = {
      entries: Sv(!0),
      values: Sv(!1)
    },
    Mv = Tv.values;
  Ti({
    target: "Object",
    stat: !0
  }, {
    values: function values(t) {
      return Mv(t);
    }
  });
  var Pv = i(et.Object.values),
    Dv = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
    Iv = G,
    Bv = co,
    Nv = Dv,
    Fv = g("".replace),
    zv = RegExp("^[" + Nv + "]+"),
    Av = RegExp("(^|[^" + Nv + "])[" + Nv + "]+$"),
    jv = function jv(t) {
      return function (e) {
        var i = Bv(Iv(e));
        return 1 & t && (i = Fv(i, zv, "")), 2 & t && (i = Fv(i, Av, "$1")), i;
      };
    },
    Rv = {
      start: jv(1),
      end: jv(2),
      trim: jv(3)
    },
    Lv = o,
    Hv = r,
    Wv = g,
    qv = co,
    Vv = Rv.trim,
    Uv = Dv,
    Yv = Lv.parseInt,
    Xv = Lv.Symbol,
    Gv = Xv && Xv.iterator,
    Kv = /^[+-]?0x/i,
    $v = Wv(Kv.exec),
    Zv = 8 !== Yv(Uv + "08") || 22 !== Yv(Uv + "0x16") || Gv && !Hv(function () {
      Yv(Object(Gv));
    }) ? function (t, e) {
      var i = Vv(qv(t));
      return Yv(i, e >>> 0 || ($v(Kv, i) ? 16 : 10));
    } : Yv;
  Ti({
    global: !0,
    forced: parseInt !== Zv
  }, {
    parseInt: Zv
  });
  var Qv = i(et.parseInt),
    Jv = Ti,
    tg = Ui.indexOf,
    eg = Xf,
    ig = x([].indexOf),
    ng = !!ig && 1 / ig([1], 1, -0) < 0;
  Jv({
    target: "Array",
    proto: !0,
    forced: ng || !eg("indexOf")
  }, {
    indexOf: function indexOf(t) {
      var e = arguments.length > 1 ? arguments[1] : void 0;
      return ng ? ig(this, t, e) || 0 : tg(this, t, e);
    }
  });
  var og = Nn("Array").indexOf,
    rg = at,
    sg = og,
    ag = Array.prototype,
    hg = function hg(t) {
      var e = t.indexOf;
      return t === ag || rg(ag, t) && e === ag.indexOf ? sg : e;
    },
    lg = i(hg),
    dg = Tv.entries;
  Ti({
    target: "Object",
    stat: !0
  }, {
    entries: function entries(t) {
      return dg(t);
    }
  });
  var cg = i(et.Object.entries);
  Ti({
    target: "Object",
    stat: !0,
    sham: !M
  }, {
    create: mr
  });
  var ug = et.Object,
    fg = function fg(t, e) {
      return ug.create(t, e);
    },
    pg = i(fg),
    vg = et,
    gg = c;
  vg.JSON || (vg.JSON = {
    stringify: JSON.stringify
  });
  var yg = function yg(t, e, i) {
      return gg(vg.JSON.stringify, null, arguments);
    },
    mg = i(yg),
    bg = "function" == typeof Bun && Bun && "string" == typeof Bun.version,
    wg = TypeError,
    kg = function kg(t, e) {
      if (t < e) throw new wg("Not enough arguments");
      return t;
    },
    _g = o,
    xg = c,
    Eg = S,
    Og = bg,
    Cg = ht,
    Sg = wn,
    Tg = kg,
    Mg = _g.Function,
    Pg = /MSIE .\./.test(Cg) || Og && function () {
      var t = _g.Bun.version.split(".");
      return t.length < 3 || "0" === t[0] && (t[1] < 3 || "3" === t[1] && "0" === t[2]);
    }(),
    Dg = function Dg(t, e) {
      var i = e ? 2 : 1;
      return Pg ? function (n, o) {
        var r = Tg(arguments.length, 1) > i,
          s = Eg(n) ? n : Mg(n),
          a = r ? Sg(arguments, i) : [],
          h = r ? function () {
            xg(s, this, a);
          } : s;
        return e ? t(h, o) : t(h);
      } : t;
    },
    Ig = Ti,
    Bg = o,
    Ng = Dg(Bg.setInterval, !0);
  Ig({
    global: !0,
    bind: !0,
    forced: Bg.setInterval !== Ng
  }, {
    setInterval: Ng
  });
  var Fg = Ti,
    zg = o,
    Ag = Dg(zg.setTimeout, !0);
  Fg({
    global: !0,
    bind: !0,
    forced: zg.setTimeout !== Ag
  }, {
    setTimeout: Ag
  });
  var jg = i(et.setTimeout),
    Rg = Kt,
    Lg = zi,
    Hg = Li,
    Wg = function Wg(t) {
      for (var e = Rg(this), i = Hg(e), n = arguments.length, o = Lg(n > 1 ? arguments[1] : void 0, i), r = n > 2 ? arguments[2] : void 0, s = void 0 === r ? i : Lg(r, i); s > o;) e[o++] = t;
      return e;
    };
  Ti({
    target: "Array",
    proto: !0
  }, {
    fill: Wg
  });
  var qg,
    Vg = Nn("Array").fill,
    Ug = at,
    Yg = Vg,
    Xg = Array.prototype,
    Gg = function Gg(t) {
      var e = t.fill;
      return t === Xg || Ug(Xg, t) && e === Xg.fill ? Yg : e;
    },
    Kg = i(Gg);
  function $g() {
    return $g = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var i = arguments[e];
        for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
      }
      return t;
    }, $g.apply(this, arguments);
  }
  function Zg(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
  }
  function Qg(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  qg = "function" != typeof Object.assign ? function (t) {
    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
    for (var e = Object(t), i = 1; i < arguments.length; i++) {
      var n = arguments[i];
      if (null != n) for (var o in n) n.hasOwnProperty(o) && (e[o] = n[o]);
    }
    return e;
  } : Object.assign;
  var Jg,
    ty = qg,
    ey = ["", "webkit", "Moz", "MS", "ms", "o"],
    iy = "undefined" == typeof document ? {
      style: {}
    } : document.createElement("div"),
    ny = Math.round,
    oy = Math.abs,
    ry = Date.now;
  function sy(t, e) {
    for (var i, n, o = e[0].toUpperCase() + e.slice(1), r = 0; r < ey.length;) {
      if ((n = (i = ey[r]) ? i + o : e) in t) return n;
      r++;
    }
  }
  Jg = "undefined" == typeof window ? {} : window;
  var ay = sy(iy.style, "touchAction"),
    hy = void 0 !== ay;
  var ly = "compute",
    dy = "auto",
    cy = "manipulation",
    uy = "none",
    fy = "pan-x",
    py = "pan-y",
    vy = function () {
      if (!hy) return !1;
      var t = {},
        e = Jg.CSS && Jg.CSS.supports;
      return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function (i) {
        return t[i] = !e || Jg.CSS.supports("touch-action", i);
      }), t;
    }(),
    gy = ("ontouchstart" in Jg),
    yy = void 0 !== sy(Jg, "PointerEvent"),
    my = gy && /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),
    by = "touch",
    wy = "mouse",
    ky = 25,
    _y = 1,
    xy = 4,
    Ey = 8,
    Oy = 1,
    Cy = 2,
    Sy = 4,
    Ty = 8,
    My = 16,
    Py = Cy | Sy,
    Dy = Ty | My,
    Iy = Py | Dy,
    By = ["x", "y"],
    Ny = ["clientX", "clientY"];
  function Fy(t, e, i) {
    var n;
    if (t) if (t.forEach) t.forEach(e, i);else if (void 0 !== t.length) for (n = 0; n < t.length;) e.call(i, t[n], n, t), n++;else for (n in t) t.hasOwnProperty(n) && e.call(i, t[n], n, t);
  }
  function zy(t, e) {
    return "function" == typeof t ? t.apply(e && e[0] || void 0, e) : t;
  }
  function Ay(t, e) {
    return t.indexOf(e) > -1;
  }
  var jy = function () {
    function t(t, e) {
      this.manager = t, this.set(e);
    }
    var e = t.prototype;
    return e.set = function (t) {
      t === ly && (t = this.compute()), hy && this.manager.element.style && vy[t] && (this.manager.element.style[ay] = t), this.actions = t.toLowerCase().trim();
    }, e.update = function () {
      this.set(this.manager.options.touchAction);
    }, e.compute = function () {
      var t = [];
      return Fy(this.manager.recognizers, function (e) {
        zy(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()));
      }), function (t) {
        if (Ay(t, uy)) return uy;
        var e = Ay(t, fy),
          i = Ay(t, py);
        return e && i ? uy : e || i ? e ? fy : py : Ay(t, cy) ? cy : dy;
      }(t.join(" "));
    }, e.preventDefaults = function (t) {
      var e = t.srcEvent,
        i = t.offsetDirection;
      if (this.manager.session.prevented) e.preventDefault();else {
        var n = this.actions,
          o = Ay(n, uy) && !vy[uy],
          r = Ay(n, py) && !vy[py],
          s = Ay(n, fy) && !vy[fy];
        if (o) {
          var a = 1 === t.pointers.length,
            h = t.distance < 2,
            l = t.deltaTime < 250;
          if (a && h && l) return;
        }
        if (!s || !r) return o || r && i & Py || s && i & Dy ? this.preventSrc(e) : void 0;
      }
    }, e.preventSrc = function (t) {
      this.manager.session.prevented = !0, t.preventDefault();
    }, t;
  }();
  function Ry(t, e) {
    for (; t;) {
      if (t === e) return !0;
      t = t.parentNode;
    }
    return !1;
  }
  function Ly(t) {
    var e = t.length;
    if (1 === e) return {
      x: ny(t[0].clientX),
      y: ny(t[0].clientY)
    };
    for (var i = 0, n = 0, o = 0; o < e;) i += t[o].clientX, n += t[o].clientY, o++;
    return {
      x: ny(i / e),
      y: ny(n / e)
    };
  }
  function Hy(t) {
    for (var e = [], i = 0; i < t.pointers.length;) e[i] = {
      clientX: ny(t.pointers[i].clientX),
      clientY: ny(t.pointers[i].clientY)
    }, i++;
    return {
      timeStamp: ry(),
      pointers: e,
      center: Ly(e),
      deltaX: t.deltaX,
      deltaY: t.deltaY
    };
  }
  function Wy(t, e, i) {
    i || (i = By);
    var n = e[i[0]] - t[i[0]],
      o = e[i[1]] - t[i[1]];
    return Math.sqrt(n * n + o * o);
  }
  function qy(t, e, i) {
    i || (i = By);
    var n = e[i[0]] - t[i[0]],
      o = e[i[1]] - t[i[1]];
    return 180 * Math.atan2(o, n) / Math.PI;
  }
  function Vy(t, e) {
    return t === e ? Oy : oy(t) >= oy(e) ? t < 0 ? Cy : Sy : e < 0 ? Ty : My;
  }
  function Uy(t, e, i) {
    return {
      x: e / t || 0,
      y: i / t || 0
    };
  }
  function Yy(t, e) {
    var i = t.session,
      n = e.pointers,
      o = n.length;
    i.firstInput || (i.firstInput = Hy(e)), o > 1 && !i.firstMultiple ? i.firstMultiple = Hy(e) : 1 === o && (i.firstMultiple = !1);
    var r = i.firstInput,
      s = i.firstMultiple,
      a = s ? s.center : r.center,
      h = e.center = Ly(n);
    e.timeStamp = ry(), e.deltaTime = e.timeStamp - r.timeStamp, e.angle = qy(a, h), e.distance = Wy(a, h), function (t, e) {
      var i = e.center,
        n = t.offsetDelta || {},
        o = t.prevDelta || {},
        r = t.prevInput || {};
      e.eventType !== _y && r.eventType !== xy || (o = t.prevDelta = {
        x: r.deltaX || 0,
        y: r.deltaY || 0
      }, n = t.offsetDelta = {
        x: i.x,
        y: i.y
      }), e.deltaX = o.x + (i.x - n.x), e.deltaY = o.y + (i.y - n.y);
    }(i, e), e.offsetDirection = Vy(e.deltaX, e.deltaY);
    var l,
      d,
      c = Uy(e.deltaTime, e.deltaX, e.deltaY);
    e.overallVelocityX = c.x, e.overallVelocityY = c.y, e.overallVelocity = oy(c.x) > oy(c.y) ? c.x : c.y, e.scale = s ? (l = s.pointers, Wy((d = n)[0], d[1], Ny) / Wy(l[0], l[1], Ny)) : 1, e.rotation = s ? function (t, e) {
      return qy(e[1], e[0], Ny) + qy(t[1], t[0], Ny);
    }(s.pointers, n) : 0, e.maxPointers = i.prevInput ? e.pointers.length > i.prevInput.maxPointers ? e.pointers.length : i.prevInput.maxPointers : e.pointers.length, function (t, e) {
      var i,
        n,
        o,
        r,
        s = t.lastInterval || e,
        a = e.timeStamp - s.timeStamp;
      if (e.eventType !== Ey && (a > ky || void 0 === s.velocity)) {
        var h = e.deltaX - s.deltaX,
          l = e.deltaY - s.deltaY,
          d = Uy(a, h, l);
        n = d.x, o = d.y, i = oy(d.x) > oy(d.y) ? d.x : d.y, r = Vy(h, l), t.lastInterval = e;
      } else i = s.velocity, n = s.velocityX, o = s.velocityY, r = s.direction;
      e.velocity = i, e.velocityX = n, e.velocityY = o, e.direction = r;
    }(i, e);
    var u,
      f = t.element,
      p = e.srcEvent;
    Ry(u = p.composedPath ? p.composedPath()[0] : p.path ? p.path[0] : p.target, f) && (f = u), e.target = f;
  }
  function Xy(t, e, i) {
    var n = i.pointers.length,
      o = i.changedPointers.length,
      r = e & _y && n - o == 0,
      s = e & (xy | Ey) && n - o == 0;
    i.isFirst = !!r, i.isFinal = !!s, r && (t.session = {}), i.eventType = e, Yy(t, i), t.emit("hammer.input", i), t.recognize(i), t.session.prevInput = i;
  }
  function Gy(t) {
    return t.trim().split(/\s+/g);
  }
  function Ky(t, e, i) {
    Fy(Gy(e), function (e) {
      t.addEventListener(e, i, !1);
    });
  }
  function $y(t, e, i) {
    Fy(Gy(e), function (e) {
      t.removeEventListener(e, i, !1);
    });
  }
  function Zy(t) {
    var e = t.ownerDocument || t;
    return e.defaultView || e.parentWindow || window;
  }
  var Qy = function () {
    function t(t, e) {
      var i = this;
      this.manager = t, this.callback = e, this.element = t.element, this.target = t.options.inputTarget, this.domHandler = function (e) {
        zy(t.options.enable, [t]) && i.handler(e);
      }, this.init();
    }
    var e = t.prototype;
    return e.handler = function () {}, e.init = function () {
      this.evEl && Ky(this.element, this.evEl, this.domHandler), this.evTarget && Ky(this.target, this.evTarget, this.domHandler), this.evWin && Ky(Zy(this.element), this.evWin, this.domHandler);
    }, e.destroy = function () {
      this.evEl && $y(this.element, this.evEl, this.domHandler), this.evTarget && $y(this.target, this.evTarget, this.domHandler), this.evWin && $y(Zy(this.element), this.evWin, this.domHandler);
    }, t;
  }();
  function Jy(t, e, i) {
    if (t.indexOf && !i) return t.indexOf(e);
    for (var n = 0; n < t.length;) {
      if (i && t[n][i] == e || !i && t[n] === e) return n;
      n++;
    }
    return -1;
  }
  var tm = {
      pointerdown: _y,
      pointermove: 2,
      pointerup: xy,
      pointercancel: Ey,
      pointerout: Ey
    },
    em = {
      2: by,
      3: "pen",
      4: wy,
      5: "kinect"
    },
    im = "pointerdown",
    nm = "pointermove pointerup pointercancel";
  Jg.MSPointerEvent && !Jg.PointerEvent && (im = "MSPointerDown", nm = "MSPointerMove MSPointerUp MSPointerCancel");
  var om = function (t) {
    function e() {
      var i,
        n = e.prototype;
      return n.evEl = im, n.evWin = nm, (i = t.apply(this, arguments) || this).store = i.manager.session.pointerEvents = [], i;
    }
    return Zg(e, t), e.prototype.handler = function (t) {
      var e = this.store,
        i = !1,
        n = t.type.toLowerCase().replace("ms", ""),
        o = tm[n],
        r = em[t.pointerType] || t.pointerType,
        s = r === by,
        a = Jy(e, t.pointerId, "pointerId");
      o & _y && (0 === t.button || s) ? a < 0 && (e.push(t), a = e.length - 1) : o & (xy | Ey) && (i = !0), a < 0 || (e[a] = t, this.callback(this.manager, o, {
        pointers: e,
        changedPointers: [t],
        pointerType: r,
        srcEvent: t
      }), i && e.splice(a, 1));
    }, e;
  }(Qy);
  function rm(t) {
    return Array.prototype.slice.call(t, 0);
  }
  function sm(t, e, i) {
    for (var n = [], o = [], r = 0; r < t.length;) {
      var s = e ? t[r][e] : t[r];
      Jy(o, s) < 0 && n.push(t[r]), o[r] = s, r++;
    }
    return i && (n = e ? n.sort(function (t, i) {
      return t[e] > i[e];
    }) : n.sort()), n;
  }
  var am = {
      touchstart: _y,
      touchmove: 2,
      touchend: xy,
      touchcancel: Ey
    },
    hm = function (t) {
      function e() {
        var i;
        return e.prototype.evTarget = "touchstart touchmove touchend touchcancel", (i = t.apply(this, arguments) || this).targetIds = {}, i;
      }
      return Zg(e, t), e.prototype.handler = function (t) {
        var e = am[t.type],
          i = lm.call(this, t, e);
        i && this.callback(this.manager, e, {
          pointers: i[0],
          changedPointers: i[1],
          pointerType: by,
          srcEvent: t
        });
      }, e;
    }(Qy);
  function lm(t, e) {
    var i,
      n,
      o = rm(t.touches),
      r = this.targetIds;
    if (e & (2 | _y) && 1 === o.length) return r[o[0].identifier] = !0, [o, o];
    var s = rm(t.changedTouches),
      a = [],
      h = this.target;
    if (n = o.filter(function (t) {
      return Ry(t.target, h);
    }), e === _y) for (i = 0; i < n.length;) r[n[i].identifier] = !0, i++;
    for (i = 0; i < s.length;) r[s[i].identifier] && a.push(s[i]), e & (xy | Ey) && delete r[s[i].identifier], i++;
    return a.length ? [sm(n.concat(a), "identifier", !0), a] : void 0;
  }
  var dm = {
      mousedown: _y,
      mousemove: 2,
      mouseup: xy
    },
    cm = function (t) {
      function e() {
        var i,
          n = e.prototype;
        return n.evEl = "mousedown", n.evWin = "mousemove mouseup", (i = t.apply(this, arguments) || this).pressed = !1, i;
      }
      return Zg(e, t), e.prototype.handler = function (t) {
        var e = dm[t.type];
        e & _y && 0 === t.button && (this.pressed = !0), 2 & e && 1 !== t.which && (e = xy), this.pressed && (e & xy && (this.pressed = !1), this.callback(this.manager, e, {
          pointers: [t],
          changedPointers: [t],
          pointerType: wy,
          srcEvent: t
        }));
      }, e;
    }(Qy),
    um = 2500;
  function fm(t) {
    var e = t.changedPointers[0];
    if (e.identifier === this.primaryTouch) {
      var i = {
          x: e.clientX,
          y: e.clientY
        },
        n = this.lastTouches;
      this.lastTouches.push(i);
      setTimeout(function () {
        var t = n.indexOf(i);
        t > -1 && n.splice(t, 1);
      }, um);
    }
  }
  function pm(t, e) {
    t & _y ? (this.primaryTouch = e.changedPointers[0].identifier, fm.call(this, e)) : t & (xy | Ey) && fm.call(this, e);
  }
  function vm(t) {
    for (var e = t.srcEvent.clientX, i = t.srcEvent.clientY, n = 0; n < this.lastTouches.length; n++) {
      var o = this.lastTouches[n],
        r = Math.abs(e - o.x),
        s = Math.abs(i - o.y);
      if (r <= 25 && s <= 25) return !0;
    }
    return !1;
  }
  var gm = function () {
    return function (t) {
      function e(e, i) {
        var n;
        return (n = t.call(this, e, i) || this).handler = function (t, e, i) {
          var o = i.pointerType === by,
            r = i.pointerType === wy;
          if (!(r && i.sourceCapabilities && i.sourceCapabilities.firesTouchEvents)) {
            if (o) pm.call(Qg(Qg(n)), e, i);else if (r && vm.call(Qg(Qg(n)), i)) return;
            n.callback(t, e, i);
          }
        }, n.touch = new hm(n.manager, n.handler), n.mouse = new cm(n.manager, n.handler), n.primaryTouch = null, n.lastTouches = [], n;
      }
      return Zg(e, t), e.prototype.destroy = function () {
        this.touch.destroy(), this.mouse.destroy();
      }, e;
    }(Qy);
  }();
  function ym(t, e, i) {
    return !!Array.isArray(t) && (Fy(t, i[e], i), !0);
  }
  var mm = 32,
    bm = 1;
  function wm(t, e) {
    var i = e.manager;
    return i ? i.get(t) : t;
  }
  function km(t) {
    return 16 & t ? "cancel" : 8 & t ? "end" : 4 & t ? "move" : 2 & t ? "start" : "";
  }
  var _m = function () {
      function t(t) {
        void 0 === t && (t = {}), this.options = $g({
          enable: !0
        }, t), this.id = bm++, this.manager = null, this.state = 1, this.simultaneous = {}, this.requireFail = [];
      }
      var e = t.prototype;
      return e.set = function (t) {
        return ty(this.options, t), this.manager && this.manager.touchAction.update(), this;
      }, e.recognizeWith = function (t) {
        if (ym(t, "recognizeWith", this)) return this;
        var e = this.simultaneous;
        return e[(t = wm(t, this)).id] || (e[t.id] = t, t.recognizeWith(this)), this;
      }, e.dropRecognizeWith = function (t) {
        return ym(t, "dropRecognizeWith", this) || (t = wm(t, this), delete this.simultaneous[t.id]), this;
      }, e.requireFailure = function (t) {
        if (ym(t, "requireFailure", this)) return this;
        var e = this.requireFail;
        return -1 === Jy(e, t = wm(t, this)) && (e.push(t), t.requireFailure(this)), this;
      }, e.dropRequireFailure = function (t) {
        if (ym(t, "dropRequireFailure", this)) return this;
        t = wm(t, this);
        var e = Jy(this.requireFail, t);
        return e > -1 && this.requireFail.splice(e, 1), this;
      }, e.hasRequireFailures = function () {
        return this.requireFail.length > 0;
      }, e.canRecognizeWith = function (t) {
        return !!this.simultaneous[t.id];
      }, e.emit = function (t) {
        var e = this,
          i = this.state;
        function n(i) {
          e.manager.emit(i, t);
        }
        i < 8 && n(e.options.event + km(i)), n(e.options.event), t.additionalEvent && n(t.additionalEvent), i >= 8 && n(e.options.event + km(i));
      }, e.tryEmit = function (t) {
        if (this.canEmit()) return this.emit(t);
        this.state = mm;
      }, e.canEmit = function () {
        for (var t = 0; t < this.requireFail.length;) {
          if (!(33 & this.requireFail[t].state)) return !1;
          t++;
        }
        return !0;
      }, e.recognize = function (t) {
        var e = ty({}, t);
        if (!zy(this.options.enable, [this, e])) return this.reset(), void (this.state = mm);
        56 & this.state && (this.state = 1), this.state = this.process(e), 30 & this.state && this.tryEmit(e);
      }, e.process = function (t) {}, e.getTouchAction = function () {}, e.reset = function () {}, t;
    }(),
    xm = function (t) {
      function e(e) {
        var i;
        return void 0 === e && (e = {}), (i = t.call(this, $g({
          event: "tap",
          pointers: 1,
          taps: 1,
          interval: 300,
          time: 250,
          threshold: 9,
          posThreshold: 10
        }, e)) || this).pTime = !1, i.pCenter = !1, i._timer = null, i._input = null, i.count = 0, i;
      }
      Zg(e, t);
      var i = e.prototype;
      return i.getTouchAction = function () {
        return [cy];
      }, i.process = function (t) {
        var e = this,
          i = this.options,
          n = t.pointers.length === i.pointers,
          o = t.distance < i.threshold,
          r = t.deltaTime < i.time;
        if (this.reset(), t.eventType & _y && 0 === this.count) return this.failTimeout();
        if (o && r && n) {
          if (t.eventType !== xy) return this.failTimeout();
          var s = !this.pTime || t.timeStamp - this.pTime < i.interval,
            a = !this.pCenter || Wy(this.pCenter, t.center) < i.posThreshold;
          if (this.pTime = t.timeStamp, this.pCenter = t.center, a && s ? this.count += 1 : this.count = 1, this._input = t, 0 === this.count % i.taps) return this.hasRequireFailures() ? (this._timer = setTimeout(function () {
            e.state = 8, e.tryEmit();
          }, i.interval), 2) : 8;
        }
        return mm;
      }, i.failTimeout = function () {
        var t = this;
        return this._timer = setTimeout(function () {
          t.state = mm;
        }, this.options.interval), mm;
      }, i.reset = function () {
        clearTimeout(this._timer);
      }, i.emit = function () {
        8 === this.state && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
      }, e;
    }(_m),
    Em = function (t) {
      function e(e) {
        return void 0 === e && (e = {}), t.call(this, $g({
          pointers: 1
        }, e)) || this;
      }
      Zg(e, t);
      var i = e.prototype;
      return i.attrTest = function (t) {
        var e = this.options.pointers;
        return 0 === e || t.pointers.length === e;
      }, i.process = function (t) {
        var e = this.state,
          i = t.eventType,
          n = 6 & e,
          o = this.attrTest(t);
        return n && (i & Ey || !o) ? 16 | e : n || o ? i & xy ? 8 | e : 2 & e ? 4 | e : 2 : mm;
      }, e;
    }(_m);
  function Om(t) {
    return t === My ? "down" : t === Ty ? "up" : t === Cy ? "left" : t === Sy ? "right" : "";
  }
  var Cm = function (t) {
      function e(e) {
        var i;
        return void 0 === e && (e = {}), (i = t.call(this, $g({
          event: "pan",
          threshold: 10,
          pointers: 1,
          direction: Iy
        }, e)) || this).pX = null, i.pY = null, i;
      }
      Zg(e, t);
      var i = e.prototype;
      return i.getTouchAction = function () {
        var t = this.options.direction,
          e = [];
        return t & Py && e.push(py), t & Dy && e.push(fy), e;
      }, i.directionTest = function (t) {
        var e = this.options,
          i = !0,
          n = t.distance,
          o = t.direction,
          r = t.deltaX,
          s = t.deltaY;
        return o & e.direction || (e.direction & Py ? (o = 0 === r ? Oy : r < 0 ? Cy : Sy, i = r !== this.pX, n = Math.abs(t.deltaX)) : (o = 0 === s ? Oy : s < 0 ? Ty : My, i = s !== this.pY, n = Math.abs(t.deltaY))), t.direction = o, i && n > e.threshold && o & e.direction;
      }, i.attrTest = function (t) {
        return Em.prototype.attrTest.call(this, t) && (2 & this.state || !(2 & this.state) && this.directionTest(t));
      }, i.emit = function (e) {
        this.pX = e.deltaX, this.pY = e.deltaY;
        var i = Om(e.direction);
        i && (e.additionalEvent = this.options.event + i), t.prototype.emit.call(this, e);
      }, e;
    }(Em),
    Sm = function (t) {
      function e(e) {
        return void 0 === e && (e = {}), t.call(this, $g({
          event: "swipe",
          threshold: 10,
          velocity: .3,
          direction: Py | Dy,
          pointers: 1
        }, e)) || this;
      }
      Zg(e, t);
      var i = e.prototype;
      return i.getTouchAction = function () {
        return Cm.prototype.getTouchAction.call(this);
      }, i.attrTest = function (e) {
        var i,
          n = this.options.direction;
        return n & (Py | Dy) ? i = e.overallVelocity : n & Py ? i = e.overallVelocityX : n & Dy && (i = e.overallVelocityY), t.prototype.attrTest.call(this, e) && n & e.offsetDirection && e.distance > this.options.threshold && e.maxPointers === this.options.pointers && oy(i) > this.options.velocity && e.eventType & xy;
      }, i.emit = function (t) {
        var e = Om(t.offsetDirection);
        e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t);
      }, e;
    }(Em),
    Tm = function (t) {
      function e(e) {
        return void 0 === e && (e = {}), t.call(this, $g({
          event: "pinch",
          threshold: 0,
          pointers: 2
        }, e)) || this;
      }
      Zg(e, t);
      var i = e.prototype;
      return i.getTouchAction = function () {
        return [uy];
      }, i.attrTest = function (e) {
        return t.prototype.attrTest.call(this, e) && (Math.abs(e.scale - 1) > this.options.threshold || 2 & this.state);
      }, i.emit = function (e) {
        if (1 !== e.scale) {
          var i = e.scale < 1 ? "in" : "out";
          e.additionalEvent = this.options.event + i;
        }
        t.prototype.emit.call(this, e);
      }, e;
    }(Em),
    Mm = function (t) {
      function e(e) {
        return void 0 === e && (e = {}), t.call(this, $g({
          event: "rotate",
          threshold: 0,
          pointers: 2
        }, e)) || this;
      }
      Zg(e, t);
      var i = e.prototype;
      return i.getTouchAction = function () {
        return [uy];
      }, i.attrTest = function (e) {
        return t.prototype.attrTest.call(this, e) && (Math.abs(e.rotation) > this.options.threshold || 2 & this.state);
      }, e;
    }(Em),
    Pm = function (t) {
      function e(e) {
        var i;
        return void 0 === e && (e = {}), (i = t.call(this, $g({
          event: "press",
          pointers: 1,
          time: 251,
          threshold: 9
        }, e)) || this)._timer = null, i._input = null, i;
      }
      Zg(e, t);
      var i = e.prototype;
      return i.getTouchAction = function () {
        return [dy];
      }, i.process = function (t) {
        var e = this,
          i = this.options,
          n = t.pointers.length === i.pointers,
          o = t.distance < i.threshold,
          r = t.deltaTime > i.time;
        if (this._input = t, !o || !n || t.eventType & (xy | Ey) && !r) this.reset();else if (t.eventType & _y) this.reset(), this._timer = setTimeout(function () {
          e.state = 8, e.tryEmit();
        }, i.time);else if (t.eventType & xy) return 8;
        return mm;
      }, i.reset = function () {
        clearTimeout(this._timer);
      }, i.emit = function (t) {
        8 === this.state && (t && t.eventType & xy ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = ry(), this.manager.emit(this.options.event, this._input)));
      }, e;
    }(_m),
    Dm = {
      domEvents: !1,
      touchAction: ly,
      enable: !0,
      inputTarget: null,
      inputClass: null,
      cssProps: {
        userSelect: "none",
        touchSelect: "none",
        touchCallout: "none",
        contentZooming: "none",
        userDrag: "none",
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    },
    Im = [[Mm, {
      enable: !1
    }], [Tm, {
      enable: !1
    }, ["rotate"]], [Sm, {
      direction: Py
    }], [Cm, {
      direction: Py
    }, ["swipe"]], [xm], [xm, {
      event: "doubletap",
      taps: 2
    }, ["tap"]], [Pm]];
  function Bm(t, e) {
    var i,
      n = t.element;
    n.style && (Fy(t.options.cssProps, function (o, r) {
      i = sy(n.style, r), e ? (t.oldCssProps[i] = n.style[i], n.style[i] = o) : n.style[i] = t.oldCssProps[i] || "";
    }), e || (t.oldCssProps = {}));
  }
  var Nm = function () {
      function t(t, e) {
        var i,
          n = this;
        this.options = ty({}, Dm, e || {}), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = t, this.input = new ((i = this).options.inputClass || (yy ? om : my ? hm : gy ? gm : cm))(i, Xy), this.touchAction = new jy(this, this.options.touchAction), Bm(this, !0), Fy(this.options.recognizers, function (t) {
          var e = n.add(new t[0](t[1]));
          t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3]);
        }, this);
      }
      var e = t.prototype;
      return e.set = function (t) {
        return ty(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this;
      }, e.stop = function (t) {
        this.session.stopped = t ? 2 : 1;
      }, e.recognize = function (t) {
        var e = this.session;
        if (!e.stopped) {
          var i;
          this.touchAction.preventDefaults(t);
          var n = this.recognizers,
            o = e.curRecognizer;
          (!o || o && 8 & o.state) && (e.curRecognizer = null, o = null);
          for (var r = 0; r < n.length;) i = n[r], 2 === e.stopped || o && i !== o && !i.canRecognizeWith(o) ? i.reset() : i.recognize(t), !o && 14 & i.state && (e.curRecognizer = i, o = i), r++;
        }
      }, e.get = function (t) {
        if (t instanceof _m) return t;
        for (var e = this.recognizers, i = 0; i < e.length; i++) if (e[i].options.event === t) return e[i];
        return null;
      }, e.add = function (t) {
        if (ym(t, "add", this)) return this;
        var e = this.get(t.options.event);
        return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t;
      }, e.remove = function (t) {
        if (ym(t, "remove", this)) return this;
        var e = this.get(t);
        if (t) {
          var i = this.recognizers,
            n = Jy(i, e);
          -1 !== n && (i.splice(n, 1), this.touchAction.update());
        }
        return this;
      }, e.on = function (t, e) {
        if (void 0 === t || void 0 === e) return this;
        var i = this.handlers;
        return Fy(Gy(t), function (t) {
          i[t] = i[t] || [], i[t].push(e);
        }), this;
      }, e.off = function (t, e) {
        if (void 0 === t) return this;
        var i = this.handlers;
        return Fy(Gy(t), function (t) {
          e ? i[t] && i[t].splice(Jy(i[t], e), 1) : delete i[t];
        }), this;
      }, e.emit = function (t, e) {
        this.options.domEvents && function (t, e) {
          var i = document.createEvent("Event");
          i.initEvent(t, !0, !0), i.gesture = e, e.target.dispatchEvent(i);
        }(t, e);
        var i = this.handlers[t] && this.handlers[t].slice();
        if (i && i.length) {
          e.type = t, e.preventDefault = function () {
            e.srcEvent.preventDefault();
          };
          for (var n = 0; n < i.length;) i[n](e), n++;
        }
      }, e.destroy = function () {
        this.element && Bm(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
      }, t;
    }(),
    Fm = {
      touchstart: _y,
      touchmove: 2,
      touchend: xy,
      touchcancel: Ey
    },
    zm = function (t) {
      function e() {
        var i,
          n = e.prototype;
        return n.evTarget = "touchstart", n.evWin = "touchstart touchmove touchend touchcancel", (i = t.apply(this, arguments) || this).started = !1, i;
      }
      return Zg(e, t), e.prototype.handler = function (t) {
        var e = Fm[t.type];
        if (e === _y && (this.started = !0), this.started) {
          var i = Am.call(this, t, e);
          e & (xy | Ey) && i[0].length - i[1].length == 0 && (this.started = !1), this.callback(this.manager, e, {
            pointers: i[0],
            changedPointers: i[1],
            pointerType: by,
            srcEvent: t
          });
        }
      }, e;
    }(Qy);
  function Am(t, e) {
    var i = rm(t.touches),
      n = rm(t.changedTouches);
    return e & (xy | Ey) && (i = sm(i.concat(n), "identifier", !0)), [i, n];
  }
  function jm(t, e, i) {
    var n = "DEPRECATED METHOD: " + e + "\n" + i + " AT \n";
    return function () {
      var e = new Error("get-stack-trace"),
        i = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace",
        o = window.console && (window.console.warn || window.console.log);
      return o && o.call(window.console, n, i), t.apply(this, arguments);
    };
  }
  var Rm = jm(function (t, e, i) {
      for (var n = Object.keys(e), o = 0; o < n.length;) (!i || i && void 0 === t[n[o]]) && (t[n[o]] = e[n[o]]), o++;
      return t;
    }, "extend", "Use `assign`."),
    Lm = jm(function (t, e) {
      return Rm(t, e, !0);
    }, "merge", "Use `assign`.");
  function Hm(t, e, i) {
    var n,
      o = e.prototype;
    (n = t.prototype = Object.create(o)).constructor = t, n._super = o, i && ty(n, i);
  }
  function Wm(t, e) {
    return function () {
      return t.apply(e, arguments);
    };
  }
  var qm = function () {
    var t = function t(_t2, e) {
      return void 0 === e && (e = {}), new Nm(_t2, $g({
        recognizers: Im.concat()
      }, e));
    };
    return t.VERSION = "2.0.17-rc", t.DIRECTION_ALL = Iy, t.DIRECTION_DOWN = My, t.DIRECTION_LEFT = Cy, t.DIRECTION_RIGHT = Sy, t.DIRECTION_UP = Ty, t.DIRECTION_HORIZONTAL = Py, t.DIRECTION_VERTICAL = Dy, t.DIRECTION_NONE = Oy, t.DIRECTION_DOWN = My, t.INPUT_START = _y, t.INPUT_MOVE = 2, t.INPUT_END = xy, t.INPUT_CANCEL = Ey, t.STATE_POSSIBLE = 1, t.STATE_BEGAN = 2, t.STATE_CHANGED = 4, t.STATE_ENDED = 8, t.STATE_RECOGNIZED = 8, t.STATE_CANCELLED = 16, t.STATE_FAILED = mm, t.Manager = Nm, t.Input = Qy, t.TouchAction = jy, t.TouchInput = hm, t.MouseInput = cm, t.PointerEventInput = om, t.TouchMouseInput = gm, t.SingleTouchInput = zm, t.Recognizer = _m, t.AttrRecognizer = Em, t.Tap = xm, t.Pan = Cm, t.Swipe = Sm, t.Pinch = Tm, t.Rotate = Mm, t.Press = Pm, t.on = Ky, t.off = $y, t.each = Fy, t.merge = Lm, t.extend = Rm, t.bindFn = Wm, t.assign = ty, t.inherit = Hm, t.bindFn = Wm, t.prefixed = sy, t.toArray = rm, t.inArray = Jy, t.uniqueArray = sm, t.splitStr = Gy, t.boolOrFn = zy, t.hasParent = Ry, t.addEventListeners = Ky, t.removeEventListeners = $y, t.defaults = ty({}, Dm, {
      preset: Im
    }), t;
  }();
  qm.defaults;
  var Vm = qm;
  function Um(t, e) {
    var i = void 0 !== gf && fh(t) || t["@@iterator"];
    if (!i) {
      if (Df(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return Ym(t, e);
        var n = xf(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Ya(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ym(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);
        var _n2 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n2 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n2++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r,
      s = !0,
      a = !1;
    return {
      s: function s() {
        i = i.call(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i["return"] || i["return"]();
        } finally {
          if (a) throw r;
        }
      }
    };
  }
  function Ym(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
    return n;
  }
  var Xm = gf("DELETE");
  function Gm(t) {
    for (var e, i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) n[o - 1] = arguments[o];
    return Km.apply(void 0, _f(e = [{}, t]).call(e, n));
  }
  function Km() {
    var t = $m.apply(void 0, arguments);
    return Qm(t), t;
  }
  function $m() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
    if (e.length < 2) return e[0];
    var n;
    if (e.length > 2) return $m.apply(void 0, _f(n = [Km(e[0], e[1])]).call(n, vf(xf(e).call(e, 2))));
    var o = e[0],
      r = e[1];
    if (o instanceof Date && r instanceof Date) return o.setTime(r.getTime()), o;
    var s,
      a = Um(Pf(r));
    try {
      for (a.s(); !(s = a.n()).done;) {
        var h = s.value;
        Object.prototype.propertyIsEnumerable.call(r, h) && (r[h] === Xm ? delete o[h] : null === o[h] || null === r[h] || "object" !== bu(o[h]) || "object" !== bu(r[h]) || Df(o[h]) || Df(r[h]) ? o[h] = Zm(r[h]) : o[h] = $m(o[h], r[h]));
      }
    } catch (t) {
      a.e(t);
    } finally {
      a.f();
    }
    return o;
  }
  function Zm(t) {
    return Df(t) ? jf(t).call(t, function (t) {
      return Zm(t);
    }) : "object" === bu(t) && null !== t ? t instanceof Date ? new Date(t.getTime()) : $m({}, t) : t;
  }
  function Qm(t) {
    for (var e = 0, i = Hf(t); e < i.length; e++) {
      var n = i[e];
      t[n] === Xm ? delete t[n] : "object" === bu(t[n]) && null !== t[n] && Qm(t[n]);
    }
  }
  function Jm() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
    return function (t) {
      var e = function () {
          for (var t = function () {
              var t = 4022871197;
              return function (e) {
                for (var i = e.toString(), n = 0; n < i.length; n++) {
                  var o = .02519603282416938 * (t += i.charCodeAt(n));
                  o -= t = o >>> 0, t = (o *= t) >>> 0, t += 4294967296 * (o -= t);
                }
                return 2.3283064365386963e-10 * (t >>> 0);
              };
            }(), e = t(" "), i = t(" "), n = t(" "), o = 0; o < arguments.length; o++) (e -= t(o < 0 || arguments.length <= o ? void 0 : arguments[o])) < 0 && (e += 1), (i -= t(o < 0 || arguments.length <= o ? void 0 : arguments[o])) < 0 && (i += 1), (n -= t(o < 0 || arguments.length <= o ? void 0 : arguments[o])) < 0 && (n += 1);
          return [e, i, n];
        }(t),
        i = pf(e, 3),
        n = i[0],
        o = i[1],
        r = i[2],
        s = 1,
        a = function a() {
          var t = 2091639 * n + 2.3283064365386963e-10 * s;
          return n = o, o = r, r = t - (s = 0 | t);
        };
      return a.uint32 = function () {
        return 4294967296 * a();
      }, a.fract53 = function () {
        return a() + 11102230246251565e-32 * (2097152 * a() | 0);
      }, a.algorithm = "Alea", a.seed = t, a.version = "0.9", a;
    }(e.length ? e : [Uf()]);
  }
  var tb = "undefined" != typeof window ? window.Hammer || Vm : function () {
    return function () {
      var t = function t() {};
      return {
        on: t,
        off: t,
        destroy: t,
        emit: t,
        get: function get() {
          return {
            set: t
          };
        }
      };
    }();
  };
  function eb(t) {
    var e,
      i = this;
    this._cleanupQueue = [], this.active = !1, this._dom = {
      container: t,
      overlay: document.createElement("div")
    }, this._dom.overlay.classList.add("vis-overlay"), this._dom.container.appendChild(this._dom.overlay), this._cleanupQueue.push(function () {
      i._dom.overlay.parentNode.removeChild(i._dom.overlay);
    });
    var n = tb(this._dom.overlay);
    n.on("tap", Hn(e = this._onTapOverlay).call(e, this)), this._cleanupQueue.push(function () {
      n.destroy();
    });
    var o = ["tap", "doubletap", "press", "pinch", "pan", "panstart", "panmove", "panend"];
    op(o).call(o, function (t) {
      n.on(t, function (t) {
        t.srcEvent.stopPropagation();
      });
    }), document && document.body && (this._onClick = function (e) {
      (function (t, e) {
        for (; t;) {
          if (t === e) return !0;
          t = t.parentNode;
        }
        return !1;
      })(e.target, t) || i.deactivate();
    }, document.body.addEventListener("click", this._onClick), this._cleanupQueue.push(function () {
      document.body.removeEventListener("click", i._onClick);
    })), this._escListener = function (t) {
      ("key" in t ? "Escape" === t.key : 27 === t.keyCode) && i.deactivate();
    };
  }
  Kn(eb.prototype), eb.current = null, eb.prototype.destroy = function () {
    var t, e;
    this.deactivate();
    var i,
      n = Um(vp(t = Ap(e = this._cleanupQueue).call(e, 0)).call(t));
    try {
      for (n.s(); !(i = n.n()).done;) {
        (0, i.value)();
      }
    } catch (t) {
      n.e(t);
    } finally {
      n.f();
    }
  }, eb.prototype.activate = function () {
    eb.current && eb.current.deactivate(), eb.current = this, this.active = !0, this._dom.overlay.style.display = "none", this._dom.container.classList.add("vis-active"), this.emit("change"), this.emit("activate"), document.body.addEventListener("keydown", this._escListener);
  }, eb.prototype.deactivate = function () {
    this.active = !1, this._dom.overlay.style.display = "block", this._dom.container.classList.remove("vis-active"), document.body.removeEventListener("keydown", this._escListener), this.emit("change"), this.emit("deactivate");
  }, eb.prototype._onTapOverlay = function (t) {
    this.activate(), t.srcEvent.stopPropagation();
  };
  var ib = /^\/?Date\((-?\d+)/i,
    nb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    ob = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    rb = /^rgb\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *\)$/i,
    sb = /^rgba\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *([01]|0?\.\d+) *\)$/i;
  function ab(t) {
    return t instanceof Number || "number" == typeof t;
  }
  function hb(t) {
    if (t) for (; !0 === t.hasChildNodes();) {
      var e = t.firstChild;
      e && (hb(e), t.removeChild(e));
    }
  }
  function lb(t) {
    return t instanceof String || "string" == typeof t;
  }
  function db(t) {
    return "object" === bu(t) && null !== t;
  }
  function cb(t, e, i, n) {
    var o = !1;
    !0 === n && (o = null === e[i] && void 0 !== t[i]), o ? delete t[i] : t[i] = e[i];
  }
  function ub(t, e) {
    var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
    for (var n in t) if (void 0 !== e[n]) if (null === e[n] || "object" !== bu(e[n])) cb(t, e, n, i);else {
      var o = t[n],
        r = e[n];
      db(o) && db(r) && ub(o, r, i);
    }
  }
  var fb = bn;
  function pb(t, e, i) {
    var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    if (Df(i)) throw new TypeError("Arrays are not supported by deepExtend");
    for (var o = 0; o < t.length; o++) {
      var r = t[o];
      if (Object.prototype.hasOwnProperty.call(i, r)) if (i[r] && i[r].constructor === Object) void 0 === e[r] && (e[r] = {}), e[r].constructor === Object ? gb(e[r], i[r], !1, n) : cb(e, i, r, n);else {
        if (Df(i[r])) throw new TypeError("Arrays are not supported by deepExtend");
        cb(e, i, r, n);
      }
    }
    return e;
  }
  function vb(t, e, i) {
    var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    if (Df(i)) throw new TypeError("Arrays are not supported by deepExtend");
    for (var o in i) if (Object.prototype.hasOwnProperty.call(i, o) && !rv(t).call(t, o)) if (i[o] && i[o].constructor === Object) void 0 === e[o] && (e[o] = {}), e[o].constructor === Object ? gb(e[o], i[o]) : cb(e, i, o, n);else if (Df(i[o])) {
      e[o] = [];
      for (var r = 0; r < i[o].length; r++) e[o].push(i[o][r]);
    } else cb(e, i, o, n);
    return e;
  }
  function gb(t, e) {
    var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
      n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    for (var o in e) if (Object.prototype.hasOwnProperty.call(e, o) || !0 === i) if ("object" === bu(e[o]) && null !== e[o] && dv(e[o]) === Object.prototype) void 0 === t[o] ? t[o] = gb({}, e[o], i) : "object" === bu(t[o]) && null !== t[o] && dv(t[o]) === Object.prototype ? gb(t[o], e[o], i) : cb(t, e, o, n);else if (Df(e[o])) {
      var r;
      t[o] = xf(r = e[o]).call(r);
    } else cb(t, e, o, n);
    return t;
  }
  function yb(t, e) {
    var i;
    return _f(i = []).call(i, vf(t), [e]);
  }
  function mb(t) {
    return xf(t).call(t);
  }
  function bb(t) {
    return t.getBoundingClientRect().left;
  }
  function wb(t) {
    return t.getBoundingClientRect().top;
  }
  function kb(t, e) {
    if (Df(t)) for (var i = t.length, n = 0; n < i; n++) e(t[n], n, t);else for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && e(t[o], o, t);
  }
  var _b = Pv;
  var xb = {
    asBoolean: function asBoolean(t, e) {
      return "function" == typeof t && (t = t()), null != t ? 0 != t : e || null;
    },
    asNumber: function asNumber(t, e) {
      return "function" == typeof t && (t = t()), null != t ? Number(t) || e || null : e || null;
    },
    asString: function asString(t, e) {
      return "function" == typeof t && (t = t()), null != t ? String(t) : e || null;
    },
    asSize: function asSize(t, e) {
      return "function" == typeof t && (t = t()), lb(t) ? t : ab(t) ? t + "px" : e || null;
    },
    asElement: function asElement(t, e) {
      return "function" == typeof t && (t = t()), t || e || null;
    }
  };
  function Eb(t) {
    var e;
    switch (t.length) {
      case 3:
      case 4:
        return (e = ob.exec(t)) ? {
          r: Qv(e[1] + e[1], 16),
          g: Qv(e[2] + e[2], 16),
          b: Qv(e[3] + e[3], 16)
        } : null;
      case 6:
      case 7:
        return (e = nb.exec(t)) ? {
          r: Qv(e[1], 16),
          g: Qv(e[2], 16),
          b: Qv(e[3], 16)
        } : null;
      default:
        return null;
    }
  }
  function Ob(t, e) {
    if (rv(t).call(t, "rgba")) return t;
    if (rv(t).call(t, "rgb")) {
      var i = t.substr(lg(t).call(t, "(") + 1).replace(")", "").split(",");
      return "rgba(" + i[0] + "," + i[1] + "," + i[2] + "," + e + ")";
    }
    var n = Eb(t);
    return null == n ? t : "rgba(" + n.r + "," + n.g + "," + n.b + "," + e + ")";
  }
  function Cb(t, e, i) {
    var n;
    return "#" + xf(n = ((1 << 24) + (t << 16) + (e << 8) + i).toString(16)).call(n, 1);
  }
  function Sb(t, e) {
    if (lb(t)) {
      var i = t;
      if (Nb(i)) {
        var n,
          o = jf(n = i.substr(4).substr(0, i.length - 5).split(",")).call(n, function (t) {
            return Qv(t);
          });
        i = Cb(o[0], o[1], o[2]);
      }
      if (!0 === Bb(i)) {
        var r = Ib(i),
          s = {
            h: r.h,
            s: .8 * r.s,
            v: Math.min(1, 1.02 * r.v)
          },
          a = {
            h: r.h,
            s: Math.min(1, 1.25 * r.s),
            v: .8 * r.v
          },
          h = Db(a.h, a.s, a.v),
          l = Db(s.h, s.s, s.v);
        return {
          background: i,
          border: h,
          highlight: {
            background: l,
            border: h
          },
          hover: {
            background: l,
            border: h
          }
        };
      }
      return {
        background: i,
        border: i,
        highlight: {
          background: i,
          border: i
        },
        hover: {
          background: i,
          border: i
        }
      };
    }
    return e ? {
      background: t.background || e.background,
      border: t.border || e.border,
      highlight: lb(t.highlight) ? {
        border: t.highlight,
        background: t.highlight
      } : {
        background: t.highlight && t.highlight.background || e.highlight.background,
        border: t.highlight && t.highlight.border || e.highlight.border
      },
      hover: lb(t.hover) ? {
        border: t.hover,
        background: t.hover
      } : {
        border: t.hover && t.hover.border || e.hover.border,
        background: t.hover && t.hover.background || e.hover.background
      }
    } : {
      background: t.background || void 0,
      border: t.border || void 0,
      highlight: lb(t.highlight) ? {
        border: t.highlight,
        background: t.highlight
      } : {
        background: t.highlight && t.highlight.background || void 0,
        border: t.highlight && t.highlight.border || void 0
      },
      hover: lb(t.hover) ? {
        border: t.hover,
        background: t.hover
      } : {
        border: t.hover && t.hover.border || void 0,
        background: t.hover && t.hover.background || void 0
      }
    };
  }
  function Tb(t, e, i) {
    t /= 255, e /= 255, i /= 255;
    var n = Math.min(t, Math.min(e, i)),
      o = Math.max(t, Math.max(e, i));
    return n === o ? {
      h: 0,
      s: 0,
      v: n
    } : {
      h: 60 * ((t === n ? 3 : i === n ? 1 : 5) - (t === n ? e - i : i === n ? t - e : i - t) / (o - n)) / 360,
      s: (o - n) / o,
      v: o
    };
  }
  function Mb(t) {
    var e = document.createElement("div"),
      i = {};
    e.style.cssText = t;
    for (var n = 0; n < e.style.length; ++n) i[e.style[n]] = e.style.getPropertyValue(e.style[n]);
    return i;
  }
  function Pb(t, e, i) {
    var n,
      o,
      r,
      s = Math.floor(6 * t),
      a = 6 * t - s,
      h = i * (1 - e),
      l = i * (1 - a * e),
      d = i * (1 - (1 - a) * e);
    switch (s % 6) {
      case 0:
        n = i, o = d, r = h;
        break;
      case 1:
        n = l, o = i, r = h;
        break;
      case 2:
        n = h, o = i, r = d;
        break;
      case 3:
        n = h, o = l, r = i;
        break;
      case 4:
        n = d, o = h, r = i;
        break;
      case 5:
        n = i, o = h, r = l;
    }
    return {
      r: Math.floor(255 * n),
      g: Math.floor(255 * o),
      b: Math.floor(255 * r)
    };
  }
  function Db(t, e, i) {
    var n = Pb(t, e, i);
    return Cb(n.r, n.g, n.b);
  }
  function Ib(t) {
    var e = Eb(t);
    if (!e) throw new TypeError("'".concat(t, "' is not a valid color."));
    return Tb(e.r, e.g, e.b);
  }
  function Bb(t) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);
  }
  function Nb(t) {
    return rb.test(t);
  }
  function Fb(t) {
    return sb.test(t);
  }
  function zb(t) {
    if (null === t || "object" !== bu(t)) return null;
    if (t instanceof Element) return t;
    var e = pg(t);
    for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && "object" == bu(t[i]) && (e[i] = zb(t[i]));
    return e;
  }
  function Ab(t, e, i) {
    var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
      o = function o(t) {
        return null != t;
      },
      r = function r(t) {
        return null !== t && "object" === bu(t);
      };
    if (!r(t)) throw new Error("Parameter mergeTarget must be an object");
    if (!r(e)) throw new Error("Parameter options must be an object");
    if (!o(i)) throw new Error("Parameter option must have a value");
    if (!r(n)) throw new Error("Parameter globalOptions must be an object");
    var s = e[i],
      a = r(n) && !function (t) {
        for (var e in t) if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
        return !0;
      }(n) ? n[i] : void 0,
      h = a ? a.enabled : void 0;
    if (void 0 !== s) {
      if ("boolean" == typeof s) return r(t[i]) || (t[i] = {}), void (t[i].enabled = s);
      if (null === s && !r(t[i])) {
        if (!o(a)) return;
        t[i] = pg(a);
      }
      if (r(s)) {
        var l = !0;
        void 0 !== s.enabled ? l = s.enabled : void 0 !== h && (l = a.enabled), function (t, e, i) {
          r(t[i]) || (t[i] = {});
          var n = e[i],
            o = t[i];
          for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (o[s] = n[s]);
        }(t, e, i), t[i].enabled = l;
      }
    }
  }
  var jb = {
    linear: function linear(t) {
      return t;
    },
    easeInQuad: function easeInQuad(t) {
      return t * t;
    },
    easeOutQuad: function easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad: function easeInOutQuad(t) {
      return t < .5 ? 2 * t * t : (4 - 2 * t) * t - 1;
    },
    easeInCubic: function easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic: function easeOutCubic(t) {
      return --t * t * t + 1;
    },
    easeInOutCubic: function easeInOutCubic(t) {
      return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart: function easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart: function easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart: function easeInOutQuart(t) {
      return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint: function easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint: function easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint: function easeInOutQuint(t) {
      return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
  };
  function Rb(t, e) {
    var i;
    Df(e) || (e = [e]);
    var n,
      o = Um(t);
    try {
      for (o.s(); !(n = o.n()).done;) {
        var r = n.value;
        if (r) {
          i = r[e[0]];
          for (var s = 1; s < e.length; s++) i && (i = i[e[s]]);
          if (void 0 !== i) break;
        }
      }
    } catch (t) {
      o.e(t);
    } finally {
      o.f();
    }
    return i;
  }
  var Lb = {
      black: "#000000",
      navy: "#000080",
      darkblue: "#00008B",
      mediumblue: "#0000CD",
      blue: "#0000FF",
      darkgreen: "#006400",
      green: "#008000",
      teal: "#008080",
      darkcyan: "#008B8B",
      deepskyblue: "#00BFFF",
      darkturquoise: "#00CED1",
      mediumspringgreen: "#00FA9A",
      lime: "#00FF00",
      springgreen: "#00FF7F",
      aqua: "#00FFFF",
      cyan: "#00FFFF",
      midnightblue: "#191970",
      dodgerblue: "#1E90FF",
      lightseagreen: "#20B2AA",
      forestgreen: "#228B22",
      seagreen: "#2E8B57",
      darkslategray: "#2F4F4F",
      limegreen: "#32CD32",
      mediumseagreen: "#3CB371",
      turquoise: "#40E0D0",
      royalblue: "#4169E1",
      steelblue: "#4682B4",
      darkslateblue: "#483D8B",
      mediumturquoise: "#48D1CC",
      indigo: "#4B0082",
      darkolivegreen: "#556B2F",
      cadetblue: "#5F9EA0",
      cornflowerblue: "#6495ED",
      mediumaquamarine: "#66CDAA",
      dimgray: "#696969",
      slateblue: "#6A5ACD",
      olivedrab: "#6B8E23",
      slategray: "#708090",
      lightslategray: "#778899",
      mediumslateblue: "#7B68EE",
      lawngreen: "#7CFC00",
      chartreuse: "#7FFF00",
      aquamarine: "#7FFFD4",
      maroon: "#800000",
      purple: "#800080",
      olive: "#808000",
      gray: "#808080",
      skyblue: "#87CEEB",
      lightskyblue: "#87CEFA",
      blueviolet: "#8A2BE2",
      darkred: "#8B0000",
      darkmagenta: "#8B008B",
      saddlebrown: "#8B4513",
      darkseagreen: "#8FBC8F",
      lightgreen: "#90EE90",
      mediumpurple: "#9370D8",
      darkviolet: "#9400D3",
      palegreen: "#98FB98",
      darkorchid: "#9932CC",
      yellowgreen: "#9ACD32",
      sienna: "#A0522D",
      brown: "#A52A2A",
      darkgray: "#A9A9A9",
      lightblue: "#ADD8E6",
      greenyellow: "#ADFF2F",
      paleturquoise: "#AFEEEE",
      lightsteelblue: "#B0C4DE",
      powderblue: "#B0E0E6",
      firebrick: "#B22222",
      darkgoldenrod: "#B8860B",
      mediumorchid: "#BA55D3",
      rosybrown: "#BC8F8F",
      darkkhaki: "#BDB76B",
      silver: "#C0C0C0",
      mediumvioletred: "#C71585",
      indianred: "#CD5C5C",
      peru: "#CD853F",
      chocolate: "#D2691E",
      tan: "#D2B48C",
      lightgrey: "#D3D3D3",
      palevioletred: "#D87093",
      thistle: "#D8BFD8",
      orchid: "#DA70D6",
      goldenrod: "#DAA520",
      crimson: "#DC143C",
      gainsboro: "#DCDCDC",
      plum: "#DDA0DD",
      burlywood: "#DEB887",
      lightcyan: "#E0FFFF",
      lavender: "#E6E6FA",
      darksalmon: "#E9967A",
      violet: "#EE82EE",
      palegoldenrod: "#EEE8AA",
      lightcoral: "#F08080",
      khaki: "#F0E68C",
      aliceblue: "#F0F8FF",
      honeydew: "#F0FFF0",
      azure: "#F0FFFF",
      sandybrown: "#F4A460",
      wheat: "#F5DEB3",
      beige: "#F5F5DC",
      whitesmoke: "#F5F5F5",
      mintcream: "#F5FFFA",
      ghostwhite: "#F8F8FF",
      salmon: "#FA8072",
      antiquewhite: "#FAEBD7",
      linen: "#FAF0E6",
      lightgoldenrodyellow: "#FAFAD2",
      oldlace: "#FDF5E6",
      red: "#FF0000",
      fuchsia: "#FF00FF",
      magenta: "#FF00FF",
      deeppink: "#FF1493",
      orangered: "#FF4500",
      tomato: "#FF6347",
      hotpink: "#FF69B4",
      coral: "#FF7F50",
      darkorange: "#FF8C00",
      lightsalmon: "#FFA07A",
      orange: "#FFA500",
      lightpink: "#FFB6C1",
      pink: "#FFC0CB",
      gold: "#FFD700",
      peachpuff: "#FFDAB9",
      navajowhite: "#FFDEAD",
      moccasin: "#FFE4B5",
      bisque: "#FFE4C4",
      mistyrose: "#FFE4E1",
      blanchedalmond: "#FFEBCD",
      papayawhip: "#FFEFD5",
      lavenderblush: "#FFF0F5",
      seashell: "#FFF5EE",
      cornsilk: "#FFF8DC",
      lemonchiffon: "#FFFACD",
      floralwhite: "#FFFAF0",
      snow: "#FFFAFA",
      yellow: "#FFFF00",
      lightyellow: "#FFFFE0",
      ivory: "#FFFFF0",
      white: "#FFFFFF"
    },
    Hb = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        ph(this, t), this.pixelRatio = e, this.generated = !1, this.centerCoordinates = {
          x: 144.5,
          y: 144.5
        }, this.r = 289 * .49, this.color = {
          r: 255,
          g: 255,
          b: 255,
          a: 1
        }, this.hueCircle = void 0, this.initialColor = {
          r: 255,
          g: 255,
          b: 255,
          a: 1
        }, this.previousColor = void 0, this.applied = !1, this.updateCallback = function () {}, this.closeCallback = function () {}, this._create();
      }
      return xu(t, [{
        key: "insertTo",
        value: function value(t) {
          void 0 !== this.hammer && (this.hammer.destroy(), this.hammer = void 0), this.container = t, this.container.appendChild(this.frame), this._bindHammer(), this._setSize();
        }
      }, {
        key: "setUpdateCallback",
        value: function value(t) {
          if ("function" != typeof t) throw new Error("Function attempted to set as colorPicker update callback is not a function.");
          this.updateCallback = t;
        }
      }, {
        key: "setCloseCallback",
        value: function value(t) {
          if ("function" != typeof t) throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
          this.closeCallback = t;
        }
      }, {
        key: "_isColorString",
        value: function value(t) {
          if ("string" == typeof t) return Lb[t];
        }
      }, {
        key: "setColor",
        value: function value(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          if ("none" !== t) {
            var i,
              n = this._isColorString(t);
            if (void 0 !== n && (t = n), !0 === lb(t)) {
              if (!0 === Nb(t)) {
                var o = t.substr(4).substr(0, t.length - 5).split(",");
                i = {
                  r: o[0],
                  g: o[1],
                  b: o[2],
                  a: 1
                };
              } else if (!0 === Fb(t)) {
                var r = t.substr(5).substr(0, t.length - 6).split(",");
                i = {
                  r: r[0],
                  g: r[1],
                  b: r[2],
                  a: r[3]
                };
              } else if (!0 === Bb(t)) {
                var s = Eb(t);
                i = {
                  r: s.r,
                  g: s.g,
                  b: s.b,
                  a: 1
                };
              }
            } else if (t instanceof Object && void 0 !== t.r && void 0 !== t.g && void 0 !== t.b) {
              var a = void 0 !== t.a ? t.a : "1.0";
              i = {
                r: t.r,
                g: t.g,
                b: t.b,
                a: a
              };
            }
            if (void 0 === i) throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + mg(t));
            this._setColor(i, e);
          }
        }
      }, {
        key: "show",
        value: function value() {
          void 0 !== this.closeCallback && (this.closeCallback(), this.closeCallback = void 0), this.applied = !1, this.frame.style.display = "block", this._generateHueCircle();
        }
      }, {
        key: "_hide",
        value: function value() {
          var t = this;
          !0 === (!(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0]) && (this.previousColor = bn({}, this.color)), !0 === this.applied && this.updateCallback(this.initialColor), this.frame.style.display = "none", jg(function () {
            void 0 !== t.closeCallback && (t.closeCallback(), t.closeCallback = void 0);
          }, 0);
        }
      }, {
        key: "_save",
        value: function value() {
          this.updateCallback(this.color), this.applied = !1, this._hide();
        }
      }, {
        key: "_apply",
        value: function value() {
          this.applied = !0, this.updateCallback(this.color), this._updatePicker(this.color);
        }
      }, {
        key: "_loadLast",
        value: function value() {
          void 0 !== this.previousColor ? this.setColor(this.previousColor, !1) : alert("There is no last color to load...");
        }
      }, {
        key: "_setColor",
        value: function value(t) {
          !0 === (!(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]) && (this.initialColor = bn({}, t)), this.color = t;
          var e = Tb(t.r, t.g, t.b),
            i = 2 * Math.PI,
            n = this.r * e.s,
            o = this.centerCoordinates.x + n * Math.sin(i * e.h),
            r = this.centerCoordinates.y + n * Math.cos(i * e.h);
          this.colorPickerSelector.style.left = o - .5 * this.colorPickerSelector.clientWidth + "px", this.colorPickerSelector.style.top = r - .5 * this.colorPickerSelector.clientHeight + "px", this._updatePicker(t);
        }
      }, {
        key: "_setOpacity",
        value: function value(t) {
          this.color.a = t / 100, this._updatePicker(this.color);
        }
      }, {
        key: "_setBrightness",
        value: function value(t) {
          var e = Tb(this.color.r, this.color.g, this.color.b);
          e.v = t / 100;
          var i = Pb(e.h, e.s, e.v);
          i.a = this.color.a, this.color = i, this._updatePicker();
        }
      }, {
        key: "_updatePicker",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.color,
            e = Tb(t.r, t.g, t.b),
            i = this.colorPickerCanvas.getContext("2d");
          void 0 === this.pixelRation && (this.pixelRatio = (window.devicePixelRatio || 1) / (i.webkitBackingStorePixelRatio || i.mozBackingStorePixelRatio || i.msBackingStorePixelRatio || i.oBackingStorePixelRatio || i.backingStorePixelRatio || 1)), i.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
          var n = this.colorPickerCanvas.clientWidth,
            o = this.colorPickerCanvas.clientHeight;
          i.clearRect(0, 0, n, o), i.putImageData(this.hueCircle, 0, 0), i.fillStyle = "rgba(0,0,0," + (1 - e.v) + ")", i.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), Kg(i).call(i), this.brightnessRange.value = 100 * e.v, this.opacityRange.value = 100 * t.a, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
        }
      }, {
        key: "_setSize",
        value: function value() {
          this.colorPickerCanvas.style.width = "100%", this.colorPickerCanvas.style.height = "100%", this.colorPickerCanvas.width = 289 * this.pixelRatio, this.colorPickerCanvas.height = 289 * this.pixelRatio;
        }
      }, {
        key: "_create",
        value: function value() {
          var t, e, i, n;
          if (this.frame = document.createElement("div"), this.frame.className = "vis-color-picker", this.colorPickerDiv = document.createElement("div"), this.colorPickerSelector = document.createElement("div"), this.colorPickerSelector.className = "vis-selector", this.colorPickerDiv.appendChild(this.colorPickerSelector), this.colorPickerCanvas = document.createElement("canvas"), this.colorPickerDiv.appendChild(this.colorPickerCanvas), this.colorPickerCanvas.getContext) {
            var o = this.colorPickerCanvas.getContext("2d");
            this.pixelRatio = (window.devicePixelRatio || 1) / (o.webkitBackingStorePixelRatio || o.mozBackingStorePixelRatio || o.msBackingStorePixelRatio || o.oBackingStorePixelRatio || o.backingStorePixelRatio || 1), this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
          } else {
            var r = document.createElement("DIV");
            r.style.color = "red", r.style.fontWeight = "bold", r.style.padding = "10px", r.innerText = "Error: your browser does not support HTML canvas", this.colorPickerCanvas.appendChild(r);
          }
          this.colorPickerDiv.className = "vis-color", this.opacityDiv = document.createElement("div"), this.opacityDiv.className = "vis-opacity", this.brightnessDiv = document.createElement("div"), this.brightnessDiv.className = "vis-brightness", this.arrowDiv = document.createElement("div"), this.arrowDiv.className = "vis-arrow", this.opacityRange = document.createElement("input");
          try {
            this.opacityRange.type = "range", this.opacityRange.min = "0", this.opacityRange.max = "100";
          } catch (t) {}
          this.opacityRange.value = "100", this.opacityRange.className = "vis-range", this.brightnessRange = document.createElement("input");
          try {
            this.brightnessRange.type = "range", this.brightnessRange.min = "0", this.brightnessRange.max = "100";
          } catch (t) {}
          this.brightnessRange.value = "100", this.brightnessRange.className = "vis-range", this.opacityDiv.appendChild(this.opacityRange), this.brightnessDiv.appendChild(this.brightnessRange);
          var s = this;
          this.opacityRange.onchange = function () {
            s._setOpacity(this.value);
          }, this.opacityRange.oninput = function () {
            s._setOpacity(this.value);
          }, this.brightnessRange.onchange = function () {
            s._setBrightness(this.value);
          }, this.brightnessRange.oninput = function () {
            s._setBrightness(this.value);
          }, this.brightnessLabel = document.createElement("div"), this.brightnessLabel.className = "vis-label vis-brightness", this.brightnessLabel.innerText = "brightness:", this.opacityLabel = document.createElement("div"), this.opacityLabel.className = "vis-label vis-opacity", this.opacityLabel.innerText = "opacity:", this.newColorDiv = document.createElement("div"), this.newColorDiv.className = "vis-new-color", this.newColorDiv.innerText = "new", this.initialColorDiv = document.createElement("div"), this.initialColorDiv.className = "vis-initial-color", this.initialColorDiv.innerText = "initial", this.cancelButton = document.createElement("div"), this.cancelButton.className = "vis-button vis-cancel", this.cancelButton.innerText = "cancel", this.cancelButton.onclick = Hn(t = this._hide).call(t, this, !1), this.applyButton = document.createElement("div"), this.applyButton.className = "vis-button vis-apply", this.applyButton.innerText = "apply", this.applyButton.onclick = Hn(e = this._apply).call(e, this), this.saveButton = document.createElement("div"), this.saveButton.className = "vis-button vis-save", this.saveButton.innerText = "save", this.saveButton.onclick = Hn(i = this._save).call(i, this), this.loadButton = document.createElement("div"), this.loadButton.className = "vis-button vis-load", this.loadButton.innerText = "load last", this.loadButton.onclick = Hn(n = this._loadLast).call(n, this), this.frame.appendChild(this.colorPickerDiv), this.frame.appendChild(this.arrowDiv), this.frame.appendChild(this.brightnessLabel), this.frame.appendChild(this.brightnessDiv), this.frame.appendChild(this.opacityLabel), this.frame.appendChild(this.opacityDiv), this.frame.appendChild(this.newColorDiv), this.frame.appendChild(this.initialColorDiv), this.frame.appendChild(this.cancelButton), this.frame.appendChild(this.applyButton), this.frame.appendChild(this.saveButton), this.frame.appendChild(this.loadButton);
        }
      }, {
        key: "_bindHammer",
        value: function value() {
          var t = this;
          this.drag = {}, this.pinch = {}, this.hammer = new tb(this.colorPickerCanvas), this.hammer.get("pinch").set({
            enable: !0
          }), this.hammer.on("hammer.input", function (e) {
            e.isFirst && t._moveSelector(e);
          }), this.hammer.on("tap", function (e) {
            t._moveSelector(e);
          }), this.hammer.on("panstart", function (e) {
            t._moveSelector(e);
          }), this.hammer.on("panmove", function (e) {
            t._moveSelector(e);
          }), this.hammer.on("panend", function (e) {
            t._moveSelector(e);
          });
        }
      }, {
        key: "_generateHueCircle",
        value: function value() {
          if (!1 === this.generated) {
            var t = this.colorPickerCanvas.getContext("2d");
            void 0 === this.pixelRation && (this.pixelRatio = (window.devicePixelRatio || 1) / (t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1)), t.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
            var e,
              i,
              n,
              o,
              r = this.colorPickerCanvas.clientWidth,
              s = this.colorPickerCanvas.clientHeight;
            t.clearRect(0, 0, r, s), this.centerCoordinates = {
              x: .5 * r,
              y: .5 * s
            }, this.r = .49 * r;
            var a,
              h = 2 * Math.PI / 360,
              l = 1 / this.r;
            for (n = 0; n < 360; n++) for (o = 0; o < this.r; o++) e = this.centerCoordinates.x + o * Math.sin(h * n), i = this.centerCoordinates.y + o * Math.cos(h * n), a = Pb(.002777777777777778 * n, o * l, 1), t.fillStyle = "rgb(" + a.r + "," + a.g + "," + a.b + ")", t.fillRect(e - .5, i - .5, 2, 2);
            t.strokeStyle = "rgba(0,0,0,1)", t.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), t.stroke(), this.hueCircle = t.getImageData(0, 0, r, s);
          }
          this.generated = !0;
        }
      }, {
        key: "_moveSelector",
        value: function value(t) {
          var e = this.colorPickerDiv.getBoundingClientRect(),
            i = t.center.x - e.left,
            n = t.center.y - e.top,
            o = .5 * this.colorPickerDiv.clientHeight,
            r = .5 * this.colorPickerDiv.clientWidth,
            s = i - r,
            a = n - o,
            h = Math.atan2(s, a),
            l = .98 * Math.min(Math.sqrt(s * s + a * a), r),
            d = Math.cos(h) * l + o,
            c = Math.sin(h) * l + r;
          this.colorPickerSelector.style.top = d - .5 * this.colorPickerSelector.clientHeight + "px", this.colorPickerSelector.style.left = c - .5 * this.colorPickerSelector.clientWidth + "px";
          var u = h / (2 * Math.PI);
          u = u < 0 ? u + 1 : u;
          var f = l / this.r,
            p = Tb(this.color.r, this.color.g, this.color.b);
          p.h = u, p.s = f;
          var v = Pb(p.h, p.s, p.v);
          v.a = this.color.a, this.color = v, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
        }
      }]), t;
    }();
  function Wb() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
    if (e.length < 1) throw new TypeError("Invalid arguments.");
    if (1 === e.length) return document.createTextNode(e[0]);
    var n = document.createElement(e[0]);
    return n.appendChild(Wb.apply(void 0, vf(xf(e).call(e, 1)))), n;
  }
  var qb,
    Vb = function () {
      function t(e, i, n) {
        var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
          r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : function () {
            return !1;
          };
        ph(this, t), this.parent = e, this.changedOptions = [], this.container = i, this.allowCreation = !1, this.hideOption = r, this.options = {}, this.initialized = !1, this.popupCounter = 0, this.defaultOptions = {
          enabled: !1,
          filter: !0,
          container: void 0,
          showButton: !0
        }, bn(this.options, this.defaultOptions), this.configureOptions = n, this.moduleOptions = {}, this.domElements = [], this.popupDiv = {}, this.popupLimit = 5, this.popupHistory = {}, this.colorPicker = new Hb(o), this.wrapper = void 0;
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          if (void 0 !== t) {
            this.popupHistory = {}, this._removePopup();
            var e = !0;
            if ("string" == typeof t) this.options.filter = t;else if (Df(t)) this.options.filter = t.join();else if ("object" === bu(t)) {
              if (null == t) throw new TypeError("options cannot be null");
              void 0 !== t.container && (this.options.container = t.container), void 0 !== yv(t) && (this.options.filter = yv(t)), void 0 !== t.showButton && (this.options.showButton = t.showButton), void 0 !== t.enabled && (e = t.enabled);
            } else "boolean" == typeof t ? (this.options.filter = !0, e = t) : "function" == typeof t && (this.options.filter = t, e = !0);
            !1 === yv(this.options) && (e = !1), this.options.enabled = e;
          }
          this._clean();
        }
      }, {
        key: "setModuleOptions",
        value: function value(t) {
          this.moduleOptions = t, !0 === this.options.enabled && (this._clean(), void 0 !== this.options.container && (this.container = this.options.container), this._create());
        }
      }, {
        key: "_create",
        value: function value() {
          this._clean(), this.changedOptions = [];
          var t = yv(this.options),
            e = 0,
            i = !1;
          for (var n in this.configureOptions) Object.prototype.hasOwnProperty.call(this.configureOptions, n) && (this.allowCreation = !1, i = !1, "function" == typeof t ? i = (i = t(n, [])) || this._handleObject(this.configureOptions[n], [n], !0) : !0 !== t && -1 === lg(t).call(t, n) || (i = !0), !1 !== i && (this.allowCreation = !0, e > 0 && this._makeItem([]), this._makeHeader(n), this._handleObject(this.configureOptions[n], [n])), e++);
          this._makeButton(), this._push();
        }
      }, {
        key: "_push",
        value: function value() {
          this.wrapper = document.createElement("div"), this.wrapper.className = "vis-configuration-wrapper", this.container.appendChild(this.wrapper);
          for (var t = 0; t < this.domElements.length; t++) this.wrapper.appendChild(this.domElements[t]);
          this._showPopupIfNeeded();
        }
      }, {
        key: "_clean",
        value: function value() {
          for (var t = 0; t < this.domElements.length; t++) this.wrapper.removeChild(this.domElements[t]);
          void 0 !== this.wrapper && (this.container.removeChild(this.wrapper), this.wrapper = void 0), this.domElements = [], this._removePopup();
        }
      }, {
        key: "_getValue",
        value: function value(t) {
          for (var e = this.moduleOptions, i = 0; i < t.length; i++) {
            if (void 0 === e[t[i]]) {
              e = void 0;
              break;
            }
            e = e[t[i]];
          }
          return e;
        }
      }, {
        key: "_makeItem",
        value: function value(t) {
          if (!0 === this.allowCreation) {
            var e = document.createElement("div");
            e.className = "vis-configuration vis-config-item vis-config-s" + t.length;
            for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) n[o - 1] = arguments[o];
            return op(n).call(n, function (t) {
              e.appendChild(t);
            }), this.domElements.push(e), this.domElements.length;
          }
          return 0;
        }
      }, {
        key: "_makeHeader",
        value: function value(t) {
          var e = document.createElement("div");
          e.className = "vis-configuration vis-config-header", e.innerText = t, this._makeItem([], e);
        }
      }, {
        key: "_makeLabel",
        value: function value(t, e) {
          var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            n = document.createElement("div");
          if (n.className = "vis-configuration vis-config-label vis-config-s" + e.length, !0 === i) {
            for (; n.firstChild;) n.removeChild(n.firstChild);
            n.appendChild(Wb("i", "b", t));
          } else n.innerText = t + ":";
          return n;
        }
      }, {
        key: "_makeDropdown",
        value: function value(t, e, i) {
          var n = document.createElement("select");
          n.className = "vis-configuration vis-config-select";
          var o = 0;
          void 0 !== e && -1 !== lg(t).call(t, e) && (o = lg(t).call(t, e));
          for (var r = 0; r < t.length; r++) {
            var s = document.createElement("option");
            s.value = t[r], r === o && (s.selected = "selected"), s.innerText = t[r], n.appendChild(s);
          }
          var a = this;
          n.onchange = function () {
            a._update(this.value, i);
          };
          var h = this._makeLabel(i[i.length - 1], i);
          this._makeItem(i, h, n);
        }
      }, {
        key: "_makeRange",
        value: function value(t, e, i) {
          var n = t[0],
            o = t[1],
            r = t[2],
            s = t[3],
            a = document.createElement("input");
          a.className = "vis-configuration vis-config-range";
          try {
            a.type = "range", a.min = o, a.max = r;
          } catch (t) {}
          a.step = s;
          var h = "",
            l = 0;
          if (void 0 !== e) {
            var d = 1.2;
            e < 0 && e * d < o ? (a.min = Math.ceil(e * d), l = a.min, h = "range increased") : e / d < o && (a.min = Math.ceil(e / d), l = a.min, h = "range increased"), e * d > r && 1 !== r && (a.max = Math.ceil(e * d), l = a.max, h = "range increased"), a.value = e;
          } else a.value = n;
          var c = document.createElement("input");
          c.className = "vis-configuration vis-config-rangeinput", c.value = a.value;
          var u = this;
          a.onchange = function () {
            c.value = this.value, u._update(Number(this.value), i);
          }, a.oninput = function () {
            c.value = this.value;
          };
          var f = this._makeLabel(i[i.length - 1], i),
            p = this._makeItem(i, f, a, c);
          "" !== h && this.popupHistory[p] !== l && (this.popupHistory[p] = l, this._setupPopup(h, p));
        }
      }, {
        key: "_makeButton",
        value: function value() {
          var t = this;
          if (!0 === this.options.showButton) {
            var e = document.createElement("div");
            e.className = "vis-configuration vis-config-button", e.innerText = "generate options", e.onclick = function () {
              t._printOptions();
            }, e.onmouseover = function () {
              e.className = "vis-configuration vis-config-button hover";
            }, e.onmouseout = function () {
              e.className = "vis-configuration vis-config-button";
            }, this.optionsContainer = document.createElement("div"), this.optionsContainer.className = "vis-configuration vis-config-option-container", this.domElements.push(this.optionsContainer), this.domElements.push(e);
          }
        }
      }, {
        key: "_setupPopup",
        value: function value(t, e) {
          var i = this;
          if (!0 === this.initialized && !0 === this.allowCreation && this.popupCounter < this.popupLimit) {
            var n = document.createElement("div");
            n.id = "vis-configuration-popup", n.className = "vis-configuration-popup", n.innerText = t, n.onclick = function () {
              i._removePopup();
            }, this.popupCounter += 1, this.popupDiv = {
              html: n,
              index: e
            };
          }
        }
      }, {
        key: "_removePopup",
        value: function value() {
          void 0 !== this.popupDiv.html && (this.popupDiv.html.parentNode.removeChild(this.popupDiv.html), clearTimeout(this.popupDiv.hideTimeout), clearTimeout(this.popupDiv.deleteTimeout), this.popupDiv = {});
        }
      }, {
        key: "_showPopupIfNeeded",
        value: function value() {
          var t = this;
          if (void 0 !== this.popupDiv.html) {
            var e = this.domElements[this.popupDiv.index].getBoundingClientRect();
            this.popupDiv.html.style.left = e.left + "px", this.popupDiv.html.style.top = e.top - 30 + "px", document.body.appendChild(this.popupDiv.html), this.popupDiv.hideTimeout = jg(function () {
              t.popupDiv.html.style.opacity = 0;
            }, 1500), this.popupDiv.deleteTimeout = jg(function () {
              t._removePopup();
            }, 1800);
          }
        }
      }, {
        key: "_makeCheckbox",
        value: function value(t, e, i) {
          var n = document.createElement("input");
          n.type = "checkbox", n.className = "vis-configuration vis-config-checkbox", n.checked = t, void 0 !== e && (n.checked = e, e !== t && ("object" === bu(t) ? e !== t.enabled && this.changedOptions.push({
            path: i,
            value: e
          }) : this.changedOptions.push({
            path: i,
            value: e
          })));
          var o = this;
          n.onchange = function () {
            o._update(this.checked, i);
          };
          var r = this._makeLabel(i[i.length - 1], i);
          this._makeItem(i, r, n);
        }
      }, {
        key: "_makeTextInput",
        value: function value(t, e, i) {
          var n = document.createElement("input");
          n.type = "text", n.className = "vis-configuration vis-config-text", n.value = e, e !== t && this.changedOptions.push({
            path: i,
            value: e
          });
          var o = this;
          n.onchange = function () {
            o._update(this.value, i);
          };
          var r = this._makeLabel(i[i.length - 1], i);
          this._makeItem(i, r, n);
        }
      }, {
        key: "_makeColorField",
        value: function value(t, e, i) {
          var n = this,
            o = t[1],
            r = document.createElement("div");
          "none" !== (e = void 0 === e ? o : e) ? (r.className = "vis-configuration vis-config-colorBlock", r.style.backgroundColor = e) : r.className = "vis-configuration vis-config-colorBlock none", e = void 0 === e ? o : e, r.onclick = function () {
            n._showColorPicker(e, r, i);
          };
          var s = this._makeLabel(i[i.length - 1], i);
          this._makeItem(i, s, r);
        }
      }, {
        key: "_showColorPicker",
        value: function value(t, e, i) {
          var n = this;
          e.onclick = function () {}, this.colorPicker.insertTo(e), this.colorPicker.show(), this.colorPicker.setColor(t), this.colorPicker.setUpdateCallback(function (t) {
            var o = "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a + ")";
            e.style.backgroundColor = o, n._update(o, i);
          }), this.colorPicker.setCloseCallback(function () {
            e.onclick = function () {
              n._showColorPicker(t, e, i);
            };
          });
        }
      }, {
        key: "_handleObject",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            n = !1,
            o = yv(this.options),
            r = !1;
          for (var s in t) if (Object.prototype.hasOwnProperty.call(t, s)) {
            n = !0;
            var a = t[s],
              h = yb(e, s);
            if ("function" == typeof o && !1 === (n = o(s, e)) && !Df(a) && "string" != typeof a && "boolean" != typeof a && a instanceof Object && (this.allowCreation = !1, n = this._handleObject(a, h, !0), this.allowCreation = !1 === i), !1 !== n) {
              r = !0;
              var l = this._getValue(h);
              if (Df(a)) this._handleArray(a, l, h);else if ("string" == typeof a) this._makeTextInput(a, l, h);else if ("boolean" == typeof a) this._makeCheckbox(a, l, h);else if (a instanceof Object) {
                if (!this.hideOption(e, s, this.moduleOptions)) if (void 0 !== a.enabled) {
                  var d = yb(h, "enabled"),
                    c = this._getValue(d);
                  if (!0 === c) {
                    var u = this._makeLabel(s, h, !0);
                    this._makeItem(h, u), r = this._handleObject(a, h) || r;
                  } else this._makeCheckbox(a, c, h);
                } else {
                  var f = this._makeLabel(s, h, !0);
                  this._makeItem(h, f), r = this._handleObject(a, h) || r;
                }
              } else console.error("dont know how to handle", a, s, h);
            }
          }
          return r;
        }
      }, {
        key: "_handleArray",
        value: function value(t, e, i) {
          "string" == typeof t[0] && "color" === t[0] ? (this._makeColorField(t, e, i), t[1] !== e && this.changedOptions.push({
            path: i,
            value: e
          })) : "string" == typeof t[0] ? (this._makeDropdown(t, e, i), t[0] !== e && this.changedOptions.push({
            path: i,
            value: e
          })) : "number" == typeof t[0] && (this._makeRange(t, e, i), t[0] !== e && this.changedOptions.push({
            path: i,
            value: Number(e)
          }));
        }
      }, {
        key: "_update",
        value: function value(t, e) {
          var i = this._constructOptions(t, e);
          this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit && this.parent.body.emitter.emit("configChange", i), this.initialized = !0, this.parent.setOptions(i);
        }
      }, {
        key: "_constructOptions",
        value: function value(t, e) {
          var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = i;
          t = "false" !== (t = "true" === t || t) && t;
          for (var o = 0; o < e.length; o++) "global" !== e[o] && (void 0 === n[e[o]] && (n[e[o]] = {}), o !== e.length - 1 ? n = n[e[o]] : n[e[o]] = t);
          return i;
        }
      }, {
        key: "_printOptions",
        value: function value() {
          for (var t = this.getOptions(); this.optionsContainer.firstChild;) this.optionsContainer.removeChild(this.optionsContainer.firstChild);
          this.optionsContainer.appendChild(Wb("pre", "const options = " + mg(t, null, 2)));
        }
      }, {
        key: "getOptions",
        value: function value() {
          for (var t = {}, e = 0; e < this.changedOptions.length; e++) this._constructOptions(this.changedOptions[e].value, this.changedOptions[e].path, t);
          return t;
        }
      }]), t;
    }(),
    Ub = function () {
      function t(e, i) {
        ph(this, t), this.container = e, this.overflowMethod = i || "cap", this.x = 0, this.y = 0, this.padding = 5, this.hidden = !1, this.frame = document.createElement("div"), this.frame.className = "vis-tooltip", this.container.appendChild(this.frame);
      }
      return xu(t, [{
        key: "setPosition",
        value: function value(t, e) {
          this.x = Qv(t), this.y = Qv(e);
        }
      }, {
        key: "setText",
        value: function value(t) {
          if (t instanceof Element) {
            for (; this.frame.firstChild;) this.frame.removeChild(this.frame.firstChild);
            this.frame.appendChild(t);
          } else this.frame.innerText = t;
        }
      }, {
        key: "show",
        value: function value(t) {
          if (void 0 === t && (t = !0), !0 === t) {
            var e = this.frame.clientHeight,
              i = this.frame.clientWidth,
              n = this.frame.parentNode.clientHeight,
              o = this.frame.parentNode.clientWidth,
              r = 0,
              s = 0;
            if ("flip" == this.overflowMethod) {
              var a = !1,
                h = !0;
              this.y - e < this.padding && (h = !1), this.x + i > o - this.padding && (a = !0), r = a ? this.x - i : this.x, s = h ? this.y - e : this.y;
            } else (s = this.y - e) + e + this.padding > n && (s = n - e - this.padding), s < this.padding && (s = this.padding), (r = this.x) + i + this.padding > o && (r = o - i - this.padding), r < this.padding && (r = this.padding);
            this.frame.style.left = r + "px", this.frame.style.top = s + "px", this.frame.style.visibility = "visible", this.hidden = !1;
          } else this.hide();
        }
      }, {
        key: "hide",
        value: function value() {
          this.hidden = !0, this.frame.style.left = "0", this.frame.style.top = "0", this.frame.style.visibility = "hidden";
        }
      }, {
        key: "destroy",
        value: function value() {
          this.frame.parentNode.removeChild(this.frame);
        }
      }]), t;
    }(),
    Yb = !1,
    Xb = "background: #FFeeee; color: #dd0000",
    Gb = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "validate",
        value: function value(e, i, n) {
          Yb = !1, qb = i;
          var o = i;
          return void 0 !== n && (o = i[n]), t.parse(e, o, []), Yb;
        }
      }, {
        key: "parse",
        value: function value(e, i, n) {
          for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.check(o, e, i, n);
        }
      }, {
        key: "check",
        value: function value(e, i, n, o) {
          if (void 0 !== n[e] || void 0 !== n.__any__) {
            var r = e,
              s = !0;
            void 0 === n[e] && void 0 !== n.__any__ && (r = "__any__", s = "object" === t.getType(i[e]));
            var a = n[r];
            s && void 0 !== a.__type__ && (a = a.__type__), t.checkFields(e, i, n, r, a, o);
          } else t.getSuggestion(e, n, o);
        }
      }, {
        key: "checkFields",
        value: function value(e, i, n, o, r, s) {
          var a = function a(i) {
              console.error("%c" + i + t.printLocation(s, e), Xb);
            },
            h = t.getType(i[e]),
            l = r[h];
          void 0 !== l ? "array" === t.getType(l) && -1 === lg(l).call(l, i[e]) ? (a('Invalid option detected in "' + e + '". Allowed values are:' + t.print(l) + ' not "' + i[e] + '". '), Yb = !0) : "object" === h && "__any__" !== o && (s = yb(s, e), t.parse(i[e], n[o], s)) : void 0 === r.any && (a('Invalid type received for "' + e + '". Expected: ' + t.print(Hf(r)) + ". Received [" + h + '] "' + i[e] + '"'), Yb = !0);
        }
      }, {
        key: "getType",
        value: function value(t) {
          var e = bu(t);
          return "object" === e ? null === t ? "null" : t instanceof Boolean ? "boolean" : t instanceof Number ? "number" : t instanceof String ? "string" : Df(t) ? "array" : t instanceof Date ? "date" : void 0 !== t.nodeType ? "dom" : !0 === t._isAMomentObject ? "moment" : "object" : "number" === e ? "number" : "boolean" === e ? "boolean" : "string" === e ? "string" : void 0 === e ? "undefined" : e;
        }
      }, {
        key: "getSuggestion",
        value: function value(e, i, n) {
          var o,
            r = t.findInOptions(e, i, n, !1),
            s = t.findInOptions(e, qb, [], !0);
          o = void 0 !== r.indexMatch ? " in " + t.printLocation(r.path, e, "") + 'Perhaps it was incomplete? Did you mean: "' + r.indexMatch + '"?\n\n' : s.distance <= 4 && r.distance > s.distance ? " in " + t.printLocation(r.path, e, "") + "Perhaps it was misplaced? Matching option found at: " + t.printLocation(s.path, s.closestMatch, "") : r.distance <= 8 ? '. Did you mean "' + r.closestMatch + '"?' + t.printLocation(r.path, e) : ". Did you mean one of these: " + t.print(Hf(i)) + t.printLocation(n, e), console.error('%cUnknown option detected: "' + e + '"' + o, Xb), Yb = !0;
        }
      }, {
        key: "findInOptions",
        value: function value(e, i, n) {
          var o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            r = 1e9,
            s = "",
            a = [],
            h = e.toLowerCase(),
            l = void 0;
          for (var d in i) {
            var c = void 0;
            if (void 0 !== i[d].__type__ && !0 === o) {
              var u = t.findInOptions(e, i[d], yb(n, d));
              r > u.distance && (s = u.closestMatch, a = u.path, r = u.distance, l = u.indexMatch);
            } else {
              var f;
              -1 !== lg(f = d.toLowerCase()).call(f, h) && (l = d), r > (c = t.levenshteinDistance(e, d)) && (s = d, a = mb(n), r = c);
            }
          }
          return {
            closestMatch: s,
            path: a,
            distance: r,
            indexMatch: l
          };
        }
      }, {
        key: "printLocation",
        value: function value(t, e) {
          for (var i = "\n\n" + (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Problem value found at: \n") + "options = {\n", n = 0; n < t.length; n++) {
            for (var o = 0; o < n + 1; o++) i += "  ";
            i += t[n] + ": {\n";
          }
          for (var r = 0; r < t.length + 1; r++) i += "  ";
          i += e + "\n";
          for (var s = 0; s < t.length + 1; s++) {
            for (var a = 0; a < t.length - s; a++) i += "  ";
            i += "}\n";
          }
          return i + "\n\n";
        }
      }, {
        key: "print",
        value: function value(t) {
          return mg(t).replace(/(")|(\[)|(\])|(,"__type__")/g, "").replace(/(,)/g, ", ");
        }
      }, {
        key: "levenshteinDistance",
        value: function value(t, e) {
          if (0 === t.length) return e.length;
          if (0 === e.length) return t.length;
          var i,
            n,
            o = [];
          for (i = 0; i <= e.length; i++) o[i] = [i];
          for (n = 0; n <= t.length; n++) o[0][n] = n;
          for (i = 1; i <= e.length; i++) for (n = 1; n <= t.length; n++) e.charAt(i - 1) == t.charAt(n - 1) ? o[i][n] = o[i - 1][n - 1] : o[i][n] = Math.min(o[i - 1][n - 1] + 1, Math.min(o[i][n - 1] + 1, o[i - 1][n] + 1));
          return o[e.length][t.length];
        }
      }]), t;
    }(),
    Kb = eb,
    $b = Hb,
    Zb = Vb,
    Qb = tb,
    Jb = Ub,
    tw = Xb,
    ew = Gb,
    iw = Object.freeze({
      __proto__: null,
      Activator: Kb,
      Alea: Jm,
      ColorPicker: $b,
      Configurator: Zb,
      DELETE: Xm,
      HSVToHex: Db,
      HSVToRGB: Pb,
      Hammer: Qb,
      Popup: Jb,
      RGBToHSV: Tb,
      RGBToHex: Cb,
      VALIDATOR_PRINT_STYLE: tw,
      Validator: ew,
      addClassName: function addClassName(t, e) {
        var i = t.className.split(" "),
          n = e.split(" ");
        i = _f(i).call(i, yv(n).call(n, function (t) {
          return !rv(i).call(i, t);
        })), t.className = i.join(" ");
      },
      addCssText: function addCssText(t, e) {
        for (var i = Mb(e), n = 0, o = cg(i); n < o.length; n++) {
          var r = pf(o[n], 2),
            s = r[0],
            a = r[1];
          t.style.setProperty(s, a);
        }
      },
      addEventListener: function addEventListener(t, e, i, n) {
        var o;
        t.addEventListener ? (void 0 === n && (n = !1), "mousewheel" === e && rv(o = navigator.userAgent).call(o, "Firefox") && (e = "DOMMouseScroll"), t.addEventListener(e, i, n)) : t.attachEvent("on" + e, i);
      },
      binarySearchCustom: function binarySearchCustom(t, e, i, n) {
        for (var o = 0, r = 0, s = t.length - 1; r <= s && o < 1e4;) {
          var a = Math.floor((r + s) / 2),
            h = t[a],
            l = e(void 0 === n ? h[i] : h[i][n]);
          if (0 == l) return a;
          -1 == l ? r = a + 1 : s = a - 1, o++;
        }
        return -1;
      },
      binarySearchValue: function binarySearchValue(t, e, i, n, o) {
        var r,
          s,
          a,
          h,
          l = 0,
          d = 0,
          c = t.length - 1;
        for (o = null != o ? o : function (t, e) {
          return t == e ? 0 : t < e ? -1 : 1;
        }; d <= c && l < 1e4;) {
          if (h = Math.floor(.5 * (c + d)), r = t[Math.max(0, h - 1)][i], s = t[h][i], a = t[Math.min(t.length - 1, h + 1)][i], 0 == o(s, e)) return h;
          if (o(r, e) < 0 && o(s, e) > 0) return "before" == n ? Math.max(0, h - 1) : h;
          if (o(s, e) < 0 && o(a, e) > 0) return "before" == n ? h : Math.min(t.length - 1, h + 1);
          o(s, e) < 0 ? d = h + 1 : c = h - 1, l++;
        }
        return -1;
      },
      bridgeObject: zb,
      copyAndExtendArray: yb,
      copyArray: mb,
      deepExtend: gb,
      deepObjectAssign: Km,
      easingFunctions: jb,
      equalArray: function equalArray(t, e) {
        if (t.length !== e.length) return !1;
        for (var i = 0, n = t.length; i < n; i++) if (t[i] != e[i]) return !1;
        return !0;
      },
      extend: fb,
      fillIfDefined: ub,
      forEach: kb,
      getAbsoluteLeft: bb,
      getAbsoluteRight: function getAbsoluteRight(t) {
        return t.getBoundingClientRect().right;
      },
      getAbsoluteTop: wb,
      getScrollBarWidth: function getScrollBarWidth() {
        var t = document.createElement("p");
        t.style.width = "100%", t.style.height = "200px";
        var e = document.createElement("div");
        e.style.position = "absolute", e.style.top = "0px", e.style.left = "0px", e.style.visibility = "hidden", e.style.width = "200px", e.style.height = "150px", e.style.overflow = "hidden", e.appendChild(t), document.body.appendChild(e);
        var i = t.offsetWidth;
        e.style.overflow = "scroll";
        var n = t.offsetWidth;
        return i == n && (n = e.clientWidth), document.body.removeChild(e), i - n;
      },
      getTarget: function getTarget() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.event,
          e = null;
        return t && (t.target ? e = t.target : t.srcElement && (e = t.srcElement)), e instanceof Element && (null == e.nodeType || 3 != e.nodeType || (e = e.parentNode) instanceof Element) ? e : null;
      },
      getType: function getType(t) {
        var e = bu(t);
        return "object" === e ? null === t ? "null" : t instanceof Boolean ? "Boolean" : t instanceof Number ? "Number" : t instanceof String ? "String" : Df(t) ? "Array" : t instanceof Date ? "Date" : "Object" : "number" === e ? "Number" : "boolean" === e ? "Boolean" : "string" === e ? "String" : void 0 === e ? "undefined" : e;
      },
      hasParent: function hasParent(t, e) {
        for (var i = t; i;) {
          if (i === e) return !0;
          if (!i.parentNode) return !1;
          i = i.parentNode;
        }
        return !1;
      },
      hexToHSV: Ib,
      hexToRGB: Eb,
      insertSort: function insertSort(t, e) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i],
            o = void 0;
          for (o = i; o > 0 && e(n, t[o - 1]) < 0; o--) t[o] = t[o - 1];
          t[o] = n;
        }
        return t;
      },
      isDate: function isDate(t) {
        if (t instanceof Date) return !0;
        if (lb(t)) {
          if (ib.exec(t)) return !0;
          if (!isNaN(Date.parse(t))) return !0;
        }
        return !1;
      },
      isNumber: ab,
      isObject: db,
      isString: lb,
      isValidHex: Bb,
      isValidRGB: Nb,
      isValidRGBA: Fb,
      mergeOptions: Ab,
      option: xb,
      overrideOpacity: Ob,
      parseColor: Sb,
      preventDefault: function preventDefault(t) {
        t || (t = window.event), t && (t.preventDefault ? t.preventDefault() : t.returnValue = !1);
      },
      pureDeepObjectAssign: Gm,
      recursiveDOMDelete: hb,
      removeClassName: function removeClassName(t, e) {
        var i = t.className.split(" "),
          n = e.split(" ");
        i = yv(i).call(i, function (t) {
          return !rv(n).call(n, t);
        }), t.className = i.join(" ");
      },
      removeCssText: function removeCssText(t, e) {
        for (var i = Mb(e), n = 0, o = Hf(i); n < o.length; n++) {
          var r = o[n];
          t.style.removeProperty(r);
        }
      },
      removeEventListener: function removeEventListener(t, e, i, n) {
        var o;
        t.removeEventListener ? (void 0 === n && (n = !1), "mousewheel" === e && rv(o = navigator.userAgent).call(o, "Firefox") && (e = "DOMMouseScroll"), t.removeEventListener(e, i, n)) : t.detachEvent("on" + e, i);
      },
      selectiveBridgeObject: function selectiveBridgeObject(t, e) {
        if (null !== e && "object" === bu(e)) {
          for (var i = pg(e), n = 0; n < t.length; n++) Object.prototype.hasOwnProperty.call(e, t[n]) && "object" == bu(e[t[n]]) && (i[t[n]] = zb(e[t[n]]));
          return i;
        }
        return null;
      },
      selectiveDeepExtend: pb,
      selectiveExtend: function selectiveExtend(t, e) {
        if (!Df(t)) throw new Error("Array with property names expected as first argument");
        for (var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), o = 2; o < i; o++) n[o - 2] = arguments[o];
        for (var r = 0, s = n; r < s.length; r++) for (var a = s[r], h = 0; h < t.length; h++) {
          var l = t[h];
          a && Object.prototype.hasOwnProperty.call(a, l) && (e[l] = a[l]);
        }
        return e;
      },
      selectiveNotDeepExtend: vb,
      throttle: function throttle(t) {
        var e = !1;
        return function () {
          e || (e = !0, requestAnimationFrame(function () {
            e = !1, t();
          }));
        };
      },
      toArray: _b,
      topMost: Rb,
      updateProperty: function updateProperty(t, e, i) {
        return t[e] !== i && (t[e] = i, !0);
      }
    });
  function nw(t) {
    return hw = t, function () {
      var t = {};
      lw = 0, void (dw = hw.charAt(0)), kw(), "strict" === cw && (t.strict = !0, kw());
      "graph" !== cw && "digraph" !== cw || (t.type = cw, kw());
      uw === sw.IDENTIFIER && (t.id = cw, kw());
      if ("{" != cw) throw Sw("Angle bracket { expected");
      if (kw(), _w(t), "}" != cw) throw Sw("Angle bracket } expected");
      if (kw(), "" !== cw) throw Sw("End of file expected");
      return kw(), delete t.node, delete t.edge, delete t.graph, t;
    }();
  }
  var ow = {
      fontsize: "font.size",
      fontcolor: "font.color",
      labelfontcolor: "font.color",
      fontname: "font.face",
      color: ["color.border", "color.background"],
      fillcolor: "color.background",
      tooltip: "title",
      labeltooltip: "title"
    },
    rw = pg(ow);
  rw.color = "color.color", rw.style = "dashes";
  var sw = {
      NULL: 0,
      DELIMITER: 1,
      IDENTIFIER: 2,
      UNKNOWN: 3
    },
    aw = {
      "{": !0,
      "}": !0,
      "[": !0,
      "]": !0,
      ";": !0,
      "=": !0,
      ",": !0,
      "->": !0,
      "--": !0
    },
    hw = "",
    lw = 0,
    dw = "",
    cw = "",
    uw = sw.NULL;
  function fw() {
    lw++, dw = hw.charAt(lw);
  }
  function pw() {
    return hw.charAt(lw + 1);
  }
  function vw(t) {
    var e = t.charCodeAt(0);
    return e < 47 ? 35 === e || 46 === e : e < 59 ? e > 47 : e < 91 ? e > 64 : e < 96 ? 95 === e : e < 123 && e > 96;
  }
  function gw(t, e) {
    if (t || (t = {}), e) for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
    return t;
  }
  function yw(t, e, i) {
    for (var n = e.split("."), o = t; n.length;) {
      var r = n.shift();
      n.length ? (o[r] || (o[r] = {}), o = o[r]) : o[r] = i;
    }
  }
  function mw(t, e) {
    for (var i, n, o = null, r = [t], s = t; s.parent;) r.push(s.parent), s = s.parent;
    if (s.nodes) for (i = 0, n = s.nodes.length; i < n; i++) if (e.id === s.nodes[i].id) {
      o = s.nodes[i];
      break;
    }
    for (o || (o = {
      id: e.id
    }, t.node && (o.attr = gw(o.attr, t.node))), i = r.length - 1; i >= 0; i--) {
      var a,
        h = r[i];
      h.nodes || (h.nodes = []), -1 === lg(a = h.nodes).call(a, o) && h.nodes.push(o);
    }
    e.attr && (o.attr = gw(o.attr, e.attr));
  }
  function bw(t, e) {
    if (t.edges || (t.edges = []), t.edges.push(e), t.edge) {
      var i = gw({}, t.edge);
      e.attr = gw(i, e.attr);
    }
  }
  function ww(t, e, i, n, o) {
    var r = {
      from: e,
      to: i,
      type: n
    };
    return t.edge && (r.attr = gw({}, t.edge)), r.attr = gw(r.attr || {}, o), null != o && o.hasOwnProperty("arrows") && null != o.arrows && (r.arrows = {
      to: {
        enabled: !0,
        type: o.arrows.type
      }
    }, o.arrows = null), r;
  }
  function kw() {
    for (uw = sw.NULL, cw = ""; " " === dw || "\t" === dw || "\n" === dw || "\r" === dw;) fw();
    do {
      var t = !1;
      if ("#" === dw) {
        for (var e = lw - 1; " " === hw.charAt(e) || "\t" === hw.charAt(e);) e--;
        if ("\n" === hw.charAt(e) || "" === hw.charAt(e)) {
          for (; "" != dw && "\n" != dw;) fw();
          t = !0;
        }
      }
      if ("/" === dw && "/" === pw()) {
        for (; "" != dw && "\n" != dw;) fw();
        t = !0;
      }
      if ("/" === dw && "*" === pw()) {
        for (; "" != dw;) {
          if ("*" === dw && "/" === pw()) {
            fw(), fw();
            break;
          }
          fw();
        }
        t = !0;
      }
      for (; " " === dw || "\t" === dw || "\n" === dw || "\r" === dw;) fw();
    } while (t);
    if ("" !== dw) {
      var i = dw + pw();
      if (aw[i]) return uw = sw.DELIMITER, cw = i, fw(), void fw();
      if (aw[dw]) return uw = sw.DELIMITER, cw = dw, void fw();
      if (vw(dw) || "-" === dw) {
        for (cw += dw, fw(); vw(dw);) cw += dw, fw();
        return "false" === cw ? cw = !1 : "true" === cw ? cw = !0 : isNaN(Number(cw)) || (cw = Number(cw)), void (uw = sw.IDENTIFIER);
      }
      if ('"' === dw) {
        for (fw(); "" != dw && ('"' != dw || '"' === dw && '"' === pw());) '"' === dw ? (cw += dw, fw()) : "\\" === dw && "n" === pw() ? (cw += "\n", fw()) : cw += dw, fw();
        if ('"' != dw) throw Sw('End of string " expected');
        return fw(), void (uw = sw.IDENTIFIER);
      }
      for (uw = sw.UNKNOWN; "" != dw;) cw += dw, fw();
      throw new SyntaxError('Syntax error in part "' + Tw(cw, 30) + '"');
    }
    uw = sw.DELIMITER;
  }
  function _w(t) {
    for (; "" !== cw && "}" != cw;) xw(t), ";" === cw && kw();
  }
  function xw(t) {
    var e = Ew(t);
    if (e) Ow(t, e);else {
      var i = function (t) {
        if ("node" === cw) return kw(), t.node = Cw(), "node";
        if ("edge" === cw) return kw(), t.edge = Cw(), "edge";
        if ("graph" === cw) return kw(), t.graph = Cw(), "graph";
        return null;
      }(t);
      if (!i) {
        if (uw != sw.IDENTIFIER) throw Sw("Identifier expected");
        var n = cw;
        if (kw(), "=" === cw) {
          if (kw(), uw != sw.IDENTIFIER) throw Sw("Identifier expected");
          t[n] = cw, kw();
        } else !function (t, e) {
          var i = {
              id: e
            },
            n = Cw();
          n && (i.attr = n);
          mw(t, i), Ow(t, e);
        }(t, n);
      }
    }
  }
  function Ew(t) {
    var e = null;
    if ("subgraph" === cw && ((e = {}).type = "subgraph", kw(), uw === sw.IDENTIFIER && (e.id = cw, kw())), "{" === cw) {
      if (kw(), e || (e = {}), e.parent = t, e.node = t.node, e.edge = t.edge, e.graph = t.graph, _w(e), "}" != cw) throw Sw("Angle bracket } expected");
      kw(), delete e.node, delete e.edge, delete e.graph, delete e.parent, t.subgraphs || (t.subgraphs = []), t.subgraphs.push(e);
    }
    return e;
  }
  function Ow(t, e) {
    for (; "->" === cw || "--" === cw;) {
      var i,
        n = cw;
      kw();
      var o = Ew(t);
      if (o) i = o;else {
        if (uw != sw.IDENTIFIER) throw Sw("Identifier or subgraph expected");
        mw(t, {
          id: i = cw
        }), kw();
      }
      bw(t, ww(t, e, i, n, Cw())), e = i;
    }
  }
  function Cw() {
    for (var t, e, i = null, n = {
        dashed: !0,
        solid: !1,
        dotted: [1, 5]
      }, o = {
        dot: "circle",
        box: "box",
        crow: "crow",
        curve: "curve",
        icurve: "inv_curve",
        normal: "triangle",
        inv: "inv_triangle",
        diamond: "diamond",
        tee: "bar",
        vee: "vee"
      }, r = new Array(), s = new Array(); "[" === cw;) {
      for (kw(), i = {}; "" !== cw && "]" != cw;) {
        if (uw != sw.IDENTIFIER) throw Sw("Attribute name expected");
        var a = cw;
        if (kw(), "=" != cw) throw Sw("Equal sign = expected");
        if (kw(), uw != sw.IDENTIFIER) throw Sw("Attribute value expected");
        var h = cw;
        "style" === a && (h = n[h]), "arrowhead" === a && (a = "arrows", h = {
          to: {
            enabled: !0,
            type: o[h]
          }
        }), "arrowtail" === a && (a = "arrows", h = {
          from: {
            enabled: !0,
            type: o[h]
          }
        }), r.push({
          attr: i,
          name: a,
          value: h
        }), s.push(a), kw(), "," == cw && kw();
      }
      if ("]" != cw) throw Sw("Bracket ] expected");
      kw();
    }
    if (rv(s).call(s, "dir")) {
      var l = {
        arrows: {}
      };
      for (t = 0; t < r.length; t++) if ("arrows" === r[t].name) {
        if (null != r[t].value.to) l.arrows.to = t;else {
          if (null == r[t].value.from) throw Sw("Invalid value of arrows");
          l.arrows.from = t;
        }
      } else "dir" === r[t].name && (l.dir = t);
      var d,
        c,
        u = r[l.dir].value;
      if (!rv(s).call(s, "arrows")) if ("both" === u) r.push({
        attr: r[l.dir].attr,
        name: "arrows",
        value: {
          to: {
            enabled: !0
          }
        }
      }), l.arrows.to = r.length - 1, r.push({
        attr: r[l.dir].attr,
        name: "arrows",
        value: {
          from: {
            enabled: !0
          }
        }
      }), l.arrows.from = r.length - 1;else if ("forward" === u) r.push({
        attr: r[l.dir].attr,
        name: "arrows",
        value: {
          to: {
            enabled: !0
          }
        }
      }), l.arrows.to = r.length - 1;else if ("back" === u) r.push({
        attr: r[l.dir].attr,
        name: "arrows",
        value: {
          from: {
            enabled: !0
          }
        }
      }), l.arrows.from = r.length - 1;else {
        if ("none" !== u) throw Sw('Invalid dir type "' + u + '"');
        r.push({
          attr: r[l.dir].attr,
          name: "arrows",
          value: ""
        }), l.arrows.to = r.length - 1;
      }
      if ("both" === u) l.arrows.to && l.arrows.from ? (c = r[l.arrows.to].value.to.type, d = r[l.arrows.from].value.from.type, r[l.arrows.to] = {
        attr: r[l.arrows.to].attr,
        name: r[l.arrows.to].name,
        value: {
          to: {
            enabled: !0,
            type: c
          },
          from: {
            enabled: !0,
            type: d
          }
        }
      }, Ap(r).call(r, l.arrows.from, 1)) : l.arrows.to ? (c = r[l.arrows.to].value.to.type, d = "arrow", r[l.arrows.to] = {
        attr: r[l.arrows.to].attr,
        name: r[l.arrows.to].name,
        value: {
          to: {
            enabled: !0,
            type: c
          },
          from: {
            enabled: !0,
            type: d
          }
        }
      }) : l.arrows.from && (c = "arrow", d = r[l.arrows.from].value.from.type, r[l.arrows.from] = {
        attr: r[l.arrows.from].attr,
        name: r[l.arrows.from].name,
        value: {
          to: {
            enabled: !0,
            type: c
          },
          from: {
            enabled: !0,
            type: d
          }
        }
      });else if ("back" === u) l.arrows.to && l.arrows.from ? (c = "", d = r[l.arrows.from].value.from.type, r[l.arrows.from] = {
        attr: r[l.arrows.from].attr,
        name: r[l.arrows.from].name,
        value: {
          to: {
            enabled: !0,
            type: c
          },
          from: {
            enabled: !0,
            type: d
          }
        }
      }) : l.arrows.to ? (c = "", d = "arrow", l.arrows.from = l.arrows.to, r[l.arrows.from] = {
        attr: r[l.arrows.from].attr,
        name: r[l.arrows.from].name,
        value: {
          to: {
            enabled: !0,
            type: c
          },
          from: {
            enabled: !0,
            type: d
          }
        }
      }) : l.arrows.from && (c = "", d = r[l.arrows.from].value.from.type, r[l.arrows.to] = {
        attr: r[l.arrows.from].attr,
        name: r[l.arrows.from].name,
        value: {
          to: {
            enabled: !0,
            type: c
          },
          from: {
            enabled: !0,
            type: d
          }
        }
      }), r[l.arrows.from] = {
        attr: r[l.arrows.from].attr,
        name: r[l.arrows.from].name,
        value: {
          from: {
            enabled: !0,
            type: r[l.arrows.from].value.from.type
          }
        }
      };else if ("none" === u) {
        var f;
        r[f = l.arrows.to ? l.arrows.to : l.arrows.from] = {
          attr: r[f].attr,
          name: r[f].name,
          value: ""
        };
      } else {
        if ("forward" !== u) throw Sw('Invalid dir type "' + u + '"');
        l.arrows.to && l.arrows.from || l.arrows.to ? (c = r[l.arrows.to].value.to.type, d = "", r[l.arrows.to] = {
          attr: r[l.arrows.to].attr,
          name: r[l.arrows.to].name,
          value: {
            to: {
              enabled: !0,
              type: c
            },
            from: {
              enabled: !0,
              type: d
            }
          }
        }) : l.arrows.from && (c = "arrow", d = "", l.arrows.to = l.arrows.from, r[l.arrows.to] = {
          attr: r[l.arrows.to].attr,
          name: r[l.arrows.to].name,
          value: {
            to: {
              enabled: !0,
              type: c
            },
            from: {
              enabled: !0,
              type: d
            }
          }
        }), r[l.arrows.to] = {
          attr: r[l.arrows.to].attr,
          name: r[l.arrows.to].name,
          value: {
            to: {
              enabled: !0,
              type: r[l.arrows.to].value.to.type
            }
          }
        };
      }
      Ap(r).call(r, l.dir, 1);
    }
    if (rv(s).call(s, "penwidth")) {
      var p = [];
      for (e = r.length, t = 0; t < e; t++) "width" !== r[t].name && ("penwidth" === r[t].name && (r[t].name = "width"), p.push(r[t]));
      r = p;
    }
    for (e = r.length, t = 0; t < e; t++) yw(r[t].attr, r[t].name, r[t].value);
    return i;
  }
  function Sw(t) {
    return new SyntaxError(t + ', got "' + Tw(cw, 30) + '" (char ' + lw + ")");
  }
  function Tw(t, e) {
    return t.length <= e ? t : t.substr(0, 27) + "...";
  }
  function Mw(t, e, i) {
    for (var n = e.split("."), o = n.pop(), r = t, s = 0; s < n.length; s++) {
      var a = n[s];
      a in r || (r[a] = {}), r = r[a];
    }
    return r[o] = i, t;
  }
  function Pw(t, e) {
    var i = {};
    for (var n in t) if (t.hasOwnProperty(n)) {
      var o = e[n];
      Df(o) ? op(o).call(o, function (e) {
        Mw(i, e, t[n]);
      }) : Mw(i, "string" == typeof o ? o : n, t[n]);
    }
    return i;
  }
  function Dw(t) {
    var e,
      i = nw(t),
      n = {
        nodes: [],
        edges: [],
        options: {}
      };
    i.nodes && op(e = i.nodes).call(e, function (t) {
      var e = {
        id: t.id,
        label: String(t.label || t.id)
      };
      gw(e, Pw(t.attr, ow)), e.image && (e.shape = "image"), n.nodes.push(e);
    });
    if (i.edges) {
      var o,
        r = function r(t) {
          var e = {
            from: t.from,
            to: t.to
          };
          return gw(e, Pw(t.attr, rw)), null == e.arrows && "->" === t.type && (e.arrows = "to"), e;
        };
      op(o = i.edges).call(o, function (t) {
        var e, i, o, s, a, h, l;
        (e = t.from instanceof Object ? t.from.nodes : {
          id: t.from
        }, i = t.to instanceof Object ? t.to.nodes : {
          id: t.to
        }, t.from instanceof Object && t.from.edges) && op(o = t.from.edges).call(o, function (t) {
          var e = r(t);
          n.edges.push(e);
        });
        (a = i, h = function h(e, i) {
          var o = ww(n, e.id, i.id, t.type, t.attr),
            s = r(o);
          n.edges.push(s);
        }, Df(s = e) ? op(s).call(s, function (t) {
          Df(a) ? op(a).call(a, function (e) {
            h(t, e);
          }) : h(t, a);
        }) : Df(a) ? op(a).call(a, function (t) {
          h(s, t);
        }) : h(s, a), t.to instanceof Object && t.to.edges) && op(l = t.to.edges).call(l, function (t) {
          var e = r(t);
          n.edges.push(e);
        });
      });
    }
    return i.attr && (n.options = i.attr), n;
  }
  var Iw = Object.freeze({
    __proto__: null,
    DOTToGraph: Dw,
    parseDOT: nw
  });
  function Bw(t, e) {
    var i,
      n = {
        edges: {
          inheritColor: !1
        },
        nodes: {
          fixed: !1,
          parseColor: !1
        }
      };
    null != e && (null != e.fixed && (n.nodes.fixed = e.fixed), null != e.parseColor && (n.nodes.parseColor = e.parseColor), null != e.inheritColor && (n.edges.inheritColor = e.inheritColor));
    var o = t.edges,
      r = jf(o).call(o, function (t) {
        var e = {
          from: t.source,
          id: t.id,
          to: t.target
        };
        return null != t.attributes && (e.attributes = t.attributes), null != t.label && (e.label = t.label), null != t.attributes && null != t.attributes.title && (e.title = t.attributes.title), "Directed" === t.type && (e.arrows = "to"), t.color && !1 === n.edges.inheritColor && (e.color = t.color), e;
      });
    return {
      nodes: jf(i = t.nodes).call(i, function (t) {
        var e = {
          id: t.id,
          fixed: n.nodes.fixed && null != t.x && null != t.y
        };
        return null != t.attributes && (e.attributes = t.attributes), null != t.label && (e.label = t.label), null != t.size && (e.size = t.size), null != t.attributes && null != t.attributes.title && (e.title = t.attributes.title), null != t.title && (e.title = t.title), null != t.x && (e.x = t.x), null != t.y && (e.y = t.y), null != t.color && (!0 === n.nodes.parseColor ? e.color = t.color : e.color = {
          background: t.color,
          border: t.color,
          highlight: {
            background: t.color,
            border: t.color
          },
          hover: {
            background: t.color,
            border: t.color
          }
        }), e;
      }),
      edges: r
    };
  }
  var Nw = Object.freeze({
      __proto__: null,
      parseGephi: Bw
    }),
    Fw = Object.freeze({
      __proto__: null,
      cn: {
        addDescription: "单击空白处放置新节点。",
        addEdge: "添加连接线",
        addNode: "添加节点",
        back: "返回",
        close: "關閉",
        createEdgeError: "无法将连接线连接到群集。",
        del: "删除选定",
        deleteClusterError: "无法删除群集。",
        edgeDescription: "单击某个节点并将该连接线拖动到另一个节点以连接它们。",
        edit: "编辑",
        editClusterError: "无法编辑群集。",
        editEdge: "编辑连接线",
        editEdgeDescription: "单击控制节点并将它们拖到节点上连接。",
        editNode: "编辑节点"
      },
      cs: {
        addDescription: "Kluknutím do prázdného prostoru můžete přidat nový vrchol.",
        addEdge: "Přidat hranu",
        addNode: "Přidat vrchol",
        back: "Zpět",
        close: "Zavřít",
        createEdgeError: "Nelze připojit hranu ke shluku.",
        del: "Smazat výběr",
        deleteClusterError: "Nelze mazat shluky.",
        edgeDescription: "Přetažením z jednoho vrcholu do druhého můžete spojit tyto vrcholy novou hranou.",
        edit: "Upravit",
        editClusterError: "Nelze upravovat shluky.",
        editEdge: "Upravit hranu",
        editEdgeDescription: "Přetažením kontrolního vrcholu hrany ji můžete připojit k jinému vrcholu.",
        editNode: "Upravit vrchol"
      },
      de: {
        addDescription: "Klicke auf eine freie Stelle, um einen neuen Knoten zu plazieren.",
        addEdge: "Kante hinzufügen",
        addNode: "Knoten hinzufügen",
        back: "Zurück",
        close: "Schließen",
        createEdgeError: "Es ist nicht möglich, Kanten mit Clustern zu verbinden.",
        del: "Lösche Auswahl",
        deleteClusterError: "Cluster können nicht gelöscht werden.",
        edgeDescription: "Klicke auf einen Knoten und ziehe die Kante zu einem anderen Knoten, um diese zu verbinden.",
        edit: "Editieren",
        editClusterError: "Cluster können nicht editiert werden.",
        editEdge: "Kante editieren",
        editEdgeDescription: "Klicke auf die Verbindungspunkte und ziehe diese auf einen Knoten, um sie zu verbinden.",
        editNode: "Knoten editieren"
      },
      en: {
        addDescription: "Click in an empty space to place a new node.",
        addEdge: "Add Edge",
        addNode: "Add Node",
        back: "Back",
        close: "Close",
        createEdgeError: "Cannot link edges to a cluster.",
        del: "Delete selected",
        deleteClusterError: "Clusters cannot be deleted.",
        edgeDescription: "Click on a node and drag the edge to another node to connect them.",
        edit: "Edit",
        editClusterError: "Clusters cannot be edited.",
        editEdge: "Edit Edge",
        editEdgeDescription: "Click on the control points and drag them to a node to connect to it.",
        editNode: "Edit Node"
      },
      es: {
        addDescription: "Haga clic en un lugar vacío para colocar un nuevo nodo.",
        addEdge: "Añadir arista",
        addNode: "Añadir nodo",
        back: "Atrás",
        close: "Cerrar",
        createEdgeError: "No se puede conectar una arista a un grupo.",
        del: "Eliminar selección",
        deleteClusterError: "No es posible eliminar grupos.",
        edgeDescription: "Haga clic en un nodo y arrastre la arista hacia otro nodo para conectarlos.",
        edit: "Editar",
        editClusterError: "No es posible editar grupos.",
        editEdge: "Editar arista",
        editEdgeDescription: "Haga clic en un punto de control y arrastrelo a un nodo para conectarlo.",
        editNode: "Editar nodo"
      },
      fr: {
        addDescription: "Cliquez dans un endroit vide pour placer un nœud.",
        addEdge: "Ajouter un lien",
        addNode: "Ajouter un nœud",
        back: "Retour",
        close: "Fermer",
        createEdgeError: "Impossible de créer un lien vers un cluster.",
        del: "Effacer la sélection",
        deleteClusterError: "Les clusters ne peuvent pas être effacés.",
        edgeDescription: "Cliquez sur un nœud et glissez le lien vers un autre nœud pour les connecter.",
        edit: "Éditer",
        editClusterError: "Les clusters ne peuvent pas être édités.",
        editEdge: "Éditer le lien",
        editEdgeDescription: "Cliquez sur les points de contrôle et glissez-les pour connecter un nœud.",
        editNode: "Éditer le nœud"
      },
      it: {
        addDescription: "Clicca per aggiungere un nuovo nodo",
        addEdge: "Aggiungi un vertice",
        addNode: "Aggiungi un nodo",
        back: "Indietro",
        close: "Chiudere",
        createEdgeError: "Non si possono collegare vertici ad un cluster",
        del: "Cancella la selezione",
        deleteClusterError: "I cluster non possono essere cancellati",
        edgeDescription: "Clicca su un nodo e trascinalo ad un altro nodo per connetterli.",
        edit: "Modifica",
        editClusterError: "I clusters non possono essere modificati.",
        editEdge: "Modifica il vertice",
        editEdgeDescription: "Clicca sui Punti di controllo e trascinali ad un nodo per connetterli.",
        editNode: "Modifica il nodo"
      },
      nl: {
        addDescription: "Klik op een leeg gebied om een nieuwe node te maken.",
        addEdge: "Link toevoegen",
        addNode: "Node toevoegen",
        back: "Terug",
        close: "Sluiten",
        createEdgeError: "Kan geen link maken naar een cluster.",
        del: "Selectie verwijderen",
        deleteClusterError: "Clusters kunnen niet worden verwijderd.",
        edgeDescription: "Klik op een node en sleep de link naar een andere node om ze te verbinden.",
        edit: "Wijzigen",
        editClusterError: "Clusters kunnen niet worden aangepast.",
        editEdge: "Link wijzigen",
        editEdgeDescription: "Klik op de verbindingspunten en sleep ze naar een node om daarmee te verbinden.",
        editNode: "Node wijzigen"
      },
      pt: {
        addDescription: "Clique em um espaço em branco para adicionar um novo nó",
        addEdge: "Adicionar aresta",
        addNode: "Adicionar nó",
        back: "Voltar",
        close: "Fechar",
        createEdgeError: "Não foi possível linkar arestas a um cluster.",
        del: "Remover selecionado",
        deleteClusterError: "Clusters não puderam ser removidos.",
        edgeDescription: "Clique em um nó e arraste a aresta até outro nó para conectá-los",
        edit: "Editar",
        editClusterError: "Clusters não puderam ser editados.",
        editEdge: "Editar aresta",
        editEdgeDescription: "Clique nos pontos de controle e os arraste para um nó para conectá-los",
        editNode: "Editar nó"
      },
      ru: {
        addDescription: "Кликните в свободное место, чтобы добавить новый узел.",
        addEdge: "Добавить ребро",
        addNode: "Добавить узел",
        back: "Назад",
        close: "Закрывать",
        createEdgeError: "Невозможно соединить ребра в кластер.",
        del: "Удалить выбранное",
        deleteClusterError: "Кластеры не могут быть удалены",
        edgeDescription: "Кликните на узел и протяните ребро к другому узлу, чтобы соединить их.",
        edit: "Редактировать",
        editClusterError: "Кластеры недоступны для редактирования.",
        editEdge: "Редактировать ребро",
        editEdgeDescription: "Кликните на контрольные точки и перетащите их в узел, чтобы подключиться к нему.",
        editNode: "Редактировать узел"
      },
      uk: {
        addDescription: "Kлікніть на вільне місце, щоб додати новий вузол.",
        addEdge: "Додати край",
        addNode: "Додати вузол",
        back: "Назад",
        close: "Закрити",
        createEdgeError: "Не можливо об'єднати краї в групу.",
        del: "Видалити обране",
        deleteClusterError: "Групи не можуть бути видалені.",
        edgeDescription: "Клікніть на вузол і перетягніть край до іншого вузла, щоб їх з'єднати.",
        edit: "Редагувати",
        editClusterError: "Групи недоступні для редагування.",
        editEdge: "Редагувати край",
        editEdgeDescription: "Клікніть на контрольні точки і перетягніть їх у вузол, щоб підключитися до нього.",
        editNode: "Редагувати вузол"
      }
    });
  var zw = function () {
      function t() {
        ph(this, t), this.NUM_ITERATIONS = 4, this.image = new Image(), this.canvas = document.createElement("canvas");
      }
      return xu(t, [{
        key: "init",
        value: function value() {
          if (!this.initialized()) {
            this.src = this.image.src;
            var t = this.image.width,
              e = this.image.height;
            this.width = t, this.height = e;
            var i = Math.floor(e / 2),
              n = Math.floor(e / 4),
              o = Math.floor(e / 8),
              r = Math.floor(e / 16),
              s = Math.floor(t / 2),
              a = Math.floor(t / 4),
              h = Math.floor(t / 8),
              l = Math.floor(t / 16);
            this.canvas.width = 3 * a, this.canvas.height = i, this.coordinates = [[0, 0, s, i], [s, 0, a, n], [s, n, h, o], [5 * h, n, l, r]], this._fillMipMap();
          }
        }
      }, {
        key: "initialized",
        value: function value() {
          return void 0 !== this.coordinates;
        }
      }, {
        key: "_fillMipMap",
        value: function value() {
          var t = this.canvas.getContext("2d"),
            e = this.coordinates[0];
          t.drawImage(this.image, e[0], e[1], e[2], e[3]);
          for (var i = 1; i < this.NUM_ITERATIONS; i++) {
            var n = this.coordinates[i - 1],
              o = this.coordinates[i];
            t.drawImage(this.canvas, n[0], n[1], n[2], n[3], o[0], o[1], o[2], o[3]);
          }
        }
      }, {
        key: "drawImageAtPosition",
        value: function value(t, e, i, n, o, r) {
          if (this.initialized()) if (e > 2) {
            e *= .5;
            for (var s = 0; e > 2 && s < this.NUM_ITERATIONS;) e *= .5, s += 1;
            s >= this.NUM_ITERATIONS && (s = this.NUM_ITERATIONS - 1);
            var a = this.coordinates[s];
            t.drawImage(this.canvas, a[0], a[1], a[2], a[3], i, n, o, r);
          } else t.drawImage(this.image, i, n, o, r);
        }
      }]), t;
    }(),
    Aw = function () {
      function t(e) {
        ph(this, t), this.images = {}, this.imageBroken = {}, this.callback = e;
      }
      return xu(t, [{
        key: "_tryloadBrokenUrl",
        value: function value(t, e, i) {
          void 0 !== t && void 0 !== i && (void 0 !== e ? (i.image.onerror = function () {
            console.error("Could not load brokenImage:", e);
          }, i.image.src = e) : console.warn("No broken url image defined"));
        }
      }, {
        key: "_redrawWithImage",
        value: function value(t) {
          this.callback && this.callback(t);
        }
      }, {
        key: "load",
        value: function value(t, e) {
          var i = this,
            n = this.images[t];
          if (n) return n;
          var o = new zw();
          return this.images[t] = o, o.image.onload = function () {
            i._fixImageCoordinates(o.image), o.init(), i._redrawWithImage(o);
          }, o.image.onerror = function () {
            console.error("Could not load image:", t), i._tryloadBrokenUrl(t, e, o);
          }, o.image.src = t, o;
        }
      }, {
        key: "_fixImageCoordinates",
        value: function value(t) {
          0 === t.width && (document.body.appendChild(t), t.width = t.offsetWidth, t.height = t.offsetHeight, document.body.removeChild(t));
        }
      }]), t;
    }(),
    jw = {
      exports: {}
    },
    Rw = r(function () {
      if ("function" == typeof ArrayBuffer) {
        var t = new ArrayBuffer(8);
        Object.isExtensible(t) && Object.defineProperty(t, "a", {
          value: 8
        });
      }
    }),
    Lw = r,
    Hw = tt,
    Ww = w,
    qw = Rw,
    Vw = Object.isExtensible,
    Uw = Lw(function () {
      Vw(1);
    }) || qw ? function (t) {
      return !!Hw(t) && (!qw || "ArrayBuffer" !== Ww(t)) && (!Vw || Vw(t));
    } : Vw,
    Yw = !r(function () {
      return Object.isExtensible(Object.preventExtensions({}));
    }),
    Xw = Ti,
    Gw = g,
    Kw = Yi,
    $w = tt,
    Zw = Qt,
    Qw = Ze.f,
    Jw = Jh,
    tk = il,
    ek = Uw,
    ik = Yw,
    nk = !1,
    ok = ne("meta"),
    rk = 0,
    sk = function sk(t) {
      Qw(t, ok, {
        value: {
          objectID: "O" + rk++,
          weakData: {}
        }
      });
    },
    ak = jw.exports = {
      enable: function enable() {
        ak.enable = function () {}, nk = !0;
        var t = Jw.f,
          e = Gw([].splice),
          i = {};
        i[ok] = 1, t(i).length && (Jw.f = function (i) {
          for (var n = t(i), o = 0, r = n.length; o < r; o++) if (n[o] === ok) {
            e(n, o, 1);
            break;
          }
          return n;
        }, Xw({
          target: "Object",
          stat: !0,
          forced: !0
        }, {
          getOwnPropertyNames: tk.f
        }));
      },
      fastKey: function fastKey(t, e) {
        if (!$w(t)) return "symbol" == _typeof(t) ? t : ("string" == typeof t ? "S" : "P") + t;
        if (!Zw(t, ok)) {
          if (!ek(t)) return "F";
          if (!e) return "E";
          sk(t);
        }
        return t[ok].objectID;
      },
      getWeakData: function getWeakData(t, e) {
        if (!Zw(t, ok)) {
          if (!ek(t)) return !0;
          if (!e) return !1;
          sk(t);
        }
        return t[ok].weakData;
      },
      onFreeze: function onFreeze(t) {
        return ik && nk && ek(t) && !Zw(t, ok) && sk(t), t;
      }
    };
  Kw[ok] = !0;
  var hk = jw.exports,
    lk = $e,
    dk = I,
    ck = ii,
    uk = St,
    fk = Ys,
    pk = Li,
    vk = at,
    gk = Sa,
    yk = wa,
    mk = Ls,
    bk = TypeError,
    wk = function wk(t, e) {
      this.stopped = t, this.result = e;
    },
    kk = wk.prototype,
    _k = function _k(t, e, i) {
      var n,
        o,
        r,
        s,
        a,
        h,
        l,
        d = i && i.that,
        c = !(!i || !i.AS_ENTRIES),
        u = !(!i || !i.IS_RECORD),
        f = !(!i || !i.IS_ITERATOR),
        p = !(!i || !i.INTERRUPTED),
        v = lk(e, d),
        g = function g(t) {
          return n && mk(n, "normal", t), new wk(!0, t);
        },
        y = function y(t) {
          return c ? (ck(t), p ? v(t[0], t[1], g) : v(t[0], t[1])) : p ? v(t, g) : v(t);
        };
      if (u) n = t.iterator;else if (f) n = t;else {
        if (!(o = yk(t))) throw new bk(uk(t) + " is not iterable");
        if (fk(o)) {
          for (r = 0, s = pk(t); s > r; r++) if ((a = y(t[r])) && vk(kk, a)) return a;
          return new wk(!1);
        }
        n = gk(t, o);
      }
      for (h = u ? t.next : n.next; !(l = dk(h, n)).done;) {
        try {
          a = y(l.value);
        } catch (t) {
          mk(n, "throw", t);
        }
        if ("object" == _typeof(a) && a && vk(kk, a)) return a;
      }
      return new wk(!1);
    },
    xk = at,
    Ek = TypeError,
    Ok = function Ok(t, e) {
      if (xk(e, t)) return t;
      throw new Ek("Incorrect invocation");
    },
    Ck = Ti,
    Sk = o,
    Tk = hk,
    Mk = r,
    Pk = gi,
    Dk = _k,
    Ik = Ok,
    Bk = S,
    Nk = tt,
    Fk = U,
    zk = Gr,
    Ak = Ze.f,
    jk = Fl.forEach,
    Rk = M,
    Lk = Lo.set,
    Hk = Lo.getterFor,
    Wk = function Wk(t, e, i) {
      var n,
        o = -1 !== t.indexOf("Map"),
        r = -1 !== t.indexOf("Weak"),
        s = o ? "set" : "add",
        a = Sk[t],
        h = a && a.prototype,
        l = {};
      if (Rk && Bk(a) && (r || h.forEach && !Mk(function () {
        new a().entries().next();
      }))) {
        var d = (n = e(function (e, i) {
            Lk(Ik(e, d), {
              type: t,
              collection: new a()
            }), Fk(i) || Dk(i, e[s], {
              that: e,
              AS_ENTRIES: o
            });
          })).prototype,
          c = Hk(t);
        jk(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function (t) {
          var e = "add" === t || "set" === t;
          !(t in h) || r && "clear" === t || Pk(d, t, function (i, n) {
            var o = c(this).collection;
            if (!e && r && !Nk(i)) return "get" === t && void 0;
            var s = o[t](0 === i ? 0 : i, n);
            return e ? this : s;
          });
        }), r || Ak(d, "size", {
          configurable: !0,
          get: function get() {
            return c(this).collection.size;
          }
        });
      } else n = i.getConstructor(e, t, o, s), Tk.enable();
      return zk(n, t, !1, !0), l[t] = n, Ck({
        global: !0,
        forced: !0
      }, l), r || i.setStrong(n, t, o), n;
    },
    qk = Mr,
    Vk = function Vk(t, e, i) {
      for (var n in e) i && i.unsafe && t[n] ? t[n] = e[n] : qk(t, n, e[n], i);
      return t;
    },
    Uk = st,
    Yk = vl,
    Xk = M,
    Gk = ue("species"),
    Kk = function Kk(t) {
      var e = Uk(t);
      Xk && e && !e[Gk] && Yk(e, Gk, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    },
    $k = mr,
    Zk = vl,
    Qk = Vk,
    Jk = $e,
    t_ = Ok,
    e_ = U,
    i_ = _k,
    n_ = Ss,
    o_ = Ts,
    r_ = Kk,
    s_ = M,
    a_ = hk.fastKey,
    h_ = Lo.set,
    l_ = Lo.getterFor,
    d_ = {
      getConstructor: function getConstructor(t, e, i, n) {
        var o = t(function (t, o) {
            t_(t, r), h_(t, {
              type: e,
              index: $k(null),
              first: void 0,
              last: void 0,
              size: 0
            }), s_ || (t.size = 0), e_(o) || i_(o, t[n], {
              that: t,
              AS_ENTRIES: i
            });
          }),
          r = o.prototype,
          s = l_(e),
          a = function a(t, e, i) {
            var n,
              o,
              r = s(t),
              a = h(t, e);
            return a ? a.value = i : (r.last = a = {
              index: o = a_(e, !0),
              key: e,
              value: i,
              previous: n = r.last,
              next: void 0,
              removed: !1
            }, r.first || (r.first = a), n && (n.next = a), s_ ? r.size++ : t.size++, "F" !== o && (r.index[o] = a)), t;
          },
          h = function h(t, e) {
            var i,
              n = s(t),
              o = a_(e);
            if ("F" !== o) return n.index[o];
            for (i = n.first; i; i = i.next) if (i.key === e) return i;
          };
        return Qk(r, {
          clear: function clear() {
            for (var t = s(this), e = t.index, i = t.first; i;) i.removed = !0, i.previous && (i.previous = i.previous.next = void 0), delete e[i.index], i = i.next;
            t.first = t.last = void 0, s_ ? t.size = 0 : this.size = 0;
          },
          "delete": function _delete(t) {
            var e = this,
              i = s(e),
              n = h(e, t);
            if (n) {
              var o = n.next,
                r = n.previous;
              delete i.index[n.index], n.removed = !0, r && (r.next = o), o && (o.previous = r), i.first === n && (i.first = o), i.last === n && (i.last = r), s_ ? i.size-- : e.size--;
            }
            return !!n;
          },
          forEach: function forEach(t) {
            for (var e, i = s(this), n = Jk(t, arguments.length > 1 ? arguments[1] : void 0); e = e ? e.next : i.first;) for (n(e.value, e.key, this); e && e.removed;) e = e.previous;
          },
          has: function has(t) {
            return !!h(this, t);
          }
        }), Qk(r, i ? {
          get: function get(t) {
            var e = h(this, t);
            return e && e.value;
          },
          set: function set(t, e) {
            return a(this, 0 === t ? 0 : t, e);
          }
        } : {
          add: function add(t) {
            return a(this, t = 0 === t ? 0 : t, t);
          }
        }), s_ && Zk(r, "size", {
          configurable: !0,
          get: function get() {
            return s(this).size;
          }
        }), o;
      },
      setStrong: function setStrong(t, e, i) {
        var n = e + " Iterator",
          o = l_(e),
          r = l_(n);
        n_(t, e, function (t, e) {
          h_(this, {
            type: n,
            target: t,
            state: o(t),
            kind: e,
            last: void 0
          });
        }, function () {
          for (var t = r(this), e = t.kind, i = t.last; i && i.removed;) i = i.previous;
          return t.target && (t.last = i = i ? i.next : t.state.first) ? o_("keys" === e ? i.key : "values" === e ? i.value : [i.key, i.value], !1) : (t.target = void 0, o_(void 0, !0));
        }, i ? "entries" : "values", !i, !0), r_(e);
      }
    };
  Wk("Map", function (t) {
    return function () {
      return t(this, arguments.length ? arguments[0] : void 0);
    };
  }, d_);
  var c_ = i(et.Map),
    u_ = function () {
      function t() {
        ph(this, t), this.clear(), this._defaultIndex = 0, this._groupIndex = 0, this._defaultGroups = [{
          border: "#2B7CE9",
          background: "#97C2FC",
          highlight: {
            border: "#2B7CE9",
            background: "#D2E5FF"
          },
          hover: {
            border: "#2B7CE9",
            background: "#D2E5FF"
          }
        }, {
          border: "#FFA500",
          background: "#FFFF00",
          highlight: {
            border: "#FFA500",
            background: "#FFFFA3"
          },
          hover: {
            border: "#FFA500",
            background: "#FFFFA3"
          }
        }, {
          border: "#FA0A10",
          background: "#FB7E81",
          highlight: {
            border: "#FA0A10",
            background: "#FFAFB1"
          },
          hover: {
            border: "#FA0A10",
            background: "#FFAFB1"
          }
        }, {
          border: "#41A906",
          background: "#7BE141",
          highlight: {
            border: "#41A906",
            background: "#A1EC76"
          },
          hover: {
            border: "#41A906",
            background: "#A1EC76"
          }
        }, {
          border: "#E129F0",
          background: "#EB7DF4",
          highlight: {
            border: "#E129F0",
            background: "#F0B3F5"
          },
          hover: {
            border: "#E129F0",
            background: "#F0B3F5"
          }
        }, {
          border: "#7C29F0",
          background: "#AD85E4",
          highlight: {
            border: "#7C29F0",
            background: "#D3BDF0"
          },
          hover: {
            border: "#7C29F0",
            background: "#D3BDF0"
          }
        }, {
          border: "#C37F00",
          background: "#FFA807",
          highlight: {
            border: "#C37F00",
            background: "#FFCA66"
          },
          hover: {
            border: "#C37F00",
            background: "#FFCA66"
          }
        }, {
          border: "#4220FB",
          background: "#6E6EFD",
          highlight: {
            border: "#4220FB",
            background: "#9B9BFD"
          },
          hover: {
            border: "#4220FB",
            background: "#9B9BFD"
          }
        }, {
          border: "#FD5A77",
          background: "#FFC0CB",
          highlight: {
            border: "#FD5A77",
            background: "#FFD1D9"
          },
          hover: {
            border: "#FD5A77",
            background: "#FFD1D9"
          }
        }, {
          border: "#4AD63A",
          background: "#C2FABC",
          highlight: {
            border: "#4AD63A",
            background: "#E6FFE3"
          },
          hover: {
            border: "#4AD63A",
            background: "#E6FFE3"
          }
        }, {
          border: "#990000",
          background: "#EE0000",
          highlight: {
            border: "#BB0000",
            background: "#FF3333"
          },
          hover: {
            border: "#BB0000",
            background: "#FF3333"
          }
        }, {
          border: "#FF6000",
          background: "#FF6000",
          highlight: {
            border: "#FF6000",
            background: "#FF6000"
          },
          hover: {
            border: "#FF6000",
            background: "#FF6000"
          }
        }, {
          border: "#97C2FC",
          background: "#2B7CE9",
          highlight: {
            border: "#D2E5FF",
            background: "#2B7CE9"
          },
          hover: {
            border: "#D2E5FF",
            background: "#2B7CE9"
          }
        }, {
          border: "#399605",
          background: "#255C03",
          highlight: {
            border: "#399605",
            background: "#255C03"
          },
          hover: {
            border: "#399605",
            background: "#255C03"
          }
        }, {
          border: "#B70054",
          background: "#FF007E",
          highlight: {
            border: "#B70054",
            background: "#FF007E"
          },
          hover: {
            border: "#B70054",
            background: "#FF007E"
          }
        }, {
          border: "#AD85E4",
          background: "#7C29F0",
          highlight: {
            border: "#D3BDF0",
            background: "#7C29F0"
          },
          hover: {
            border: "#D3BDF0",
            background: "#7C29F0"
          }
        }, {
          border: "#4557FA",
          background: "#000EA1",
          highlight: {
            border: "#6E6EFD",
            background: "#000EA1"
          },
          hover: {
            border: "#6E6EFD",
            background: "#000EA1"
          }
        }, {
          border: "#FFC0CB",
          background: "#FD5A77",
          highlight: {
            border: "#FFD1D9",
            background: "#FD5A77"
          },
          hover: {
            border: "#FFD1D9",
            background: "#FD5A77"
          }
        }, {
          border: "#C2FABC",
          background: "#74D66A",
          highlight: {
            border: "#E6FFE3",
            background: "#74D66A"
          },
          hover: {
            border: "#E6FFE3",
            background: "#74D66A"
          }
        }, {
          border: "#EE0000",
          background: "#990000",
          highlight: {
            border: "#FF3333",
            background: "#BB0000"
          },
          hover: {
            border: "#FF3333",
            background: "#BB0000"
          }
        }], this.options = {}, this.defaultOptions = {
          useDefaultGroups: !0
        }, bn(this.options, this.defaultOptions);
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          var e = ["useDefaultGroups"];
          if (void 0 !== t) for (var i in t) if (Object.prototype.hasOwnProperty.call(t, i) && -1 === lg(e).call(e, i)) {
            var n = t[i];
            this.add(i, n);
          }
        }
      }, {
        key: "clear",
        value: function value() {
          this._groups = new c_(), this._groupNames = [];
        }
      }, {
        key: "get",
        value: function value(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            i = this._groups.get(t);
          if (void 0 === i && e) if (!1 === this.options.useDefaultGroups && this._groupNames.length > 0) {
            var n = this._groupIndex % this._groupNames.length;
            ++this._groupIndex, (i = {}).color = this._groups.get(this._groupNames[n]), this._groups.set(t, i);
          } else {
            var o = this._defaultIndex % this._defaultGroups.length;
            this._defaultIndex++, (i = {}).color = this._defaultGroups[o], this._groups.set(t, i);
          }
          return i;
        }
      }, {
        key: "add",
        value: function value(t, e) {
          return this._groups.has(t) || this._groupNames.push(t), this._groups.set(t, e), e;
        }
      }]), t;
    }();
  Ti({
    target: "Number",
    stat: !0
  }, {
    isNaN: function isNaN(t) {
      return t != t;
    }
  });
  var f_ = i(et.Number.isNaN),
    p_ = o.isFinite,
    v_ = Number.isFinite || function (t) {
      return "number" == typeof t && p_(t);
    };
  Ti({
    target: "Number",
    stat: !0
  }, {
    isFinite: v_
  });
  var g_ = i(et.Number.isFinite),
    y_ = Fl.some;
  Ti({
    target: "Array",
    proto: !0,
    forced: !Xf("some")
  }, {
    some: function some(t) {
      return y_(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var m_ = Nn("Array").some,
    b_ = at,
    w_ = m_,
    k_ = Array.prototype,
    __ = function __(t) {
      var e = t.some;
      return t === k_ || b_(k_, t) && e === k_.some ? w_ : e;
    },
    x_ = i(__);
  function E_(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  var O_ = fg,
    C_ = i(O_);
  Ti({
    target: "Object",
    stat: !0
  }, {
    setPrototypeOf: ds
  });
  var S_ = et.Object.setPrototypeOf,
    T_ = i(S_),
    M_ = i(Ln);
  function P_(t, e) {
    var i;
    return P_ = T_ ? M_(i = T_).call(i) : function (t, e) {
      return t.__proto__ = e, t;
    }, P_(t, e);
  }
  function D_(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = C_(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), xh(t, "prototype", {
      writable: !1
    }), e && P_(t, e);
  }
  function I_(t, e) {
    if (e && ("object" === bu(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return E_(t);
  }
  var B_ = lv,
    N_ = i(B_);
  function F_(t) {
    var e;
    return F_ = T_ ? M_(e = N_).call(e) : function (t) {
      return t.__proto__ || N_(t);
    }, F_(t);
  }
  function z_(t, e, i) {
    return (e = ku(e)) in t ? xh(t, e, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = i, t;
  }
  var A_ = {
      exports: {}
    },
    j_ = {
      exports: {}
    };
  !function (t) {
    var e = pu,
      i = yu;
    function n(o) {
      return t.exports = n = "function" == typeof e && "symbol" == _typeof(i) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof e && t.constructor === e && t !== e.prototype ? "symbol" : _typeof(t);
      }, t.exports.__esModule = !0, t.exports["default"] = t.exports, n(o);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports["default"] = t.exports;
  }(j_);
  var R_ = j_.exports,
    L_ = np,
    H_ = Qt,
    W_ = Mf,
    q_ = T,
    V_ = Ze,
    U_ = tt,
    Y_ = gi,
    X_ = Error,
    G_ = g("".replace),
    K_ = String(new X_("zxcasd").stack),
    $_ = /\n\s*at [^:]*:[^\n]*/,
    Z_ = $_.test(K_),
    Q_ = R,
    J_ = !r(function () {
      var t = new Error("a");
      return !("stack" in t) || (Object.defineProperty(t, "stack", Q_(1, 7)), 7 !== t.stack);
    }),
    tx = gi,
    ex = function ex(t, e) {
      if (Z_ && "string" == typeof t && !X_.prepareStackTrace) for (; e--;) t = G_(t, $_, "");
      return t;
    },
    ix = J_,
    nx = Error.captureStackTrace,
    ox = co,
    rx = Ti,
    sx = at,
    ax = Sr,
    hx = ds,
    lx = function lx(t, e, i) {
      for (var n = W_(e), o = V_.f, r = q_.f, s = 0; s < n.length; s++) {
        var a = n[s];
        H_(t, a) || i && H_(i, a) || o(t, a, r(e, a));
      }
    },
    dx = mr,
    cx = gi,
    ux = R,
    fx = function fx(t, e) {
      U_(e) && "cause" in e && Y_(t, "cause", e.cause);
    },
    px = function px(t, e, i, n) {
      ix && (nx ? nx(t, e) : tx(t, "stack", ex(i, n)));
    },
    vx = _k,
    gx = function gx(t, e) {
      return void 0 === t ? arguments.length < 2 ? "" : e : ox(t);
    },
    yx = ue("toStringTag"),
    mx = Error,
    bx = [].push,
    wx = function wx(t, e) {
      var i,
        n = sx(kx, this);
      hx ? i = hx(new mx(), n ? ax(this) : kx) : (i = n ? this : dx(kx), cx(i, yx, "Error")), void 0 !== e && cx(i, "message", gx(e)), px(i, wx, i.stack, 1), arguments.length > 2 && fx(i, arguments[2]);
      var o = [];
      return vx(t, bx, {
        that: o
      }), cx(i, "errors", o), i;
    };
  hx ? hx(wx, mx) : lx(wx, mx, {
    name: !0
  });
  var kx = wx.prototype = dx(mx.prototype, {
    constructor: ux(1, wx),
    message: ux(1, ""),
    name: ux(1, "AggregateError")
  });
  rx({
    global: !0,
    constructor: !0,
    arity: 2
  }, {
    AggregateError: wx
  });
  var _x,
    xx,
    Ex,
    Ox,
    Cx = "process" === w(o.process),
    Sx = da,
    Tx = St,
    Mx = TypeError,
    Px = function Px(t) {
      if (Sx(t)) return t;
      throw new Mx(Tx(t) + " is not a constructor");
    },
    Dx = ii,
    Ix = Px,
    Bx = U,
    Nx = ue("species"),
    Fx = function Fx(t, e) {
      var i,
        n = Dx(t).constructor;
      return void 0 === n || Bx(i = Dx(n)[Nx]) ? e : Ix(i);
    },
    zx = /(?:ipad|iphone|ipod).*applewebkit/i.test(ht),
    Ax = o,
    jx = c,
    Rx = $e,
    Lx = S,
    Hx = Qt,
    Wx = r,
    qx = er,
    Vx = wn,
    Ux = Ce,
    Yx = kg,
    Xx = zx,
    Gx = Cx,
    Kx = Ax.setImmediate,
    $x = Ax.clearImmediate,
    Zx = Ax.process,
    Qx = Ax.Dispatch,
    Jx = Ax.Function,
    tE = Ax.MessageChannel,
    eE = Ax.String,
    iE = 0,
    nE = {},
    oE = "onreadystatechange";
  Wx(function () {
    _x = Ax.location;
  });
  var rE = function rE(t) {
      if (Hx(nE, t)) {
        var e = nE[t];
        delete nE[t], e();
      }
    },
    sE = function sE(t) {
      return function () {
        rE(t);
      };
    },
    aE = function aE(t) {
      rE(t.data);
    },
    hE = function hE(t) {
      Ax.postMessage(eE(t), _x.protocol + "//" + _x.host);
    };
  Kx && $x || (Kx = function Kx(t) {
    Yx(arguments.length, 1);
    var e = Lx(t) ? t : Jx(t),
      i = Vx(arguments, 1);
    return nE[++iE] = function () {
      jx(e, void 0, i);
    }, xx(iE), iE;
  }, $x = function $x(t) {
    delete nE[t];
  }, Gx ? xx = function xx(t) {
    Zx.nextTick(sE(t));
  } : Qx && Qx.now ? xx = function xx(t) {
    Qx.now(sE(t));
  } : tE && !Xx ? (Ox = (Ex = new tE()).port2, Ex.port1.onmessage = aE, xx = Rx(Ox.postMessage, Ox)) : Ax.addEventListener && Lx(Ax.postMessage) && !Ax.importScripts && _x && "file:" !== _x.protocol && !Wx(hE) ? (xx = hE, Ax.addEventListener("message", aE, !1)) : xx = oE in Ux("script") ? function (t) {
    qx.appendChild(Ux("script"))[oE] = function () {
      qx.removeChild(this), rE(t);
    };
  } : function (t) {
    setTimeout(sE(t), 0);
  });
  var lE = {
      set: Kx,
      clear: $x
    },
    dE = function dE() {
      this.head = null, this.tail = null;
    };
  dE.prototype = {
    add: function add(t) {
      var e = {
          item: t,
          next: null
        },
        i = this.tail;
      i ? i.next = e : this.head = e, this.tail = e;
    },
    get: function get() {
      var t = this.head;
      if (t) return null === (this.head = t.next) && (this.tail = null), t.item;
    }
  };
  var cE,
    uE,
    fE,
    pE,
    vE,
    gE = dE,
    yE = /ipad|iphone|ipod/i.test(ht) && "undefined" != typeof Pebble,
    mE = /web0s(?!.*chrome)/i.test(ht),
    bE = o,
    wE = $e,
    kE = T.f,
    _E = lE.set,
    xE = gE,
    EE = zx,
    OE = yE,
    CE = mE,
    SE = Cx,
    TE = bE.MutationObserver || bE.WebKitMutationObserver,
    ME = bE.document,
    PE = bE.process,
    DE = bE.Promise,
    IE = kE(bE, "queueMicrotask"),
    BE = IE && IE.value;
  if (!BE) {
    var NE = new xE(),
      FE = function FE() {
        var t, e;
        for (SE && (t = PE.domain) && t.exit(); e = NE.get();) try {
          e();
        } catch (t) {
          throw NE.head && cE(), t;
        }
        t && t.enter();
      };
    EE || SE || CE || !TE || !ME ? !OE && DE && DE.resolve ? ((pE = DE.resolve(void 0)).constructor = DE, vE = wE(pE.then, pE), cE = function cE() {
      vE(FE);
    }) : SE ? cE = function cE() {
      PE.nextTick(FE);
    } : (_E = wE(_E, bE), cE = function cE() {
      _E(FE);
    }) : (uE = !0, fE = ME.createTextNode(""), new TE(FE).observe(fE, {
      characterData: !0
    }), cE = function cE() {
      fE.data = uE = !uE;
    }), BE = function BE(t) {
      NE.head || cE(), NE.add(t);
    };
  }
  var zE = BE,
    AE = function AE(t) {
      try {
        return {
          error: !1,
          value: t()
        };
      } catch (t) {
        return {
          error: !0,
          value: t
        };
      }
    },
    jE = o.Promise,
    RE = "object" == (typeof Deno === "undefined" ? "undefined" : _typeof(Deno)) && Deno && "object" == _typeof(Deno.version),
    LE = !RE && !Cx && "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && "object" == (typeof document === "undefined" ? "undefined" : _typeof(document)),
    HE = o,
    WE = jE,
    qE = S,
    VE = Ye,
    UE = $s,
    YE = ue,
    XE = LE,
    GE = RE,
    KE = vt,
    $E = WE && WE.prototype,
    ZE = YE("species"),
    QE = !1,
    JE = qE(HE.PromiseRejectionEvent),
    tO = VE("Promise", function () {
      var t = UE(WE),
        e = t !== String(WE);
      if (!e && 66 === KE) return !0;
      if (!$E["catch"] || !$E["finally"]) return !0;
      if (!KE || KE < 51 || !/native code/.test(t)) {
        var i = new WE(function (t) {
            t(1);
          }),
          n = function n(t) {
            t(function () {}, function () {});
          };
        if ((i.constructor = {})[ZE] = n, !(QE = i.then(function () {}) instanceof n)) return !0;
      }
      return !e && (XE || GE) && !JE;
    }),
    eO = {
      CONSTRUCTOR: tO,
      REJECTION_EVENT: JE,
      SUBCLASSING: QE
    },
    iO = {},
    nO = Dt,
    oO = TypeError,
    rO = function rO(t) {
      var e, i;
      this.promise = new t(function (t, n) {
        if (void 0 !== e || void 0 !== i) throw new oO("Bad Promise constructor");
        e = t, i = n;
      }), this.resolve = nO(e), this.reject = nO(i);
    };
  iO.f = function (t) {
    return new rO(t);
  };
  var sO,
    aO,
    hO = Ti,
    lO = Cx,
    dO = o,
    cO = I,
    uO = Mr,
    fO = Gr,
    pO = Kk,
    vO = Dt,
    gO = S,
    yO = tt,
    mO = Ok,
    bO = Fx,
    wO = lE.set,
    kO = zE,
    _O = function _O(t, e) {
      try {
        1 === arguments.length ? console.error(t) : console.error(t, e);
      } catch (t) {}
    },
    xO = AE,
    EO = gE,
    OO = Lo,
    CO = jE,
    SO = eO,
    TO = iO,
    MO = "Promise",
    PO = SO.CONSTRUCTOR,
    DO = SO.REJECTION_EVENT,
    IO = OO.getterFor(MO),
    BO = OO.set,
    NO = CO && CO.prototype,
    FO = CO,
    zO = NO,
    AO = dO.TypeError,
    jO = dO.document,
    RO = dO.process,
    LO = TO.f,
    HO = LO,
    WO = !!(jO && jO.createEvent && dO.dispatchEvent),
    qO = "unhandledrejection",
    VO = function VO(t) {
      var e;
      return !(!yO(t) || !gO(e = t.then)) && e;
    },
    UO = function UO(t, e) {
      var i,
        n,
        o,
        r = e.value,
        s = 1 === e.state,
        a = s ? t.ok : t.fail,
        h = t.resolve,
        l = t.reject,
        d = t.domain;
      try {
        a ? (s || (2 === e.rejection && $O(e), e.rejection = 1), !0 === a ? i = r : (d && d.enter(), i = a(r), d && (d.exit(), o = !0)), i === t.promise ? l(new AO("Promise-chain cycle")) : (n = VO(i)) ? cO(n, i, h, l) : h(i)) : l(r);
      } catch (t) {
        d && !o && d.exit(), l(t);
      }
    },
    YO = function YO(t, e) {
      t.notified || (t.notified = !0, kO(function () {
        for (var i, n = t.reactions; i = n.get();) UO(i, t);
        t.notified = !1, e && !t.rejection && GO(t);
      }));
    },
    XO = function XO(t, e, i) {
      var n, o;
      WO ? ((n = jO.createEvent("Event")).promise = e, n.reason = i, n.initEvent(t, !1, !0), dO.dispatchEvent(n)) : n = {
        promise: e,
        reason: i
      }, !DO && (o = dO["on" + t]) ? o(n) : t === qO && _O("Unhandled promise rejection", i);
    },
    GO = function GO(t) {
      cO(wO, dO, function () {
        var e,
          i = t.facade,
          n = t.value;
        if (KO(t) && (e = xO(function () {
          lO ? RO.emit("unhandledRejection", n, i) : XO(qO, i, n);
        }), t.rejection = lO || KO(t) ? 2 : 1, e.error)) throw e.value;
      });
    },
    KO = function KO(t) {
      return 1 !== t.rejection && !t.parent;
    },
    $O = function $O(t) {
      cO(wO, dO, function () {
        var e = t.facade;
        lO ? RO.emit("rejectionHandled", e) : XO("rejectionhandled", e, t.value);
      });
    },
    ZO = function ZO(t, e, i) {
      return function (n) {
        t(e, n, i);
      };
    },
    QO = function QO(t, e, i) {
      t.done || (t.done = !0, i && (t = i), t.value = e, t.state = 2, YO(t, !0));
    },
    JO = function JO(t, e, i) {
      if (!t.done) {
        t.done = !0, i && (t = i);
        try {
          if (t.facade === e) throw new AO("Promise can't be resolved itself");
          var n = VO(e);
          n ? kO(function () {
            var i = {
              done: !1
            };
            try {
              cO(n, e, ZO(JO, i, t), ZO(QO, i, t));
            } catch (e) {
              QO(i, e, t);
            }
          }) : (t.value = e, t.state = 1, YO(t, !1));
        } catch (e) {
          QO({
            done: !1
          }, e, t);
        }
      }
    };
  PO && (zO = (FO = function FO(t) {
    mO(this, zO), vO(t), cO(sO, this);
    var e = IO(this);
    try {
      t(ZO(JO, e), ZO(QO, e));
    } catch (t) {
      QO(e, t);
    }
  }).prototype, (sO = function sO(t) {
    BO(this, {
      type: MO,
      done: !1,
      notified: !1,
      parent: !1,
      reactions: new EO(),
      rejection: !1,
      state: 0,
      value: void 0
    });
  }).prototype = uO(zO, "then", function (t, e) {
    var i = IO(this),
      n = LO(bO(this, FO));
    return i.parent = !0, n.ok = !gO(t) || t, n.fail = gO(e) && e, n.domain = lO ? RO.domain : void 0, 0 === i.state ? i.reactions.add(n) : kO(function () {
      UO(n, i);
    }), n.promise;
  }), aO = function aO() {
    var t = new sO(),
      e = IO(t);
    this.promise = t, this.resolve = ZO(JO, e), this.reject = ZO(QO, e);
  }, TO.f = LO = function LO(t) {
    return t === FO || undefined === t ? new aO(t) : HO(t);
  }), hO({
    global: !0,
    constructor: !0,
    wrap: !0,
    forced: PO
  }, {
    Promise: FO
  }), fO(FO, MO, !1, !0), pO(MO);
  var tC = jE,
    eC = eO.CONSTRUCTOR || !qa(function (t) {
      tC.all(t).then(void 0, function () {});
    }),
    iC = I,
    nC = Dt,
    oC = iO,
    rC = AE,
    sC = _k;
  Ti({
    target: "Promise",
    stat: !0,
    forced: eC
  }, {
    all: function all(t) {
      var e = this,
        i = oC.f(e),
        n = i.resolve,
        o = i.reject,
        r = rC(function () {
          var i = nC(e.resolve),
            r = [],
            s = 0,
            a = 1;
          sC(t, function (t) {
            var h = s++,
              l = !1;
            a++, iC(i, e, t).then(function (t) {
              l || (l = !0, r[h] = t, --a || n(r));
            }, o);
          }), --a || n(r);
        });
      return r.error && o(r.value), i.promise;
    }
  });
  var aC = Ti,
    hC = eO.CONSTRUCTOR;
  jE && jE.prototype, aC({
    target: "Promise",
    proto: !0,
    forced: hC,
    real: !0
  }, {
    "catch": function _catch(t) {
      return this.then(void 0, t);
    }
  });
  var lC = I,
    dC = Dt,
    cC = iO,
    uC = AE,
    fC = _k;
  Ti({
    target: "Promise",
    stat: !0,
    forced: eC
  }, {
    race: function race(t) {
      var e = this,
        i = cC.f(e),
        n = i.reject,
        o = uC(function () {
          var o = dC(e.resolve);
          fC(t, function (t) {
            lC(o, e, t).then(i.resolve, n);
          });
        });
      return o.error && n(o.value), i.promise;
    }
  });
  var pC = I,
    vC = iO;
  Ti({
    target: "Promise",
    stat: !0,
    forced: eO.CONSTRUCTOR
  }, {
    reject: function reject(t) {
      var e = vC.f(this);
      return pC(e.reject, void 0, t), e.promise;
    }
  });
  var gC = ii,
    yC = tt,
    mC = iO,
    bC = function bC(t, e) {
      if (gC(t), yC(e) && e.constructor === t) return e;
      var i = mC.f(t);
      return (0, i.resolve)(e), i.promise;
    },
    wC = Ti,
    kC = jE,
    _C = eO.CONSTRUCTOR,
    xC = bC,
    EC = st("Promise"),
    OC = !_C;
  wC({
    target: "Promise",
    stat: !0,
    forced: true
  }, {
    resolve: function resolve(t) {
      return xC(OC && this === EC ? kC : this, t);
    }
  });
  var CC = I,
    SC = Dt,
    TC = iO,
    MC = AE,
    PC = _k;
  Ti({
    target: "Promise",
    stat: !0,
    forced: eC
  }, {
    allSettled: function allSettled(t) {
      var e = this,
        i = TC.f(e),
        n = i.resolve,
        o = i.reject,
        r = MC(function () {
          var i = SC(e.resolve),
            o = [],
            r = 0,
            s = 1;
          PC(t, function (t) {
            var a = r++,
              h = !1;
            s++, CC(i, e, t).then(function (t) {
              h || (h = !0, o[a] = {
                status: "fulfilled",
                value: t
              }, --s || n(o));
            }, function (t) {
              h || (h = !0, o[a] = {
                status: "rejected",
                reason: t
              }, --s || n(o));
            });
          }), --s || n(o);
        });
      return r.error && o(r.value), i.promise;
    }
  });
  var DC = I,
    IC = Dt,
    BC = st,
    NC = iO,
    FC = AE,
    zC = _k,
    AC = "No one promise resolved";
  Ti({
    target: "Promise",
    stat: !0,
    forced: eC
  }, {
    any: function any(t) {
      var e = this,
        i = BC("AggregateError"),
        n = NC.f(e),
        o = n.resolve,
        r = n.reject,
        s = FC(function () {
          var n = IC(e.resolve),
            s = [],
            a = 0,
            h = 1,
            l = !1;
          zC(t, function (t) {
            var d = a++,
              c = !1;
            h++, DC(n, e, t).then(function (t) {
              c || l || (l = !0, o(t));
            }, function (t) {
              c || l || (c = !0, s[d] = t, --h || r(new i(s, AC)));
            });
          }), --h || r(new i(s, AC));
        });
      return s.error && r(s.value), n.promise;
    }
  });
  var jC = Ti,
    RC = jE,
    LC = r,
    HC = st,
    WC = S,
    qC = Fx,
    VC = bC,
    UC = RC && RC.prototype;
  jC({
    target: "Promise",
    proto: !0,
    real: !0,
    forced: !!RC && LC(function () {
      UC["finally"].call({
        then: function then() {}
      }, function () {});
    })
  }, {
    "finally": function _finally(t) {
      var e = qC(this, HC("Promise")),
        i = WC(t);
      return this.then(i ? function (i) {
        return VC(e, t()).then(function () {
          return i;
        });
      } : t, i ? function (i) {
        return VC(e, t()).then(function () {
          throw i;
        });
      } : t);
    }
  });
  var YC = et.Promise,
    XC = iO;
  Ti({
    target: "Promise",
    stat: !0
  }, {
    withResolvers: function withResolvers() {
      var t = XC.f(this);
      return {
        promise: t.promise,
        resolve: t.resolve,
        reject: t.reject
      };
    }
  });
  var GC = YC,
    KC = iO,
    $C = AE;
  Ti({
    target: "Promise",
    stat: !0,
    forced: !0
  }, {
    "try": function _try(t) {
      var e = KC.f(this),
        i = $C(t);
      return (i.error ? e.reject : e.resolve)(i.value), e.promise;
    }
  });
  var ZC = GC,
    QC = pp;
  !function (t) {
    var e = R_["default"],
      i = _h,
      n = pu,
      o = O_,
      r = B_,
      s = L_,
      a = Lu,
      h = S_,
      l = ZC,
      d = QC,
      c = lf;
    function u() {
      t.exports = u = function u() {
        return p;
      }, t.exports.__esModule = !0, t.exports["default"] = t.exports;
      var f,
        p = {},
        v = Object.prototype,
        g = v.hasOwnProperty,
        y = i || function (t, e, i) {
          t[e] = i.value;
        },
        m = "function" == typeof n ? n : {},
        b = m.iterator || "@@iterator",
        w = m.asyncIterator || "@@asyncIterator",
        k = m.toStringTag || "@@toStringTag";
      function _(t, e, n) {
        return i(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[e];
      }
      try {
        _({}, "");
      } catch (f) {
        _ = function _(t, e, i) {
          return t[e] = i;
        };
      }
      function x(t, e, i, n) {
        var r = e && e.prototype instanceof P ? e : P,
          s = o(r.prototype),
          a = new W(n || []);
        return y(s, "_invoke", {
          value: j(t, i, a)
        }), s;
      }
      function E(t, e, i) {
        try {
          return {
            type: "normal",
            arg: t.call(e, i)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }
      p.wrap = x;
      var O = "suspendedStart",
        C = "suspendedYield",
        S = "executing",
        T = "completed",
        M = {};
      function P() {}
      function D() {}
      function I() {}
      var B = {};
      _(B, b, function () {
        return this;
      });
      var N = r && r(r(q([])));
      N && N !== v && g.call(N, b) && (B = N);
      var F = I.prototype = P.prototype = o(B);
      function z(t) {
        var e;
        s(e = ["next", "throw", "return"]).call(e, function (e) {
          _(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }
      function A(t, i) {
        function n(o, r, s, a) {
          var h = E(t[o], t, r);
          if ("throw" !== h.type) {
            var l = h.arg,
              d = l.value;
            return d && "object" == e(d) && g.call(d, "__await") ? i.resolve(d.__await).then(function (t) {
              n("next", t, s, a);
            }, function (t) {
              n("throw", t, s, a);
            }) : i.resolve(d).then(function (t) {
              l.value = t, s(l);
            }, function (t) {
              return n("throw", t, s, a);
            });
          }
          a(h.arg);
        }
        var o;
        y(this, "_invoke", {
          value: function value(t, e) {
            function r() {
              return new i(function (i, o) {
                n(t, e, i, o);
              });
            }
            return o = o ? o.then(r, r) : r();
          }
        });
      }
      function j(t, e, i) {
        var n = O;
        return function (o, r) {
          if (n === S) throw new Error("Generator is already running");
          if (n === T) {
            if ("throw" === o) throw r;
            return {
              value: f,
              done: !0
            };
          }
          for (i.method = o, i.arg = r;;) {
            var s = i.delegate;
            if (s) {
              var a = R(s, i);
              if (a) {
                if (a === M) continue;
                return a;
              }
            }
            if ("next" === i.method) i.sent = i._sent = i.arg;else if ("throw" === i.method) {
              if (n === O) throw n = T, i.arg;
              i.dispatchException(i.arg);
            } else "return" === i.method && i.abrupt("return", i.arg);
            n = S;
            var h = E(t, e, i);
            if ("normal" === h.type) {
              if (n = i.done ? T : C, h.arg === M) continue;
              return {
                value: h.arg,
                done: i.done
              };
            }
            "throw" === h.type && (n = T, i.method = "throw", i.arg = h.arg);
          }
        };
      }
      function R(t, e) {
        var i = e.method,
          n = t.iterator[i];
        if (n === f) return e.delegate = null, "throw" === i && t.iterator["return"] && (e.method = "return", e.arg = f, R(t, e), "throw" === e.method) || "return" !== i && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + i + "' method")), M;
        var o = E(n, t.iterator, e.arg);
        if ("throw" === o.type) return e.method = "throw", e.arg = o.arg, e.delegate = null, M;
        var r = o.arg;
        return r ? r.done ? (e[t.resultName] = r.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = f), e.delegate = null, M) : r : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, M);
      }
      function L(t) {
        var e,
          i = {
            tryLoc: t[0]
          };
        1 in t && (i.catchLoc = t[1]), 2 in t && (i.finallyLoc = t[2], i.afterLoc = t[3]), a(e = this.tryEntries).call(e, i);
      }
      function H(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }
      function W(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], s(t).call(t, L, this), this.reset(!0);
      }
      function q(t) {
        if (t || "" === t) {
          var i = t[b];
          if (i) return i.call(t);
          if ("function" == typeof t.next) return t;
          if (!isNaN(t.length)) {
            var n = -1,
              o = function e() {
                for (; ++n < t.length;) if (g.call(t, n)) return e.value = t[n], e.done = !1, e;
                return e.value = f, e.done = !0, e;
              };
            return o.next = o;
          }
        }
        throw new TypeError(e(t) + " is not iterable");
      }
      return D.prototype = I, y(F, "constructor", {
        value: I,
        configurable: !0
      }), y(I, "constructor", {
        value: D,
        configurable: !0
      }), D.displayName = _(I, k, "GeneratorFunction"), p.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === D || "GeneratorFunction" === (e.displayName || e.name));
      }, p.mark = function (t) {
        return h ? h(t, I) : (t.__proto__ = I, _(t, k, "GeneratorFunction")), t.prototype = o(F), t;
      }, p.awrap = function (t) {
        return {
          __await: t
        };
      }, z(A.prototype), _(A.prototype, w, function () {
        return this;
      }), p.AsyncIterator = A, p.async = function (t, e, i, n, o) {
        void 0 === o && (o = l);
        var r = new A(x(t, e, i, n), o);
        return p.isGeneratorFunction(e) ? r : r.next().then(function (t) {
          return t.done ? t.value : r.next();
        });
      }, z(F), _(F, k, "Generator"), _(F, b, function () {
        return this;
      }), _(F, "toString", function () {
        return "[object Generator]";
      }), p.keys = function (t) {
        var e = Object(t),
          i = [];
        for (var n in e) a(i).call(i, n);
        return d(i).call(i), function t() {
          for (; i.length;) {
            var n = i.pop();
            if (n in e) return t.value = n, t.done = !1, t;
          }
          return t.done = !0, t;
        };
      }, p.values = q, W.prototype = {
        constructor: W,
        reset: function reset(t) {
          var e;
          if (this.prev = 0, this.next = 0, this.sent = this._sent = f, this.done = !1, this.delegate = null, this.method = "next", this.arg = f, s(e = this.tryEntries).call(e, H), !t) for (var i in this) "t" === i.charAt(0) && g.call(this, i) && !isNaN(+c(i).call(i, 1)) && (this[i] = f);
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;
          function i(i, n) {
            return r.type = "throw", r.arg = t, e.next = i, n && (e.method = "next", e.arg = f), !!n;
          }
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n],
              r = o.completion;
            if ("root" === o.tryLoc) return i("end");
            if (o.tryLoc <= this.prev) {
              var s = g.call(o, "catchLoc"),
                a = g.call(o, "finallyLoc");
              if (s && a) {
                if (this.prev < o.catchLoc) return i(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return i(o.finallyLoc);
              } else if (s) {
                if (this.prev < o.catchLoc) return i(o.catchLoc, !0);
              } else {
                if (!a) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return i(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var n = this.tryEntries[i];
            if (n.tryLoc <= this.prev && g.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
              var o = n;
              break;
            }
          }
          o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
          var r = o ? o.completion : {};
          return r.type = t, r.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, M) : this.complete(r);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), M;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var i = this.tryEntries[e];
            if (i.finallyLoc === t) return this.complete(i.completion, i.afterLoc), H(i), M;
          }
        },
        "catch": function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var i = this.tryEntries[e];
            if (i.tryLoc === t) {
              var n = i.completion;
              if ("throw" === n.type) {
                var o = n.arg;
                H(i);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, i) {
          return this.delegate = {
            iterator: q(t),
            resultName: e,
            nextLoc: i
          }, "next" === this.method && (this.arg = f), M;
        }
      }, p;
    }
    t.exports = u, t.exports.__esModule = !0, t.exports["default"] = t.exports;
  }(A_);
  var JC = (0, A_.exports)(),
    tS = JC;
  try {
    regeneratorRuntime = JC;
  } catch (t) {
    "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) ? globalThis.regeneratorRuntime = JC : Function("r", "regeneratorRuntime = r")(JC);
  }
  var eS = i(tS),
    iS = Dt,
    nS = Kt,
    oS = V,
    rS = Li,
    sS = TypeError,
    aS = function aS(t) {
      return function (e, i, n, o) {
        iS(i);
        var r = nS(e),
          s = oS(r),
          a = rS(r),
          h = t ? a - 1 : 0,
          l = t ? -1 : 1;
        if (n < 2) for (;;) {
          if (h in s) {
            o = s[h], h += l;
            break;
          }
          if (h += l, t ? h < 0 : a <= h) throw new sS("Reduce of empty array with no initial value");
        }
        for (; t ? h >= 0 : a > h; h += l) h in s && (o = i(o, s[h], h, r));
        return o;
      };
    },
    hS = {
      left: aS(!1),
      right: aS(!0)
    }.left;
  Ti({
    target: "Array",
    proto: !0,
    forced: !Cx && vt > 79 && vt < 83 || !Xf("reduce")
  }, {
    reduce: function reduce(t) {
      var e = arguments.length;
      return hS(this, t, e, e > 1 ? arguments[1] : void 0);
    }
  });
  var lS = Nn("Array").reduce,
    dS = at,
    cS = lS,
    uS = Array.prototype,
    fS = function fS(t) {
      var e = t.reduce;
      return t === uS || dS(uS, t) && e === uS.reduce ? cS : e;
    },
    pS = i(fS),
    vS = Oh,
    gS = Li,
    yS = Sh,
    mS = $e,
    bS = function bS(t, e, i, n, o, r, s, a) {
      for (var h, l, d = o, c = 0, u = !!s && mS(s, a); c < n;) c in i && (h = u ? u(i[c], c, e) : i[c], r > 0 && vS(h) ? (l = gS(h), d = bS(t, e, h, l, d, r - 1) - 1) : (yS(d + 1), t[d] = h), d++), c++;
      return d;
    },
    wS = bS,
    kS = Dt,
    _S = Kt,
    xS = Li,
    ES = Nh;
  Ti({
    target: "Array",
    proto: !0
  }, {
    flatMap: function flatMap(t) {
      var e,
        i = _S(this),
        n = xS(i);
      return kS(t), (e = ES(i, 0)).length = wS(e, i, i, n, 0, 1, t, arguments.length > 1 ? arguments[1] : void 0), e;
    }
  });
  var OS = Nn("Array").flatMap,
    CS = at,
    SS = OS,
    TS = Array.prototype,
    MS = function MS(t) {
      var e = t.flatMap;
      return t === TS || CS(TS, t) && e === TS.flatMap ? SS : e;
    },
    PS = i(MS);
  Wk("Set", function (t) {
    return function () {
      return t(this, arguments.length ? arguments[0] : void 0);
    };
  }, d_);
  var DS = i(et.Set),
    IS = i(gu),
    BS = i(Sa),
    NS = hl,
    FS = Math.floor,
    zS = function zS(t, e) {
      var i = t.length,
        n = FS(i / 2);
      return i < 8 ? AS(t, e) : jS(t, zS(NS(t, 0, n), e), zS(NS(t, n), e), e);
    },
    AS = function AS(t, e) {
      for (var i, n, o = t.length, r = 1; r < o;) {
        for (n = r, i = t[r]; n && e(t[n - 1], i) > 0;) t[n] = t[--n];
        n !== r++ && (t[n] = i);
      }
      return t;
    },
    jS = function jS(t, e, i, n) {
      for (var o = e.length, r = i.length, s = 0, a = 0; s < o || a < r;) t[s + a] = s < o && a < r ? n(e[s], i[a]) <= 0 ? e[s++] : i[a++] : s < o ? e[s++] : i[a++];
      return t;
    },
    RS = zS,
    LS = ht.match(/firefox\/(\d+)/i),
    HS = !!LS && +LS[1],
    WS = /MSIE|Trident/.test(ht),
    qS = ht.match(/AppleWebKit\/(\d+)\./),
    VS = !!qS && +qS[1],
    US = Ti,
    YS = g,
    XS = Dt,
    GS = Kt,
    KS = Li,
    $S = mp,
    ZS = co,
    QS = r,
    JS = RS,
    tT = Xf,
    eT = HS,
    iT = WS,
    nT = vt,
    oT = VS,
    rT = [],
    sT = YS(rT.sort),
    aT = YS(rT.push),
    hT = QS(function () {
      rT.sort(void 0);
    }),
    lT = QS(function () {
      rT.sort(null);
    }),
    dT = tT("sort"),
    cT = !QS(function () {
      if (nT) return nT < 70;
      if (!(eT && eT > 3)) {
        if (iT) return !0;
        if (oT) return oT < 603;
        var t,
          e,
          i,
          n,
          o = "";
        for (t = 65; t < 76; t++) {
          switch (e = String.fromCharCode(t), t) {
            case 66:
            case 69:
            case 70:
            case 72:
              i = 3;
              break;
            case 68:
            case 71:
              i = 4;
              break;
            default:
              i = 2;
          }
          for (n = 0; n < 47; n++) rT.push({
            k: e + n,
            v: i
          });
        }
        for (rT.sort(function (t, e) {
          return e.v - t.v;
        }), n = 0; n < rT.length; n++) e = rT[n].k.charAt(0), o.charAt(o.length - 1) !== e && (o += e);
        return "DGBEFHACIJK" !== o;
      }
    });
  US({
    target: "Array",
    proto: !0,
    forced: hT || !lT || !dT || !cT
  }, {
    sort: function sort(t) {
      void 0 !== t && XS(t);
      var e = GS(this);
      if (cT) return void 0 === t ? sT(e) : sT(e, t);
      var i,
        n,
        o = [],
        r = KS(e);
      for (n = 0; n < r; n++) n in e && aT(o, e[n]);
      for (JS(o, function (t) {
        return function (e, i) {
          return void 0 === i ? -1 : void 0 === e ? 1 : void 0 !== t ? +t(e, i) || 0 : ZS(e) > ZS(i) ? 1 : -1;
        };
      }(t)), i = KS(o), n = 0; n < i;) e[n] = o[n++];
      for (; n < r;) $S(e, n++);
      return e;
    }
  });
  var uT = Nn("Array").sort,
    fT = at,
    pT = uT,
    vT = Array.prototype,
    gT = function gT(t) {
      var e = t.sort;
      return t === vT || fT(vT, t) && e === vT.sort ? pT : e;
    },
    yT = i(gT),
    mT = Nn("Array").keys,
    bT = ao,
    wT = Qt,
    kT = at,
    _T = mT,
    xT = Array.prototype,
    ET = {
      DOMTokenList: !0,
      NodeList: !0
    },
    OT = function OT(t) {
      var e = t.keys;
      return t === xT || kT(xT, t) && e === xT.keys || wT(ET, bT(t)) ? _T : e;
    },
    CT = i(OT),
    ST = Nn("Array").values,
    TT = ao,
    MT = Qt,
    PT = at,
    DT = ST,
    IT = Array.prototype,
    BT = {
      DOMTokenList: !0,
      NodeList: !0
    },
    NT = function NT(t) {
      var e = t.values;
      return t === IT || PT(IT, t) && e === IT.values || MT(BT, TT(t)) ? DT : e;
    },
    FT = i(NT),
    zT = Nn("Array").entries,
    AT = ao,
    jT = Qt,
    RT = at,
    LT = zT,
    HT = Array.prototype,
    WT = {
      DOMTokenList: !0,
      NodeList: !0
    },
    qT = function qT(t) {
      var e = t.entries;
      return t === HT || RT(HT, t) && e === HT.entries || jT(WT, AT(t)) ? LT : e;
    },
    VT = i(qT),
    UT = i(kh),
    YT = Ti,
    XT = c,
    GT = Dn,
    KT = Px,
    $T = ii,
    ZT = tt,
    QT = mr,
    JT = r,
    tM = st("Reflect", "construct"),
    eM = Object.prototype,
    iM = [].push,
    nM = JT(function () {
      function t() {}
      return !(tM(function () {}, [], t) instanceof t);
    }),
    oM = !JT(function () {
      tM(function () {});
    }),
    rM = nM || oM;
  YT({
    target: "Reflect",
    stat: !0,
    forced: rM,
    sham: rM
  }, {
    construct: function construct(t, e) {
      KT(t), $T(e);
      var i = arguments.length < 3 ? t : KT(arguments[2]);
      if (oM && !nM) return tM(t, e, i);
      if (t === i) {
        switch (e.length) {
          case 0:
            return new t();
          case 1:
            return new t(e[0]);
          case 2:
            return new t(e[0], e[1]);
          case 3:
            return new t(e[0], e[1], e[2]);
          case 4:
            return new t(e[0], e[1], e[2], e[3]);
        }
        var n = [null];
        return XT(iM, n, e), new (XT(GT, t, n))();
      }
      var o = i.prototype,
        r = QT(ZT(o) ? o : eM),
        s = XT(t, r, e);
      return ZT(s) ? s : r;
    }
  });
  var sM = i(et.Reflect.construct),
    aM = i(et.Object.getOwnPropertySymbols),
    hM = {
      exports: {}
    },
    lM = Ti,
    dM = r,
    cM = Z,
    uM = T.f,
    fM = M;
  lM({
    target: "Object",
    stat: !0,
    forced: !fM || dM(function () {
      uM(1);
    }),
    sham: !fM
  }, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, e) {
      return uM(cM(t), e);
    }
  });
  var pM = et.Object,
    vM = hM.exports = function (t, e) {
      return pM.getOwnPropertyDescriptor(t, e);
    };
  pM.getOwnPropertyDescriptor.sham && (vM.sham = !0);
  var gM = hM.exports,
    yM = i(gM),
    mM = Mf,
    bM = Z,
    wM = T,
    kM = pa;
  Ti({
    target: "Object",
    stat: !0,
    sham: !M
  }, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
      for (var e, i, n = bM(t), o = wM.f, r = mM(n), s = {}, a = 0; r.length > a;) void 0 !== (i = o(n, e = r[a++])) && kM(s, e, i);
      return s;
    }
  });
  var _M = i(et.Object.getOwnPropertyDescriptors),
    xM = {
      exports: {}
    },
    EM = Ti,
    OM = M,
    CM = Xo.f;
  EM({
    target: "Object",
    stat: !0,
    forced: Object.defineProperties !== CM,
    sham: !OM
  }, {
    defineProperties: CM
  });
  var SM = et.Object,
    TM = xM.exports = function (t, e) {
      return SM.defineProperties(t, e);
    };
  SM.defineProperties.sham && (TM.sham = !0);
  var MM = i(xM.exports);
  var PM;
  var DM = new Uint8Array(16);
  function IM() {
    if (!PM && (PM = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !PM)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return PM(DM);
  }
  var BM = [];
  for (var _t3 = 0; _t3 < 256; ++_t3) BM.push((_t3 + 256).toString(16).slice(1));
  var NM,
    FM = {
      randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
    };
  function zM(t, e, i) {
    if (FM.randomUUID && !e && !t) return FM.randomUUID();
    var n = (t = t || {}).random || (t.rng || IM)();
    if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, e) {
      i = i || 0;
      for (var _t4 = 0; _t4 < 16; ++_t4) e[i + _t4] = n[_t4];
      return e;
    }
    return function (t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return BM[t[e + 0]] + BM[t[e + 1]] + BM[t[e + 2]] + BM[t[e + 3]] + "-" + BM[t[e + 4]] + BM[t[e + 5]] + "-" + BM[t[e + 6]] + BM[t[e + 7]] + "-" + BM[t[e + 8]] + BM[t[e + 9]] + "-" + BM[t[e + 10]] + BM[t[e + 11]] + BM[t[e + 12]] + BM[t[e + 13]] + BM[t[e + 14]] + BM[t[e + 15]];
    }(n);
  }
  function AM(t, e) {
    var i = Hf(t);
    if (aM) {
      var n = aM(t);
      e && (n = yv(n).call(n, function (e) {
        return yM(t, e).enumerable;
      })), i.push.apply(i, n);
    }
    return i;
  }
  function jM(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i,
        n,
        o = null != arguments[e] ? arguments[e] : {};
      e % 2 ? op(i = AM(Object(o), !0)).call(i, function (e) {
        z_(t, e, o[e]);
      }) : _M ? MM(t, _M(o)) : op(n = AM(Object(o))).call(n, function (e) {
        UT(t, e, yM(o, e));
      });
    }
    return t;
  }
  function RM(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  function LM(t, e) {
    var i = void 0 !== gf && fh(t) || t["@@iterator"];
    if (!i) {
      if (Df(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return HM(t, e);
        var n = xf(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Ya(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return HM(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);
        var _n3 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n3 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n3++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r,
      s = !0,
      a = !1;
    return {
      s: function s() {
        i = i.call(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i["return"] || i["return"]();
        } finally {
          if (a) throw r;
        }
      }
    };
  }
  function HM(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
    return n;
  }
  var WM = function () {
      function t(e, i, n) {
        var o, r, s;
        ph(this, t), z_(this, "_source", void 0), z_(this, "_transformers", void 0), z_(this, "_target", void 0), z_(this, "_listeners", {
          add: Hn(o = this._add).call(o, this),
          remove: Hn(r = this._remove).call(r, this),
          update: Hn(s = this._update).call(s, this)
        }), this._source = e, this._transformers = i, this._target = n;
      }
      return xu(t, [{
        key: "all",
        value: function value() {
          return this._target.update(this._transformItems(this._source.get())), this;
        }
      }, {
        key: "start",
        value: function value() {
          return this._source.on("add", this._listeners.add), this._source.on("remove", this._listeners.remove), this._source.on("update", this._listeners.update), this;
        }
      }, {
        key: "stop",
        value: function value() {
          return this._source.off("add", this._listeners.add), this._source.off("remove", this._listeners.remove), this._source.off("update", this._listeners.update), this;
        }
      }, {
        key: "_transformItems",
        value: function value(t) {
          var e;
          return pS(e = this._transformers).call(e, function (t, e) {
            return e(t);
          }, t);
        }
      }, {
        key: "_add",
        value: function value(t, e) {
          null != e && this._target.add(this._transformItems(this._source.get(e.items)));
        }
      }, {
        key: "_update",
        value: function value(t, e) {
          null != e && this._target.update(this._transformItems(this._source.get(e.items)));
        }
      }, {
        key: "_remove",
        value: function value(t, e) {
          null != e && this._target.remove(this._transformItems(e.oldData));
        }
      }]), t;
    }(),
    qM = function () {
      function t(e) {
        ph(this, t), z_(this, "_source", void 0), z_(this, "_transformers", []), this._source = e;
      }
      return xu(t, [{
        key: "filter",
        value: function value(t) {
          return this._transformers.push(function (e) {
            return yv(e).call(e, t);
          }), this;
        }
      }, {
        key: "map",
        value: function value(t) {
          return this._transformers.push(function (e) {
            return jf(e).call(e, t);
          }), this;
        }
      }, {
        key: "flatMap",
        value: function value(t) {
          return this._transformers.push(function (e) {
            return PS(e).call(e, t);
          }), this;
        }
      }, {
        key: "to",
        value: function value(t) {
          return new WM(this._source, this._transformers, t);
        }
      }]), t;
    }();
  function VM(t) {
    return "string" == typeof t || "number" == typeof t;
  }
  var UM = function () {
      function t(e) {
        ph(this, t), z_(this, "delay", void 0), z_(this, "max", void 0), z_(this, "_queue", []), z_(this, "_timeout", null), z_(this, "_extended", null), this.delay = null, this.max = 1 / 0, this.setOptions(e);
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          t && void 0 !== t.delay && (this.delay = t.delay), t && void 0 !== t.max && (this.max = t.max), this._flushIfNeeded();
        }
      }, {
        key: "destroy",
        value: function value() {
          if (this.flush(), this._extended) {
            for (var t = this._extended.object, e = this._extended.methods, i = 0; i < e.length; i++) {
              var n = e[i];
              n.original ? t[n.name] = n.original : delete t[n.name];
            }
            this._extended = null;
          }
        }
      }, {
        key: "replace",
        value: function value(t, e) {
          var i = this,
            n = t[e];
          if (!n) throw new Error("Method " + e + " undefined");
          t[e] = function () {
            for (var t = arguments.length, e = new Array(t), o = 0; o < t; o++) e[o] = arguments[o];
            i.queue({
              args: e,
              fn: n,
              context: this
            });
          };
        }
      }, {
        key: "queue",
        value: function value(t) {
          "function" == typeof t ? this._queue.push({
            fn: t
          }) : this._queue.push(t), this._flushIfNeeded();
        }
      }, {
        key: "_flushIfNeeded",
        value: function value() {
          var t = this;
          this._queue.length > this.max && this.flush(), null != this._timeout && (clearTimeout(this._timeout), this._timeout = null), this.queue.length > 0 && "number" == typeof this.delay && (this._timeout = jg(function () {
            t.flush();
          }, this.delay));
        }
      }, {
        key: "flush",
        value: function value() {
          var t, e;
          op(t = Ap(e = this._queue).call(e, 0)).call(t, function (t) {
            t.fn.apply(t.context || t.fn, t.args || []);
          });
        }
      }], [{
        key: "extend",
        value: function value(e, i) {
          var n = new t(i);
          if (void 0 !== e.flush) throw new Error("Target object already has a property flush");
          e.flush = function () {
            n.flush();
          };
          var o = [{
            name: "flush",
            original: void 0
          }];
          if (i && i.replace) for (var r = 0; r < i.replace.length; r++) {
            var s = i.replace[r];
            o.push({
              name: s,
              original: e[s]
            }), n.replace(e, s);
          }
          return n._extended = {
            object: e,
            methods: o
          }, n;
        }
      }]), t;
    }(),
    YM = function () {
      function t() {
        ph(this, t), z_(this, "_subscribers", {
          "*": [],
          add: [],
          remove: [],
          update: []
        }), z_(this, "subscribe", t.prototype.on), z_(this, "unsubscribe", t.prototype.off);
      }
      return xu(t, [{
        key: "_trigger",
        value: function value(t, e, i) {
          var n, o;
          if ("*" === t) throw new Error("Cannot trigger event *");
          op(n = _f(o = []).call(o, vf(this._subscribers[t]), vf(this._subscribers["*"]))).call(n, function (n) {
            n(t, e, null != i ? i : null);
          });
        }
      }, {
        key: "on",
        value: function value(t, e) {
          "function" == typeof e && this._subscribers[t].push(e);
        }
      }, {
        key: "off",
        value: function value(t, e) {
          var i;
          this._subscribers[t] = yv(i = this._subscribers[t]).call(i, function (t) {
            return t !== e;
          });
        }
      }]), t;
    }();
  NM = IS;
  var XM = function () {
    function t(e) {
      ph(this, t), z_(this, "_pairs", void 0), this._pairs = e;
    }
    return xu(t, [{
      key: NM,
      value: eS.mark(function t() {
        var e, i, n, o, r;
        return eS.wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              e = LM(this._pairs), t.prev = 1, e.s();
            case 3:
              if ((i = e.n()).done) {
                t.next = 9;
                break;
              }
              return n = pf(i.value, 2), o = n[0], r = n[1], t.next = 7, [o, r];
            case 7:
              t.next = 3;
              break;
            case 9:
              t.next = 14;
              break;
            case 11:
              t.prev = 11, t.t0 = t["catch"](1), e.e(t.t0);
            case 14:
              return t.prev = 14, e.f(), t.finish(14);
            case 17:
            case "end":
              return t.stop();
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "entries",
      value: eS.mark(function t() {
        var e, i, n, o, r;
        return eS.wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              e = LM(this._pairs), t.prev = 1, e.s();
            case 3:
              if ((i = e.n()).done) {
                t.next = 9;
                break;
              }
              return n = pf(i.value, 2), o = n[0], r = n[1], t.next = 7, [o, r];
            case 7:
              t.next = 3;
              break;
            case 9:
              t.next = 14;
              break;
            case 11:
              t.prev = 11, t.t0 = t["catch"](1), e.e(t.t0);
            case 14:
              return t.prev = 14, e.f(), t.finish(14);
            case 17:
            case "end":
              return t.stop();
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "keys",
      value: eS.mark(function t() {
        var e, i, n, o;
        return eS.wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              e = LM(this._pairs), t.prev = 1, e.s();
            case 3:
              if ((i = e.n()).done) {
                t.next = 9;
                break;
              }
              return n = pf(i.value, 1), o = n[0], t.next = 7, o;
            case 7:
              t.next = 3;
              break;
            case 9:
              t.next = 14;
              break;
            case 11:
              t.prev = 11, t.t0 = t["catch"](1), e.e(t.t0);
            case 14:
              return t.prev = 14, e.f(), t.finish(14);
            case 17:
            case "end":
              return t.stop();
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "values",
      value: eS.mark(function t() {
        var e, i, n, o;
        return eS.wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              e = LM(this._pairs), t.prev = 1, e.s();
            case 3:
              if ((i = e.n()).done) {
                t.next = 9;
                break;
              }
              return n = pf(i.value, 2), o = n[1], t.next = 7, o;
            case 7:
              t.next = 3;
              break;
            case 9:
              t.next = 14;
              break;
            case 11:
              t.prev = 11, t.t0 = t["catch"](1), e.e(t.t0);
            case 14:
              return t.prev = 14, e.f(), t.finish(14);
            case 17:
            case "end":
              return t.stop();
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "toIdArray",
      value: function value() {
        var t;
        return jf(t = vf(this._pairs)).call(t, function (t) {
          return t[0];
        });
      }
    }, {
      key: "toItemArray",
      value: function value() {
        var t;
        return jf(t = vf(this._pairs)).call(t, function (t) {
          return t[1];
        });
      }
    }, {
      key: "toEntryArray",
      value: function value() {
        return vf(this._pairs);
      }
    }, {
      key: "toObjectMap",
      value: function value() {
        var t,
          e = pg(null),
          i = LM(this._pairs);
        try {
          for (i.s(); !(t = i.n()).done;) {
            var n = pf(t.value, 2),
              o = n[0],
              r = n[1];
            e[o] = r;
          }
        } catch (t) {
          i.e(t);
        } finally {
          i.f();
        }
        return e;
      }
    }, {
      key: "toMap",
      value: function value() {
        return new c_(this._pairs);
      }
    }, {
      key: "toIdSet",
      value: function value() {
        return new DS(this.toIdArray());
      }
    }, {
      key: "toItemSet",
      value: function value() {
        return new DS(this.toItemArray());
      }
    }, {
      key: "cache",
      value: function value() {
        return new t(vf(this._pairs));
      }
    }, {
      key: "distinct",
      value: function value(t) {
        var e,
          i = new DS(),
          n = LM(this._pairs);
        try {
          for (n.s(); !(e = n.n()).done;) {
            var o = pf(e.value, 2),
              r = o[0],
              s = o[1];
            i.add(t(s, r));
          }
        } catch (t) {
          n.e(t);
        } finally {
          n.f();
        }
        return i;
      }
    }, {
      key: "filter",
      value: function value(e) {
        var i = this._pairs;
        return new t(z_({}, IS, eS.mark(function t() {
          var n, o, r, s, a;
          return eS.wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                n = LM(i), t.prev = 1, n.s();
              case 3:
                if ((o = n.n()).done) {
                  t.next = 10;
                  break;
                }
                if (r = pf(o.value, 2), s = r[0], a = r[1], !e(a, s)) {
                  t.next = 8;
                  break;
                }
                return t.next = 8, [s, a];
              case 8:
                t.next = 3;
                break;
              case 10:
                t.next = 15;
                break;
              case 12:
                t.prev = 12, t.t0 = t["catch"](1), n.e(t.t0);
              case 15:
                return t.prev = 15, n.f(), t.finish(15);
              case 18:
              case "end":
                return t.stop();
            }
          }, t, null, [[1, 12, 15, 18]]);
        })));
      }
    }, {
      key: "forEach",
      value: function value(t) {
        var e,
          i = LM(this._pairs);
        try {
          for (i.s(); !(e = i.n()).done;) {
            var n = pf(e.value, 2),
              o = n[0];
            t(n[1], o);
          }
        } catch (t) {
          i.e(t);
        } finally {
          i.f();
        }
      }
    }, {
      key: "map",
      value: function value(e) {
        var i = this._pairs;
        return new t(z_({}, IS, eS.mark(function t() {
          var n, o, r, s, a;
          return eS.wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                n = LM(i), t.prev = 1, n.s();
              case 3:
                if ((o = n.n()).done) {
                  t.next = 9;
                  break;
                }
                return r = pf(o.value, 2), s = r[0], a = r[1], t.next = 7, [s, e(a, s)];
              case 7:
                t.next = 3;
                break;
              case 9:
                t.next = 14;
                break;
              case 11:
                t.prev = 11, t.t0 = t["catch"](1), n.e(t.t0);
              case 14:
                return t.prev = 14, n.f(), t.finish(14);
              case 17:
              case "end":
                return t.stop();
            }
          }, t, null, [[1, 11, 14, 17]]);
        })));
      }
    }, {
      key: "max",
      value: function value(t) {
        var e = BS(this._pairs),
          i = e.next();
        if (i.done) return null;
        for (var n = i.value[1], o = t(i.value[1], i.value[0]); !(i = e.next()).done;) {
          var r = pf(i.value, 2),
            s = r[0],
            a = r[1],
            h = t(a, s);
          h > o && (o = h, n = a);
        }
        return n;
      }
    }, {
      key: "min",
      value: function value(t) {
        var e = BS(this._pairs),
          i = e.next();
        if (i.done) return null;
        for (var n = i.value[1], o = t(i.value[1], i.value[0]); !(i = e.next()).done;) {
          var r = pf(i.value, 2),
            s = r[0],
            a = r[1],
            h = t(a, s);
          h < o && (o = h, n = a);
        }
        return n;
      }
    }, {
      key: "reduce",
      value: function value(t, e) {
        var i,
          n = LM(this._pairs);
        try {
          for (n.s(); !(i = n.n()).done;) {
            var o = pf(i.value, 2),
              r = o[0];
            e = t(e, o[1], r);
          }
        } catch (t) {
          n.e(t);
        } finally {
          n.f();
        }
        return e;
      }
    }, {
      key: "sort",
      value: function value(e) {
        var i = this;
        return new t(z_({}, IS, function () {
          var t;
          return BS(yT(t = vf(i._pairs)).call(t, function (t, i) {
            var n = pf(t, 2),
              o = n[0],
              r = n[1],
              s = pf(i, 2),
              a = s[0],
              h = s[1];
            return e(r, h, o, a);
          }));
        }));
      }
    }]), t;
  }();
  var GM = function (t) {
      D_(i, t);
      var e = RM(i);
      function i(t, n) {
        var o;
        return ph(this, i), z_(E_(o = e.call(this)), "flush", void 0), z_(E_(o), "length", void 0), z_(E_(o), "_options", void 0), z_(E_(o), "_data", void 0), z_(E_(o), "_idProp", void 0), z_(E_(o), "_queue", null), t && !Df(t) && (n = t, t = []), o._options = n || {}, o._data = new c_(), o.length = 0, o._idProp = o._options.fieldId || "id", t && t.length && o.add(t), o.setOptions(n), o;
      }
      return xu(i, [{
        key: "idProp",
        get: function get() {
          return this._idProp;
        }
      }, {
        key: "setOptions",
        value: function value(t) {
          t && void 0 !== t.queue && (!1 === t.queue ? this._queue && (this._queue.destroy(), this._queue = null) : (this._queue || (this._queue = UM.extend(this, {
            replace: ["add", "update", "remove"]
          })), t.queue && "object" === bu(t.queue) && this._queue.setOptions(t.queue)));
        }
      }, {
        key: "add",
        value: function value(t, e) {
          var i,
            n = this,
            o = [];
          if (Df(t)) {
            var r = jf(t).call(t, function (t) {
              return t[n._idProp];
            });
            if (x_(r).call(r, function (t) {
              return n._data.has(t);
            })) throw new Error("A duplicate id was found in the parameter array.");
            for (var s = 0, a = t.length; s < a; s++) i = this._addItem(t[s]), o.push(i);
          } else {
            if (!t || "object" !== bu(t)) throw new Error("Unknown dataType");
            i = this._addItem(t), o.push(i);
          }
          return o.length && this._trigger("add", {
            items: o
          }, e), o;
        }
      }, {
        key: "update",
        value: function value(t, e) {
          var i = this,
            n = [],
            o = [],
            r = [],
            s = [],
            a = this._idProp,
            h = function h(t) {
              var e = t[a];
              if (null != e && i._data.has(e)) {
                var h = t,
                  l = bn({}, i._data.get(e)),
                  d = i._updateItem(h);
                o.push(d), s.push(h), r.push(l);
              } else {
                var c = i._addItem(t);
                n.push(c);
              }
            };
          if (Df(t)) for (var l = 0, d = t.length; l < d; l++) t[l] && "object" === bu(t[l]) ? h(t[l]) : console.warn("Ignoring input item, which is not an object at index " + l);else {
            if (!t || "object" !== bu(t)) throw new Error("Unknown dataType");
            h(t);
          }
          if (n.length && this._trigger("add", {
            items: n
          }, e), o.length) {
            var c = {
              items: o,
              oldData: r,
              data: s
            };
            this._trigger("update", c, e);
          }
          return _f(n).call(n, o);
        }
      }, {
        key: "updateOnly",
        value: function value(t, e) {
          var i,
            n = this;
          Df(t) || (t = [t]);
          var o = jf(i = jf(t).call(t, function (t) {
            var e = n._data.get(t[n._idProp]);
            if (null == e) throw new Error("Updating non-existent items is not allowed.");
            return {
              oldData: e,
              update: t
            };
          })).call(i, function (t) {
            var e = t.oldData,
              i = t.update,
              o = e[n._idProp],
              r = Gm(e, i);
            return n._data.set(o, r), {
              id: o,
              oldData: e,
              updatedData: r
            };
          });
          if (o.length) {
            var r = {
              items: jf(o).call(o, function (t) {
                return t.id;
              }),
              oldData: jf(o).call(o, function (t) {
                return t.oldData;
              }),
              data: jf(o).call(o, function (t) {
                return t.updatedData;
              })
            };
            return this._trigger("update", r, e), r.items;
          }
          return [];
        }
      }, {
        key: "get",
        value: function value(t, e) {
          var i = void 0,
            n = void 0,
            o = void 0;
          VM(t) ? (i = t, o = e) : Df(t) ? (n = t, o = e) : o = t;
          var r,
            s = o && "Object" === o.returnType ? "Object" : "Array",
            a = o && yv(o),
            h = [],
            l = void 0,
            d = void 0,
            c = void 0;
          if (null != i) (l = this._data.get(i)) && a && !a(l) && (l = void 0);else if (null != n) for (var u = 0, f = n.length; u < f; u++) null == (l = this._data.get(n[u])) || a && !a(l) || h.push(l);else for (var p, v = 0, g = (d = vf(CT(p = this._data).call(p))).length; v < g; v++) c = d[v], null == (l = this._data.get(c)) || a && !a(l) || h.push(l);
          if (o && o.order && null == i && this._sort(h, o.order), o && o.fields) {
            var y = o.fields;
            if (null != i && null != l) l = this._filterFields(l, y);else for (var m = 0, b = h.length; m < b; m++) h[m] = this._filterFields(h[m], y);
          }
          if ("Object" == s) {
            for (var w = {}, k = 0, _ = h.length; k < _; k++) {
              var x = h[k];
              w[x[this._idProp]] = x;
            }
            return w;
          }
          return null != i ? null !== (r = l) && void 0 !== r ? r : null : h;
        }
      }, {
        key: "getIds",
        value: function value(t) {
          var e = this._data,
            i = t && yv(t),
            n = t && t.order,
            o = vf(CT(e).call(e)),
            r = [];
          if (i) {
            if (n) {
              for (var s = [], a = 0, h = o.length; a < h; a++) {
                var l = o[a],
                  d = this._data.get(l);
                null != d && i(d) && s.push(d);
              }
              this._sort(s, n);
              for (var c = 0, u = s.length; c < u; c++) r.push(s[c][this._idProp]);
            } else for (var f = 0, p = o.length; f < p; f++) {
              var v = o[f],
                g = this._data.get(v);
              null != g && i(g) && r.push(g[this._idProp]);
            }
          } else if (n) {
            for (var y = [], m = 0, b = o.length; m < b; m++) {
              var w = o[m];
              y.push(e.get(w));
            }
            this._sort(y, n);
            for (var k = 0, _ = y.length; k < _; k++) r.push(y[k][this._idProp]);
          } else for (var x = 0, E = o.length; x < E; x++) {
            var O = o[x],
              C = e.get(O);
            null != C && r.push(C[this._idProp]);
          }
          return r;
        }
      }, {
        key: "getDataSet",
        value: function value() {
          return this;
        }
      }, {
        key: "forEach",
        value: function value(t, e) {
          var i = e && yv(e),
            n = this._data,
            o = vf(CT(n).call(n));
          if (e && e.order) for (var r = this.get(e), s = 0, a = r.length; s < a; s++) {
            var h = r[s];
            t(h, h[this._idProp]);
          } else for (var l = 0, d = o.length; l < d; l++) {
            var c = o[l],
              u = this._data.get(c);
            null == u || i && !i(u) || t(u, c);
          }
        }
      }, {
        key: "map",
        value: function value(t, e) {
          for (var i = e && yv(e), n = [], o = this._data, r = vf(CT(o).call(o)), s = 0, a = r.length; s < a; s++) {
            var h = r[s],
              l = this._data.get(h);
            null == l || i && !i(l) || n.push(t(l, h));
          }
          return e && e.order && this._sort(n, e.order), n;
        }
      }, {
        key: "_filterFields",
        value: function value(t, e) {
          var i;
          return t ? pS(i = Df(e) ? e : Hf(e)).call(i, function (e, i) {
            return e[i] = t[i], e;
          }, {}) : t;
        }
      }, {
        key: "_sort",
        value: function value(t, e) {
          if ("string" == typeof e) {
            var i = e;
            yT(t).call(t, function (t, e) {
              var n = t[i],
                o = e[i];
              return n > o ? 1 : n < o ? -1 : 0;
            });
          } else {
            if ("function" != typeof e) throw new TypeError("Order must be a function or a string");
            yT(t).call(t, e);
          }
        }
      }, {
        key: "remove",
        value: function value(t, e) {
          for (var i = [], n = [], o = Df(t) ? t : [t], r = 0, s = o.length; r < s; r++) {
            var a = this._remove(o[r]);
            if (a) {
              var h = a[this._idProp];
              null != h && (i.push(h), n.push(a));
            }
          }
          return i.length && this._trigger("remove", {
            items: i,
            oldData: n
          }, e), i;
        }
      }, {
        key: "_remove",
        value: function value(t) {
          var e;
          if (VM(t) ? e = t : t && "object" === bu(t) && (e = t[this._idProp]), null != e && this._data.has(e)) {
            var i = this._data.get(e) || null;
            return this._data["delete"](e), --this.length, i;
          }
          return null;
        }
      }, {
        key: "clear",
        value: function value(t) {
          for (var e, i = vf(CT(e = this._data).call(e)), n = [], o = 0, r = i.length; o < r; o++) n.push(this._data.get(i[o]));
          return this._data.clear(), this.length = 0, this._trigger("remove", {
            items: i,
            oldData: n
          }, t), i;
        }
      }, {
        key: "max",
        value: function value(t) {
          var e,
            i,
            n = null,
            o = null,
            r = LM(FT(e = this._data).call(e));
          try {
            for (r.s(); !(i = r.n()).done;) {
              var s = i.value,
                a = s[t];
              "number" == typeof a && (null == o || a > o) && (n = s, o = a);
            }
          } catch (t) {
            r.e(t);
          } finally {
            r.f();
          }
          return n || null;
        }
      }, {
        key: "min",
        value: function value(t) {
          var e,
            i,
            n = null,
            o = null,
            r = LM(FT(e = this._data).call(e));
          try {
            for (r.s(); !(i = r.n()).done;) {
              var s = i.value,
                a = s[t];
              "number" == typeof a && (null == o || a < o) && (n = s, o = a);
            }
          } catch (t) {
            r.e(t);
          } finally {
            r.f();
          }
          return n || null;
        }
      }, {
        key: "distinct",
        value: function value(t) {
          for (var e = this._data, i = vf(CT(e).call(e)), n = [], o = 0, r = 0, s = i.length; r < s; r++) {
            for (var a = i[r], h = e.get(a)[t], l = !1, d = 0; d < o; d++) if (n[d] == h) {
              l = !0;
              break;
            }
            l || void 0 === h || (n[o] = h, o++);
          }
          return n;
        }
      }, {
        key: "_addItem",
        value: function value(t) {
          var e = function (t, e) {
              return null == t[e] && (t[e] = zM()), t;
            }(t, this._idProp),
            i = e[this._idProp];
          if (this._data.has(i)) throw new Error("Cannot add item: item with id " + i + " already exists");
          return this._data.set(i, e), ++this.length, i;
        }
      }, {
        key: "_updateItem",
        value: function value(t) {
          var e = t[this._idProp];
          if (null == e) throw new Error("Cannot update item: item has no id (item: " + mg(t) + ")");
          var i = this._data.get(e);
          if (!i) throw new Error("Cannot update item: no item with id " + e + " found");
          return this._data.set(e, jM(jM({}, i), t)), e;
        }
      }, {
        key: "stream",
        value: function value(t) {
          if (t) {
            var e = this._data;
            return new XM(z_({}, IS, eS.mark(function i() {
              var n, o, r, s;
              return eS.wrap(function (i) {
                for (;;) switch (i.prev = i.next) {
                  case 0:
                    n = LM(t), i.prev = 1, n.s();
                  case 3:
                    if ((o = n.n()).done) {
                      i.next = 11;
                      break;
                    }
                    if (r = o.value, null == (s = e.get(r))) {
                      i.next = 9;
                      break;
                    }
                    return i.next = 9, [r, s];
                  case 9:
                    i.next = 3;
                    break;
                  case 11:
                    i.next = 16;
                    break;
                  case 13:
                    i.prev = 13, i.t0 = i["catch"](1), n.e(i.t0);
                  case 16:
                    return i.prev = 16, n.f(), i.finish(16);
                  case 19:
                  case "end":
                    return i.stop();
                }
              }, i, null, [[1, 13, 16, 19]]);
            })));
          }
          var i;
          return new XM(z_({}, IS, Hn(i = VT(this._data)).call(i, this._data)));
        }
      }]), i;
    }(YM),
    KM = function (t) {
      D_(i, t);
      var e = RM(i);
      function i(t, n) {
        var o, r;
        return ph(this, i), z_(E_(r = e.call(this)), "length", 0), z_(E_(r), "_listener", void 0), z_(E_(r), "_data", void 0), z_(E_(r), "_ids", new DS()), z_(E_(r), "_options", void 0), r._options = n || {}, r._listener = Hn(o = r._onEvent).call(o, E_(r)), r.setData(t), r;
      }
      return xu(i, [{
        key: "idProp",
        get: function get() {
          return this.getDataSet().idProp;
        }
      }, {
        key: "setData",
        value: function value(t) {
          if (this._data) {
            this._data.off && this._data.off("*", this._listener);
            var e = this._data.getIds({
                filter: yv(this._options)
              }),
              i = this._data.get(e);
            this._ids.clear(), this.length = 0, this._trigger("remove", {
              items: e,
              oldData: i
            });
          }
          if (null != t) {
            this._data = t;
            for (var n = this._data.getIds({
                filter: yv(this._options)
              }), o = 0, r = n.length; o < r; o++) {
              var s = n[o];
              this._ids.add(s);
            }
            this.length = n.length, this._trigger("add", {
              items: n
            });
          } else this._data = new GM();
          this._data.on && this._data.on("*", this._listener);
        }
      }, {
        key: "refresh",
        value: function value() {
          for (var t = this._data.getIds({
              filter: yv(this._options)
            }), e = vf(this._ids), i = {}, n = [], o = [], r = [], s = 0, a = t.length; s < a; s++) {
            var h = t[s];
            i[h] = !0, this._ids.has(h) || (n.push(h), this._ids.add(h));
          }
          for (var l = 0, d = e.length; l < d; l++) {
            var c = e[l],
              u = this._data.get(c);
            null == u ? console.error("If you see this, report it please.") : i[c] || (o.push(c), r.push(u), this._ids["delete"](c));
          }
          this.length += n.length - o.length, n.length && this._trigger("add", {
            items: n
          }), o.length && this._trigger("remove", {
            items: o,
            oldData: r
          });
        }
      }, {
        key: "get",
        value: function value(t, e) {
          if (null == this._data) return null;
          var i,
            n = null;
          VM(t) || Df(t) ? (n = t, i = e) : i = t;
          var o = bn({}, this._options, i),
            r = yv(this._options),
            s = i && yv(i);
          return r && s && (o.filter = function (t) {
            return r(t) && s(t);
          }), null == n ? this._data.get(o) : this._data.get(n, o);
        }
      }, {
        key: "getIds",
        value: function value(t) {
          if (this._data.length) {
            var e,
              i = yv(this._options),
              n = null != t ? yv(t) : null;
            return e = n ? i ? function (t) {
              return i(t) && n(t);
            } : n : i, this._data.getIds({
              filter: e,
              order: t && t.order
            });
          }
          return [];
        }
      }, {
        key: "forEach",
        value: function value(t, e) {
          if (this._data) {
            var i,
              n,
              o = yv(this._options),
              r = e && yv(e);
            n = r ? o ? function (t) {
              return o(t) && r(t);
            } : r : o, op(i = this._data).call(i, t, {
              filter: n,
              order: e && e.order
            });
          }
        }
      }, {
        key: "map",
        value: function value(t, e) {
          if (this._data) {
            var i,
              n,
              o = yv(this._options),
              r = e && yv(e);
            return n = r ? o ? function (t) {
              return o(t) && r(t);
            } : r : o, jf(i = this._data).call(i, t, {
              filter: n,
              order: e && e.order
            });
          }
          return [];
        }
      }, {
        key: "getDataSet",
        value: function value() {
          return this._data.getDataSet();
        }
      }, {
        key: "stream",
        value: function value(t) {
          var e;
          return this._data.stream(t || z_({}, IS, Hn(e = CT(this._ids)).call(e, this._ids)));
        }
      }, {
        key: "dispose",
        value: function value() {
          var t;
          null !== (t = this._data) && void 0 !== t && t.off && this._data.off("*", this._listener);
          var e,
            n = "This data view has already been disposed of.",
            o = {
              get: function get() {
                throw new Error(n);
              },
              set: function set() {
                throw new Error(n);
              },
              configurable: !1
            },
            r = LM(Pf(i.prototype));
          try {
            for (r.s(); !(e = r.n()).done;) {
              var s = e.value;
              UT(this, s, o);
            }
          } catch (t) {
            r.e(t);
          } finally {
            r.f();
          }
        }
      }, {
        key: "_onEvent",
        value: function value(t, e, i) {
          if (e && e.items && this._data) {
            var n = e.items,
              o = [],
              r = [],
              s = [],
              a = [],
              h = [],
              l = [];
            switch (t) {
              case "add":
                for (var d = 0, c = n.length; d < c; d++) {
                  var u = n[d];
                  this.get(u) && (this._ids.add(u), o.push(u));
                }
                break;
              case "update":
                for (var f = 0, p = n.length; f < p; f++) {
                  var v = n[f];
                  this.get(v) ? this._ids.has(v) ? (r.push(v), h.push(e.data[f]), a.push(e.oldData[f])) : (this._ids.add(v), o.push(v)) : this._ids.has(v) && (this._ids["delete"](v), s.push(v), l.push(e.oldData[f]));
                }
                break;
              case "remove":
                for (var g = 0, y = n.length; g < y; g++) {
                  var m = n[g];
                  this._ids.has(m) && (this._ids["delete"](m), s.push(m), l.push(e.oldData[g]));
                }
            }
            this.length += o.length - s.length, o.length && this._trigger("add", {
              items: o
            }, i), r.length && this._trigger("update", {
              items: r,
              oldData: a,
              data: h
            }, i), s.length && this._trigger("remove", {
              items: s,
              oldData: l
            }, i);
          }
        }
      }]), i;
    }(YM);
  function $M(t, e) {
    return "object" === bu(e) && null !== e && t === e.idProp && "function" == typeof e.add && "function" == typeof e.clear && "function" == typeof e.distinct && "function" == typeof op(e) && "function" == typeof e.get && "function" == typeof e.getDataSet && "function" == typeof e.getIds && "number" == typeof e.length && "function" == typeof jf(e) && "function" == typeof e.max && "function" == typeof e.min && "function" == typeof e.off && "function" == typeof e.on && "function" == typeof e.remove && "function" == typeof e.setOptions && "function" == typeof e.stream && "function" == typeof e.update && "function" == typeof e.updateOnly;
  }
  function ZM(t, e) {
    return "object" === bu(e) && null !== e && t === e.idProp && "function" == typeof op(e) && "function" == typeof e.get && "function" == typeof e.getDataSet && "function" == typeof e.getIds && "number" == typeof e.length && "function" == typeof jf(e) && "function" == typeof e.off && "function" == typeof e.on && "function" == typeof e.stream && $M(t, e.getDataSet());
  }
  var QM = Object.freeze({
      __proto__: null,
      DELETE: Xm,
      DataSet: GM,
      DataStream: XM,
      DataView: KM,
      Queue: UM,
      createNewDataPipeFrom: function createNewDataPipeFrom(t) {
        return new qM(t);
      },
      isDataSetLike: $M,
      isDataViewLike: ZM
    }),
    JM = o,
    tP = r,
    eP = co,
    iP = Rv.trim,
    nP = Dv,
    oP = g("".charAt),
    rP = JM.parseFloat,
    sP = JM.Symbol,
    aP = sP && sP.iterator,
    hP = 1 / rP(nP + "-0") != -1 / 0 || aP && !tP(function () {
      rP(Object(aP));
    }) ? function (t) {
      var e = iP(eP(t)),
        i = rP(e);
      return 0 === i && "-" === oP(e, 0) ? -0 : i;
    } : rP;
  Ti({
    global: !0,
    forced: parseFloat !== hP
  }, {
    parseFloat: hP
  });
  var lP = i(et.parseFloat),
    dP = Ti,
    cP = r,
    uP = il.f;
  dP({
    target: "Object",
    stat: !0,
    forced: cP(function () {
      return !Object.getOwnPropertyNames(1);
    })
  }, {
    getOwnPropertyNames: uP
  });
  var fP = et.Object,
    pP = function pP(t) {
      return fP.getOwnPropertyNames(t);
    },
    vP = i(pP);
  function gP(t, e) {
    var i = ["node", "edge", "label"],
      n = !0,
      o = Rb(e, "chosen");
    if ("boolean" == typeof o) n = o;else if ("object" === bu(o)) {
      if (-1 === lg(i).call(i, t)) throw new Error("choosify: subOption '" + t + "' should be one of '" + i.join("', '") + "'");
      var r = Rb(e, ["chosen", t]);
      "boolean" != typeof r && "function" != typeof r || (n = r);
    }
    return n;
  }
  function yP(t, e, i) {
    if (t.width <= 0 || t.height <= 0) return !1;
    if (void 0 !== i) {
      var n = {
        x: e.x - i.x,
        y: e.y - i.y
      };
      if (0 !== i.angle) {
        var o = -i.angle;
        e = {
          x: Math.cos(o) * n.x - Math.sin(o) * n.y,
          y: Math.sin(o) * n.x + Math.cos(o) * n.y
        };
      } else e = n;
    }
    var r = t.x + t.width,
      s = t.y + t.width;
    return t.left < e.x && r > e.x && t.top < e.y && s > e.y;
  }
  function mP(t) {
    return "string" == typeof t && "" !== t;
  }
  function bP(t, e, i, n) {
    var o = n.x,
      r = n.y;
    if ("function" == typeof n.distanceToBorder) {
      var s = n.distanceToBorder(t, e),
        a = Math.sin(e) * s,
        h = Math.cos(e) * s;
      h === s ? (o += s, r = n.y) : a === s ? (o = n.x, r -= s) : (o += h, r -= a);
    } else n.shape.width > n.shape.height ? (o = n.x + .5 * n.shape.width, r = n.y - i) : (o = n.x + i, r = n.y - .5 * n.shape.height);
    return {
      x: o,
      y: r
    };
  }
  var wP = function () {
      function t(e) {
        ph(this, t), this.measureText = e, this.current = 0, this.width = 0, this.height = 0, this.lines = [];
      }
      return xu(t, [{
        key: "_add",
        value: function value(t, e) {
          var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "normal";
          void 0 === this.lines[t] && (this.lines[t] = {
            width: 0,
            height: 0,
            blocks: []
          });
          var n = e;
          void 0 !== e && "" !== e || (n = " ");
          var o = this.measureText(n, i),
            r = bn({}, FT(o));
          r.text = e, r.width = o.width, r.mod = i, void 0 !== e && "" !== e || (r.width = 0), this.lines[t].blocks.push(r), this.lines[t].width += r.width;
        }
      }, {
        key: "curWidth",
        value: function value() {
          var t = this.lines[this.current];
          return void 0 === t ? 0 : t.width;
        }
      }, {
        key: "append",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "normal";
          this._add(this.current, t, e);
        }
      }, {
        key: "newLine",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "normal";
          this._add(this.current, t, e), this.current++;
        }
      }, {
        key: "determineLineHeights",
        value: function value() {
          for (var t = 0; t < this.lines.length; t++) {
            var e = this.lines[t],
              i = 0;
            if (void 0 !== e.blocks) for (var n = 0; n < e.blocks.length; n++) {
              var o = e.blocks[n];
              i < o.height && (i = o.height);
            }
            e.height = i;
          }
        }
      }, {
        key: "determineLabelSize",
        value: function value() {
          for (var t = 0, e = 0, i = 0; i < this.lines.length; i++) {
            var n = this.lines[i];
            n.width > t && (t = n.width), e += n.height;
          }
          this.width = t, this.height = e;
        }
      }, {
        key: "removeEmptyBlocks",
        value: function value() {
          for (var t = [], e = 0; e < this.lines.length; e++) {
            var i = this.lines[e];
            if (0 !== i.blocks.length && (e !== this.lines.length - 1 || 0 !== i.width)) {
              var n = {};
              bn(n, i), n.blocks = [];
              for (var o = void 0, r = [], s = 0; s < i.blocks.length; s++) {
                var a = i.blocks[s];
                0 !== a.width ? r.push(a) : void 0 === o && (o = a);
              }
              0 === r.length && void 0 !== o && r.push(o), n.blocks = r, t.push(n);
            }
          }
          return t;
        }
      }, {
        key: "finalize",
        value: function value() {
          this.determineLineHeights(), this.determineLabelSize();
          var t = this.removeEmptyBlocks();
          return {
            width: this.width,
            height: this.height,
            lines: t
          };
        }
      }]), t;
    }(),
    kP = {
      "<b>": /<b>/,
      "<i>": /<i>/,
      "<code>": /<code>/,
      "</b>": /<\/b>/,
      "</i>": /<\/i>/,
      "</code>": /<\/code>/,
      "*": /\*/,
      _: /_/,
      "`": /`/,
      afterBold: /[^*]/,
      afterItal: /[^_]/,
      afterMono: /[^`]/
    },
    _P = function () {
      function t(e) {
        ph(this, t), this.text = e, this.bold = !1, this.ital = !1, this.mono = !1, this.spacing = !1, this.position = 0, this.buffer = "", this.modStack = [], this.blocks = [];
      }
      return xu(t, [{
        key: "mod",
        value: function value() {
          return 0 === this.modStack.length ? "normal" : this.modStack[0];
        }
      }, {
        key: "modName",
        value: function value() {
          return 0 === this.modStack.length ? "normal" : "mono" === this.modStack[0] ? "mono" : this.bold && this.ital ? "boldital" : this.bold ? "bold" : this.ital ? "ital" : void 0;
        }
      }, {
        key: "emitBlock",
        value: function value() {
          this.spacing && (this.add(" "), this.spacing = !1), this.buffer.length > 0 && (this.blocks.push({
            text: this.buffer,
            mod: this.modName()
          }), this.buffer = "");
        }
      }, {
        key: "add",
        value: function value(t) {
          " " === t && (this.spacing = !0), this.spacing && (this.buffer += " ", this.spacing = !1), " " != t && (this.buffer += t);
        }
      }, {
        key: "parseWS",
        value: function value(t) {
          return !!/[ \t]/.test(t) && (this.mono ? this.add(t) : this.spacing = !0, !0);
        }
      }, {
        key: "setTag",
        value: function value(t) {
          this.emitBlock(), this[t] = !0, this.modStack.unshift(t);
        }
      }, {
        key: "unsetTag",
        value: function value(t) {
          this.emitBlock(), this[t] = !1, this.modStack.shift();
        }
      }, {
        key: "parseStartTag",
        value: function value(t, e) {
          return !(this.mono || this[t] || !this.match(e)) && (this.setTag(t), !0);
        }
      }, {
        key: "match",
        value: function value(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            i = pf(this.prepareRegExp(t), 2),
            n = i[0],
            o = i[1],
            r = n.test(this.text.substr(this.position, o));
          return r && e && (this.position += o - 1), r;
        }
      }, {
        key: "parseEndTag",
        value: function value(t, e, i) {
          var n = this.mod() === t;
          return !(!(n = "mono" === t ? n && this.mono : n && !this.mono) || !this.match(e)) && (void 0 !== i ? (this.position === this.text.length - 1 || this.match(i, !1)) && this.unsetTag(t) : this.unsetTag(t), !0);
        }
      }, {
        key: "replace",
        value: function value(t, e) {
          return !!this.match(t) && (this.add(e), this.position += length - 1, !0);
        }
      }, {
        key: "prepareRegExp",
        value: function value(t) {
          var e, i;
          if (t instanceof RegExp) i = t, e = 1;else {
            var n = kP[t];
            i = void 0 !== n ? n : new RegExp(t), e = t.length;
          }
          return [i, e];
        }
      }]), t;
    }(),
    xP = function () {
      function t(e, i, n, o) {
        var r = this;
        ph(this, t), this.ctx = e, this.parent = i, this.selected = n, this.hover = o;
        this.lines = new wP(function (t, i) {
          if (void 0 === t) return 0;
          var s = r.parent.getFormattingValues(e, n, o, i),
            a = 0;
          "" !== t && (a = r.ctx.measureText(t).width);
          return {
            width: a,
            values: s
          };
        });
      }
      return xu(t, [{
        key: "process",
        value: function value(t) {
          if (!mP(t)) return this.lines.finalize();
          var e = this.parent.fontOptions;
          t = (t = t.replace(/\r\n/g, "\n")).replace(/\r/g, "\n");
          var i = String(t).split("\n"),
            n = i.length;
          if (e.multi) for (var o = 0; o < n; o++) {
            var r = this.splitBlocks(i[o], e.multi);
            if (void 0 !== r) if (0 !== r.length) {
              if (e.maxWdt > 0) for (var s = 0; s < r.length; s++) {
                var a = r[s].mod,
                  h = r[s].text;
                this.splitStringIntoLines(h, a, !0);
              } else for (var l = 0; l < r.length; l++) {
                var d = r[l].mod,
                  c = r[l].text;
                this.lines.append(c, d);
              }
              this.lines.newLine();
            } else this.lines.newLine("");
          } else if (e.maxWdt > 0) for (var u = 0; u < n; u++) this.splitStringIntoLines(i[u]);else for (var f = 0; f < n; f++) this.lines.newLine(i[f]);
          return this.lines.finalize();
        }
      }, {
        key: "decodeMarkupSystem",
        value: function value(t) {
          var e = "none";
          return "markdown" === t || "md" === t ? e = "markdown" : !0 !== t && "html" !== t || (e = "html"), e;
        }
      }, {
        key: "splitHtmlBlocks",
        value: function value(t) {
          for (var e = new _P(t), i = function i(t) {
              return !!/&/.test(t) && (e.replace(e.text, "&lt;", "<") || e.replace(e.text, "&amp;", "&") || e.add("&"), !0);
            }; e.position < e.text.length;) {
            var n = e.text.charAt(e.position);
            e.parseWS(n) || /</.test(n) && (e.parseStartTag("bold", "<b>") || e.parseStartTag("ital", "<i>") || e.parseStartTag("mono", "<code>") || e.parseEndTag("bold", "</b>") || e.parseEndTag("ital", "</i>") || e.parseEndTag("mono", "</code>")) || i(n) || e.add(n), e.position++;
          }
          return e.emitBlock(), e.blocks;
        }
      }, {
        key: "splitMarkdownBlocks",
        value: function value(t) {
          for (var e = this, i = new _P(t), n = !0, o = function o(t) {
              return !!/\\/.test(t) && (i.position < e.text.length + 1 && (i.position++, t = e.text.charAt(i.position), / \t/.test(t) ? i.spacing = !0 : (i.add(t), n = !1)), !0);
            }; i.position < i.text.length;) {
            var r = i.text.charAt(i.position);
            i.parseWS(r) || o(r) || (n || i.spacing) && (i.parseStartTag("bold", "*") || i.parseStartTag("ital", "_") || i.parseStartTag("mono", "`")) || i.parseEndTag("bold", "*", "afterBold") || i.parseEndTag("ital", "_", "afterItal") || i.parseEndTag("mono", "`", "afterMono") || (i.add(r), n = !1), i.position++;
          }
          return i.emitBlock(), i.blocks;
        }
      }, {
        key: "splitBlocks",
        value: function value(t, e) {
          var i = this.decodeMarkupSystem(e);
          return "none" === i ? [{
            text: t,
            mod: "normal"
          }] : "markdown" === i ? this.splitMarkdownBlocks(t) : "html" === i ? this.splitHtmlBlocks(t) : void 0;
        }
      }, {
        key: "overMaxWidth",
        value: function value(t) {
          var e = this.ctx.measureText(t).width;
          return this.lines.curWidth() + e > this.parent.fontOptions.maxWdt;
        }
      }, {
        key: "getLongestFit",
        value: function value(t) {
          for (var e = "", i = 0; i < t.length;) {
            var n = e + ("" === e ? "" : " ") + t[i];
            if (this.overMaxWidth(n)) break;
            e = n, i++;
          }
          return i;
        }
      }, {
        key: "getLongestFitWord",
        value: function value(t) {
          for (var e = 0; e < t.length && !this.overMaxWidth(xf(t).call(t, 0, e));) e++;
          return e;
        }
      }, {
        key: "splitStringIntoLines",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "normal",
            i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          this.parent.getFormattingValues(this.ctx, this.selected, this.hover, e);
          for (var n = (t = (t = t.replace(/^( +)/g, "$1\r")).replace(/([^\r][^ ]*)( +)/g, "$1\r$2\r")).split("\r"); n.length > 0;) {
            var o = this.getLongestFit(n);
            if (0 === o) {
              var r = n[0],
                s = this.getLongestFitWord(r);
              this.lines.newLine(xf(r).call(r, 0, s), e), n[0] = xf(r).call(r, s);
            } else {
              var a = o;
              " " === n[o - 1] ? o-- : " " === n[a] && a++;
              var h = xf(n).call(n, 0, o).join("");
              o == n.length && i ? this.lines.append(h, e) : this.lines.newLine(h, e), n = xf(n).call(n, a);
            }
          }
        }
      }]), t;
    }(),
    EP = ["bold", "ital", "boldital", "mono"],
    OP = function () {
      function t(e, i) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        ph(this, t), this.body = e, this.pointToSelf = !1, this.baseSize = void 0, this.fontOptions = {}, this.setOptions(i), this.size = {
          top: 0,
          left: 0,
          width: 0,
          height: 0,
          yLine: 0
        }, this.isEdgeLabel = n;
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          if (this.elementOptions = t, this.initFontOptions(t.font), mP(t.label) ? this.labelDirty = !0 : t.label = void 0, void 0 !== t.font && null !== t.font) if ("string" == typeof t.font) this.baseSize = this.fontOptions.size;else if ("object" === bu(t.font)) {
            var e = t.font.size;
            void 0 !== e && (this.baseSize = e);
          }
        }
      }, {
        key: "initFontOptions",
        value: function value(e) {
          var i = this;
          kb(EP, function (t) {
            i.fontOptions[t] = {};
          }), t.parseFontString(this.fontOptions, e) ? this.fontOptions.vadjust = 0 : kb(e, function (t, e) {
            null != t && "object" !== bu(t) && (i.fontOptions[e] = t);
          });
        }
      }, {
        key: "constrain",
        value: function value(t) {
          var e = {
              constrainWidth: !1,
              maxWdt: -1,
              minWdt: -1,
              constrainHeight: !1,
              minHgt: -1,
              valign: "middle"
            },
            i = Rb(t, "widthConstraint");
          if ("number" == typeof i) e.maxWdt = Number(i), e.minWdt = Number(i);else if ("object" === bu(i)) {
            var n = Rb(t, ["widthConstraint", "maximum"]);
            "number" == typeof n && (e.maxWdt = Number(n));
            var o = Rb(t, ["widthConstraint", "minimum"]);
            "number" == typeof o && (e.minWdt = Number(o));
          }
          var r = Rb(t, "heightConstraint");
          if ("number" == typeof r) e.minHgt = Number(r);else if ("object" === bu(r)) {
            var s = Rb(t, ["heightConstraint", "minimum"]);
            "number" == typeof s && (e.minHgt = Number(s));
            var a = Rb(t, ["heightConstraint", "valign"]);
            "string" == typeof a && ("top" !== a && "bottom" !== a || (e.valign = a));
          }
          return e;
        }
      }, {
        key: "update",
        value: function value(t, e) {
          this.setOptions(t, !0), this.propagateFonts(e), gb(this.fontOptions, this.constrain(e)), this.fontOptions.chooser = gP("label", e);
        }
      }, {
        key: "adjustSizes",
        value: function value(t) {
          var e = t ? t.right + t.left : 0;
          this.fontOptions.constrainWidth && (this.fontOptions.maxWdt -= e, this.fontOptions.minWdt -= e);
          var i = t ? t.top + t.bottom : 0;
          this.fontOptions.constrainHeight && (this.fontOptions.minHgt -= i);
        }
      }, {
        key: "addFontOptionsToPile",
        value: function value(t, e) {
          for (var i = 0; i < e.length; ++i) this.addFontToPile(t, e[i]);
        }
      }, {
        key: "addFontToPile",
        value: function value(t, e) {
          if (void 0 !== e && void 0 !== e.font && null !== e.font) {
            var i = e.font;
            t.push(i);
          }
        }
      }, {
        key: "getBasicOptions",
        value: function value(e) {
          for (var i = {}, n = 0; n < e.length; ++n) {
            var o = e[n],
              r = {};
            t.parseFontString(r, o) && (o = r), kb(o, function (t, e) {
              void 0 !== t && (Object.prototype.hasOwnProperty.call(i, e) || (-1 !== lg(EP).call(EP, e) ? i[e] = {} : i[e] = t));
            });
          }
          return i;
        }
      }, {
        key: "getFontOption",
        value: function value(e, i, n) {
          for (var o, r = 0; r < e.length; ++r) {
            var s = e[r];
            if (Object.prototype.hasOwnProperty.call(s, i)) {
              if (null == (o = s[i])) continue;
              var a = {};
              if (t.parseFontString(a, o) && (o = a), Object.prototype.hasOwnProperty.call(o, n)) return o[n];
            }
          }
          if (Object.prototype.hasOwnProperty.call(this.fontOptions, n)) return this.fontOptions[n];
          throw new Error("Did not find value for multi-font for property: '" + n + "'");
        }
      }, {
        key: "getFontOptions",
        value: function value(t, e) {
          for (var i = {}, n = ["color", "size", "face", "mod", "vadjust"], o = 0; o < n.length; ++o) {
            var r = n[o];
            i[r] = this.getFontOption(t, e, r);
          }
          return i;
        }
      }, {
        key: "propagateFonts",
        value: function value(t) {
          var e = this,
            i = [];
          this.addFontOptionsToPile(i, t), this.fontOptions = this.getBasicOptions(i);
          for (var n = function n() {
              var t = EP[o],
                n = e.fontOptions[t];
              kb(e.getFontOptions(i, t), function (t, e) {
                n[e] = t;
              }), n.size = Number(n.size), n.vadjust = Number(n.vadjust);
            }, o = 0; o < EP.length; ++o) n();
        }
      }, {
        key: "draw",
        value: function value(t, e, i, n, o) {
          var r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "middle";
          if (void 0 !== this.elementOptions.label) {
            var s = this.fontOptions.size * this.body.view.scale;
            this.elementOptions.label && s < this.elementOptions.scaling.label.drawThreshold - 1 || (s >= this.elementOptions.scaling.label.maxVisible && (s = Number(this.elementOptions.scaling.label.maxVisible) / this.body.view.scale), this.calculateLabelSize(t, n, o, e, i, r), this._drawBackground(t), this._drawText(t, e, this.size.yLine, r, s));
          }
        }
      }, {
        key: "_drawBackground",
        value: function value(t) {
          if (void 0 !== this.fontOptions.background && "none" !== this.fontOptions.background) {
            t.fillStyle = this.fontOptions.background;
            var e = this.getSize();
            t.fillRect(e.left, e.top, e.width, e.height);
          }
        }
      }, {
        key: "_drawText",
        value: function value(t, e, i) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "middle",
            o = arguments.length > 4 ? arguments[4] : void 0,
            r = pf(this._setAlignment(t, e, i, n), 2);
          e = r[0], i = r[1], t.textAlign = "left", e -= this.size.width / 2, this.fontOptions.valign && this.size.height > this.size.labelHeight && ("top" === this.fontOptions.valign && (i -= (this.size.height - this.size.labelHeight) / 2), "bottom" === this.fontOptions.valign && (i += (this.size.height - this.size.labelHeight) / 2));
          for (var s = 0; s < this.lineCount; s++) {
            var a = this.lines[s];
            if (a && a.blocks) {
              var h = 0;
              this.isEdgeLabel || "center" === this.fontOptions.align ? h += (this.size.width - a.width) / 2 : "right" === this.fontOptions.align && (h += this.size.width - a.width);
              for (var l = 0; l < a.blocks.length; l++) {
                var d = a.blocks[l];
                t.font = d.font;
                var c = pf(this._getColor(d.color, o, d.strokeColor), 2),
                  u = c[0],
                  f = c[1];
                d.strokeWidth > 0 && (t.lineWidth = d.strokeWidth, t.strokeStyle = f, t.lineJoin = "round"), t.fillStyle = u, d.strokeWidth > 0 && t.strokeText(d.text, e + h, i + d.vadjust), t.fillText(d.text, e + h, i + d.vadjust), h += d.width;
              }
              i += a.height;
            }
          }
        }
      }, {
        key: "_setAlignment",
        value: function value(t, e, i, n) {
          if (this.isEdgeLabel && "horizontal" !== this.fontOptions.align && !1 === this.pointToSelf) {
            e = 0, i = 0;
            "top" === this.fontOptions.align ? (t.textBaseline = "alphabetic", i -= 4) : "bottom" === this.fontOptions.align ? (t.textBaseline = "hanging", i += 4) : t.textBaseline = "middle";
          } else t.textBaseline = n;
          return [e, i];
        }
      }, {
        key: "_getColor",
        value: function value(t, e, i) {
          var n = t || "#000000",
            o = i || "#ffffff";
          if (e <= this.elementOptions.scaling.label.drawThreshold) {
            var r = Math.max(0, Math.min(1, 1 - (this.elementOptions.scaling.label.drawThreshold - e)));
            n = Ob(n, r), o = Ob(o, r);
          }
          return [n, o];
        }
      }, {
        key: "getTextSize",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return this._processLabel(t, e, i), {
            width: this.size.width,
            height: this.size.height,
            lineCount: this.lineCount
          };
        }
      }, {
        key: "getSize",
        value: function value() {
          var t = this.size.left,
            e = this.size.top - 1;
          if (this.isEdgeLabel) {
            var i = .5 * -this.size.width;
            switch (this.fontOptions.align) {
              case "middle":
                t = i, e = .5 * -this.size.height;
                break;
              case "top":
                t = i, e = -(this.size.height + 2);
                break;
              case "bottom":
                t = i, e = 2;
            }
          }
          return {
            left: t,
            top: e,
            width: this.size.width,
            height: this.size.height
          };
        }
      }, {
        key: "calculateLabelSize",
        value: function value(t, e, i) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
            o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
            r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "middle";
          this._processLabel(t, e, i), this.size.left = n - .5 * this.size.width, this.size.top = o - .5 * this.size.height, this.size.yLine = o + .5 * (1 - this.lineCount) * this.fontOptions.size, "hanging" === r && (this.size.top += .5 * this.fontOptions.size, this.size.top += 4, this.size.yLine += 4);
        }
      }, {
        key: "getFormattingValues",
        value: function value(t, e, i, n) {
          var o = function o(t, e, i) {
              return "normal" === e ? "mod" === i ? "" : t[i] : void 0 !== t[e][i] ? t[e][i] : t[i];
            },
            r = {
              color: o(this.fontOptions, n, "color"),
              size: o(this.fontOptions, n, "size"),
              face: o(this.fontOptions, n, "face"),
              mod: o(this.fontOptions, n, "mod"),
              vadjust: o(this.fontOptions, n, "vadjust"),
              strokeWidth: this.fontOptions.strokeWidth,
              strokeColor: this.fontOptions.strokeColor
            };
          (e || i) && ("normal" === n && !0 === this.fontOptions.chooser && this.elementOptions.labelHighlightBold ? r.mod = "bold" : "function" == typeof this.fontOptions.chooser && this.fontOptions.chooser(r, this.elementOptions.id, e, i));
          var s = "";
          return void 0 !== r.mod && "" !== r.mod && (s += r.mod + " "), s += r.size + "px " + r.face, t.font = s.replace(/"/g, ""), r.font = t.font, r.height = r.size, r;
        }
      }, {
        key: "differentState",
        value: function value(t, e) {
          return t !== this.selectedState || e !== this.hoverState;
        }
      }, {
        key: "_processLabelText",
        value: function value(t, e, i, n) {
          return new xP(t, this, e, i).process(n);
        }
      }, {
        key: "_processLabel",
        value: function value(t, e, i) {
          if (!1 !== this.labelDirty || this.differentState(e, i)) {
            var n = this._processLabelText(t, e, i, this.elementOptions.label);
            this.fontOptions.minWdt > 0 && n.width < this.fontOptions.minWdt && (n.width = this.fontOptions.minWdt), this.size.labelHeight = n.height, this.fontOptions.minHgt > 0 && n.height < this.fontOptions.minHgt && (n.height = this.fontOptions.minHgt), this.lines = n.lines, this.lineCount = n.lines.length, this.size.width = n.width, this.size.height = n.height, this.selectedState = e, this.hoverState = i, this.labelDirty = !1;
          }
        }
      }, {
        key: "visible",
        value: function value() {
          return 0 !== this.size.width && 0 !== this.size.height && void 0 !== this.elementOptions.label && !(this.fontOptions.size * this.body.view.scale < this.elementOptions.scaling.label.drawThreshold - 1);
        }
      }], [{
        key: "parseFontString",
        value: function value(t, e) {
          if (!e || "string" != typeof e) return !1;
          var i = e.split(" ");
          return t.size = +i[0].replace("px", ""), t.face = i[1], t.color = i[2], !0;
        }
      }]), t;
    }(),
    CP = function () {
      function t(e, i, n) {
        ph(this, t), this.body = i, this.labelModule = n, this.setOptions(e), this.top = void 0, this.left = void 0, this.height = void 0, this.width = void 0, this.radius = void 0, this.margin = void 0, this.refreshNeeded = !0, this.boundingBox = {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        };
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          this.options = t;
        }
      }, {
        key: "_setMargins",
        value: function value(t) {
          this.margin = {}, this.options.margin && ("object" == bu(this.options.margin) ? (this.margin.top = this.options.margin.top, this.margin.right = this.options.margin.right, this.margin.bottom = this.options.margin.bottom, this.margin.left = this.options.margin.left) : (this.margin.top = this.options.margin, this.margin.right = this.options.margin, this.margin.bottom = this.options.margin, this.margin.left = this.options.margin)), t.adjustSizes(this.margin);
        }
      }, {
        key: "_distanceToBorder",
        value: function value(t, e) {
          var i = this.options.borderWidth;
          return t && this.resize(t), Math.min(Math.abs(this.width / 2 / Math.cos(e)), Math.abs(this.height / 2 / Math.sin(e))) + i;
        }
      }, {
        key: "enableShadow",
        value: function value(t, e) {
          e.shadow && (t.shadowColor = e.shadowColor, t.shadowBlur = e.shadowSize, t.shadowOffsetX = e.shadowX, t.shadowOffsetY = e.shadowY);
        }
      }, {
        key: "disableShadow",
        value: function value(t, e) {
          e.shadow && (t.shadowColor = "rgba(0,0,0,0)", t.shadowBlur = 0, t.shadowOffsetX = 0, t.shadowOffsetY = 0);
        }
      }, {
        key: "enableBorderDashes",
        value: function value(t, e) {
          if (!1 !== e.borderDashes) if (void 0 !== t.setLineDash) {
            var i = e.borderDashes;
            !0 === i && (i = [5, 15]), t.setLineDash(i);
          } else console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used."), this.options.shapeProperties.borderDashes = !1, e.borderDashes = !1;
        }
      }, {
        key: "disableBorderDashes",
        value: function value(t, e) {
          !1 !== e.borderDashes && (void 0 !== t.setLineDash ? t.setLineDash([0]) : (console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used."), this.options.shapeProperties.borderDashes = !1, e.borderDashes = !1));
        }
      }, {
        key: "needsRefresh",
        value: function value(t, e) {
          return !0 === this.refreshNeeded ? (this.refreshNeeded = !1, !0) : void 0 === this.width || this.labelModule.differentState(t, e);
        }
      }, {
        key: "initContextForDraw",
        value: function value(t, e) {
          var i = e.borderWidth / this.body.view.scale;
          t.lineWidth = Math.min(this.width, i), t.strokeStyle = e.borderColor, t.fillStyle = e.color;
        }
      }, {
        key: "performStroke",
        value: function value(t, e) {
          var i = e.borderWidth / this.body.view.scale;
          t.save(), i > 0 && (this.enableBorderDashes(t, e), t.stroke(), this.disableBorderDashes(t, e)), t.restore();
        }
      }, {
        key: "performFill",
        value: function value(t, e) {
          t.save(), t.fillStyle = e.color, this.enableShadow(t, e), Kg(t).call(t), this.disableShadow(t, e), t.restore(), this.performStroke(t, e);
        }
      }, {
        key: "_addBoundingBoxMargin",
        value: function value(t) {
          this.boundingBox.left -= t, this.boundingBox.top -= t, this.boundingBox.bottom += t, this.boundingBox.right += t;
        }
      }, {
        key: "_updateBoundingBox",
        value: function value(t, e, i, n, o) {
          void 0 !== i && this.resize(i, n, o), this.left = t - this.width / 2, this.top = e - this.height / 2, this.boundingBox.left = this.left, this.boundingBox.top = this.top, this.boundingBox.bottom = this.top + this.height, this.boundingBox.right = this.left + this.width;
        }
      }, {
        key: "updateBoundingBox",
        value: function value(t, e, i, n, o) {
          this._updateBoundingBox(t, e, i, n, o);
        }
      }, {
        key: "getDimensionsFromLabel",
        value: function value(t, e, i) {
          this.textSize = this.labelModule.getTextSize(t, e, i);
          var n = this.textSize.width,
            o = this.textSize.height;
          return 0 === n && (n = 14, o = 14), {
            width: n,
            height: o
          };
        }
      }]), t;
    }();
  function SP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var TP = function (t) {
    D_(i, t);
    var e = SP(i);
    function i(t, n, o) {
      var r;
      return ph(this, i), (r = e.call(this, t, n, o))._setMargins(o), r;
    }
    return xu(i, [{
      key: "resize",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.selected,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.hover;
        if (this.needsRefresh(e, i)) {
          var n = this.getDimensionsFromLabel(t, e, i);
          this.width = n.width + this.margin.right + this.margin.left, this.height = n.height + this.margin.top + this.margin.bottom, this.radius = this.width / 2;
        }
      }
    }, {
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        this.resize(t, n, o), this.left = e - this.width / 2, this.top = i - this.height / 2, this.initContextForDraw(t, r), qn(t, this.left, this.top, this.width, this.height, r.borderRadius), this.performFill(t, r), this.updateBoundingBox(e, i, t, n, o), this.labelModule.draw(t, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, n, o);
      }
    }, {
      key: "updateBoundingBox",
      value: function value(t, e, i, n, o) {
        this._updateBoundingBox(t, e, i, n, o);
        var r = this.options.shapeProperties.borderRadius;
        this._addBoundingBoxMargin(r);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        t && this.resize(t);
        var i = this.options.borderWidth;
        return Math.min(Math.abs(this.width / 2 / Math.cos(e)), Math.abs(this.height / 2 / Math.sin(e))) + i;
      }
    }]), i;
  }(CP);
  function MP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var PP = function (t) {
    D_(i, t);
    var e = MP(i);
    function i(t, n, o) {
      var r;
      return ph(this, i), (r = e.call(this, t, n, o)).labelOffset = 0, r.selected = !1, r;
    }
    return xu(i, [{
      key: "setOptions",
      value: function value(t, e, i) {
        this.options = t, void 0 === e && void 0 === i || this.setImages(e, i);
      }
    }, {
      key: "setImages",
      value: function value(t, e) {
        e && this.selected ? (this.imageObj = e, this.imageObjAlt = t) : (this.imageObj = t, this.imageObjAlt = e);
      }
    }, {
      key: "switchImages",
      value: function value(t) {
        var e = t && !this.selected || !t && this.selected;
        if (this.selected = t, void 0 !== this.imageObjAlt && e) {
          var i = this.imageObj;
          this.imageObj = this.imageObjAlt, this.imageObjAlt = i;
        }
      }
    }, {
      key: "_getImagePadding",
      value: function value() {
        var t = {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        };
        if (this.options.imagePadding) {
          var e = this.options.imagePadding;
          "object" == bu(e) ? (t.top = e.top, t.right = e.right, t.bottom = e.bottom, t.left = e.left) : (t.top = e, t.right = e, t.bottom = e, t.left = e);
        }
        return t;
      }
    }, {
      key: "_resizeImage",
      value: function value() {
        var t, e;
        if (!1 === this.options.shapeProperties.useImageSize) {
          var i = 1,
            n = 1;
          this.imageObj.width && this.imageObj.height && (this.imageObj.width > this.imageObj.height ? i = this.imageObj.width / this.imageObj.height : n = this.imageObj.height / this.imageObj.width), t = 2 * this.options.size * i, e = 2 * this.options.size * n;
        } else {
          var o = this._getImagePadding();
          t = this.imageObj.width + o.left + o.right, e = this.imageObj.height + o.top + o.bottom;
        }
        this.width = t, this.height = e, this.radius = .5 * this.width;
      }
    }, {
      key: "_drawRawCircle",
      value: function value(t, e, i, n) {
        this.initContextForDraw(t, n), Wn(t, e, i, n.size), this.performFill(t, n);
      }
    }, {
      key: "_drawImageAtPosition",
      value: function value(t, e) {
        if (0 != this.imageObj.width) {
          t.globalAlpha = void 0 !== e.opacity ? e.opacity : 1, this.enableShadow(t, e);
          var i = 1;
          !0 === this.options.shapeProperties.interpolation && (i = this.imageObj.width / this.width / this.body.view.scale);
          var n = this._getImagePadding(),
            o = this.left + n.left,
            r = this.top + n.top,
            s = this.width - n.left - n.right,
            a = this.height - n.top - n.bottom;
          this.imageObj.drawImageAtPosition(t, i, o, r, s, a), this.disableShadow(t, e);
        }
      }
    }, {
      key: "_drawImageLabel",
      value: function value(t, e, i, n, o) {
        var r = 0;
        if (void 0 !== this.height) {
          r = .5 * this.height;
          var s = this.labelModule.getTextSize(t, n, o);
          s.lineCount >= 1 && (r += s.height / 2);
        }
        var a = i + r;
        this.options.label && (this.labelOffset = r), this.labelModule.draw(t, e, a, n, o, "hanging");
      }
    }]), i;
  }(CP);
  function DP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var IP = function (t) {
    D_(i, t);
    var e = DP(i);
    function i(t, n, o) {
      var r;
      return ph(this, i), (r = e.call(this, t, n, o))._setMargins(o), r;
    }
    return xu(i, [{
      key: "resize",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.selected,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.hover;
        if (this.needsRefresh(e, i)) {
          var n = this.getDimensionsFromLabel(t, e, i),
            o = Math.max(n.width + this.margin.right + this.margin.left, n.height + this.margin.top + this.margin.bottom);
          this.options.size = o / 2, this.width = o, this.height = o, this.radius = this.width / 2;
        }
      }
    }, {
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        this.resize(t, n, o), this.left = e - this.width / 2, this.top = i - this.height / 2, this._drawRawCircle(t, e, i, r), this.updateBoundingBox(e, i), this.labelModule.draw(t, this.left + this.textSize.width / 2 + this.margin.left, i, n, o);
      }
    }, {
      key: "updateBoundingBox",
      value: function value(t, e) {
        this.boundingBox.top = e - this.options.size, this.boundingBox.left = t - this.options.size, this.boundingBox.right = t + this.options.size, this.boundingBox.bottom = e + this.options.size;
      }
    }, {
      key: "distanceToBorder",
      value: function value(t) {
        return t && this.resize(t), .5 * this.width;
      }
    }]), i;
  }(PP);
  function BP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var NP = function (t) {
    D_(i, t);
    var e = BP(i);
    function i(t, n, o, r, s) {
      var a;
      return ph(this, i), (a = e.call(this, t, n, o)).setImages(r, s), a;
    }
    return xu(i, [{
      key: "resize",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.selected,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.hover;
        if (void 0 === this.imageObj.src || void 0 === this.imageObj.width || void 0 === this.imageObj.height) {
          var n = 2 * this.options.size;
          return this.width = n, this.height = n, void (this.radius = .5 * this.width);
        }
        this.needsRefresh(e, i) && this._resizeImage();
      }
    }, {
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        this.switchImages(n), this.resize();
        var s = e,
          a = i;
        "top-left" === this.options.shapeProperties.coordinateOrigin ? (this.left = e, this.top = i, s += this.width / 2, a += this.height / 2) : (this.left = e - this.width / 2, this.top = i - this.height / 2), this._drawRawCircle(t, s, a, r), t.save(), t.clip(), this._drawImageAtPosition(t, r), t.restore(), this._drawImageLabel(t, s, a, n, o), this.updateBoundingBox(e, i);
      }
    }, {
      key: "updateBoundingBox",
      value: function value(t, e) {
        "top-left" === this.options.shapeProperties.coordinateOrigin ? (this.boundingBox.top = e, this.boundingBox.left = t, this.boundingBox.right = t + 2 * this.options.size, this.boundingBox.bottom = e + 2 * this.options.size) : (this.boundingBox.top = e - this.options.size, this.boundingBox.left = t - this.options.size, this.boundingBox.right = t + this.options.size, this.boundingBox.bottom = e + this.options.size), this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left), this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width), this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelOffset);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t) {
        return t && this.resize(t), .5 * this.width;
      }
    }]), i;
  }(PP);
  function FP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var zP = function (t) {
    D_(i, t);
    var e = FP(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "resize",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.selected,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.hover,
          n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
            size: this.options.size
          };
        if (this.needsRefresh(e, i)) {
          var o, r;
          this.labelModule.getTextSize(t, e, i);
          var s = 2 * n.size;
          this.width = null !== (o = this.customSizeWidth) && void 0 !== o ? o : s, this.height = null !== (r = this.customSizeHeight) && void 0 !== r ? r : s, this.radius = .5 * this.width;
        }
      }
    }, {
      key: "_drawShape",
      value: function value(t, e, i, n, o, r, s, a) {
        var h,
          l = this;
        return this.resize(t, r, s, a), this.left = n - this.width / 2, this.top = o - this.height / 2, this.initContextForDraw(t, a), (h = e, Object.prototype.hasOwnProperty.call(Xn, h) ? Xn[h] : function (t) {
          for (var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) i[n - 1] = arguments[n];
          CanvasRenderingContext2D.prototype[h].call(t, i);
        })(t, n, o, a.size), this.performFill(t, a), void 0 !== this.options.icon && void 0 !== this.options.icon.code && (t.font = (r ? "bold " : "") + this.height / 2 + "px " + (this.options.icon.face || "FontAwesome"), t.fillStyle = this.options.icon.color || "black", t.textAlign = "center", t.textBaseline = "middle", t.fillText(this.options.icon.code, n, o)), {
          drawExternalLabel: function drawExternalLabel() {
            if (void 0 !== l.options.label) {
              l.labelModule.calculateLabelSize(t, r, s, n, o, "hanging");
              var e = o + .5 * l.height + .5 * l.labelModule.size.height;
              l.labelModule.draw(t, n, e, r, s, "hanging");
            }
            l.updateBoundingBox(n, o);
          }
        };
      }
    }, {
      key: "updateBoundingBox",
      value: function value(t, e) {
        this.boundingBox.top = e - this.options.size, this.boundingBox.left = t - this.options.size, this.boundingBox.right = t + this.options.size, this.boundingBox.bottom = e + this.options.size, void 0 !== this.options.label && this.labelModule.size.width > 0 && (this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left), this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width), this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelModule.size.height));
      }
    }]), i;
  }(CP);
  function AP(t, e) {
    var i = Hf(t);
    if (aM) {
      var n = aM(t);
      e && (n = yv(n).call(n, function (e) {
        return yM(t, e).enumerable;
      })), i.push.apply(i, n);
    }
    return i;
  }
  function jP(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i,
        n,
        o = null != arguments[e] ? arguments[e] : {};
      e % 2 ? op(i = AP(Object(o), !0)).call(i, function (e) {
        z_(t, e, o[e]);
      }) : _M ? MM(t, _M(o)) : op(n = AP(Object(o))).call(n, function (e) {
        UT(t, e, yM(o, e));
      });
    }
    return t;
  }
  function RP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var LP = function (t) {
    D_(i, t);
    var e = RP(i);
    function i(t, n, o, r) {
      var s;
      return ph(this, i), (s = e.call(this, t, n, o, r)).ctxRenderer = r, s;
    }
    return xu(i, [{
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        this.resize(t, n, o, r), this.left = e - this.width / 2, this.top = i - this.height / 2, t.save();
        var s = this.ctxRenderer({
          ctx: t,
          id: this.options.id,
          x: e,
          y: i,
          state: {
            selected: n,
            hover: o
          },
          style: jP({}, r),
          label: this.options.label
        });
        if (null != s.drawNode && s.drawNode(), t.restore(), s.drawExternalLabel) {
          var a = s.drawExternalLabel;
          s.drawExternalLabel = function () {
            t.save(), a(), t.restore();
          };
        }
        return s.nodeDimensions && (this.customSizeWidth = s.nodeDimensions.width, this.customSizeHeight = s.nodeDimensions.height), s;
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(zP);
  function HP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var WP = function (t) {
    D_(i, t);
    var e = HP(i);
    function i(t, n, o) {
      var r;
      return ph(this, i), (r = e.call(this, t, n, o))._setMargins(o), r;
    }
    return xu(i, [{
      key: "resize",
      value: function value(t, e, i) {
        if (this.needsRefresh(e, i)) {
          var n = this.getDimensionsFromLabel(t, e, i).width + this.margin.right + this.margin.left;
          this.width = n, this.height = n, this.radius = this.width / 2;
        }
      }
    }, {
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        this.resize(t, n, o), this.left = e - this.width / 2, this.top = i - this.height / 2, this.initContextForDraw(t, r), Un(t, e - this.width / 2, i - this.height / 2, this.width, this.height), this.performFill(t, r), this.updateBoundingBox(e, i, t, n, o), this.labelModule.draw(t, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, n, o);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(CP);
  function qP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var VP = function (t) {
    D_(i, t);
    var e = qP(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        return this._drawShape(t, "diamond", 4, e, i, n, o, r);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(zP);
  function UP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var YP = function (t) {
    D_(i, t);
    var e = UP(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        return this._drawShape(t, "circle", 2, e, i, n, o, r);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t) {
        return t && this.resize(t), this.options.size;
      }
    }]), i;
  }(zP);
  function XP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var GP = function (t) {
    D_(i, t);
    var e = XP(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "resize",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.selected,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.hover;
        if (this.needsRefresh(e, i)) {
          var n = this.getDimensionsFromLabel(t, e, i);
          this.height = 2 * n.height, this.width = n.width + n.height, this.radius = .5 * this.width;
        }
      }
    }, {
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        this.resize(t, n, o), this.left = e - .5 * this.width, this.top = i - .5 * this.height, this.initContextForDraw(t, r), Vn(t, this.left, this.top, this.width, this.height), this.performFill(t, r), this.updateBoundingBox(e, i, t, n, o), this.labelModule.draw(t, e, i, n, o);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        t && this.resize(t);
        var i = .5 * this.width,
          n = .5 * this.height,
          o = Math.sin(e) * i,
          r = Math.cos(e) * n;
        return i * n / Math.sqrt(o * o + r * r);
      }
    }]), i;
  }(CP);
  function KP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var $P = function (t) {
    D_(i, t);
    var e = KP(i);
    function i(t, n, o) {
      var r;
      return ph(this, i), (r = e.call(this, t, n, o))._setMargins(o), r;
    }
    return xu(i, [{
      key: "resize",
      value: function value(t, e, i) {
        this.needsRefresh(e, i) && (this.iconSize = {
          width: Number(this.options.icon.size),
          height: Number(this.options.icon.size)
        }, this.width = this.iconSize.width + this.margin.right + this.margin.left, this.height = this.iconSize.height + this.margin.top + this.margin.bottom, this.radius = .5 * this.width);
      }
    }, {
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        var s = this;
        return this.resize(t, n, o), this.options.icon.size = this.options.icon.size || 50, this.left = e - this.width / 2, this.top = i - this.height / 2, this._icon(t, e, i, n, o, r), {
          drawExternalLabel: function drawExternalLabel() {
            if (void 0 !== s.options.label) {
              s.labelModule.draw(t, s.left + s.iconSize.width / 2 + s.margin.left, i + s.height / 2 + 5, n);
            }
            s.updateBoundingBox(e, i);
          }
        };
      }
    }, {
      key: "updateBoundingBox",
      value: function value(t, e) {
        if (this.boundingBox.top = e - .5 * this.options.icon.size, this.boundingBox.left = t - .5 * this.options.icon.size, this.boundingBox.right = t + .5 * this.options.icon.size, this.boundingBox.bottom = e + .5 * this.options.icon.size, void 0 !== this.options.label && this.labelModule.size.width > 0) {
          this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left), this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width), this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelModule.size.height + 5);
        }
      }
    }, {
      key: "_icon",
      value: function value(t, e, i, n, o, r) {
        var s = Number(this.options.icon.size);
        void 0 !== this.options.icon.code ? (t.font = [null != this.options.icon.weight ? this.options.icon.weight : n ? "bold" : "", (null != this.options.icon.weight && n ? 5 : 0) + s + "px", this.options.icon.face].join(" "), t.fillStyle = this.options.icon.color || "black", t.textAlign = "center", t.textBaseline = "middle", this.enableShadow(t, r), t.fillText(this.options.icon.code, e, i), this.disableShadow(t, r)) : console.error("When using the icon shape, you need to define the code in the icon options object. This can be done per node or globally.");
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(CP);
  function ZP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var QP = function (t) {
    D_(i, t);
    var e = ZP(i);
    function i(t, n, o, r, s) {
      var a;
      return ph(this, i), (a = e.call(this, t, n, o)).setImages(r, s), a;
    }
    return xu(i, [{
      key: "resize",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.selected,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.hover;
        if (void 0 === this.imageObj.src || void 0 === this.imageObj.width || void 0 === this.imageObj.height) {
          var n = 2 * this.options.size;
          return this.width = n, void (this.height = n);
        }
        this.needsRefresh(e, i) && this._resizeImage();
      }
    }, {
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        t.save(), this.switchImages(n), this.resize();
        var s = e,
          a = i;
        if ("top-left" === this.options.shapeProperties.coordinateOrigin ? (this.left = e, this.top = i, s += this.width / 2, a += this.height / 2) : (this.left = e - this.width / 2, this.top = i - this.height / 2), !0 === this.options.shapeProperties.useBorderWithImage) {
          var h = this.options.borderWidth,
            l = this.options.borderWidthSelected || 2 * this.options.borderWidth,
            d = (n ? l : h) / this.body.view.scale;
          t.lineWidth = Math.min(this.width, d), t.beginPath();
          var c = n ? this.options.color.highlight.border : o ? this.options.color.hover.border : this.options.color.border,
            u = n ? this.options.color.highlight.background : o ? this.options.color.hover.background : this.options.color.background;
          void 0 !== r.opacity && (c = Ob(c, r.opacity), u = Ob(u, r.opacity)), t.strokeStyle = c, t.fillStyle = u, t.rect(this.left - .5 * t.lineWidth, this.top - .5 * t.lineWidth, this.width + t.lineWidth, this.height + t.lineWidth), Kg(t).call(t), this.performStroke(t, r), t.closePath();
        }
        this._drawImageAtPosition(t, r), this._drawImageLabel(t, s, a, n, o), this.updateBoundingBox(e, i), t.restore();
      }
    }, {
      key: "updateBoundingBox",
      value: function value(t, e) {
        this.resize(), "top-left" === this.options.shapeProperties.coordinateOrigin ? (this.left = t, this.top = e) : (this.left = t - this.width / 2, this.top = e - this.height / 2), this.boundingBox.left = this.left, this.boundingBox.top = this.top, this.boundingBox.bottom = this.top + this.height, this.boundingBox.right = this.left + this.width, void 0 !== this.options.label && this.labelModule.size.width > 0 && (this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left), this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width), this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelOffset));
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(PP);
  function JP(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var tD = function (t) {
    D_(i, t);
    var e = JP(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        return this._drawShape(t, "square", 2, e, i, n, o, r);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(zP);
  function eD(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var iD = function (t) {
    D_(i, t);
    var e = eD(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        return this._drawShape(t, "hexagon", 4, e, i, n, o, r);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(zP);
  function nD(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var oD = function (t) {
    D_(i, t);
    var e = nD(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        return this._drawShape(t, "star", 4, e, i, n, o, r);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(zP);
  function rD(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var sD = function (t) {
    D_(i, t);
    var e = rD(i);
    function i(t, n, o) {
      var r;
      return ph(this, i), (r = e.call(this, t, n, o))._setMargins(o), r;
    }
    return xu(i, [{
      key: "resize",
      value: function value(t, e, i) {
        this.needsRefresh(e, i) && (this.textSize = this.labelModule.getTextSize(t, e, i), this.width = this.textSize.width + this.margin.right + this.margin.left, this.height = this.textSize.height + this.margin.top + this.margin.bottom, this.radius = .5 * this.width);
      }
    }, {
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        this.resize(t, n, o), this.left = e - this.width / 2, this.top = i - this.height / 2, this.enableShadow(t, r), this.labelModule.draw(t, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, n, o), this.disableShadow(t, r), this.updateBoundingBox(e, i, t, n, o);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(CP);
  function aD(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var hD = function (t) {
    D_(i, t);
    var e = aD(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        return this._drawShape(t, "triangle", 3, e, i, n, o, r);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(zP);
  function lD(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var dD = function (t) {
    D_(i, t);
    var e = lD(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "draw",
      value: function value(t, e, i, n, o, r) {
        return this._drawShape(t, "triangleDown", 3, e, i, n, o, r);
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this._distanceToBorder(t, e);
      }
    }]), i;
  }(zP);
  function cD(t, e) {
    var i = Hf(t);
    if (aM) {
      var n = aM(t);
      e && (n = yv(n).call(n, function (e) {
        return yM(t, e).enumerable;
      })), i.push.apply(i, n);
    }
    return i;
  }
  function uD(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i,
        n,
        o = null != arguments[e] ? arguments[e] : {};
      e % 2 ? op(i = cD(Object(o), !0)).call(i, function (e) {
        z_(t, e, o[e]);
      }) : _M ? MM(t, _M(o)) : op(n = cD(Object(o))).call(n, function (e) {
        UT(t, e, yM(o, e));
      });
    }
    return t;
  }
  var fD = function () {
    function t(e, i, n, o, r, s) {
      ph(this, t), this.options = zb(r), this.globalOptions = r, this.defaultOptions = s, this.body = i, this.edges = [], this.id = void 0, this.imagelist = n, this.grouplist = o, this.x = void 0, this.y = void 0, this.baseSize = this.options.size, this.baseFontSize = this.options.font.size, this.predefinedPosition = !1, this.selected = !1, this.hover = !1, this.labelModule = new OP(this.body, this.options, !1), this.setOptions(e);
    }
    return xu(t, [{
      key: "attachEdge",
      value: function value(t) {
        var e;
        -1 === lg(e = this.edges).call(e, t) && this.edges.push(t);
      }
    }, {
      key: "detachEdge",
      value: function value(t) {
        var e,
          i,
          n = lg(e = this.edges).call(e, t);
        -1 != n && Ap(i = this.edges).call(i, n, 1);
      }
    }, {
      key: "setOptions",
      value: function value(e) {
        var i = this.options.shape;
        if (e) {
          if (void 0 !== e.color && (this._localColor = e.color), void 0 !== e.id && (this.id = e.id), void 0 === this.id) throw new Error("Node must have an id");
          t.checkMass(e, this.id), void 0 !== e.x && (null === e.x ? (this.x = void 0, this.predefinedPosition = !1) : (this.x = Qv(e.x), this.predefinedPosition = !0)), void 0 !== e.y && (null === e.y ? (this.y = void 0, this.predefinedPosition = !1) : (this.y = Qv(e.y), this.predefinedPosition = !0)), void 0 !== e.size && (this.baseSize = e.size), void 0 !== e.value && (e.value = lP(e.value)), t.parseOptions(this.options, e, !0, this.globalOptions, this.grouplist);
          var n = [e, this.options, this.defaultOptions];
          return this.chooser = gP("node", n), this._load_images(), this.updateLabelModule(e), void 0 !== e.opacity && t.checkOpacity(e.opacity) && (this.options.opacity = e.opacity), this.updateShape(i), void 0 !== e.hidden || void 0 !== e.physics;
        }
      }
    }, {
      key: "_load_images",
      value: function value() {
        if (("circularImage" === this.options.shape || "image" === this.options.shape) && void 0 === this.options.image) throw new Error("Option image must be defined for node type '" + this.options.shape + "'");
        if (void 0 !== this.options.image) {
          if (void 0 === this.imagelist) throw new Error("Internal Error: No images provided");
          if ("string" == typeof this.options.image) this.imageObj = this.imagelist.load(this.options.image, this.options.brokenImage, this.id);else {
            if (void 0 === this.options.image.unselected) throw new Error("No unselected image provided");
            this.imageObj = this.imagelist.load(this.options.image.unselected, this.options.brokenImage, this.id), void 0 !== this.options.image.selected ? this.imageObjAlt = this.imagelist.load(this.options.image.selected, this.options.brokenImage, this.id) : this.imageObjAlt = void 0;
          }
        }
      }
    }, {
      key: "getFormattingValues",
      value: function value() {
        var t = {
          color: this.options.color.background,
          opacity: this.options.opacity,
          borderWidth: this.options.borderWidth,
          borderColor: this.options.color.border,
          size: this.options.size,
          borderDashes: this.options.shapeProperties.borderDashes,
          borderRadius: this.options.shapeProperties.borderRadius,
          shadow: this.options.shadow.enabled,
          shadowColor: this.options.shadow.color,
          shadowSize: this.options.shadow.size,
          shadowX: this.options.shadow.x,
          shadowY: this.options.shadow.y
        };
        if (this.selected || this.hover ? !0 === this.chooser ? this.selected ? (null != this.options.borderWidthSelected ? t.borderWidth = this.options.borderWidthSelected : t.borderWidth *= 2, t.color = this.options.color.highlight.background, t.borderColor = this.options.color.highlight.border, t.shadow = this.options.shadow.enabled) : this.hover && (t.color = this.options.color.hover.background, t.borderColor = this.options.color.hover.border, t.shadow = this.options.shadow.enabled) : "function" == typeof this.chooser && (this.chooser(t, this.options.id, this.selected, this.hover), !1 === t.shadow && (t.shadowColor === this.options.shadow.color && t.shadowSize === this.options.shadow.size && t.shadowX === this.options.shadow.x && t.shadowY === this.options.shadow.y || (t.shadow = !0))) : t.shadow = this.options.shadow.enabled, void 0 !== this.options.opacity) {
          var e = this.options.opacity;
          t.borderColor = Ob(t.borderColor, e), t.color = Ob(t.color, e), t.shadowColor = Ob(t.shadowColor, e);
        }
        return t;
      }
    }, {
      key: "updateLabelModule",
      value: function value(e) {
        void 0 !== this.options.label && null !== this.options.label || (this.options.label = ""), t.updateGroupOptions(this.options, uD(uD({}, e), {}, {
          color: e && e.color || this._localColor || void 0
        }), this.grouplist);
        var i = this.grouplist.get(this.options.group, !1),
          n = [e, this.options, i, this.globalOptions, this.defaultOptions];
        this.labelModule.update(this.options, n), void 0 !== this.labelModule.baseSize && (this.baseFontSize = this.labelModule.baseSize);
      }
    }, {
      key: "updateShape",
      value: function value(t) {
        if (t === this.options.shape && this.shape) this.shape.setOptions(this.options, this.imageObj, this.imageObjAlt);else switch (this.options.shape) {
          case "box":
            this.shape = new TP(this.options, this.body, this.labelModule);
            break;
          case "circle":
            this.shape = new IP(this.options, this.body, this.labelModule);
            break;
          case "circularImage":
            this.shape = new NP(this.options, this.body, this.labelModule, this.imageObj, this.imageObjAlt);
            break;
          case "custom":
            this.shape = new LP(this.options, this.body, this.labelModule, this.options.ctxRenderer);
            break;
          case "database":
            this.shape = new WP(this.options, this.body, this.labelModule);
            break;
          case "diamond":
            this.shape = new VP(this.options, this.body, this.labelModule);
            break;
          case "dot":
            this.shape = new YP(this.options, this.body, this.labelModule);
            break;
          case "ellipse":
          default:
            this.shape = new GP(this.options, this.body, this.labelModule);
            break;
          case "icon":
            this.shape = new $P(this.options, this.body, this.labelModule);
            break;
          case "image":
            this.shape = new QP(this.options, this.body, this.labelModule, this.imageObj, this.imageObjAlt);
            break;
          case "square":
            this.shape = new tD(this.options, this.body, this.labelModule);
            break;
          case "hexagon":
            this.shape = new iD(this.options, this.body, this.labelModule);
            break;
          case "star":
            this.shape = new oD(this.options, this.body, this.labelModule);
            break;
          case "text":
            this.shape = new sD(this.options, this.body, this.labelModule);
            break;
          case "triangle":
            this.shape = new hD(this.options, this.body, this.labelModule);
            break;
          case "triangleDown":
            this.shape = new dD(this.options, this.body, this.labelModule);
        }
        this.needsRefresh();
      }
    }, {
      key: "select",
      value: function value() {
        this.selected = !0, this.needsRefresh();
      }
    }, {
      key: "unselect",
      value: function value() {
        this.selected = !1, this.needsRefresh();
      }
    }, {
      key: "needsRefresh",
      value: function value() {
        this.shape.refreshNeeded = !0;
      }
    }, {
      key: "getTitle",
      value: function value() {
        return this.options.title;
      }
    }, {
      key: "distanceToBorder",
      value: function value(t, e) {
        return this.shape.distanceToBorder(t, e);
      }
    }, {
      key: "isFixed",
      value: function value() {
        return this.options.fixed.x && this.options.fixed.y;
      }
    }, {
      key: "isSelected",
      value: function value() {
        return this.selected;
      }
    }, {
      key: "getValue",
      value: function value() {
        return this.options.value;
      }
    }, {
      key: "getLabelSize",
      value: function value() {
        return this.labelModule.size();
      }
    }, {
      key: "setValueRange",
      value: function value(t, e, i) {
        if (void 0 !== this.options.value) {
          var n = this.options.scaling.customScalingFunction(t, e, i, this.options.value),
            o = this.options.scaling.max - this.options.scaling.min;
          if (!0 === this.options.scaling.label.enabled) {
            var r = this.options.scaling.label.max - this.options.scaling.label.min;
            this.options.font.size = this.options.scaling.label.min + n * r;
          }
          this.options.size = this.options.scaling.min + n * o;
        } else this.options.size = this.baseSize, this.options.font.size = this.baseFontSize;
        this.updateLabelModule();
      }
    }, {
      key: "draw",
      value: function value(t) {
        var e = this.getFormattingValues();
        return this.shape.draw(t, this.x, this.y, this.selected, this.hover, e) || {};
      }
    }, {
      key: "updateBoundingBox",
      value: function value(t) {
        this.shape.updateBoundingBox(this.x, this.y, t);
      }
    }, {
      key: "resize",
      value: function value(t) {
        var e = this.getFormattingValues();
        this.shape.resize(t, this.selected, this.hover, e);
      }
    }, {
      key: "getItemsOnPoint",
      value: function value(t) {
        var e = [];
        return this.labelModule.visible() && yP(this.labelModule.getSize(), t) && e.push({
          nodeId: this.id,
          labelId: 0
        }), yP(this.shape.boundingBox, t) && e.push({
          nodeId: this.id
        }), e;
      }
    }, {
      key: "isOverlappingWith",
      value: function value(t) {
        return this.shape.left < t.right && this.shape.left + this.shape.width > t.left && this.shape.top < t.bottom && this.shape.top + this.shape.height > t.top;
      }
    }, {
      key: "isBoundingBoxOverlappingWith",
      value: function value(t) {
        return this.shape.boundingBox.left < t.right && this.shape.boundingBox.right > t.left && this.shape.boundingBox.top < t.bottom && this.shape.boundingBox.bottom > t.top;
      }
    }], [{
      key: "checkOpacity",
      value: function value(t) {
        return 0 <= t && t <= 1;
      }
    }, {
      key: "checkCoordinateOrigin",
      value: function value(t) {
        return void 0 === t || "center" === t || "top-left" === t;
      }
    }, {
      key: "updateGroupOptions",
      value: function value(e, i, n) {
        var o;
        if (void 0 !== n) {
          var r = e.group;
          if (void 0 !== i && void 0 !== i.group && r !== i.group) throw new Error("updateGroupOptions: group values in options don't match.");
          if ("number" == typeof r || "string" == typeof r && "" != r) {
            var s = n.get(r);
            void 0 !== s.opacity && void 0 === i.opacity && (t.checkOpacity(s.opacity) || (console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + s.opacity), s.opacity = void 0));
            var a = yv(o = vP(i)).call(o, function (t) {
              return null != i[t];
            });
            a.push("font"), vb(a, e, s), e.color = Sb(e.color);
          }
        }
      }
    }, {
      key: "parseOptions",
      value: function value(e, i) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
          r = arguments.length > 4 ? arguments[4] : void 0;
        if (vb(["color", "fixed", "shadow"], e, i, n), t.checkMass(i), void 0 !== e.opacity && (t.checkOpacity(e.opacity) || (console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + e.opacity), e.opacity = void 0)), void 0 !== i.opacity && (t.checkOpacity(i.opacity) || (console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + i.opacity), i.opacity = void 0)), i.shapeProperties && !t.checkCoordinateOrigin(i.shapeProperties.coordinateOrigin) && console.error("Invalid option for node coordinateOrigin, found: " + i.shapeProperties.coordinateOrigin), Ab(e, i, "shadow", o), void 0 !== i.color && null !== i.color) {
          var s = Sb(i.color);
          ub(e.color, s);
        } else !0 === n && null === i.color && (e.color = zb(o.color));
        void 0 !== i.fixed && null !== i.fixed && ("boolean" == typeof i.fixed ? (e.fixed.x = i.fixed, e.fixed.y = i.fixed) : (void 0 !== i.fixed.x && "boolean" == typeof i.fixed.x && (e.fixed.x = i.fixed.x), void 0 !== i.fixed.y && "boolean" == typeof i.fixed.y && (e.fixed.y = i.fixed.y))), !0 === n && null === i.font && (e.font = zb(o.font)), t.updateGroupOptions(e, i, r), void 0 !== i.scaling && Ab(e.scaling, i.scaling, "label", o.scaling);
      }
    }, {
      key: "checkMass",
      value: function value(t, e) {
        if (void 0 !== t.mass && t.mass <= 0) {
          var i = "";
          void 0 !== e && (i = " in node id: " + e), console.error("%cNegative or zero mass disallowed" + i + ", setting mass to 1.", tw), t.mass = 1;
        }
      }
    }]), t;
  }();
  function pD(t, e) {
    var i = void 0 !== gf && fh(t) || t["@@iterator"];
    if (!i) {
      if (Df(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return vD(t, e);
        var n = xf(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Ya(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return vD(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);
        var _n4 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n4 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n4++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r,
      s = !0,
      a = !1;
    return {
      s: function s() {
        i = i.call(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i["return"] || i["return"]();
        } finally {
          if (a) throw r;
        }
      }
    };
  }
  function vD(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
    return n;
  }
  var gD = function () {
      function t(e, i, n, o) {
        var r,
          s = this;
        if (ph(this, t), this.body = e, this.images = i, this.groups = n, this.layoutEngine = o, this.body.functions.createNode = Hn(r = this.create).call(r, this), this.nodesListeners = {
          add: function add(t, e) {
            s.add(e.items);
          },
          update: function update(t, e) {
            s.update(e.items, e.data, e.oldData);
          },
          remove: function remove(t, e) {
            s.remove(e.items);
          }
        }, this.defaultOptions = {
          borderWidth: 1,
          borderWidthSelected: void 0,
          brokenImage: void 0,
          color: {
            border: "#2B7CE9",
            background: "#97C2FC",
            highlight: {
              border: "#2B7CE9",
              background: "#D2E5FF"
            },
            hover: {
              border: "#2B7CE9",
              background: "#D2E5FF"
            }
          },
          opacity: void 0,
          fixed: {
            x: !1,
            y: !1
          },
          font: {
            color: "#343434",
            size: 14,
            face: "arial",
            background: "none",
            strokeWidth: 0,
            strokeColor: "#ffffff",
            align: "center",
            vadjust: 0,
            multi: !1,
            bold: {
              mod: "bold"
            },
            boldital: {
              mod: "bold italic"
            },
            ital: {
              mod: "italic"
            },
            mono: {
              mod: "",
              size: 15,
              face: "monospace",
              vadjust: 2
            }
          },
          group: void 0,
          hidden: !1,
          icon: {
            face: "FontAwesome",
            code: void 0,
            size: 50,
            color: "#2B7CE9"
          },
          image: void 0,
          imagePadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
          label: void 0,
          labelHighlightBold: !0,
          level: void 0,
          margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
          },
          mass: 1,
          physics: !0,
          scaling: {
            min: 10,
            max: 30,
            label: {
              enabled: !1,
              min: 14,
              max: 30,
              maxVisible: 30,
              drawThreshold: 5
            },
            customScalingFunction: function customScalingFunction(t, e, i, n) {
              if (e === t) return .5;
              var o = 1 / (e - t);
              return Math.max(0, (n - t) * o);
            }
          },
          shadow: {
            enabled: !1,
            color: "rgba(0,0,0,0.5)",
            size: 10,
            x: 5,
            y: 5
          },
          shape: "ellipse",
          shapeProperties: {
            borderDashes: !1,
            borderRadius: 6,
            interpolation: !0,
            useImageSize: !1,
            useBorderWithImage: !1,
            coordinateOrigin: "center"
          },
          size: 25,
          title: void 0,
          value: void 0,
          x: void 0,
          y: void 0
        }, this.defaultOptions.mass <= 0) throw "Internal error: mass in defaultOptions of NodesHandler may not be zero or negative";
        this.options = zb(this.defaultOptions), this.bindEventListeners();
      }
      return xu(t, [{
        key: "bindEventListeners",
        value: function value() {
          var t,
            e,
            i = this;
          this.body.emitter.on("refreshNodes", Hn(t = this.refresh).call(t, this)), this.body.emitter.on("refresh", Hn(e = this.refresh).call(e, this)), this.body.emitter.on("destroy", function () {
            kb(i.nodesListeners, function (t, e) {
              i.body.data.nodes && i.body.data.nodes.off(e, t);
            }), delete i.body.functions.createNode, delete i.nodesListeners.add, delete i.nodesListeners.update, delete i.nodesListeners.remove, delete i.nodesListeners;
          });
        }
      }, {
        key: "setOptions",
        value: function value(t) {
          if (void 0 !== t) {
            if (fD.parseOptions(this.options, t), void 0 !== t.opacity && (f_(t.opacity) || !g_(t.opacity) || t.opacity < 0 || t.opacity > 1 ? console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + t.opacity) : this.options.opacity = t.opacity), void 0 !== t.shape) for (var e in this.body.nodes) Object.prototype.hasOwnProperty.call(this.body.nodes, e) && this.body.nodes[e].updateShape();
            if (void 0 !== t.font || void 0 !== t.widthConstraint || void 0 !== t.heightConstraint) for (var i = 0, n = Hf(this.body.nodes); i < n.length; i++) {
              var o = n[i];
              this.body.nodes[o].updateLabelModule(), this.body.nodes[o].needsRefresh();
            }
            if (void 0 !== t.size) for (var r in this.body.nodes) Object.prototype.hasOwnProperty.call(this.body.nodes, r) && this.body.nodes[r].needsRefresh();
            void 0 === t.hidden && void 0 === t.physics || this.body.emitter.emit("_dataChanged");
          }
        }
      }, {
        key: "setData",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            i = this.body.data.nodes;
          if (ZM("id", t)) this.body.data.nodes = t;else if (Df(t)) this.body.data.nodes = new GM(), this.body.data.nodes.add(t);else {
            if (t) throw new TypeError("Array or DataSet expected");
            this.body.data.nodes = new GM();
          }
          if (i && kb(this.nodesListeners, function (t, e) {
            i.off(e, t);
          }), this.body.nodes = {}, this.body.data.nodes) {
            var n = this;
            kb(this.nodesListeners, function (t, e) {
              n.body.data.nodes.on(e, t);
            });
            var o = this.body.data.nodes.getIds();
            this.add(o, !0);
          }
          !1 === e && this.body.emitter.emit("_dataChanged");
        }
      }, {
        key: "add",
        value: function value(t) {
          for (var e, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = [], o = 0; o < t.length; o++) {
            e = t[o];
            var r = this.body.data.nodes.get(e),
              s = this.create(r);
            n.push(s), this.body.nodes[e] = s;
          }
          this.layoutEngine.positionInitially(n), !1 === i && this.body.emitter.emit("_dataChanged");
        }
      }, {
        key: "update",
        value: function value(t, e, i) {
          for (var n = this.body.nodes, o = !1, r = 0; r < t.length; r++) {
            var s = t[r],
              a = n[s],
              h = e[r];
            void 0 !== a ? a.setOptions(h) && (o = !0) : (o = !0, a = this.create(h), n[s] = a);
          }
          o || void 0 === i || (o = x_(e).call(e, function (t, e) {
            var n = i[e];
            return n && n.level !== t.level;
          })), !0 === o ? this.body.emitter.emit("_dataChanged") : this.body.emitter.emit("_dataUpdated");
        }
      }, {
        key: "remove",
        value: function value(t) {
          for (var e = this.body.nodes, i = 0; i < t.length; i++) {
            delete e[t[i]];
          }
          this.body.emitter.emit("_dataChanged");
        }
      }, {
        key: "create",
        value: function value(t) {
          return new (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : fD)(t, this.body, this.images, this.groups, this.options, this.defaultOptions);
        }
      }, {
        key: "refresh",
        value: function value() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          kb(this.body.nodes, function (i, n) {
            var o = t.body.data.nodes.get(n);
            void 0 !== o && (!0 === e && i.setOptions({
              x: null,
              y: null
            }), i.setOptions({
              fixed: !1
            }), i.setOptions(o));
          });
        }
      }, {
        key: "getPositions",
        value: function value(t) {
          var e = {};
          if (void 0 !== t) {
            if (!0 === Df(t)) {
              for (var i = 0; i < t.length; i++) if (void 0 !== this.body.nodes[t[i]]) {
                var n = this.body.nodes[t[i]];
                e[t[i]] = {
                  x: Math.round(n.x),
                  y: Math.round(n.y)
                };
              }
            } else if (void 0 !== this.body.nodes[t]) {
              var o = this.body.nodes[t];
              e[t] = {
                x: Math.round(o.x),
                y: Math.round(o.y)
              };
            }
          } else for (var r = 0; r < this.body.nodeIndices.length; r++) {
            var s = this.body.nodes[this.body.nodeIndices[r]];
            e[this.body.nodeIndices[r]] = {
              x: Math.round(s.x),
              y: Math.round(s.y)
            };
          }
          return e;
        }
      }, {
        key: "getPosition",
        value: function value(t) {
          if (null == t) throw new TypeError("No id was specified for getPosition method.");
          if (null == this.body.nodes[t]) throw new ReferenceError("NodeId provided for getPosition does not exist. Provided: ".concat(t));
          return {
            x: Math.round(this.body.nodes[t].x),
            y: Math.round(this.body.nodes[t].y)
          };
        }
      }, {
        key: "storePositions",
        value: function value() {
          var t,
            e = [],
            i = this.body.data.nodes.getDataSet(),
            n = pD(i.get());
          try {
            for (n.s(); !(t = n.n()).done;) {
              var o = t.value,
                r = o.id,
                s = this.body.nodes[r],
                a = Math.round(s.x),
                h = Math.round(s.y);
              o.x === a && o.y === h || e.push({
                id: r,
                x: a,
                y: h
              });
            }
          } catch (t) {
            n.e(t);
          } finally {
            n.f();
          }
          i.update(e);
        }
      }, {
        key: "getBoundingBox",
        value: function value(t) {
          if (void 0 !== this.body.nodes[t]) return this.body.nodes[t].shape.boundingBox;
        }
      }, {
        key: "getConnectedNodes",
        value: function value(t, e) {
          var i = [];
          if (void 0 !== this.body.nodes[t]) for (var n = this.body.nodes[t], o = {}, r = 0; r < n.edges.length; r++) {
            var s = n.edges[r];
            "to" !== e && s.toId == n.id ? void 0 === o[s.fromId] && (i.push(s.fromId), o[s.fromId] = !0) : "from" !== e && s.fromId == n.id && void 0 === o[s.toId] && (i.push(s.toId), o[s.toId] = !0);
          }
          return i;
        }
      }, {
        key: "getConnectedEdges",
        value: function value(t) {
          var e = [];
          if (void 0 !== this.body.nodes[t]) for (var i = this.body.nodes[t], n = 0; n < i.edges.length; n++) e.push(i.edges[n].id);else console.error("NodeId provided for getConnectedEdges does not exist. Provided: ", t);
          return e;
        }
      }, {
        key: "moveNode",
        value: function value(t, e, i) {
          var n = this;
          void 0 !== this.body.nodes[t] ? (this.body.nodes[t].x = Number(e), this.body.nodes[t].y = Number(i), jg(function () {
            n.body.emitter.emit("startSimulation");
          }, 0)) : console.error("Node id supplied to moveNode does not exist. Provided: ", t);
        }
      }]), t;
    }(),
    yD = Qt,
    mD = I,
    bD = tt,
    wD = ii,
    kD = function kD(t) {
      return void 0 !== t && (yD(t, "value") || yD(t, "writable"));
    },
    _D = T,
    xD = Sr;
  Ti({
    target: "Reflect",
    stat: !0
  }, {
    get: function t(e, i) {
      var n,
        o,
        r = arguments.length < 3 ? e : arguments[2];
      return wD(e) === r ? e[i] : (n = _D.f(e, i)) ? kD(n) ? n.value : void 0 === n.get ? void 0 : mD(n.get, r) : bD(o = xD(e)) ? t(o, i, r) : void 0;
    }
  });
  var ED = i(et.Reflect.get),
    OD = i(gM);
  function CD() {
    var t;
    "undefined" != typeof Reflect && ED ? CD = M_(t = ED).call(t) : CD = function CD(t, e, i) {
      var n = function (t, e) {
        for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = F_(t)););
        return t;
      }(t, e);
      if (n) {
        var o = OD(n, e);
        return o.get ? o.get.call(arguments.length < 3 ? t : i) : o.value;
      }
    };
    return CD.apply(this, arguments);
  }
  var SD = Ti,
    TD = Math.hypot,
    MD = Math.abs,
    PD = Math.sqrt;
  SD({
    target: "Math",
    stat: !0,
    arity: 2,
    forced: !!TD && TD(1 / 0, NaN) !== 1 / 0
  }, {
    hypot: function hypot(t, e) {
      for (var i, n, o = 0, r = 0, s = arguments.length, a = 0; r < s;) a < (i = MD(arguments[r++])) ? (o = o * (n = a / i) * n + 1, a = i) : o += i > 0 ? (n = i / a) * n : i;
      return a === 1 / 0 ? 1 / 0 : a * PD(o);
    }
  });
  var DD = i(et.Math.hypot);
  function ID(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var BD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "transform",
        value: function value(t, e) {
          Df(t) || (t = [t]);
          for (var i = e.point.x, n = e.point.y, o = e.angle, r = e.length, s = 0; s < t.length; ++s) {
            var a = t[s],
              h = a.x * Math.cos(o) - a.y * Math.sin(o),
              l = a.x * Math.sin(o) + a.y * Math.cos(o);
            a.x = i + r * h, a.y = n + r * l;
          }
        }
      }, {
        key: "drawPath",
        value: function value(t, e) {
          t.beginPath(), t.moveTo(e[0].x, e[0].y);
          for (var i = 1; i < e.length; ++i) t.lineTo(e[i].x, e[i].y);
          t.closePath();
        }
      }]), t;
    }(),
    ND = function (t) {
      D_(i, t);
      var e = ID(i);
      function i() {
        return ph(this, i), e.apply(this, arguments);
      }
      return xu(i, null, [{
        key: "draw",
        value: function value(t, e) {
          if (e.image) {
            t.save(), t.translate(e.point.x, e.point.y), t.rotate(Math.PI / 2 + e.angle);
            var i = null != e.imageWidth ? e.imageWidth : e.image.width,
              n = null != e.imageHeight ? e.imageHeight : e.image.height;
            e.image.drawImageAtPosition(t, 1, -i / 2, 0, i, n), t.restore();
          }
          return !1;
        }
      }]), i;
    }(BD),
    FD = function (t) {
      D_(i, t);
      var e = ID(i);
      function i() {
        return ph(this, i), e.apply(this, arguments);
      }
      return xu(i, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = [{
            x: 0,
            y: 0
          }, {
            x: -1,
            y: .3
          }, {
            x: -.9,
            y: 0
          }, {
            x: -1,
            y: -.3
          }];
          return BD.transform(i, e), BD.drawPath(t, i), !0;
        }
      }]), i;
    }(BD),
    zD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = [{
            x: -1,
            y: 0
          }, {
            x: 0,
            y: .3
          }, {
            x: -.4,
            y: 0
          }, {
            x: 0,
            y: -.3
          }];
          return BD.transform(i, e), BD.drawPath(t, i), !0;
        }
      }]), t;
    }(),
    AD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = {
            x: -.4,
            y: 0
          };
          BD.transform(i, e), t.strokeStyle = t.fillStyle, t.fillStyle = "rgba(0, 0, 0, 0)";
          var n = Math.PI,
            o = e.angle - n / 2,
            r = e.angle + n / 2;
          return t.beginPath(), t.arc(i.x, i.y, .4 * e.length, o, r, !1), t.stroke(), !0;
        }
      }]), t;
    }(),
    jD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = {
            x: -.3,
            y: 0
          };
          BD.transform(i, e), t.strokeStyle = t.fillStyle, t.fillStyle = "rgba(0, 0, 0, 0)";
          var n = Math.PI,
            o = e.angle + n / 2,
            r = e.angle + 3 * n / 2;
          return t.beginPath(), t.arc(i.x, i.y, .4 * e.length, o, r, !1), t.stroke(), !0;
        }
      }]), t;
    }(),
    RD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = [{
            x: .02,
            y: 0
          }, {
            x: -1,
            y: .3
          }, {
            x: -1,
            y: -.3
          }];
          return BD.transform(i, e), BD.drawPath(t, i), !0;
        }
      }]), t;
    }(),
    LD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = [{
            x: 0,
            y: .3
          }, {
            x: 0,
            y: -.3
          }, {
            x: -1,
            y: 0
          }];
          return BD.transform(i, e), BD.drawPath(t, i), !0;
        }
      }]), t;
    }(),
    HD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = {
            x: -.4,
            y: 0
          };
          return BD.transform(i, e), Wn(t, i.x, i.y, .4 * e.length), !0;
        }
      }]), t;
    }(),
    WD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = [{
            x: 0,
            y: .5
          }, {
            x: 0,
            y: -.5
          }, {
            x: -.15,
            y: -.5
          }, {
            x: -.15,
            y: .5
          }];
          return BD.transform(i, e), BD.drawPath(t, i), !0;
        }
      }]), t;
    }(),
    qD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = [{
            x: 0,
            y: .3
          }, {
            x: 0,
            y: -.3
          }, {
            x: -.6,
            y: -.3
          }, {
            x: -.6,
            y: .3
          }];
          return BD.transform(i, e), BD.drawPath(t, i), !0;
        }
      }]), t;
    }(),
    VD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = [{
            x: 0,
            y: 0
          }, {
            x: -.5,
            y: -.3
          }, {
            x: -1,
            y: 0
          }, {
            x: -.5,
            y: .3
          }];
          return BD.transform(i, e), BD.drawPath(t, i), !0;
        }
      }]), t;
    }(),
    UD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i = [{
            x: -1,
            y: .3
          }, {
            x: -.5,
            y: 0
          }, {
            x: -1,
            y: -.3
          }, {
            x: 0,
            y: 0
          }];
          return BD.transform(i, e), BD.drawPath(t, i), !0;
        }
      }]), t;
    }(),
    YD = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "draw",
        value: function value(t, e) {
          var i;
          switch (e.type && (i = e.type.toLowerCase()), i) {
            case "image":
              return ND.draw(t, e);
            case "circle":
              return HD.draw(t, e);
            case "box":
              return qD.draw(t, e);
            case "crow":
              return zD.draw(t, e);
            case "curve":
              return AD.draw(t, e);
            case "diamond":
              return VD.draw(t, e);
            case "inv_curve":
              return jD.draw(t, e);
            case "triangle":
              return RD.draw(t, e);
            case "inv_triangle":
              return LD.draw(t, e);
            case "bar":
              return WD.draw(t, e);
            case "vee":
              return UD.draw(t, e);
            default:
              return FD.draw(t, e);
          }
        }
      }]), t;
    }();
  function XD(t, e) {
    var i = Hf(t);
    if (aM) {
      var n = aM(t);
      e && (n = yv(n).call(n, function (e) {
        return yM(t, e).enumerable;
      })), i.push.apply(i, n);
    }
    return i;
  }
  function GD(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i,
        n,
        o = null != arguments[e] ? arguments[e] : {};
      e % 2 ? op(i = XD(Object(o), !0)).call(i, function (e) {
        z_(t, e, o[e]);
      }) : _M ? MM(t, _M(o)) : op(n = XD(Object(o))).call(n, function (e) {
        UT(t, e, yM(o, e));
      });
    }
    return t;
  }
  var KD = function () {
    function t(e, i, n) {
      ph(this, t), this._body = i, this._labelModule = n, this.color = {}, this.colorDirty = !0, this.hoverWidth = 1.5, this.selectionWidth = 2, this.setOptions(e), this.fromPoint = this.from, this.toPoint = this.to;
    }
    return xu(t, [{
      key: "connect",
      value: function value() {
        this.from = this._body.nodes[this.options.from], this.to = this._body.nodes[this.options.to];
      }
    }, {
      key: "cleanup",
      value: function value() {
        return !1;
      }
    }, {
      key: "setOptions",
      value: function value(t) {
        this.options = t, this.from = this._body.nodes[this.options.from], this.to = this._body.nodes[this.options.to], this.id = this.options.id;
      }
    }, {
      key: "drawLine",
      value: function value(t, e, i, n) {
        var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.getViaNode();
        t.strokeStyle = this.getColor(t, e), t.lineWidth = e.width, !1 !== e.dashes ? this._drawDashedLine(t, e, o) : this._drawLine(t, e, o);
      }
    }, {
      key: "_drawLine",
      value: function value(t, e, i, n, o) {
        if (this.from != this.to) this._line(t, e, i, n, o);else {
          var r = pf(this._getCircleData(t), 3),
            s = r[0],
            a = r[1],
            h = r[2];
          this._circle(t, e, s, a, h);
        }
      }
    }, {
      key: "_drawDashedLine",
      value: function value(t, e, i, n, o) {
        t.lineCap = "round";
        var r = Df(e.dashes) ? e.dashes : [5, 5];
        if (void 0 !== t.setLineDash) {
          if (t.save(), t.setLineDash(r), t.lineDashOffset = 0, this.from != this.to) this._line(t, e, i);else {
            var s = pf(this._getCircleData(t), 3),
              a = s[0],
              h = s[1],
              l = s[2];
            this._circle(t, e, a, h, l);
          }
          t.setLineDash([0]), t.lineDashOffset = 0, t.restore();
        } else {
          if (this.from != this.to) Yn(t, this.from.x, this.from.y, this.to.x, this.to.y, r);else {
            var d = pf(this._getCircleData(t), 3),
              c = d[0],
              u = d[1],
              f = d[2];
            this._circle(t, e, c, u, f);
          }
          this.enableShadow(t, e), t.stroke(), this.disableShadow(t, e);
        }
      }
    }, {
      key: "findBorderPosition",
      value: function value(t, e, i) {
        return this.from != this.to ? this._findBorderPosition(t, e, i) : this._findBorderPositionCircle(t, e, i);
      }
    }, {
      key: "findBorderPositions",
      value: function value(t) {
        if (this.from != this.to) return {
          from: this._findBorderPosition(this.from, t),
          to: this._findBorderPosition(this.to, t)
        };
        var e,
          i = pf(xf(e = this._getCircleData(t)).call(e, 0, 2), 2),
          n = i[0],
          o = i[1];
        return {
          from: this._findBorderPositionCircle(this.from, t, {
            x: n,
            y: o,
            low: .25,
            high: .6,
            direction: -1
          }),
          to: this._findBorderPositionCircle(this.from, t, {
            x: n,
            y: o,
            low: .6,
            high: .8,
            direction: 1
          })
        };
      }
    }, {
      key: "_getCircleData",
      value: function value(t) {
        var e = this.options.selfReference.size;
        void 0 !== t && void 0 === this.from.shape.width && this.from.shape.resize(t);
        var i = bP(t, this.options.selfReference.angle, e, this.from);
        return [i.x, i.y, e];
      }
    }, {
      key: "_pointOnCircle",
      value: function value(t, e, i, n) {
        var o = 2 * n * Math.PI;
        return {
          x: t + i * Math.cos(o),
          y: e - i * Math.sin(o)
        };
      }
    }, {
      key: "_findBorderPositionCircle",
      value: function value(t, e, i) {
        var n,
          o = i.x,
          r = i.y,
          s = i.low,
          a = i.high,
          h = i.direction,
          l = this.options.selfReference.size,
          d = .5 * (s + a),
          c = 0;
        !0 === this.options.arrowStrikethrough && (-1 === h ? c = this.options.endPointOffset.from : 1 === h && (c = this.options.endPointOffset.to));
        var u = 0;
        do {
          d = .5 * (s + a), n = this._pointOnCircle(o, r, l, d);
          var f = Math.atan2(t.y - n.y, t.x - n.x),
            p = t.distanceToBorder(e, f) + c - Math.sqrt(Math.pow(n.x - t.x, 2) + Math.pow(n.y - t.y, 2));
          if (Math.abs(p) < .05) break;
          p > 0 ? h > 0 ? s = d : a = d : h > 0 ? a = d : s = d, ++u;
        } while (s <= a && u < 10);
        return GD(GD({}, n), {}, {
          t: d
        });
      }
    }, {
      key: "getLineWidth",
      value: function value(t, e) {
        return !0 === t ? Math.max(this.selectionWidth, .3 / this._body.view.scale) : !0 === e ? Math.max(this.hoverWidth, .3 / this._body.view.scale) : Math.max(this.options.width, .3 / this._body.view.scale);
      }
    }, {
      key: "getColor",
      value: function value(t, e) {
        if (!1 !== e.inheritsColor) {
          if ("both" === e.inheritsColor && this.from.id !== this.to.id) {
            var i = t.createLinearGradient(this.from.x, this.from.y, this.to.x, this.to.y),
              n = this.from.options.color.highlight.border,
              o = this.to.options.color.highlight.border;
            return !1 === this.from.selected && !1 === this.to.selected ? (n = Ob(this.from.options.color.border, e.opacity), o = Ob(this.to.options.color.border, e.opacity)) : !0 === this.from.selected && !1 === this.to.selected ? o = this.to.options.color.border : !1 === this.from.selected && !0 === this.to.selected && (n = this.from.options.color.border), i.addColorStop(0, n), i.addColorStop(1, o), i;
          }
          return "to" === e.inheritsColor ? Ob(this.to.options.color.border, e.opacity) : Ob(this.from.options.color.border, e.opacity);
        }
        return Ob(e.color, e.opacity);
      }
    }, {
      key: "_circle",
      value: function value(t, e, i, n, o) {
        this.enableShadow(t, e);
        var r = 0,
          s = 2 * Math.PI;
        if (!this.options.selfReference.renderBehindTheNode) {
          var a = this.options.selfReference.angle,
            h = this.options.selfReference.angle + Math.PI,
            l = this._findBorderPositionCircle(this.from, t, {
              x: i,
              y: n,
              low: a,
              high: h,
              direction: -1
            }),
            d = this._findBorderPositionCircle(this.from, t, {
              x: i,
              y: n,
              low: a,
              high: h,
              direction: 1
            });
          r = Math.atan2(l.y - n, l.x - i), s = Math.atan2(d.y - n, d.x - i);
        }
        t.beginPath(), t.arc(i, n, o, r, s, !1), t.stroke(), this.disableShadow(t, e);
      }
    }, {
      key: "getDistanceToEdge",
      value: function value(t, e, i, n, o, r) {
        if (this.from != this.to) return this._getDistanceToEdge(t, e, i, n, o, r);
        var s = pf(this._getCircleData(void 0), 3),
          a = s[0],
          h = s[1],
          l = s[2],
          d = a - o,
          c = h - r;
        return Math.abs(Math.sqrt(d * d + c * c) - l);
      }
    }, {
      key: "_getDistanceToLine",
      value: function value(t, e, i, n, o, r) {
        var s = i - t,
          a = n - e,
          h = ((o - t) * s + (r - e) * a) / (s * s + a * a);
        h > 1 ? h = 1 : h < 0 && (h = 0);
        var l = t + h * s - o,
          d = e + h * a - r;
        return Math.sqrt(l * l + d * d);
      }
    }, {
      key: "getArrowData",
      value: function value(t, e, i, n, o, r) {
        var s,
          a,
          h,
          l,
          d,
          c,
          u,
          f = r.width;
        "from" === e ? (h = this.from, l = this.to, d = r.fromArrowScale < 0, c = Math.abs(r.fromArrowScale), u = r.fromArrowType) : "to" === e ? (h = this.to, l = this.from, d = r.toArrowScale < 0, c = Math.abs(r.toArrowScale), u = r.toArrowType) : (h = this.to, l = this.from, d = r.middleArrowScale < 0, c = Math.abs(r.middleArrowScale), u = r.middleArrowType);
        var p = 15 * c + 3 * f;
        if (h != l) {
          var v = p / DD(h.x - l.x, h.y - l.y);
          if ("middle" !== e) {
            if (!0 === this.options.smooth.enabled) {
              var g = this._findBorderPosition(h, t, {
                  via: i
                }),
                y = this.getPoint(g.t + v * ("from" === e ? 1 : -1), i);
              s = Math.atan2(g.y - y.y, g.x - y.x), a = g;
            } else s = Math.atan2(h.y - l.y, h.x - l.x), a = this._findBorderPosition(h, t);
          } else {
            var m = (d ? -v : v) / 2,
              b = this.getPoint(.5 + m, i),
              w = this.getPoint(.5 - m, i);
            s = Math.atan2(b.y - w.y, b.x - w.x), a = this.getPoint(.5, i);
          }
        } else {
          var k = pf(this._getCircleData(t), 3),
            _ = k[0],
            x = k[1],
            E = k[2];
          if ("from" === e) {
            var O = this.options.selfReference.angle,
              C = this.options.selfReference.angle + Math.PI,
              S = this._findBorderPositionCircle(this.from, t, {
                x: _,
                y: x,
                low: O,
                high: C,
                direction: -1
              });
            s = -2 * S.t * Math.PI + 1.5 * Math.PI + .1 * Math.PI, a = S;
          } else if ("to" === e) {
            var T = this.options.selfReference.angle,
              M = this.options.selfReference.angle + Math.PI,
              P = this._findBorderPositionCircle(this.from, t, {
                x: _,
                y: x,
                low: T,
                high: M,
                direction: 1
              });
            s = -2 * P.t * Math.PI + 1.5 * Math.PI - 1.1 * Math.PI, a = P;
          } else {
            var D = this.options.selfReference.angle / (2 * Math.PI);
            a = this._pointOnCircle(_, x, E, D), s = -2 * D * Math.PI + 1.5 * Math.PI + .1 * Math.PI;
          }
        }
        return {
          point: a,
          core: {
            x: a.x - .9 * p * Math.cos(s),
            y: a.y - .9 * p * Math.sin(s)
          },
          angle: s,
          length: p,
          type: u
        };
      }
    }, {
      key: "drawArrowHead",
      value: function value(t, e, i, n, o) {
        t.strokeStyle = this.getColor(t, e), t.fillStyle = t.strokeStyle, t.lineWidth = e.width, YD.draw(t, o) && (this.enableShadow(t, e), Kg(t).call(t), this.disableShadow(t, e));
      }
    }, {
      key: "enableShadow",
      value: function value(t, e) {
        !0 === e.shadow && (t.shadowColor = e.shadowColor, t.shadowBlur = e.shadowSize, t.shadowOffsetX = e.shadowX, t.shadowOffsetY = e.shadowY);
      }
    }, {
      key: "disableShadow",
      value: function value(t, e) {
        !0 === e.shadow && (t.shadowColor = "rgba(0,0,0,0)", t.shadowBlur = 0, t.shadowOffsetX = 0, t.shadowOffsetY = 0);
      }
    }, {
      key: "drawBackground",
      value: function value(t, e) {
        if (!1 !== e.background) {
          var i = {
            strokeStyle: t.strokeStyle,
            lineWidth: t.lineWidth,
            dashes: t.dashes
          };
          t.strokeStyle = e.backgroundColor, t.lineWidth = e.backgroundSize, this.setStrokeDashed(t, e.backgroundDashes), t.stroke(), t.strokeStyle = i.strokeStyle, t.lineWidth = i.lineWidth, t.dashes = i.dashes, this.setStrokeDashed(t, e.dashes);
        }
      }
    }, {
      key: "setStrokeDashed",
      value: function value(t, e) {
        if (!1 !== e) {
          if (void 0 !== t.setLineDash) {
            var i = Df(e) ? e : [5, 5];
            t.setLineDash(i);
          } else console.warn("setLineDash is not supported in this browser. The dashed stroke cannot be used.");
        } else void 0 !== t.setLineDash ? t.setLineDash([]) : console.warn("setLineDash is not supported in this browser. The dashed stroke cannot be used.");
      }
    }]), t;
  }();
  function $D(t, e) {
    var i = Hf(t);
    if (aM) {
      var n = aM(t);
      e && (n = yv(n).call(n, function (e) {
        return yM(t, e).enumerable;
      })), i.push.apply(i, n);
    }
    return i;
  }
  function ZD(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i,
        n,
        o = null != arguments[e] ? arguments[e] : {};
      e % 2 ? op(i = $D(Object(o), !0)).call(i, function (e) {
        z_(t, e, o[e]);
      }) : _M ? MM(t, _M(o)) : op(n = $D(Object(o))).call(n, function (e) {
        UT(t, e, yM(o, e));
      });
    }
    return t;
  }
  function QD(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var JD = function (t) {
    D_(i, t);
    var e = QD(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "_findBorderPositionBezier",
      value: function value(t, e) {
        var i,
          n,
          o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this._getViaCoordinates(),
          r = !1,
          s = 1,
          a = 0,
          h = this.to,
          l = this.options.endPointOffset ? this.options.endPointOffset.to : 0;
        t.id === this.from.id && (h = this.from, r = !0, l = this.options.endPointOffset ? this.options.endPointOffset.from : 0), !1 === this.options.arrowStrikethrough && (l = 0);
        var d = 0;
        do {
          n = .5 * (a + s), i = this.getPoint(n, o);
          var c = Math.atan2(h.y - i.y, h.x - i.x),
            u = h.distanceToBorder(e, c) + l - Math.sqrt(Math.pow(i.x - h.x, 2) + Math.pow(i.y - h.y, 2));
          if (Math.abs(u) < .2) break;
          u < 0 ? !1 === r ? a = n : s = n : !1 === r ? s = n : a = n, ++d;
        } while (a <= s && d < 10);
        return ZD(ZD({}, i), {}, {
          t: n
        });
      }
    }, {
      key: "_getDistanceToBezierEdge",
      value: function value(t, e, i, n, o, r, s) {
        var a,
          h,
          l,
          d,
          c,
          u = 1e9,
          f = t,
          p = e;
        for (h = 1; h < 10; h++) l = .1 * h, d = Math.pow(1 - l, 2) * t + 2 * l * (1 - l) * s.x + Math.pow(l, 2) * i, c = Math.pow(1 - l, 2) * e + 2 * l * (1 - l) * s.y + Math.pow(l, 2) * n, h > 0 && (u = (a = this._getDistanceToLine(f, p, d, c, o, r)) < u ? a : u), f = d, p = c;
        return u;
      }
    }, {
      key: "_bezierCurve",
      value: function value(t, e, i, n) {
        t.beginPath(), t.moveTo(this.fromPoint.x, this.fromPoint.y), null != i && null != i.x ? null != n && null != n.x ? t.bezierCurveTo(i.x, i.y, n.x, n.y, this.toPoint.x, this.toPoint.y) : t.quadraticCurveTo(i.x, i.y, this.toPoint.x, this.toPoint.y) : t.lineTo(this.toPoint.x, this.toPoint.y), this.drawBackground(t, e), this.enableShadow(t, e), t.stroke(), this.disableShadow(t, e);
      }
    }, {
      key: "getViaNode",
      value: function value() {
        return this._getViaCoordinates();
      }
    }]), i;
  }(KD);
  function tI(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var eI = function (t) {
    D_(i, t);
    var e = tI(i);
    function i(t, n, o) {
      var r;
      return ph(this, i), (r = e.call(this, t, n, o)).via = r.via, r._boundFunction = function () {
        r.positionBezierNode();
      }, r._body.emitter.on("_repositionBezierNodes", r._boundFunction), r;
    }
    return xu(i, [{
      key: "setOptions",
      value: function value(t) {
        CD(F_(i.prototype), "setOptions", this).call(this, t);
        var e = !1;
        this.options.physics !== t.physics && (e = !0), this.options = t, this.id = this.options.id, this.from = this._body.nodes[this.options.from], this.to = this._body.nodes[this.options.to], this.setupSupportNode(), this.connect(), !0 === e && (this.via.setOptions({
          physics: this.options.physics
        }), this.positionBezierNode());
      }
    }, {
      key: "connect",
      value: function value() {
        this.from = this._body.nodes[this.options.from], this.to = this._body.nodes[this.options.to], void 0 === this.from || void 0 === this.to || !1 === this.options.physics || this.from.id === this.to.id ? this.via.setOptions({
          physics: !1
        }) : this.via.setOptions({
          physics: !0
        });
      }
    }, {
      key: "cleanup",
      value: function value() {
        return this._body.emitter.off("_repositionBezierNodes", this._boundFunction), void 0 !== this.via && (delete this._body.nodes[this.via.id], this.via = void 0, !0);
      }
    }, {
      key: "setupSupportNode",
      value: function value() {
        if (void 0 === this.via) {
          var t = "edgeId:" + this.id,
            e = this._body.functions.createNode({
              id: t,
              shape: "circle",
              physics: !0,
              hidden: !0
            });
          this._body.nodes[t] = e, this.via = e, this.via.parentEdgeId = this.id, this.positionBezierNode();
        }
      }
    }, {
      key: "positionBezierNode",
      value: function value() {
        void 0 !== this.via && void 0 !== this.from && void 0 !== this.to ? (this.via.x = .5 * (this.from.x + this.to.x), this.via.y = .5 * (this.from.y + this.to.y)) : void 0 !== this.via && (this.via.x = 0, this.via.y = 0);
      }
    }, {
      key: "_line",
      value: function value(t, e, i) {
        this._bezierCurve(t, e, i);
      }
    }, {
      key: "_getViaCoordinates",
      value: function value() {
        return this.via;
      }
    }, {
      key: "getViaNode",
      value: function value() {
        return this.via;
      }
    }, {
      key: "getPoint",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.via;
        if (this.from === this.to) {
          var i = pf(this._getCircleData(), 3),
            n = i[0],
            o = i[1],
            r = i[2],
            s = 2 * Math.PI * (1 - t);
          return {
            x: n + r * Math.sin(s),
            y: o + r - r * (1 - Math.cos(s))
          };
        }
        return {
          x: Math.pow(1 - t, 2) * this.fromPoint.x + 2 * t * (1 - t) * e.x + Math.pow(t, 2) * this.toPoint.x,
          y: Math.pow(1 - t, 2) * this.fromPoint.y + 2 * t * (1 - t) * e.y + Math.pow(t, 2) * this.toPoint.y
        };
      }
    }, {
      key: "_findBorderPosition",
      value: function value(t, e) {
        return this._findBorderPositionBezier(t, e, this.via);
      }
    }, {
      key: "_getDistanceToEdge",
      value: function value(t, e, i, n, o, r) {
        return this._getDistanceToBezierEdge(t, e, i, n, o, r, this.via);
      }
    }]), i;
  }(JD);
  function iI(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var nI = function (t) {
    D_(i, t);
    var e = iI(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "_line",
      value: function value(t, e, i) {
        this._bezierCurve(t, e, i);
      }
    }, {
      key: "getViaNode",
      value: function value() {
        return this._getViaCoordinates();
      }
    }, {
      key: "_getViaCoordinates",
      value: function value() {
        var t,
          e,
          i = this.options.smooth.roundness,
          n = this.options.smooth.type,
          o = Math.abs(this.from.x - this.to.x),
          r = Math.abs(this.from.y - this.to.y);
        if ("discrete" === n || "diagonalCross" === n) {
          var s, a;
          s = a = o <= r ? i * r : i * o, this.from.x > this.to.x && (s = -s), this.from.y >= this.to.y && (a = -a);
          var h = this.from.x + s,
            l = this.from.y + a;
          return "discrete" === n && (o <= r ? h = o < i * r ? this.from.x : h : l = r < i * o ? this.from.y : l), {
            x: h,
            y: l
          };
        }
        if ("straightCross" === n) {
          var d = (1 - i) * o,
            c = (1 - i) * r;
          return o <= r ? (d = 0, this.from.y < this.to.y && (c = -c)) : (this.from.x < this.to.x && (d = -d), c = 0), {
            x: this.to.x + d,
            y: this.to.y + c
          };
        }
        if ("horizontal" === n) {
          var u = (1 - i) * o;
          return this.from.x < this.to.x && (u = -u), {
            x: this.to.x + u,
            y: this.from.y
          };
        }
        if ("vertical" === n) {
          var f = (1 - i) * r;
          return this.from.y < this.to.y && (f = -f), {
            x: this.from.x,
            y: this.to.y + f
          };
        }
        if ("curvedCW" === n) {
          o = this.to.x - this.from.x, r = this.from.y - this.to.y;
          var p = Math.sqrt(o * o + r * r),
            v = Math.PI,
            g = (Math.atan2(r, o) + (.5 * i + .5) * v) % (2 * v);
          return {
            x: this.from.x + (.5 * i + .5) * p * Math.sin(g),
            y: this.from.y + (.5 * i + .5) * p * Math.cos(g)
          };
        }
        if ("curvedCCW" === n) {
          o = this.to.x - this.from.x, r = this.from.y - this.to.y;
          var y = Math.sqrt(o * o + r * r),
            m = Math.PI,
            b = (Math.atan2(r, o) + (.5 * -i + .5) * m) % (2 * m);
          return {
            x: this.from.x + (.5 * i + .5) * y * Math.sin(b),
            y: this.from.y + (.5 * i + .5) * y * Math.cos(b)
          };
        }
        t = e = o <= r ? i * r : i * o, this.from.x > this.to.x && (t = -t), this.from.y >= this.to.y && (e = -e);
        var w = this.from.x + t,
          k = this.from.y + e;
        return o <= r ? w = this.from.x <= this.to.x ? this.to.x < w ? this.to.x : w : this.to.x > w ? this.to.x : w : k = this.from.y >= this.to.y ? this.to.y > k ? this.to.y : k : this.to.y < k ? this.to.y : k, {
          x: w,
          y: k
        };
      }
    }, {
      key: "_findBorderPosition",
      value: function value(t, e) {
        var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return this._findBorderPositionBezier(t, e, i.via);
      }
    }, {
      key: "_getDistanceToEdge",
      value: function value(t, e, i, n, o, r) {
        var s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : this._getViaCoordinates();
        return this._getDistanceToBezierEdge(t, e, i, n, o, r, s);
      }
    }, {
      key: "getPoint",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._getViaCoordinates(),
          i = t;
        return {
          x: Math.pow(1 - i, 2) * this.fromPoint.x + 2 * i * (1 - i) * e.x + Math.pow(i, 2) * this.toPoint.x,
          y: Math.pow(1 - i, 2) * this.fromPoint.y + 2 * i * (1 - i) * e.y + Math.pow(i, 2) * this.toPoint.y
        };
      }
    }]), i;
  }(JD);
  function oI(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var rI = function (t) {
    D_(i, t);
    var e = oI(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "_getDistanceToBezierEdge2",
      value: function value(t, e, i, n, o, r, s, a) {
        for (var h = 1e9, l = t, d = e, c = [0, 0, 0, 0], u = 1; u < 10; u++) {
          var f = .1 * u;
          c[0] = Math.pow(1 - f, 3), c[1] = 3 * f * Math.pow(1 - f, 2), c[2] = 3 * Math.pow(f, 2) * (1 - f), c[3] = Math.pow(f, 3);
          var p = c[0] * t + c[1] * s.x + c[2] * a.x + c[3] * i,
            v = c[0] * e + c[1] * s.y + c[2] * a.y + c[3] * n;
          if (u > 0) {
            var g = this._getDistanceToLine(l, d, p, v, o, r);
            h = g < h ? g : h;
          }
          l = p, d = v;
        }
        return h;
      }
    }]), i;
  }(JD);
  function sI(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var aI = function (t) {
    D_(i, t);
    var e = sI(i);
    function i(t, n, o) {
      return ph(this, i), e.call(this, t, n, o);
    }
    return xu(i, [{
      key: "_line",
      value: function value(t, e, i) {
        var n = i[0],
          o = i[1];
        this._bezierCurve(t, e, n, o);
      }
    }, {
      key: "_getViaCoordinates",
      value: function value() {
        var t,
          e,
          i,
          n,
          o = this.from.x - this.to.x,
          r = this.from.y - this.to.y,
          s = this.options.smooth.roundness;
        return (Math.abs(o) > Math.abs(r) || !0 === this.options.smooth.forceDirection || "horizontal" === this.options.smooth.forceDirection) && "vertical" !== this.options.smooth.forceDirection ? (e = this.from.y, n = this.to.y, t = this.from.x - s * o, i = this.to.x + s * o) : (e = this.from.y - s * r, n = this.to.y + s * r, t = this.from.x, i = this.to.x), [{
          x: t,
          y: e
        }, {
          x: i,
          y: n
        }];
      }
    }, {
      key: "getViaNode",
      value: function value() {
        return this._getViaCoordinates();
      }
    }, {
      key: "_findBorderPosition",
      value: function value(t, e) {
        return this._findBorderPositionBezier(t, e);
      }
    }, {
      key: "_getDistanceToEdge",
      value: function value(t, e, i, n, o, r) {
        var s = pf(arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : this._getViaCoordinates(), 2),
          a = s[0],
          h = s[1];
        return this._getDistanceToBezierEdge2(t, e, i, n, o, r, a, h);
      }
    }, {
      key: "getPoint",
      value: function value(t) {
        var e = pf(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._getViaCoordinates(), 2),
          i = e[0],
          n = e[1],
          o = t,
          r = [Math.pow(1 - o, 3), 3 * o * Math.pow(1 - o, 2), 3 * Math.pow(o, 2) * (1 - o), Math.pow(o, 3)];
        return {
          x: r[0] * this.fromPoint.x + r[1] * i.x + r[2] * n.x + r[3] * this.toPoint.x,
          y: r[0] * this.fromPoint.y + r[1] * i.y + r[2] * n.y + r[3] * this.toPoint.y
        };
      }
    }]), i;
  }(rI);
  function hI(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var lI = function (t) {
      D_(i, t);
      var e = hI(i);
      function i(t, n, o) {
        return ph(this, i), e.call(this, t, n, o);
      }
      return xu(i, [{
        key: "_line",
        value: function value(t, e) {
          t.beginPath(), t.moveTo(this.fromPoint.x, this.fromPoint.y), t.lineTo(this.toPoint.x, this.toPoint.y), this.enableShadow(t, e), t.stroke(), this.disableShadow(t, e);
        }
      }, {
        key: "getViaNode",
        value: function value() {}
      }, {
        key: "getPoint",
        value: function value(t) {
          return {
            x: (1 - t) * this.fromPoint.x + t * this.toPoint.x,
            y: (1 - t) * this.fromPoint.y + t * this.toPoint.y
          };
        }
      }, {
        key: "_findBorderPosition",
        value: function value(t, e) {
          var i = this.to,
            n = this.from;
          t.id === this.from.id && (i = this.from, n = this.to);
          var o = Math.atan2(i.y - n.y, i.x - n.x),
            r = i.x - n.x,
            s = i.y - n.y,
            a = Math.sqrt(r * r + s * s),
            h = (a - t.distanceToBorder(e, o)) / a;
          return {
            x: (1 - h) * n.x + h * i.x,
            y: (1 - h) * n.y + h * i.y,
            t: 0
          };
        }
      }, {
        key: "_getDistanceToEdge",
        value: function value(t, e, i, n, o, r) {
          return this._getDistanceToLine(t, e, i, n, o, r);
        }
      }]), i;
    }(KD),
    dI = function () {
      function t(e, i, n, o, r) {
        if (ph(this, t), void 0 === i) throw new Error("No body provided");
        this.options = zb(o), this.globalOptions = o, this.defaultOptions = r, this.body = i, this.imagelist = n, this.id = void 0, this.fromId = void 0, this.toId = void 0, this.selected = !1, this.hover = !1, this.labelDirty = !0, this.baseWidth = this.options.width, this.baseFontSize = this.options.font.size, this.from = void 0, this.to = void 0, this.edgeType = void 0, this.connected = !1, this.labelModule = new OP(this.body, this.options, !0), this.setOptions(e);
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(e) {
          if (e) {
            var i = void 0 !== e.physics && this.options.physics !== e.physics || void 0 !== e.hidden && (this.options.hidden || !1) !== (e.hidden || !1) || void 0 !== e.from && this.options.from !== e.from || void 0 !== e.to && this.options.to !== e.to;
            t.parseOptions(this.options, e, !0, this.globalOptions), void 0 !== e.id && (this.id = e.id), void 0 !== e.from && (this.fromId = e.from), void 0 !== e.to && (this.toId = e.to), void 0 !== e.title && (this.title = e.title), void 0 !== e.value && (e.value = lP(e.value));
            var n = [e, this.options, this.defaultOptions];
            return this.chooser = gP("edge", n), this.updateLabelModule(e), i = this.updateEdgeType() || i, this._setInteractionWidths(), this.connect(), i;
          }
        }
      }, {
        key: "getFormattingValues",
        value: function value() {
          var t = !0 === this.options.arrows.to || !0 === this.options.arrows.to.enabled,
            e = !0 === this.options.arrows.from || !0 === this.options.arrows.from.enabled,
            i = !0 === this.options.arrows.middle || !0 === this.options.arrows.middle.enabled,
            n = this.options.color.inherit,
            o = {
              toArrow: t,
              toArrowScale: this.options.arrows.to.scaleFactor,
              toArrowType: this.options.arrows.to.type,
              toArrowSrc: this.options.arrows.to.src,
              toArrowImageWidth: this.options.arrows.to.imageWidth,
              toArrowImageHeight: this.options.arrows.to.imageHeight,
              middleArrow: i,
              middleArrowScale: this.options.arrows.middle.scaleFactor,
              middleArrowType: this.options.arrows.middle.type,
              middleArrowSrc: this.options.arrows.middle.src,
              middleArrowImageWidth: this.options.arrows.middle.imageWidth,
              middleArrowImageHeight: this.options.arrows.middle.imageHeight,
              fromArrow: e,
              fromArrowScale: this.options.arrows.from.scaleFactor,
              fromArrowType: this.options.arrows.from.type,
              fromArrowSrc: this.options.arrows.from.src,
              fromArrowImageWidth: this.options.arrows.from.imageWidth,
              fromArrowImageHeight: this.options.arrows.from.imageHeight,
              arrowStrikethrough: this.options.arrowStrikethrough,
              color: n ? void 0 : this.options.color.color,
              inheritsColor: n,
              opacity: this.options.color.opacity,
              hidden: this.options.hidden,
              length: this.options.length,
              shadow: this.options.shadow.enabled,
              shadowColor: this.options.shadow.color,
              shadowSize: this.options.shadow.size,
              shadowX: this.options.shadow.x,
              shadowY: this.options.shadow.y,
              dashes: this.options.dashes,
              width: this.options.width,
              background: this.options.background.enabled,
              backgroundColor: this.options.background.color,
              backgroundSize: this.options.background.size,
              backgroundDashes: this.options.background.dashes
            };
          if (this.selected || this.hover) {
            if (!0 === this.chooser) {
              if (this.selected) {
                var r = this.options.selectionWidth;
                "function" == typeof r ? o.width = r(o.width) : "number" == typeof r && (o.width += r), o.width = Math.max(o.width, .3 / this.body.view.scale), o.color = this.options.color.highlight, o.shadow = this.options.shadow.enabled;
              } else if (this.hover) {
                var s = this.options.hoverWidth;
                "function" == typeof s ? o.width = s(o.width) : "number" == typeof s && (o.width += s), o.width = Math.max(o.width, .3 / this.body.view.scale), o.color = this.options.color.hover, o.shadow = this.options.shadow.enabled;
              }
            } else "function" == typeof this.chooser && (this.chooser(o, this.options.id, this.selected, this.hover), void 0 !== o.color && (o.inheritsColor = !1), !1 === o.shadow && (o.shadowColor === this.options.shadow.color && o.shadowSize === this.options.shadow.size && o.shadowX === this.options.shadow.x && o.shadowY === this.options.shadow.y || (o.shadow = !0)));
          } else o.shadow = this.options.shadow.enabled, o.width = Math.max(o.width, .3 / this.body.view.scale);
          return o;
        }
      }, {
        key: "updateLabelModule",
        value: function value(t) {
          var e = [t, this.options, this.globalOptions, this.defaultOptions];
          this.labelModule.update(this.options, e), void 0 !== this.labelModule.baseSize && (this.baseFontSize = this.labelModule.baseSize);
        }
      }, {
        key: "updateEdgeType",
        value: function value() {
          var t = this.options.smooth,
            e = !1,
            i = !0;
          return void 0 !== this.edgeType && ((this.edgeType instanceof eI && !0 === t.enabled && "dynamic" === t.type || this.edgeType instanceof aI && !0 === t.enabled && "cubicBezier" === t.type || this.edgeType instanceof nI && !0 === t.enabled && "dynamic" !== t.type && "cubicBezier" !== t.type || this.edgeType instanceof lI && !1 === t.type.enabled) && (i = !1), !0 === i && (e = this.cleanup())), !0 === i ? !0 === t.enabled ? "dynamic" === t.type ? (e = !0, this.edgeType = new eI(this.options, this.body, this.labelModule)) : "cubicBezier" === t.type ? this.edgeType = new aI(this.options, this.body, this.labelModule) : this.edgeType = new nI(this.options, this.body, this.labelModule) : this.edgeType = new lI(this.options, this.body, this.labelModule) : this.edgeType.setOptions(this.options), e;
        }
      }, {
        key: "connect",
        value: function value() {
          this.disconnect(), this.from = this.body.nodes[this.fromId] || void 0, this.to = this.body.nodes[this.toId] || void 0, this.connected = void 0 !== this.from && void 0 !== this.to, !0 === this.connected ? (this.from.attachEdge(this), this.to.attachEdge(this)) : (this.from && this.from.detachEdge(this), this.to && this.to.detachEdge(this)), this.edgeType.connect();
        }
      }, {
        key: "disconnect",
        value: function value() {
          this.from && (this.from.detachEdge(this), this.from = void 0), this.to && (this.to.detachEdge(this), this.to = void 0), this.connected = !1;
        }
      }, {
        key: "getTitle",
        value: function value() {
          return this.title;
        }
      }, {
        key: "isSelected",
        value: function value() {
          return this.selected;
        }
      }, {
        key: "getValue",
        value: function value() {
          return this.options.value;
        }
      }, {
        key: "setValueRange",
        value: function value(t, e, i) {
          if (void 0 !== this.options.value) {
            var n = this.options.scaling.customScalingFunction(t, e, i, this.options.value),
              o = this.options.scaling.max - this.options.scaling.min;
            if (!0 === this.options.scaling.label.enabled) {
              var r = this.options.scaling.label.max - this.options.scaling.label.min;
              this.options.font.size = this.options.scaling.label.min + n * r;
            }
            this.options.width = this.options.scaling.min + n * o;
          } else this.options.width = this.baseWidth, this.options.font.size = this.baseFontSize;
          this._setInteractionWidths(), this.updateLabelModule();
        }
      }, {
        key: "_setInteractionWidths",
        value: function value() {
          "function" == typeof this.options.hoverWidth ? this.edgeType.hoverWidth = this.options.hoverWidth(this.options.width) : this.edgeType.hoverWidth = this.options.hoverWidth + this.options.width, "function" == typeof this.options.selectionWidth ? this.edgeType.selectionWidth = this.options.selectionWidth(this.options.width) : this.edgeType.selectionWidth = this.options.selectionWidth + this.options.width;
        }
      }, {
        key: "draw",
        value: function value(t) {
          var e = this.getFormattingValues();
          if (!e.hidden) {
            var i = this.edgeType.getViaNode();
            this.edgeType.drawLine(t, e, this.selected, this.hover, i), this.drawLabel(t, i);
          }
        }
      }, {
        key: "drawArrows",
        value: function value(t) {
          var e = this.getFormattingValues();
          if (!e.hidden) {
            var i = this.edgeType.getViaNode(),
              n = {};
            this.edgeType.fromPoint = this.edgeType.from, this.edgeType.toPoint = this.edgeType.to, e.fromArrow && (n.from = this.edgeType.getArrowData(t, "from", i, this.selected, this.hover, e), !1 === e.arrowStrikethrough && (this.edgeType.fromPoint = n.from.core), e.fromArrowSrc && (n.from.image = this.imagelist.load(e.fromArrowSrc)), e.fromArrowImageWidth && (n.from.imageWidth = e.fromArrowImageWidth), e.fromArrowImageHeight && (n.from.imageHeight = e.fromArrowImageHeight)), e.toArrow && (n.to = this.edgeType.getArrowData(t, "to", i, this.selected, this.hover, e), !1 === e.arrowStrikethrough && (this.edgeType.toPoint = n.to.core), e.toArrowSrc && (n.to.image = this.imagelist.load(e.toArrowSrc)), e.toArrowImageWidth && (n.to.imageWidth = e.toArrowImageWidth), e.toArrowImageHeight && (n.to.imageHeight = e.toArrowImageHeight)), e.middleArrow && (n.middle = this.edgeType.getArrowData(t, "middle", i, this.selected, this.hover, e), e.middleArrowSrc && (n.middle.image = this.imagelist.load(e.middleArrowSrc)), e.middleArrowImageWidth && (n.middle.imageWidth = e.middleArrowImageWidth), e.middleArrowImageHeight && (n.middle.imageHeight = e.middleArrowImageHeight)), e.fromArrow && this.edgeType.drawArrowHead(t, e, this.selected, this.hover, n.from), e.middleArrow && this.edgeType.drawArrowHead(t, e, this.selected, this.hover, n.middle), e.toArrow && this.edgeType.drawArrowHead(t, e, this.selected, this.hover, n.to);
          }
        }
      }, {
        key: "drawLabel",
        value: function value(t, e) {
          if (void 0 !== this.options.label) {
            var i,
              n = this.from,
              o = this.to;
            if (this.labelModule.differentState(this.selected, this.hover) && this.labelModule.getTextSize(t, this.selected, this.hover), n.id != o.id) {
              this.labelModule.pointToSelf = !1, i = this.edgeType.getPoint(.5, e), t.save();
              var r = this._getRotation(t);
              0 != r.angle && (t.translate(r.x, r.y), t.rotate(r.angle)), this.labelModule.draw(t, i.x, i.y, this.selected, this.hover), t.restore();
            } else {
              this.labelModule.pointToSelf = !0;
              var s = bP(t, this.options.selfReference.angle, this.options.selfReference.size, n);
              i = this._pointOnCircle(s.x, s.y, this.options.selfReference.size, this.options.selfReference.angle), this.labelModule.draw(t, i.x, i.y, this.selected, this.hover);
            }
          }
        }
      }, {
        key: "getItemsOnPoint",
        value: function value(t) {
          var e = [];
          if (this.labelModule.visible()) {
            var i = this._getRotation();
            yP(this.labelModule.getSize(), t, i) && e.push({
              edgeId: this.id,
              labelId: 0
            });
          }
          var n = {
            left: t.x,
            top: t.y
          };
          return this.isOverlappingWith(n) && e.push({
            edgeId: this.id
          }), e;
        }
      }, {
        key: "isOverlappingWith",
        value: function value(t) {
          if (this.connected) {
            var e = this.from.x,
              i = this.from.y,
              n = this.to.x,
              o = this.to.y,
              r = t.left,
              s = t.top;
            return this.edgeType.getDistanceToEdge(e, i, n, o, r, s) < 10;
          }
          return !1;
        }
      }, {
        key: "_getRotation",
        value: function value(t) {
          var e = this.edgeType.getViaNode(),
            i = this.edgeType.getPoint(.5, e);
          void 0 !== t && this.labelModule.calculateLabelSize(t, this.selected, this.hover, i.x, i.y);
          var n = {
            x: i.x,
            y: this.labelModule.size.yLine,
            angle: 0
          };
          if (!this.labelModule.visible()) return n;
          if ("horizontal" === this.options.font.align) return n;
          var o = this.from.y - this.to.y,
            r = this.from.x - this.to.x,
            s = Math.atan2(o, r);
          return (s < -1 && r < 0 || s > 0 && r < 0) && (s += Math.PI), n.angle = s, n;
        }
      }, {
        key: "_pointOnCircle",
        value: function value(t, e, i, n) {
          return {
            x: t + i * Math.cos(n),
            y: e - i * Math.sin(n)
          };
        }
      }, {
        key: "select",
        value: function value() {
          this.selected = !0;
        }
      }, {
        key: "unselect",
        value: function value() {
          this.selected = !1;
        }
      }, {
        key: "cleanup",
        value: function value() {
          return this.edgeType.cleanup();
        }
      }, {
        key: "remove",
        value: function value() {
          this.cleanup(), this.disconnect(), delete this.body.edges[this.id];
        }
      }, {
        key: "endPointsValid",
        value: function value() {
          return void 0 !== this.body.nodes[this.fromId] && void 0 !== this.body.nodes[this.toId];
        }
      }], [{
        key: "parseOptions",
        value: function value(t, e) {
          var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
          if (pb(["endPointOffset", "arrowStrikethrough", "id", "from", "hidden", "hoverWidth", "labelHighlightBold", "length", "line", "opacity", "physics", "scaling", "selectionWidth", "selfReferenceSize", "selfReference", "to", "title", "value", "width", "font", "chosen", "widthConstraint"], t, e, i), void 0 !== e.endPointOffset && void 0 !== e.endPointOffset.from && (g_(e.endPointOffset.from) ? t.endPointOffset.from = e.endPointOffset.from : (t.endPointOffset.from = void 0 !== n.endPointOffset.from ? n.endPointOffset.from : 0, console.error("endPointOffset.from is not a valid number"))), void 0 !== e.endPointOffset && void 0 !== e.endPointOffset.to && (g_(e.endPointOffset.to) ? t.endPointOffset.to = e.endPointOffset.to : (t.endPointOffset.to = void 0 !== n.endPointOffset.to ? n.endPointOffset.to : 0, console.error("endPointOffset.to is not a valid number"))), mP(e.label) ? t.label = e.label : mP(t.label) || (t.label = void 0), Ab(t, e, "smooth", n), Ab(t, e, "shadow", n), Ab(t, e, "background", n), void 0 !== e.dashes && null !== e.dashes ? t.dashes = e.dashes : !0 === i && null === e.dashes && (t.dashes = pg(n.dashes)), void 0 !== e.scaling && null !== e.scaling ? (void 0 !== e.scaling.min && (t.scaling.min = e.scaling.min), void 0 !== e.scaling.max && (t.scaling.max = e.scaling.max), Ab(t.scaling, e.scaling, "label", n.scaling)) : !0 === i && null === e.scaling && (t.scaling = pg(n.scaling)), void 0 !== e.arrows && null !== e.arrows) {
            if ("string" == typeof e.arrows) {
              var r = e.arrows.toLowerCase();
              t.arrows.to.enabled = -1 != lg(r).call(r, "to"), t.arrows.middle.enabled = -1 != lg(r).call(r, "middle"), t.arrows.from.enabled = -1 != lg(r).call(r, "from");
            } else {
              if ("object" !== bu(e.arrows)) throw new Error("The arrow newOptions can only be an object or a string. Refer to the documentation. You used:" + mg(e.arrows));
              Ab(t.arrows, e.arrows, "to", n.arrows), Ab(t.arrows, e.arrows, "middle", n.arrows), Ab(t.arrows, e.arrows, "from", n.arrows);
            }
          } else !0 === i && null === e.arrows && (t.arrows = pg(n.arrows));
          if (void 0 !== e.color && null !== e.color) {
            var s = lb(e.color) ? {
                color: e.color,
                highlight: e.color,
                hover: e.color,
                inherit: !1,
                opacity: 1
              } : e.color,
              a = t.color;
            if (o) gb(a, n.color, !1, i);else for (var h in a) Object.prototype.hasOwnProperty.call(a, h) && delete a[h];
            if (lb(a)) a.color = a, a.highlight = a, a.hover = a, a.inherit = !1, void 0 === s.opacity && (a.opacity = 1);else {
              var l = !1;
              void 0 !== s.color && (a.color = s.color, l = !0), void 0 !== s.highlight && (a.highlight = s.highlight, l = !0), void 0 !== s.hover && (a.hover = s.hover, l = !0), void 0 !== s.inherit && (a.inherit = s.inherit), void 0 !== s.opacity && (a.opacity = Math.min(1, Math.max(0, s.opacity))), !0 === l ? a.inherit = !1 : void 0 === a.inherit && (a.inherit = "from");
            }
          } else !0 === i && null === e.color && (t.color = zb(n.color));
          !0 === i && null === e.font && (t.font = zb(n.font)), Object.prototype.hasOwnProperty.call(e, "selfReferenceSize") && (console.warn("The selfReferenceSize property has been deprecated. Please use selfReference property instead. The selfReference can be set like thise selfReference:{size:30, angle:Math.PI / 4}"), t.selfReference.size = e.selfReferenceSize);
        }
      }]), t;
    }(),
    cI = function () {
      function t(e, i, n) {
        var o,
          r = this;
        ph(this, t), this.body = e, this.images = i, this.groups = n, this.body.functions.createEdge = Hn(o = this.create).call(o, this), this.edgesListeners = {
          add: function add(t, e) {
            r.add(e.items);
          },
          update: function update(t, e) {
            r.update(e.items);
          },
          remove: function remove(t, e) {
            r.remove(e.items);
          }
        }, this.options = {}, this.defaultOptions = {
          arrows: {
            to: {
              enabled: !1,
              scaleFactor: 1,
              type: "arrow"
            },
            middle: {
              enabled: !1,
              scaleFactor: 1,
              type: "arrow"
            },
            from: {
              enabled: !1,
              scaleFactor: 1,
              type: "arrow"
            }
          },
          endPointOffset: {
            from: 0,
            to: 0
          },
          arrowStrikethrough: !0,
          color: {
            color: "#848484",
            highlight: "#848484",
            hover: "#848484",
            inherit: "from",
            opacity: 1
          },
          dashes: !1,
          font: {
            color: "#343434",
            size: 14,
            face: "arial",
            background: "none",
            strokeWidth: 2,
            strokeColor: "#ffffff",
            align: "horizontal",
            multi: !1,
            vadjust: 0,
            bold: {
              mod: "bold"
            },
            boldital: {
              mod: "bold italic"
            },
            ital: {
              mod: "italic"
            },
            mono: {
              mod: "",
              size: 15,
              face: "courier new",
              vadjust: 2
            }
          },
          hidden: !1,
          hoverWidth: 1.5,
          label: void 0,
          labelHighlightBold: !0,
          length: void 0,
          physics: !0,
          scaling: {
            min: 1,
            max: 15,
            label: {
              enabled: !0,
              min: 14,
              max: 30,
              maxVisible: 30,
              drawThreshold: 5
            },
            customScalingFunction: function customScalingFunction(t, e, i, n) {
              if (e === t) return .5;
              var o = 1 / (e - t);
              return Math.max(0, (n - t) * o);
            }
          },
          selectionWidth: 1.5,
          selfReference: {
            size: 20,
            angle: Math.PI / 4,
            renderBehindTheNode: !0
          },
          shadow: {
            enabled: !1,
            color: "rgba(0,0,0,0.5)",
            size: 10,
            x: 5,
            y: 5
          },
          background: {
            enabled: !1,
            color: "rgba(111,111,111,1)",
            size: 10,
            dashes: !1
          },
          smooth: {
            enabled: !0,
            type: "dynamic",
            forceDirection: "none",
            roundness: .5
          },
          title: void 0,
          width: 1,
          value: void 0
        }, gb(this.options, this.defaultOptions), this.bindEventListeners();
      }
      return xu(t, [{
        key: "bindEventListeners",
        value: function value() {
          var t,
            e,
            i = this;
          this.body.emitter.on("_forceDisableDynamicCurves", function (t) {
            var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            "dynamic" === t && (t = "continuous");
            var n = !1;
            for (var o in i.body.edges) if (Object.prototype.hasOwnProperty.call(i.body.edges, o)) {
              var r = i.body.edges[o],
                s = i.body.data.edges.get(o);
              if (null != s) {
                var a = s.smooth;
                void 0 !== a && !0 === a.enabled && "dynamic" === a.type && (void 0 === t ? r.setOptions({
                  smooth: !1
                }) : r.setOptions({
                  smooth: {
                    type: t
                  }
                }), n = !0);
              }
            }
            !0 === e && !0 === n && i.body.emitter.emit("_dataChanged");
          }), this.body.emitter.on("_dataUpdated", function () {
            i.reconnectEdges();
          }), this.body.emitter.on("refreshEdges", Hn(t = this.refresh).call(t, this)), this.body.emitter.on("refresh", Hn(e = this.refresh).call(e, this)), this.body.emitter.on("destroy", function () {
            kb(i.edgesListeners, function (t, e) {
              i.body.data.edges && i.body.data.edges.off(e, t);
            }), delete i.body.functions.createEdge, delete i.edgesListeners.add, delete i.edgesListeners.update, delete i.edgesListeners.remove, delete i.edgesListeners;
          });
        }
      }, {
        key: "setOptions",
        value: function value(t) {
          if (void 0 !== t) {
            dI.parseOptions(this.options, t, !0, this.defaultOptions, !0);
            var e = !1;
            if (void 0 !== t.smooth) for (var i in this.body.edges) Object.prototype.hasOwnProperty.call(this.body.edges, i) && (e = this.body.edges[i].updateEdgeType() || e);
            if (void 0 !== t.font) for (var n in this.body.edges) Object.prototype.hasOwnProperty.call(this.body.edges, n) && this.body.edges[n].updateLabelModule();
            void 0 === t.hidden && void 0 === t.physics && !0 !== e || this.body.emitter.emit("_dataChanged");
          }
        }
      }, {
        key: "setData",
        value: function value(t) {
          var e = this,
            i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = this.body.data.edges;
          if (ZM("id", t)) this.body.data.edges = t;else if (Df(t)) this.body.data.edges = new GM(), this.body.data.edges.add(t);else {
            if (t) throw new TypeError("Array or DataSet expected");
            this.body.data.edges = new GM();
          }
          if (n && kb(this.edgesListeners, function (t, e) {
            n.off(e, t);
          }), this.body.edges = {}, this.body.data.edges) {
            kb(this.edgesListeners, function (t, i) {
              e.body.data.edges.on(i, t);
            });
            var o = this.body.data.edges.getIds();
            this.add(o, !0);
          }
          this.body.emitter.emit("_adjustEdgesForHierarchicalLayout"), !1 === i && this.body.emitter.emit("_dataChanged");
        }
      }, {
        key: "add",
        value: function value(t) {
          for (var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], i = this.body.edges, n = this.body.data.edges, o = 0; o < t.length; o++) {
            var r = t[o],
              s = i[r];
            s && s.disconnect();
            var a = n.get(r, {
              showInternalIds: !0
            });
            i[r] = this.create(a);
          }
          this.body.emitter.emit("_adjustEdgesForHierarchicalLayout"), !1 === e && this.body.emitter.emit("_dataChanged");
        }
      }, {
        key: "update",
        value: function value(t) {
          for (var e = this.body.edges, i = this.body.data.edges, n = !1, o = 0; o < t.length; o++) {
            var r = t[o],
              s = i.get(r),
              a = e[r];
            void 0 !== a ? (a.disconnect(), n = a.setOptions(s) || n, a.connect()) : (this.body.edges[r] = this.create(s), n = !0);
          }
          !0 === n ? (this.body.emitter.emit("_adjustEdgesForHierarchicalLayout"), this.body.emitter.emit("_dataChanged")) : this.body.emitter.emit("_dataUpdated");
        }
      }, {
        key: "remove",
        value: function value(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          if (0 !== t.length) {
            var i = this.body.edges;
            kb(t, function (t) {
              var e = i[t];
              void 0 !== e && e.remove();
            }), e && this.body.emitter.emit("_dataChanged");
          }
        }
      }, {
        key: "refresh",
        value: function value() {
          var t = this;
          kb(this.body.edges, function (e, i) {
            var n = t.body.data.edges.get(i);
            void 0 !== n && e.setOptions(n);
          });
        }
      }, {
        key: "create",
        value: function value(t) {
          return new dI(t, this.body, this.images, this.options, this.defaultOptions);
        }
      }, {
        key: "reconnectEdges",
        value: function value() {
          var t,
            e = this.body.nodes,
            i = this.body.edges;
          for (t in e) Object.prototype.hasOwnProperty.call(e, t) && (e[t].edges = []);
          for (t in i) if (Object.prototype.hasOwnProperty.call(i, t)) {
            var n = i[t];
            n.from = null, n.to = null, n.connect();
          }
        }
      }, {
        key: "getConnectedNodes",
        value: function value(t) {
          var e = [];
          if (void 0 !== this.body.edges[t]) {
            var i = this.body.edges[t];
            void 0 !== i.fromId && e.push(i.fromId), void 0 !== i.toId && e.push(i.toId);
          }
          return e;
        }
      }, {
        key: "_updateState",
        value: function value() {
          this._addMissingEdges(), this._removeInvalidEdges();
        }
      }, {
        key: "_removeInvalidEdges",
        value: function value() {
          var t = this,
            e = [];
          kb(this.body.edges, function (i, n) {
            var o = t.body.nodes[i.toId],
              r = t.body.nodes[i.fromId];
            void 0 !== o && !0 === o.isCluster || void 0 !== r && !0 === r.isCluster || void 0 !== o && void 0 !== r || e.push(n);
          }), this.remove(e, !1);
        }
      }, {
        key: "_addMissingEdges",
        value: function value() {
          var t = this.body.data.edges;
          if (null != t) {
            var e = this.body.edges,
              i = [];
            op(t).call(t, function (t, n) {
              void 0 === e[n] && i.push(n);
            }), this.add(i, !0);
          }
        }
      }]), t;
    }(),
    uI = function () {
      function t(e, i, n) {
        ph(this, t), this.body = e, this.physicsBody = i, this.barnesHutTree, this.setOptions(n), this._rng = Jm("BARNES HUT SOLVER");
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          this.options = t, this.thetaInversed = 1 / this.options.theta, this.overlapAvoidanceFactor = 1 - Math.max(0, Math.min(1, this.options.avoidOverlap));
        }
      }, {
        key: "solve",
        value: function value() {
          if (0 !== this.options.gravitationalConstant && this.physicsBody.physicsNodeIndices.length > 0) {
            var t,
              e = this.body.nodes,
              i = this.physicsBody.physicsNodeIndices,
              n = i.length,
              o = this._formBarnesHutTree(e, i);
            this.barnesHutTree = o;
            for (var r = 0; r < n; r++) (t = e[i[r]]).options.mass > 0 && this._getForceContributions(o.root, t);
          }
        }
      }, {
        key: "_getForceContributions",
        value: function value(t, e) {
          this._getForceContribution(t.children.NW, e), this._getForceContribution(t.children.NE, e), this._getForceContribution(t.children.SW, e), this._getForceContribution(t.children.SE, e);
        }
      }, {
        key: "_getForceContribution",
        value: function value(t, e) {
          if (t.childrenCount > 0) {
            var i = t.centerOfMass.x - e.x,
              n = t.centerOfMass.y - e.y,
              o = Math.sqrt(i * i + n * n);
            o * t.calcSize > this.thetaInversed ? this._calculateForces(o, i, n, e, t) : 4 === t.childrenCount ? this._getForceContributions(t, e) : t.children.data.id != e.id && this._calculateForces(o, i, n, e, t);
          }
        }
      }, {
        key: "_calculateForces",
        value: function value(t, e, i, n, o) {
          0 === t && (e = t = .1), this.overlapAvoidanceFactor < 1 && n.shape.radius && (t = Math.max(.1 + this.overlapAvoidanceFactor * n.shape.radius, t - n.shape.radius));
          var r = this.options.gravitationalConstant * o.mass * n.options.mass / Math.pow(t, 3),
            s = e * r,
            a = i * r;
          this.physicsBody.forces[n.id].x += s, this.physicsBody.forces[n.id].y += a;
        }
      }, {
        key: "_formBarnesHutTree",
        value: function value(t, e) {
          for (var i, n = e.length, o = t[e[0]].x, r = t[e[0]].y, s = t[e[0]].x, a = t[e[0]].y, h = 1; h < n; h++) {
            var l = t[e[h]],
              d = l.x,
              c = l.y;
            l.options.mass > 0 && (d < o && (o = d), d > s && (s = d), c < r && (r = c), c > a && (a = c));
          }
          var u = Math.abs(s - o) - Math.abs(a - r);
          u > 0 ? (r -= .5 * u, a += .5 * u) : (o += .5 * u, s -= .5 * u);
          var f = Math.max(1e-5, Math.abs(s - o)),
            p = .5 * f,
            v = .5 * (o + s),
            g = .5 * (r + a),
            y = {
              root: {
                centerOfMass: {
                  x: 0,
                  y: 0
                },
                mass: 0,
                range: {
                  minX: v - p,
                  maxX: v + p,
                  minY: g - p,
                  maxY: g + p
                },
                size: f,
                calcSize: 1 / f,
                children: {
                  data: null
                },
                maxWidth: 0,
                level: 0,
                childrenCount: 4
              }
            };
          this._splitBranch(y.root);
          for (var m = 0; m < n; m++) (i = t[e[m]]).options.mass > 0 && this._placeInTree(y.root, i);
          return y;
        }
      }, {
        key: "_updateBranchMass",
        value: function value(t, e) {
          var i = t.centerOfMass,
            n = t.mass + e.options.mass,
            o = 1 / n;
          i.x = i.x * t.mass + e.x * e.options.mass, i.x *= o, i.y = i.y * t.mass + e.y * e.options.mass, i.y *= o, t.mass = n;
          var r = Math.max(Math.max(e.height, e.radius), e.width);
          t.maxWidth = t.maxWidth < r ? r : t.maxWidth;
        }
      }, {
        key: "_placeInTree",
        value: function value(t, e, i) {
          1 == i && void 0 !== i || this._updateBranchMass(t, e);
          var n,
            o = t.children.NW.range;
          n = o.maxX > e.x ? o.maxY > e.y ? "NW" : "SW" : o.maxY > e.y ? "NE" : "SE", this._placeInRegion(t, e, n);
        }
      }, {
        key: "_placeInRegion",
        value: function value(t, e, i) {
          var n = t.children[i];
          switch (n.childrenCount) {
            case 0:
              n.children.data = e, n.childrenCount = 1, this._updateBranchMass(n, e);
              break;
            case 1:
              n.children.data.x === e.x && n.children.data.y === e.y ? (e.x += this._rng(), e.y += this._rng()) : (this._splitBranch(n), this._placeInTree(n, e));
              break;
            case 4:
              this._placeInTree(n, e);
          }
        }
      }, {
        key: "_splitBranch",
        value: function value(t) {
          var e = null;
          1 === t.childrenCount && (e = t.children.data, t.mass = 0, t.centerOfMass.x = 0, t.centerOfMass.y = 0), t.childrenCount = 4, t.children.data = null, this._insertRegion(t, "NW"), this._insertRegion(t, "NE"), this._insertRegion(t, "SW"), this._insertRegion(t, "SE"), null != e && this._placeInTree(t, e);
        }
      }, {
        key: "_insertRegion",
        value: function value(t, e) {
          var i,
            n,
            o,
            r,
            s = .5 * t.size;
          switch (e) {
            case "NW":
              i = t.range.minX, n = t.range.minX + s, o = t.range.minY, r = t.range.minY + s;
              break;
            case "NE":
              i = t.range.minX + s, n = t.range.maxX, o = t.range.minY, r = t.range.minY + s;
              break;
            case "SW":
              i = t.range.minX, n = t.range.minX + s, o = t.range.minY + s, r = t.range.maxY;
              break;
            case "SE":
              i = t.range.minX + s, n = t.range.maxX, o = t.range.minY + s, r = t.range.maxY;
          }
          t.children[e] = {
            centerOfMass: {
              x: 0,
              y: 0
            },
            mass: 0,
            range: {
              minX: i,
              maxX: n,
              minY: o,
              maxY: r
            },
            size: .5 * t.size,
            calcSize: 2 * t.calcSize,
            children: {
              data: null
            },
            maxWidth: 0,
            level: t.level + 1,
            childrenCount: 0
          };
        }
      }, {
        key: "_debug",
        value: function value(t, e) {
          void 0 !== this.barnesHutTree && (t.lineWidth = 1, this._drawBranch(this.barnesHutTree.root, t, e));
        }
      }, {
        key: "_drawBranch",
        value: function value(t, e, i) {
          void 0 === i && (i = "#FF0000"), 4 === t.childrenCount && (this._drawBranch(t.children.NW, e), this._drawBranch(t.children.NE, e), this._drawBranch(t.children.SE, e), this._drawBranch(t.children.SW, e)), e.strokeStyle = i, e.beginPath(), e.moveTo(t.range.minX, t.range.minY), e.lineTo(t.range.maxX, t.range.minY), e.stroke(), e.beginPath(), e.moveTo(t.range.maxX, t.range.minY), e.lineTo(t.range.maxX, t.range.maxY), e.stroke(), e.beginPath(), e.moveTo(t.range.maxX, t.range.maxY), e.lineTo(t.range.minX, t.range.maxY), e.stroke(), e.beginPath(), e.moveTo(t.range.minX, t.range.maxY), e.lineTo(t.range.minX, t.range.minY), e.stroke();
        }
      }]), t;
    }(),
    fI = function () {
      function t(e, i, n) {
        ph(this, t), this._rng = Jm("REPULSION SOLVER"), this.body = e, this.physicsBody = i, this.setOptions(n);
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          this.options = t;
        }
      }, {
        key: "solve",
        value: function value() {
          for (var t, e, i, n, o, r, s, a, h = this.body.nodes, l = this.physicsBody.physicsNodeIndices, d = this.physicsBody.forces, c = this.options.nodeDistance, u = -2 / 3 / c, f = 0; f < l.length - 1; f++) {
            s = h[l[f]];
            for (var p = f + 1; p < l.length; p++) t = (a = h[l[p]]).x - s.x, e = a.y - s.y, 0 === (i = Math.sqrt(t * t + e * e)) && (t = i = .1 * this._rng()), i < 2 * c && (r = i < .5 * c ? 1 : u * i + 1.3333333333333333, n = t * (r /= i), o = e * r, d[s.id].x -= n, d[s.id].y -= o, d[a.id].x += n, d[a.id].y += o);
          }
        }
      }]), t;
    }(),
    pI = function () {
      function t(e, i, n) {
        ph(this, t), this.body = e, this.physicsBody = i, this.setOptions(n);
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          this.options = t, this.overlapAvoidanceFactor = Math.max(0, Math.min(1, this.options.avoidOverlap || 0));
        }
      }, {
        key: "solve",
        value: function value() {
          for (var t = this.body.nodes, e = this.physicsBody.physicsNodeIndices, i = this.physicsBody.forces, n = this.options.nodeDistance, o = 0; o < e.length - 1; o++) for (var r = t[e[o]], s = o + 1; s < e.length; s++) {
            var a = t[e[s]];
            if (r.level === a.level) {
              var h = n + this.overlapAvoidanceFactor * ((r.shape.radius || 0) / 2 + (a.shape.radius || 0) / 2),
                l = a.x - r.x,
                d = a.y - r.y,
                c = Math.sqrt(l * l + d * d),
                u = void 0;
              u = c < h ? -Math.pow(.05 * c, 2) + Math.pow(.05 * h, 2) : 0, 0 !== c && (u /= c);
              var f = l * u,
                p = d * u;
              i[r.id].x -= f, i[r.id].y -= p, i[a.id].x += f, i[a.id].y += p;
            }
          }
        }
      }]), t;
    }(),
    vI = function () {
      function t(e, i, n) {
        ph(this, t), this.body = e, this.physicsBody = i, this.setOptions(n);
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          this.options = t;
        }
      }, {
        key: "solve",
        value: function value() {
          for (var t, e, i, n, o, r = this.physicsBody.physicsEdgeIndices, s = this.body.edges, a = 0; a < r.length; a++) !0 === (e = s[r[a]]).connected && e.toId !== e.fromId && void 0 !== this.body.nodes[e.toId] && void 0 !== this.body.nodes[e.fromId] && (void 0 !== e.edgeType.via ? (t = void 0 === e.options.length ? this.options.springLength : e.options.length, i = e.to, n = e.edgeType.via, o = e.from, this._calculateSpringForce(i, n, .5 * t), this._calculateSpringForce(n, o, .5 * t)) : (t = void 0 === e.options.length ? 1.5 * this.options.springLength : e.options.length, this._calculateSpringForce(e.from, e.to, t)));
        }
      }, {
        key: "_calculateSpringForce",
        value: function value(t, e, i) {
          var n = t.x - e.x,
            o = t.y - e.y,
            r = Math.max(Math.sqrt(n * n + o * o), .01),
            s = this.options.springConstant * (i - r) / r,
            a = n * s,
            h = o * s;
          void 0 !== this.physicsBody.forces[t.id] && (this.physicsBody.forces[t.id].x += a, this.physicsBody.forces[t.id].y += h), void 0 !== this.physicsBody.forces[e.id] && (this.physicsBody.forces[e.id].x -= a, this.physicsBody.forces[e.id].y -= h);
        }
      }]), t;
    }(),
    gI = function () {
      function t(e, i, n) {
        ph(this, t), this.body = e, this.physicsBody = i, this.setOptions(n);
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          this.options = t;
        }
      }, {
        key: "solve",
        value: function value() {
          for (var t, e, i, n, o, r, s, a, h, l, d = this.body.edges, c = .5, u = this.physicsBody.physicsEdgeIndices, f = this.physicsBody.physicsNodeIndices, p = this.physicsBody.forces, v = 0; v < f.length; v++) {
            var g = f[v];
            p[g].springFx = 0, p[g].springFy = 0;
          }
          for (var y = 0; y < u.length; y++) !0 === (e = d[u[y]]).connected && (t = void 0 === e.options.length ? this.options.springLength : e.options.length, i = e.from.x - e.to.x, n = e.from.y - e.to.y, a = 0 === (a = Math.sqrt(i * i + n * n)) ? .01 : a, o = i * (s = this.options.springConstant * (t - a) / a), r = n * s, e.to.level != e.from.level ? (void 0 !== p[e.toId] && (p[e.toId].springFx -= o, p[e.toId].springFy -= r), void 0 !== p[e.fromId] && (p[e.fromId].springFx += o, p[e.fromId].springFy += r)) : (void 0 !== p[e.toId] && (p[e.toId].x -= c * o, p[e.toId].y -= c * r), void 0 !== p[e.fromId] && (p[e.fromId].x += c * o, p[e.fromId].y += c * r)));
          s = 1;
          for (var m = 0; m < f.length; m++) {
            var b = f[m];
            h = Math.min(s, Math.max(-s, p[b].springFx)), l = Math.min(s, Math.max(-s, p[b].springFy)), p[b].x += h, p[b].y += l;
          }
          for (var w = 0, k = 0, _ = 0; _ < f.length; _++) {
            var x = f[_];
            w += p[x].x, k += p[x].y;
          }
          for (var E = w / f.length, O = k / f.length, C = 0; C < f.length; C++) {
            var S = f[C];
            p[S].x -= E, p[S].y -= O;
          }
        }
      }]), t;
    }(),
    yI = function () {
      function t(e, i, n) {
        ph(this, t), this.body = e, this.physicsBody = i, this.setOptions(n);
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          this.options = t;
        }
      }, {
        key: "solve",
        value: function value() {
          for (var t, e, i, n, o = this.body.nodes, r = this.physicsBody.physicsNodeIndices, s = this.physicsBody.forces, a = 0; a < r.length; a++) {
            t = -(n = o[r[a]]).x, e = -n.y, i = Math.sqrt(t * t + e * e), this._calculateForces(i, t, e, s, n);
          }
        }
      }, {
        key: "_calculateForces",
        value: function value(t, e, i, n, o) {
          var r = 0 === t ? 0 : this.options.centralGravity / t;
          n[o.id].x = e * r, n[o.id].y = i * r;
        }
      }]), t;
    }();
  function mI(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var bI = function (t) {
    D_(i, t);
    var e = mI(i);
    function i(t, n, o) {
      var r;
      return ph(this, i), (r = e.call(this, t, n, o))._rng = Jm("FORCE ATLAS 2 BASED REPULSION SOLVER"), r;
    }
    return xu(i, [{
      key: "_calculateForces",
      value: function value(t, e, i, n, o) {
        0 === t && (e = t = .1 * this._rng()), this.overlapAvoidanceFactor < 1 && n.shape.radius && (t = Math.max(.1 + this.overlapAvoidanceFactor * n.shape.radius, t - n.shape.radius));
        var r = n.edges.length + 1,
          s = this.options.gravitationalConstant * o.mass * n.options.mass * r / Math.pow(t, 2),
          a = e * s,
          h = i * s;
        this.physicsBody.forces[n.id].x += a, this.physicsBody.forces[n.id].y += h;
      }
    }]), i;
  }(uI);
  function wI(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var kI = function (t) {
      D_(i, t);
      var e = wI(i);
      function i(t, n, o) {
        return ph(this, i), e.call(this, t, n, o);
      }
      return xu(i, [{
        key: "_calculateForces",
        value: function value(t, e, i, n, o) {
          if (t > 0) {
            var r = o.edges.length + 1,
              s = this.options.centralGravity * r * o.options.mass;
            n[o.id].x = e * s, n[o.id].y = i * s;
          }
        }
      }]), i;
    }(yI),
    _I = function () {
      function t(e) {
        ph(this, t), this.body = e, this.physicsBody = {
          physicsNodeIndices: [],
          physicsEdgeIndices: [],
          forces: {},
          velocities: {}
        }, this.physicsEnabled = !0, this.simulationInterval = 1e3 / 60, this.requiresTimeout = !0, this.previousStates = {}, this.referenceState = {}, this.freezeCache = {}, this.renderTimer = void 0, this.adaptiveTimestep = !1, this.adaptiveTimestepEnabled = !1, this.adaptiveCounter = 0, this.adaptiveInterval = 3, this.stabilized = !1, this.startedStabilization = !1, this.stabilizationIterations = 0, this.ready = !1, this.options = {}, this.defaultOptions = {
          enabled: !0,
          barnesHut: {
            theta: .5,
            gravitationalConstant: -2e3,
            centralGravity: .3,
            springLength: 95,
            springConstant: .04,
            damping: .09,
            avoidOverlap: 0
          },
          forceAtlas2Based: {
            theta: .5,
            gravitationalConstant: -50,
            centralGravity: .01,
            springConstant: .08,
            springLength: 100,
            damping: .4,
            avoidOverlap: 0
          },
          repulsion: {
            centralGravity: .2,
            springLength: 200,
            springConstant: .05,
            nodeDistance: 100,
            damping: .09,
            avoidOverlap: 0
          },
          hierarchicalRepulsion: {
            centralGravity: 0,
            springLength: 100,
            springConstant: .01,
            nodeDistance: 120,
            damping: .09
          },
          maxVelocity: 50,
          minVelocity: .75,
          solver: "barnesHut",
          stabilization: {
            enabled: !0,
            iterations: 1e3,
            updateInterval: 50,
            onlyDynamicEdges: !1,
            fit: !0
          },
          timestep: .5,
          adaptiveTimestep: !0,
          wind: {
            x: 0,
            y: 0
          }
        }, bn(this.options, this.defaultOptions), this.timestep = .5, this.layoutFailed = !1, this.bindEventListeners();
      }
      return xu(t, [{
        key: "bindEventListeners",
        value: function value() {
          var t = this;
          this.body.emitter.on("initPhysics", function () {
            t.initPhysics();
          }), this.body.emitter.on("_layoutFailed", function () {
            t.layoutFailed = !0;
          }), this.body.emitter.on("resetPhysics", function () {
            t.stopSimulation(), t.ready = !1;
          }), this.body.emitter.on("disablePhysics", function () {
            t.physicsEnabled = !1, t.stopSimulation();
          }), this.body.emitter.on("restorePhysics", function () {
            t.setOptions(t.options), !0 === t.ready && t.startSimulation();
          }), this.body.emitter.on("startSimulation", function () {
            !0 === t.ready && t.startSimulation();
          }), this.body.emitter.on("stopSimulation", function () {
            t.stopSimulation();
          }), this.body.emitter.on("destroy", function () {
            t.stopSimulation(!1), t.body.emitter.off();
          }), this.body.emitter.on("_dataChanged", function () {
            t.updatePhysicsData();
          });
        }
      }, {
        key: "setOptions",
        value: function value(t) {
          if (void 0 !== t) if (!1 === t) this.options.enabled = !1, this.physicsEnabled = !1, this.stopSimulation();else if (!0 === t) this.options.enabled = !0, this.physicsEnabled = !0, this.startSimulation();else {
            this.physicsEnabled = !0, vb(["stabilization"], this.options, t), Ab(this.options, t, "stabilization"), void 0 === t.enabled && (this.options.enabled = !0), !1 === this.options.enabled && (this.physicsEnabled = !1, this.stopSimulation());
            var e = this.options.wind;
            e && (("number" != typeof e.x || f_(e.x)) && (e.x = 0), ("number" != typeof e.y || f_(e.y)) && (e.y = 0)), this.timestep = this.options.timestep;
          }
          this.init();
        }
      }, {
        key: "init",
        value: function value() {
          var t;
          "forceAtlas2Based" === this.options.solver ? (t = this.options.forceAtlas2Based, this.nodesSolver = new bI(this.body, this.physicsBody, t), this.edgesSolver = new vI(this.body, this.physicsBody, t), this.gravitySolver = new kI(this.body, this.physicsBody, t)) : "repulsion" === this.options.solver ? (t = this.options.repulsion, this.nodesSolver = new fI(this.body, this.physicsBody, t), this.edgesSolver = new vI(this.body, this.physicsBody, t), this.gravitySolver = new yI(this.body, this.physicsBody, t)) : "hierarchicalRepulsion" === this.options.solver ? (t = this.options.hierarchicalRepulsion, this.nodesSolver = new pI(this.body, this.physicsBody, t), this.edgesSolver = new gI(this.body, this.physicsBody, t), this.gravitySolver = new yI(this.body, this.physicsBody, t)) : (t = this.options.barnesHut, this.nodesSolver = new uI(this.body, this.physicsBody, t), this.edgesSolver = new vI(this.body, this.physicsBody, t), this.gravitySolver = new yI(this.body, this.physicsBody, t)), this.modelOptions = t;
        }
      }, {
        key: "initPhysics",
        value: function value() {
          !0 === this.physicsEnabled && !0 === this.options.enabled ? !0 === this.options.stabilization.enabled ? this.stabilize() : (this.stabilized = !1, this.ready = !0, this.body.emitter.emit("fit", {}, this.layoutFailed), this.startSimulation()) : (this.ready = !0, this.body.emitter.emit("fit"));
        }
      }, {
        key: "startSimulation",
        value: function value() {
          var t;
          !0 === this.physicsEnabled && !0 === this.options.enabled ? (this.stabilized = !1, this.adaptiveTimestep = !1, this.body.emitter.emit("_resizeNodes"), void 0 === this.viewFunction && (this.viewFunction = Hn(t = this.simulationStep).call(t, this), this.body.emitter.on("initRedraw", this.viewFunction), this.body.emitter.emit("_startRendering"))) : this.body.emitter.emit("_redraw");
        }
      }, {
        key: "stopSimulation",
        value: function value() {
          var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          this.stabilized = !0, !0 === t && this._emitStabilized(), void 0 !== this.viewFunction && (this.body.emitter.off("initRedraw", this.viewFunction), this.viewFunction = void 0, !0 === t && this.body.emitter.emit("_stopRendering"));
        }
      }, {
        key: "simulationStep",
        value: function value() {
          var t = Uf();
          this.physicsTick(), (Uf() - t < .4 * this.simulationInterval || !0 === this.runDoubleSpeed) && !1 === this.stabilized && (this.physicsTick(), this.runDoubleSpeed = !0), !0 === this.stabilized && this.stopSimulation();
        }
      }, {
        key: "_emitStabilized",
        value: function value() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.stabilizationIterations;
          (this.stabilizationIterations > 1 || !0 === this.startedStabilization) && jg(function () {
            t.body.emitter.emit("stabilized", {
              iterations: e
            }), t.startedStabilization = !1, t.stabilizationIterations = 0;
          }, 0);
        }
      }, {
        key: "physicsStep",
        value: function value() {
          this.gravitySolver.solve(), this.nodesSolver.solve(), this.edgesSolver.solve(), this.moveNodes();
        }
      }, {
        key: "adjustTimeStep",
        value: function value() {
          !0 === this._evaluateStepQuality() ? this.timestep = 1.2 * this.timestep : this.timestep / 1.2 < this.options.timestep ? this.timestep = this.options.timestep : (this.adaptiveCounter = -1, this.timestep = Math.max(this.options.timestep, this.timestep / 1.2));
        }
      }, {
        key: "physicsTick",
        value: function value() {
          if (this._startStabilizing(), !0 !== this.stabilized) {
            if (!0 === this.adaptiveTimestep && !0 === this.adaptiveTimestepEnabled) this.adaptiveCounter % this.adaptiveInterval == 0 ? (this.timestep = 2 * this.timestep, this.physicsStep(), this.revert(), this.timestep = .5 * this.timestep, this.physicsStep(), this.physicsStep(), this.adjustTimeStep()) : this.physicsStep(), this.adaptiveCounter += 1;else this.timestep = this.options.timestep, this.physicsStep();
            !0 === this.stabilized && this.revert(), this.stabilizationIterations++;
          }
        }
      }, {
        key: "updatePhysicsData",
        value: function value() {
          this.physicsBody.forces = {}, this.physicsBody.physicsNodeIndices = [], this.physicsBody.physicsEdgeIndices = [];
          var t = this.body.nodes,
            e = this.body.edges;
          for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && !0 === t[i].options.physics && this.physicsBody.physicsNodeIndices.push(t[i].id);
          for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && !0 === e[n].options.physics && this.physicsBody.physicsEdgeIndices.push(e[n].id);
          for (var o = 0; o < this.physicsBody.physicsNodeIndices.length; o++) {
            var r = this.physicsBody.physicsNodeIndices[o];
            this.physicsBody.forces[r] = {
              x: 0,
              y: 0
            }, void 0 === this.physicsBody.velocities[r] && (this.physicsBody.velocities[r] = {
              x: 0,
              y: 0
            });
          }
          for (var s in this.physicsBody.velocities) void 0 === t[s] && delete this.physicsBody.velocities[s];
        }
      }, {
        key: "revert",
        value: function value() {
          var t = Hf(this.previousStates),
            e = this.body.nodes,
            i = this.physicsBody.velocities;
          this.referenceState = {};
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            void 0 !== e[o] ? !0 === e[o].options.physics && (this.referenceState[o] = {
              positions: {
                x: e[o].x,
                y: e[o].y
              }
            }, i[o].x = this.previousStates[o].vx, i[o].y = this.previousStates[o].vy, e[o].x = this.previousStates[o].x, e[o].y = this.previousStates[o].y) : delete this.previousStates[o];
          }
        }
      }, {
        key: "_evaluateStepQuality",
        value: function value() {
          var t,
            e,
            i = this.body.nodes,
            n = this.referenceState;
          for (var o in this.referenceState) if (Object.prototype.hasOwnProperty.call(this.referenceState, o) && void 0 !== i[o] && (t = i[o].x - n[o].positions.x, e = i[o].y - n[o].positions.y, Math.sqrt(Math.pow(t, 2) + Math.pow(e, 2)) > .3)) return !1;
          return !0;
        }
      }, {
        key: "moveNodes",
        value: function value() {
          for (var t = this.physicsBody.physicsNodeIndices, e = 0, i = 0, n = 0; n < t.length; n++) {
            var o = t[n],
              r = this._performStep(o);
            e = Math.max(e, r), i += r;
          }
          this.adaptiveTimestepEnabled = i / t.length < 5, this.stabilized = e < this.options.minVelocity;
        }
      }, {
        key: "calculateComponentVelocity",
        value: function value(t, e, i) {
          t += (e - this.modelOptions.damping * t) / i * this.timestep;
          var n = this.options.maxVelocity || 1e9;
          return Math.abs(t) > n && (t = t > 0 ? n : -n), t;
        }
      }, {
        key: "_performStep",
        value: function value(t) {
          var e = this.body.nodes[t],
            i = this.physicsBody.forces[t];
          this.options.wind && (i.x += this.options.wind.x, i.y += this.options.wind.y);
          var n = this.physicsBody.velocities[t];
          return this.previousStates[t] = {
            x: e.x,
            y: e.y,
            vx: n.x,
            vy: n.y
          }, !1 === e.options.fixed.x ? (n.x = this.calculateComponentVelocity(n.x, i.x, e.options.mass), e.x += n.x * this.timestep) : (i.x = 0, n.x = 0), !1 === e.options.fixed.y ? (n.y = this.calculateComponentVelocity(n.y, i.y, e.options.mass), e.y += n.y * this.timestep) : (i.y = 0, n.y = 0), Math.sqrt(Math.pow(n.x, 2) + Math.pow(n.y, 2));
        }
      }, {
        key: "_freezeNodes",
        value: function value() {
          var t = this.body.nodes;
          for (var e in t) if (Object.prototype.hasOwnProperty.call(t, e) && t[e].x && t[e].y) {
            var i = t[e].options.fixed;
            this.freezeCache[e] = {
              x: i.x,
              y: i.y
            }, i.x = !0, i.y = !0;
          }
        }
      }, {
        key: "_restoreFrozenNodes",
        value: function value() {
          var t = this.body.nodes;
          for (var e in t) Object.prototype.hasOwnProperty.call(t, e) && void 0 !== this.freezeCache[e] && (t[e].options.fixed.x = this.freezeCache[e].x, t[e].options.fixed.y = this.freezeCache[e].y);
          this.freezeCache = {};
        }
      }, {
        key: "stabilize",
        value: function value() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.options.stabilization.iterations;
          "number" != typeof e && (e = this.options.stabilization.iterations, console.error("The stabilize method needs a numeric amount of iterations. Switching to default: ", e)), 0 !== this.physicsBody.physicsNodeIndices.length ? (this.adaptiveTimestep = this.options.adaptiveTimestep, this.body.emitter.emit("_resizeNodes"), this.stopSimulation(), this.stabilized = !1, this.body.emitter.emit("_blockRedraw"), this.targetIterations = e, !0 === this.options.stabilization.onlyDynamicEdges && this._freezeNodes(), this.stabilizationIterations = 0, jg(function () {
            return t._stabilizationBatch();
          }, 0)) : this.ready = !0;
        }
      }, {
        key: "_startStabilizing",
        value: function value() {
          return !0 !== this.startedStabilization && (this.body.emitter.emit("startStabilizing"), this.startedStabilization = !0, !0);
        }
      }, {
        key: "_stabilizationBatch",
        value: function value() {
          var t = this,
            e = function e() {
              return !1 === t.stabilized && t.stabilizationIterations < t.targetIterations;
            },
            i = function i() {
              t.body.emitter.emit("stabilizationProgress", {
                iterations: t.stabilizationIterations,
                total: t.targetIterations
              });
            };
          this._startStabilizing() && i();
          for (var n, o = 0; e() && o < this.options.stabilization.updateInterval;) this.physicsTick(), o++;
          (i(), e()) ? jg(Hn(n = this._stabilizationBatch).call(n, this), 0) : this._finalizeStabilization();
        }
      }, {
        key: "_finalizeStabilization",
        value: function value() {
          this.body.emitter.emit("_allowRedraw"), !0 === this.options.stabilization.fit && this.body.emitter.emit("fit"), !0 === this.options.stabilization.onlyDynamicEdges && this._restoreFrozenNodes(), this.body.emitter.emit("stabilizationIterationsDone"), this.body.emitter.emit("_requestRedraw"), !0 === this.stabilized ? this._emitStabilized() : this.startSimulation(), this.ready = !0;
        }
      }, {
        key: "_drawForces",
        value: function value(t) {
          for (var e = 0; e < this.physicsBody.physicsNodeIndices.length; e++) {
            var i = this.physicsBody.physicsNodeIndices[e],
              n = this.body.nodes[i],
              o = this.physicsBody.forces[i],
              r = Math.sqrt(Math.pow(o.x, 2) + Math.pow(o.x, 2)),
              s = Math.min(Math.max(5, r), 15),
              a = 3 * s,
              h = Db((180 - 180 * Math.min(1, Math.max(0, .03 * r))) / 360, 1, 1),
              l = {
                x: n.x + 20 * o.x,
                y: n.y + 20 * o.y
              };
            t.lineWidth = s, t.strokeStyle = h, t.beginPath(), t.moveTo(n.x, n.y), t.lineTo(l.x, l.y), t.stroke();
            var d = Math.atan2(o.y, o.x);
            t.fillStyle = h, YD.draw(t, {
              type: "arrow",
              point: l,
              angle: d,
              length: a
            }), Kg(t).call(t);
          }
        }
      }]), t;
    }(),
    xI = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, null, [{
        key: "getRange",
        value: function value(t) {
          var e,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = 1e9,
            o = -1e9,
            r = 1e9,
            s = -1e9;
          if (i.length > 0) for (var a = 0; a < i.length; a++) r > (e = t[i[a]]).shape.boundingBox.left && (r = e.shape.boundingBox.left), s < e.shape.boundingBox.right && (s = e.shape.boundingBox.right), n > e.shape.boundingBox.top && (n = e.shape.boundingBox.top), o < e.shape.boundingBox.bottom && (o = e.shape.boundingBox.bottom);
          return 1e9 === r && -1e9 === s && 1e9 === n && -1e9 === o && (n = 0, o = 0, r = 0, s = 0), {
            minX: r,
            maxX: s,
            minY: n,
            maxY: o
          };
        }
      }, {
        key: "getRangeCore",
        value: function value(t) {
          var e,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = 1e9,
            o = -1e9,
            r = 1e9,
            s = -1e9;
          if (i.length > 0) for (var a = 0; a < i.length; a++) r > (e = t[i[a]]).x && (r = e.x), s < e.x && (s = e.x), n > e.y && (n = e.y), o < e.y && (o = e.y);
          return 1e9 === r && -1e9 === s && 1e9 === n && -1e9 === o && (n = 0, o = 0, r = 0, s = 0), {
            minX: r,
            maxX: s,
            minY: n,
            maxY: o
          };
        }
      }, {
        key: "findCenter",
        value: function value(t) {
          return {
            x: .5 * (t.maxX + t.minX),
            y: .5 * (t.maxY + t.minY)
          };
        }
      }, {
        key: "cloneOptions",
        value: function value(t, e) {
          var i = {};
          return void 0 === e || "node" === e ? (gb(i, t.options, !0), i.x = t.x, i.y = t.y, i.amountOfConnections = t.edges.length) : gb(i, t.options, !0), i;
        }
      }]), t;
    }();
  function EI(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var OI = function (t) {
      D_(i, t);
      var e = EI(i);
      function i(t, n, o, r, s, a) {
        var h;
        return ph(this, i), (h = e.call(this, t, n, o, r, s, a)).isCluster = !0, h.containedNodes = {}, h.containedEdges = {}, h;
      }
      return xu(i, [{
        key: "_openChildCluster",
        value: function value(t) {
          var e = this,
            i = this.body.nodes[t];
          if (void 0 === this.containedNodes[t]) throw new Error("node with id: " + t + " not in current cluster");
          if (!i.isCluster) throw new Error("node with id: " + t + " is not a cluster");
          delete this.containedNodes[t], kb(i.edges, function (t) {
            delete e.containedEdges[t.id];
          }), kb(i.containedNodes, function (t, i) {
            e.containedNodes[i] = t;
          }), i.containedNodes = {}, kb(i.containedEdges, function (t, i) {
            e.containedEdges[i] = t;
          }), i.containedEdges = {}, kb(i.edges, function (t) {
            kb(e.edges, function (i) {
              var n,
                o,
                r = lg(n = i.clusteringEdgeReplacingIds).call(n, t.id);
              -1 !== r && (kb(t.clusteringEdgeReplacingIds, function (t) {
                i.clusteringEdgeReplacingIds.push(t), e.body.edges[t].edgeReplacedById = i.id;
              }), Ap(o = i.clusteringEdgeReplacingIds).call(o, r, 1));
            });
          }), i.edges = [];
        }
      }]), i;
    }(fD),
    CI = function () {
      function t(e) {
        var i = this;
        ph(this, t), this.body = e, this.clusteredNodes = {}, this.clusteredEdges = {}, this.options = {}, this.defaultOptions = {}, bn(this.options, this.defaultOptions), this.body.emitter.on("_resetData", function () {
          i.clusteredNodes = {}, i.clusteredEdges = {};
        });
      }
      return xu(t, [{
        key: "clusterByHubsize",
        value: function value(t, e) {
          void 0 === t ? t = this._getHubSize() : "object" === bu(t) && (e = this._checkOptions(t), t = this._getHubSize());
          for (var i = [], n = 0; n < this.body.nodeIndices.length; n++) {
            var o = this.body.nodes[this.body.nodeIndices[n]];
            o.edges.length >= t && i.push(o.id);
          }
          for (var r = 0; r < i.length; r++) this.clusterByConnection(i[r], e, !0);
          this.body.emitter.emit("_dataChanged");
        }
      }, {
        key: "cluster",
        value: function value() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            i = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          if (void 0 === e.joinCondition) throw new Error("Cannot call clusterByNodeData without a joinCondition function in the options.");
          e = this._checkOptions(e);
          var n = {},
            o = {};
          kb(this.body.nodes, function (i, r) {
            i.options && !0 === e.joinCondition(i.options) && (n[r] = i, kb(i.edges, function (e) {
              void 0 === t.clusteredEdges[e.id] && (o[e.id] = e);
            }));
          }), this._cluster(n, o, e, i);
        }
      }, {
        key: "clusterByEdgeCount",
        value: function value(t, e) {
          var i = this,
            n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
          e = this._checkOptions(e);
          for (var o, r, s, a = [], h = {}, l = function l() {
              var n = {},
                l = {},
                c = i.body.nodeIndices[d],
                u = i.body.nodes[c];
              if (void 0 === h[c]) {
                s = 0, r = [];
                for (var f = 0; f < u.edges.length; f++) o = u.edges[f], void 0 === i.clusteredEdges[o.id] && (o.toId !== o.fromId && s++, r.push(o));
                if (s === t) {
                  for (var p = function p(t) {
                      if (void 0 === e.joinCondition || null === e.joinCondition) return !0;
                      var i = xI.cloneOptions(t);
                      return e.joinCondition(i);
                    }, v = !0, g = 0; g < r.length; g++) {
                    o = r[g];
                    var y = i._getConnectedId(o, c);
                    if (!p(u)) {
                      v = !1;
                      break;
                    }
                    l[o.id] = o, n[c] = u, n[y] = i.body.nodes[y], h[c] = !0;
                  }
                  if (Hf(n).length > 0 && Hf(l).length > 0 && !0 === v) {
                    var m = function () {
                      for (var t = 0; t < a.length; ++t) for (var e in n) if (void 0 !== a[t].nodes[e]) return a[t];
                    }();
                    if (void 0 !== m) {
                      for (var b in n) void 0 === m.nodes[b] && (m.nodes[b] = n[b]);
                      for (var w in l) void 0 === m.edges[w] && (m.edges[w] = l[w]);
                    } else a.push({
                      nodes: n,
                      edges: l
                    });
                  }
                }
              }
            }, d = 0; d < this.body.nodeIndices.length; d++) l();
          for (var c = 0; c < a.length; c++) this._cluster(a[c].nodes, a[c].edges, e, !1);
          !0 === n && this.body.emitter.emit("_dataChanged");
        }
      }, {
        key: "clusterOutliers",
        value: function value(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          this.clusterByEdgeCount(1, t, e);
        }
      }, {
        key: "clusterBridges",
        value: function value(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          this.clusterByEdgeCount(2, t, e);
        }
      }, {
        key: "clusterByConnection",
        value: function value(t, e) {
          var i,
            n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
          if (void 0 === t) throw new Error("No nodeId supplied to clusterByConnection!");
          if (void 0 === this.body.nodes[t]) throw new Error("The nodeId given to clusterByConnection does not exist!");
          var o = this.body.nodes[t];
          void 0 === (e = this._checkOptions(e, o)).clusterNodeProperties.x && (e.clusterNodeProperties.x = o.x), void 0 === e.clusterNodeProperties.y && (e.clusterNodeProperties.y = o.y), void 0 === e.clusterNodeProperties.fixed && (e.clusterNodeProperties.fixed = {}, e.clusterNodeProperties.fixed.x = o.options.fixed.x, e.clusterNodeProperties.fixed.y = o.options.fixed.y);
          var r = {},
            s = {},
            a = o.id,
            h = xI.cloneOptions(o);
          r[a] = o;
          for (var l = 0; l < o.edges.length; l++) {
            var d = o.edges[l];
            if (void 0 === this.clusteredEdges[d.id]) {
              var c = this._getConnectedId(d, a);
              if (void 0 === this.clusteredNodes[c]) if (c !== a) {
                if (void 0 === e.joinCondition) s[d.id] = d, r[c] = this.body.nodes[c];else {
                  var u = xI.cloneOptions(this.body.nodes[c]);
                  !0 === e.joinCondition(h, u) && (s[d.id] = d, r[c] = this.body.nodes[c]);
                }
              } else s[d.id] = d;
            }
          }
          var f = jf(i = Hf(r)).call(i, function (t) {
            return r[t].id;
          });
          for (var p in r) if (Object.prototype.hasOwnProperty.call(r, p)) for (var v = r[p], g = 0; g < v.edges.length; g++) {
            var y = v.edges[g];
            lg(f).call(f, this._getConnectedId(y, v.id)) > -1 && (s[y.id] = y);
          }
          this._cluster(r, s, e, n);
        }
      }, {
        key: "_createClusterEdges",
        value: function value(t, e, i, n) {
          for (var o, r, s, a, h, l, d = Hf(t), c = [], u = 0; u < d.length; u++) {
            s = t[r = d[u]];
            for (var f = 0; f < s.edges.length; f++) o = s.edges[f], void 0 === this.clusteredEdges[o.id] && (o.toId == o.fromId ? e[o.id] = o : o.toId == r ? (a = i.id, l = h = o.fromId) : (a = o.toId, h = i.id, l = a), void 0 === t[l] && c.push({
              edge: o,
              fromId: h,
              toId: a
            }));
          }
          for (var p = [], v = function v(t) {
              for (var e = 0; e < p.length; e++) {
                var i = p[e],
                  n = t.fromId === i.fromId && t.toId === i.toId,
                  o = t.fromId === i.toId && t.toId === i.fromId;
                if (n || o) return i;
              }
              return null;
            }, g = 0; g < c.length; g++) {
            var y = c[g],
              m = y.edge,
              b = v(y);
            null === b ? (b = this._createClusteredEdge(y.fromId, y.toId, m, n), p.push(b)) : b.clusteringEdgeReplacingIds.push(m.id), this.body.edges[m.id].edgeReplacedById = b.id, this._backupEdgeOptions(m), m.setOptions({
              physics: !1
            });
          }
        }
      }, {
        key: "_checkOptions",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return void 0 === t.clusterEdgeProperties && (t.clusterEdgeProperties = {}), void 0 === t.clusterNodeProperties && (t.clusterNodeProperties = {}), t;
        }
      }, {
        key: "_cluster",
        value: function value(t, e, i) {
          var n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
            o = [];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && void 0 !== this.clusteredNodes[r] && o.push(r);
          for (var s = 0; s < o.length; ++s) delete t[o[s]];
          if (0 != Hf(t).length && (1 != Hf(t).length || 1 == i.clusterNodeProperties.allowSingleNodeCluster)) {
            var a = gb({}, i.clusterNodeProperties);
            if (void 0 !== i.processProperties) {
              var h = [];
              for (var l in t) if (Object.prototype.hasOwnProperty.call(t, l)) {
                var d = xI.cloneOptions(t[l]);
                h.push(d);
              }
              var c = [];
              for (var u in e) if (Object.prototype.hasOwnProperty.call(e, u) && "clusterEdge:" !== u.substr(0, 12)) {
                var f = xI.cloneOptions(e[u], "edge");
                c.push(f);
              }
              if (!(a = i.processProperties(a, h, c))) throw new Error("The processProperties function does not return properties!");
            }
            void 0 === a.id && (a.id = "cluster:" + zM());
            var p = a.id;
            void 0 === a.label && (a.label = "cluster");
            var v = void 0;
            void 0 === a.x && (v = this._getClusterPosition(t), a.x = v.x), void 0 === a.y && (void 0 === v && (v = this._getClusterPosition(t)), a.y = v.y), a.id = p;
            var g = this.body.functions.createNode(a, OI);
            g.containedNodes = t, g.containedEdges = e, g.clusterEdgeProperties = i.clusterEdgeProperties, this.body.nodes[a.id] = g, this._clusterEdges(t, e, a, i.clusterEdgeProperties), a.id = void 0, !0 === n && this.body.emitter.emit("_dataChanged");
          }
        }
      }, {
        key: "_backupEdgeOptions",
        value: function value(t) {
          void 0 === this.clusteredEdges[t.id] && (this.clusteredEdges[t.id] = {
            physics: t.options.physics
          });
        }
      }, {
        key: "_restoreEdge",
        value: function value(t) {
          var e = this.clusteredEdges[t.id];
          void 0 !== e && (t.setOptions({
            physics: e.physics
          }), delete this.clusteredEdges[t.id]);
        }
      }, {
        key: "isCluster",
        value: function value(t) {
          return void 0 !== this.body.nodes[t] ? !0 === this.body.nodes[t].isCluster : (console.error("Node does not exist."), !1);
        }
      }, {
        key: "_getClusterPosition",
        value: function value(t) {
          for (var e, i = Hf(t), n = t[i[0]].x, o = t[i[0]].x, r = t[i[0]].y, s = t[i[0]].y, a = 1; a < i.length; a++) n = (e = t[i[a]]).x < n ? e.x : n, o = e.x > o ? e.x : o, r = e.y < r ? e.y : r, s = e.y > s ? e.y : s;
          return {
            x: .5 * (n + o),
            y: .5 * (r + s)
          };
        }
      }, {
        key: "openCluster",
        value: function value(t, e) {
          var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
          if (void 0 === t) throw new Error("No clusterNodeId supplied to openCluster.");
          var n = this.body.nodes[t];
          if (void 0 === n) throw new Error("The clusterNodeId supplied to openCluster does not exist.");
          if (!0 !== n.isCluster || void 0 === n.containedNodes || void 0 === n.containedEdges) throw new Error("The node:" + t + " is not a valid cluster.");
          var o = this.findNode(t),
            r = lg(o).call(o, t) - 1;
          if (r >= 0) {
            var s = o[r];
            return this.body.nodes[s]._openChildCluster(t), delete this.body.nodes[t], void (!0 === i && this.body.emitter.emit("_dataChanged"));
          }
          var a = n.containedNodes,
            h = n.containedEdges;
          if (void 0 !== e && void 0 !== e.releaseFunction && "function" == typeof e.releaseFunction) {
            var l = {},
              d = {
                x: n.x,
                y: n.y
              };
            for (var c in a) if (Object.prototype.hasOwnProperty.call(a, c)) {
              var u = this.body.nodes[c];
              l[c] = {
                x: u.x,
                y: u.y
              };
            }
            var f = e.releaseFunction(d, l);
            for (var p in a) if (Object.prototype.hasOwnProperty.call(a, p)) {
              var v = this.body.nodes[p];
              void 0 !== f[p] && (v.x = void 0 === f[p].x ? n.x : f[p].x, v.y = void 0 === f[p].y ? n.y : f[p].y);
            }
          } else kb(a, function (t) {
            !1 === t.options.fixed.x && (t.x = n.x), !1 === t.options.fixed.y && (t.y = n.y);
          });
          for (var g in a) if (Object.prototype.hasOwnProperty.call(a, g)) {
            var y = this.body.nodes[g];
            y.vx = n.vx, y.vy = n.vy, y.setOptions({
              physics: !0
            }), delete this.clusteredNodes[g];
          }
          for (var m = [], b = 0; b < n.edges.length; b++) m.push(n.edges[b]);
          for (var w = 0; w < m.length; w++) {
            for (var k = m[w], _ = this._getConnectedId(k, t), x = this.clusteredNodes[_], E = 0; E < k.clusteringEdgeReplacingIds.length; E++) {
              var O = k.clusteringEdgeReplacingIds[E],
                C = this.body.edges[O];
              if (void 0 !== C) if (void 0 !== x) {
                var S = this.body.nodes[x.clusterId];
                S.containedEdges[C.id] = C, delete h[C.id];
                var T = C.fromId,
                  M = C.toId;
                C.toId == _ ? M = x.clusterId : T = x.clusterId, this._createClusteredEdge(T, M, C, S.clusterEdgeProperties, {
                  hidden: !1,
                  physics: !0
                });
              } else this._restoreEdge(C);
            }
            k.remove();
          }
          for (var P in h) Object.prototype.hasOwnProperty.call(h, P) && this._restoreEdge(h[P]);
          delete this.body.nodes[t], !0 === i && this.body.emitter.emit("_dataChanged");
        }
      }, {
        key: "getNodesInCluster",
        value: function value(t) {
          var e = [];
          if (!0 === this.isCluster(t)) {
            var i = this.body.nodes[t].containedNodes;
            for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && e.push(this.body.nodes[n].id);
          }
          return e;
        }
      }, {
        key: "findNode",
        value: function value(t) {
          for (var e, i = [], n = 0; void 0 !== this.clusteredNodes[t] && n < 100;) {
            if (void 0 === (e = this.body.nodes[t])) return [];
            i.push(e.id), t = this.clusteredNodes[t].clusterId, n++;
          }
          return void 0 === (e = this.body.nodes[t]) ? [] : (i.push(e.id), vp(i).call(i), i);
        }
      }, {
        key: "updateClusteredNode",
        value: function value(t, e) {
          if (void 0 === t) throw new Error("No clusteredNodeId supplied to updateClusteredNode.");
          if (void 0 === e) throw new Error("No newOptions supplied to updateClusteredNode.");
          if (void 0 === this.body.nodes[t]) throw new Error("The clusteredNodeId supplied to updateClusteredNode does not exist.");
          this.body.nodes[t].setOptions(e), this.body.emitter.emit("_dataChanged");
        }
      }, {
        key: "updateEdge",
        value: function value(t, e) {
          if (void 0 === t) throw new Error("No startEdgeId supplied to updateEdge.");
          if (void 0 === e) throw new Error("No newOptions supplied to updateEdge.");
          if (void 0 === this.body.edges[t]) throw new Error("The startEdgeId supplied to updateEdge does not exist.");
          for (var i = this.getClusteredEdges(t), n = 0; n < i.length; n++) {
            this.body.edges[i[n]].setOptions(e);
          }
          this.body.emitter.emit("_dataChanged");
        }
      }, {
        key: "getClusteredEdges",
        value: function value(t) {
          for (var e = [], i = 0; void 0 !== t && void 0 !== this.body.edges[t] && i < 100;) e.push(this.body.edges[t].id), t = this.body.edges[t].edgeReplacedById, i++;
          return vp(e).call(e), e;
        }
      }, {
        key: "getBaseEdge",
        value: function value(t) {
          return this.getBaseEdges(t)[0];
        }
      }, {
        key: "getBaseEdges",
        value: function value(t) {
          for (var e = [t], i = [], n = [], o = 0; e.length > 0 && o < 100;) {
            var r = e.pop();
            if (void 0 !== r) {
              var s = this.body.edges[r];
              if (void 0 !== s) {
                o++;
                var a = s.clusteringEdgeReplacingIds;
                if (void 0 === a) n.push(r);else for (var h = 0; h < a.length; ++h) {
                  var l = a[h];
                  -1 === lg(e).call(e, a) && -1 === lg(i).call(i, a) && e.push(l);
                }
                i.push(r);
              }
            }
          }
          return n;
        }
      }, {
        key: "_getConnectedId",
        value: function value(t, e) {
          return t.toId != e ? t.toId : (t.fromId, t.fromId);
        }
      }, {
        key: "_getHubSize",
        value: function value() {
          for (var t = 0, e = 0, i = 0, n = 0, o = 0; o < this.body.nodeIndices.length; o++) {
            var r = this.body.nodes[this.body.nodeIndices[o]];
            r.edges.length > n && (n = r.edges.length), t += r.edges.length, e += Math.pow(r.edges.length, 2), i += 1;
          }
          t /= i;
          var s = (e /= i) - Math.pow(t, 2),
            a = Math.sqrt(s),
            h = Math.floor(t + 2 * a);
          return h > n && (h = n), h;
        }
      }, {
        key: "_createClusteredEdge",
        value: function value(t, e, i, n, o) {
          var r = xI.cloneOptions(i, "edge");
          gb(r, n), r.from = t, r.to = e, r.id = "clusterEdge:" + zM(), void 0 !== o && gb(r, o);
          var s = this.body.functions.createEdge(r);
          return s.clusteringEdgeReplacingIds = [i.id], s.connect(), this.body.edges[s.id] = s, s;
        }
      }, {
        key: "_clusterEdges",
        value: function value(t, e, i, n) {
          if (e instanceof dI) {
            var o = e,
              r = {};
            r[o.id] = o, e = r;
          }
          if (t instanceof fD) {
            var s = t,
              a = {};
            a[s.id] = s, t = a;
          }
          if (null == i) throw new Error("_clusterEdges: parameter clusterNode required");
          for (var h in void 0 === n && (n = i.clusterEdgeProperties), this._createClusterEdges(t, e, i, n), e) if (Object.prototype.hasOwnProperty.call(e, h) && void 0 !== this.body.edges[h]) {
            var l = this.body.edges[h];
            this._backupEdgeOptions(l), l.setOptions({
              physics: !1
            });
          }
          for (var d in t) Object.prototype.hasOwnProperty.call(t, d) && (this.clusteredNodes[d] = {
            clusterId: i.id,
            node: this.body.nodes[d]
          }, this.body.nodes[d].setOptions({
            physics: !1
          }));
        }
      }, {
        key: "_getClusterNodeForNode",
        value: function value(t) {
          if (void 0 !== t) {
            var e = this.clusteredNodes[t];
            if (void 0 !== e) {
              var i = e.clusterId;
              if (void 0 !== i) return this.body.nodes[i];
            }
          }
        }
      }, {
        key: "_filter",
        value: function value(t, e) {
          var i = [];
          return kb(t, function (t) {
            e(t) && i.push(t);
          }), i;
        }
      }, {
        key: "_updateState",
        value: function value() {
          var t,
            e = this,
            i = [],
            n = {},
            o = function o(t) {
              kb(e.body.nodes, function (e) {
                !0 === e.isCluster && t(e);
              });
            };
          for (t in this.clusteredNodes) {
            if (Object.prototype.hasOwnProperty.call(this.clusteredNodes, t)) void 0 === this.body.nodes[t] && i.push(t);
          }
          o(function (t) {
            for (var e = 0; e < i.length; e++) delete t.containedNodes[i[e]];
          });
          for (var r = 0; r < i.length; r++) delete this.clusteredNodes[i[r]];
          kb(this.clusteredEdges, function (t) {
            var i = e.body.edges[t];
            void 0 !== i && i.endPointsValid() || (n[t] = t);
          }), o(function (t) {
            kb(t.containedEdges, function (t, e) {
              t.endPointsValid() || n[e] || (n[e] = e);
            });
          }), kb(this.body.edges, function (t, i) {
            var o = !0,
              r = t.clusteringEdgeReplacingIds;
            if (void 0 !== r) {
              var s = 0;
              kb(r, function (t) {
                var i = e.body.edges[t];
                void 0 !== i && i.endPointsValid() && (s += 1);
              }), o = s > 0;
            }
            t.endPointsValid() && o || (n[i] = i);
          }), o(function (t) {
            kb(n, function (i) {
              delete t.containedEdges[i], kb(t.edges, function (o, r) {
                o.id !== i ? o.clusteringEdgeReplacingIds = e._filter(o.clusteringEdgeReplacingIds, function (t) {
                  return !n[t];
                }) : t.edges[r] = null;
              }), t.edges = e._filter(t.edges, function (t) {
                return null !== t;
              });
            });
          }), kb(n, function (t) {
            delete e.clusteredEdges[t];
          }), kb(n, function (t) {
            delete e.body.edges[t];
          }), kb(Hf(this.body.edges), function (t) {
            var i = e.body.edges[t],
              n = e._isClusteredNode(i.fromId) || e._isClusteredNode(i.toId);
            if (n !== e._isClusteredEdge(i.id)) if (n) {
              var o = e._getClusterNodeForNode(i.fromId);
              void 0 !== o && e._clusterEdges(e.body.nodes[i.fromId], i, o);
              var r = e._getClusterNodeForNode(i.toId);
              void 0 !== r && e._clusterEdges(e.body.nodes[i.toId], i, r);
            } else delete e._clusterEdges[t], e._restoreEdge(i);
          });
          for (var s = !1, a = !0, h = function h() {
              var t = [];
              o(function (e) {
                var i = Hf(e.containedNodes).length,
                  n = !0 === e.options.allowSingleNodeCluster;
                (n && i < 1 || !n && i < 2) && t.push(e.id);
              });
              for (var i = 0; i < t.length; ++i) e.openCluster(t[i], {}, !1);
              a = t.length > 0, s = s || a;
            }; a;) h();
          s && this._updateState();
        }
      }, {
        key: "_isClusteredNode",
        value: function value(t) {
          return void 0 !== this.clusteredNodes[t];
        }
      }, {
        key: "_isClusteredEdge",
        value: function value(t) {
          return void 0 !== this.clusteredEdges[t];
        }
      }]), t;
    }();
  var SI = function () {
      function t(e, i) {
        var n;
        ph(this, t), void 0 !== window && (n = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame), window.requestAnimationFrame = void 0 === n ? function (t) {
          t();
        } : n, this.body = e, this.canvas = i, this.redrawRequested = !1, this.renderTimer = void 0, this.requiresTimeout = !0, this.renderingActive = !1, this.renderRequests = 0, this.allowRedraw = !0, this.dragging = !1, this.zooming = !1, this.options = {}, this.defaultOptions = {
          hideEdgesOnDrag: !1,
          hideEdgesOnZoom: !1,
          hideNodesOnDrag: !1
        }, bn(this.options, this.defaultOptions), this._determineBrowserMethod(), this.bindEventListeners();
      }
      return xu(t, [{
        key: "bindEventListeners",
        value: function value() {
          var t,
            e = this;
          this.body.emitter.on("dragStart", function () {
            e.dragging = !0;
          }), this.body.emitter.on("dragEnd", function () {
            e.dragging = !1;
          }), this.body.emitter.on("zoom", function () {
            e.zooming = !0, window.clearTimeout(e.zoomTimeoutId), e.zoomTimeoutId = jg(function () {
              var t;
              e.zooming = !1, Hn(t = e._requestRedraw).call(t, e)();
            }, 250);
          }), this.body.emitter.on("_resizeNodes", function () {
            e._resizeNodes();
          }), this.body.emitter.on("_redraw", function () {
            !1 === e.renderingActive && e._redraw();
          }), this.body.emitter.on("_blockRedraw", function () {
            e.allowRedraw = !1;
          }), this.body.emitter.on("_allowRedraw", function () {
            e.allowRedraw = !0, e.redrawRequested = !1;
          }), this.body.emitter.on("_requestRedraw", Hn(t = this._requestRedraw).call(t, this)), this.body.emitter.on("_startRendering", function () {
            e.renderRequests += 1, e.renderingActive = !0, e._startRendering();
          }), this.body.emitter.on("_stopRendering", function () {
            e.renderRequests -= 1, e.renderingActive = e.renderRequests > 0, e.renderTimer = void 0;
          }), this.body.emitter.on("destroy", function () {
            e.renderRequests = 0, e.allowRedraw = !1, e.renderingActive = !1, !0 === e.requiresTimeout ? clearTimeout(e.renderTimer) : window.cancelAnimationFrame(e.renderTimer), e.body.emitter.off();
          });
        }
      }, {
        key: "setOptions",
        value: function value(t) {
          if (void 0 !== t) {
            pb(["hideEdgesOnDrag", "hideEdgesOnZoom", "hideNodesOnDrag"], this.options, t);
          }
        }
      }, {
        key: "_requestNextFrame",
        value: function value(t, e) {
          if ("undefined" != typeof window) {
            var i,
              n = window;
            return !0 === this.requiresTimeout ? i = jg(t, e) : n.requestAnimationFrame && (i = n.requestAnimationFrame(t)), i;
          }
        }
      }, {
        key: "_startRendering",
        value: function value() {
          var t;
          !0 === this.renderingActive && void 0 === this.renderTimer && (this.renderTimer = this._requestNextFrame(Hn(t = this._renderStep).call(t, this), this.simulationInterval));
        }
      }, {
        key: "_renderStep",
        value: function value() {
          !0 === this.renderingActive && (this.renderTimer = void 0, !0 === this.requiresTimeout && this._startRendering(), this._redraw(), !1 === this.requiresTimeout && this._startRendering());
        }
      }, {
        key: "redraw",
        value: function value() {
          this.body.emitter.emit("setSize"), this._redraw();
        }
      }, {
        key: "_requestRedraw",
        value: function value() {
          var t = this;
          !0 !== this.redrawRequested && !1 === this.renderingActive && !0 === this.allowRedraw && (this.redrawRequested = !0, this._requestNextFrame(function () {
            t._redraw(!1);
          }, 0));
        }
      }, {
        key: "_redraw",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (!0 === this.allowRedraw) {
            this.body.emitter.emit("initRedraw"), this.redrawRequested = !1;
            var e = {
              drawExternalLabels: null
            };
            0 !== this.canvas.frame.canvas.width && 0 !== this.canvas.frame.canvas.height || this.canvas.setSize(), this.canvas.setTransform();
            var i = this.canvas.getContext(),
              n = this.canvas.frame.canvas.clientWidth,
              o = this.canvas.frame.canvas.clientHeight;
            if (i.clearRect(0, 0, n, o), 0 === this.canvas.frame.clientWidth) return;
            if (i.save(), i.translate(this.body.view.translation.x, this.body.view.translation.y), i.scale(this.body.view.scale, this.body.view.scale), i.beginPath(), this.body.emitter.emit("beforeDrawing", i), i.closePath(), !1 === t && (!1 === this.dragging || !0 === this.dragging && !1 === this.options.hideEdgesOnDrag) && (!1 === this.zooming || !0 === this.zooming && !1 === this.options.hideEdgesOnZoom) && this._drawEdges(i), !1 === this.dragging || !0 === this.dragging && !1 === this.options.hideNodesOnDrag) {
              var r = this._drawNodes(i, t).drawExternalLabels;
              e.drawExternalLabels = r;
            }
            !1 === t && (!1 === this.dragging || !0 === this.dragging && !1 === this.options.hideEdgesOnDrag) && (!1 === this.zooming || !0 === this.zooming && !1 === this.options.hideEdgesOnZoom) && this._drawArrows(i), null != e.drawExternalLabels && e.drawExternalLabels(), !1 === t && this._drawSelectionBox(i), i.beginPath(), this.body.emitter.emit("afterDrawing", i), i.closePath(), i.restore(), !0 === t && i.clearRect(0, 0, n, o);
          }
        }
      }, {
        key: "_resizeNodes",
        value: function value() {
          this.canvas.setTransform();
          var t = this.canvas.getContext();
          t.save(), t.translate(this.body.view.translation.x, this.body.view.translation.y), t.scale(this.body.view.scale, this.body.view.scale);
          var e,
            i = this.body.nodes;
          for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && ((e = i[n]).resize(t), e.updateBoundingBox(t, e.selected));
          t.restore();
        }
      }, {
        key: "_drawNodes",
        value: function value(t) {
          for (var e, i, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], o = this.body.nodes, r = this.body.nodeIndices, s = [], a = [], h = this.canvas.DOMtoCanvas({
              x: -20,
              y: -20
            }), l = this.canvas.DOMtoCanvas({
              x: this.canvas.frame.canvas.clientWidth + 20,
              y: this.canvas.frame.canvas.clientHeight + 20
            }), d = {
              top: h.y,
              left: h.x,
              bottom: l.y,
              right: l.x
            }, c = [], u = 0; u < r.length; u++) if ((e = o[r[u]]).hover) a.push(r[u]);else if (e.isSelected()) s.push(r[u]);else if (!0 === n) {
            var f = e.draw(t);
            null != f.drawExternalLabel && c.push(f.drawExternalLabel);
          } else if (!0 === e.isBoundingBoxOverlappingWith(d)) {
            var p = e.draw(t);
            null != p.drawExternalLabel && c.push(p.drawExternalLabel);
          } else e.updateBoundingBox(t, e.selected);
          var v = s.length,
            g = a.length;
          for (i = 0; i < v; i++) {
            var y = (e = o[s[i]]).draw(t);
            null != y.drawExternalLabel && c.push(y.drawExternalLabel);
          }
          for (i = 0; i < g; i++) {
            var m = (e = o[a[i]]).draw(t);
            null != m.drawExternalLabel && c.push(m.drawExternalLabel);
          }
          return {
            drawExternalLabels: function drawExternalLabels() {
              for (var t = 0, e = c; t < e.length; t++) {
                (0, e[t])();
              }
            }
          };
        }
      }, {
        key: "_drawEdges",
        value: function value(t) {
          for (var e = this.body.edges, i = this.body.edgeIndices, n = 0; n < i.length; n++) {
            var o = e[i[n]];
            !0 === o.connected && o.draw(t);
          }
        }
      }, {
        key: "_drawArrows",
        value: function value(t) {
          for (var e = this.body.edges, i = this.body.edgeIndices, n = 0; n < i.length; n++) {
            var o = e[i[n]];
            !0 === o.connected && o.drawArrows(t);
          }
        }
      }, {
        key: "_determineBrowserMethod",
        value: function value() {
          if ("undefined" != typeof window) {
            var t = navigator.userAgent.toLowerCase();
            this.requiresTimeout = !1, (-1 != lg(t).call(t, "msie 9.0") || -1 != lg(t).call(t, "safari") && lg(t).call(t, "chrome") <= -1) && (this.requiresTimeout = !0);
          } else this.requiresTimeout = !0;
        }
      }, {
        key: "_drawSelectionBox",
        value: function value(t) {
          if (this.body.selectionBox.show) {
            t.beginPath();
            var e = this.body.selectionBox.position.end.x - this.body.selectionBox.position.start.x,
              i = this.body.selectionBox.position.end.y - this.body.selectionBox.position.start.y;
            t.rect(this.body.selectionBox.position.start.x, this.body.selectionBox.position.start.y, e, i), t.fillStyle = "rgba(151, 194, 252, 0.2)", t.fillRect(this.body.selectionBox.position.start.x, this.body.selectionBox.position.start.y, e, i), t.strokeStyle = "rgba(151, 194, 252, 1)", t.stroke();
          } else t.closePath();
        }
      }]), t;
    }(),
    TI = i(et.setInterval);
  function MI(t, e) {
    e.inputHandler = function (t) {
      t.isFirst && e(t);
    }, t.on("hammer.input", e.inputHandler);
  }
  function PI(t, e) {
    return e.inputHandler = function (t) {
      t.isFinal && e(t);
    }, t.on("hammer.input", e.inputHandler);
  }
  var DI = function () {
    function t(e) {
      ph(this, t), this.body = e, this.pixelRatio = 1, this.cameraState = {}, this.initialized = !1, this.canvasViewCenter = {}, this._cleanupCallbacks = [], this.options = {}, this.defaultOptions = {
        autoResize: !0,
        height: "100%",
        width: "100%"
      }, bn(this.options, this.defaultOptions), this.bindEventListeners();
    }
    return xu(t, [{
      key: "bindEventListeners",
      value: function value() {
        var t,
          e = this;
        this.body.emitter.once("resize", function (t) {
          0 !== t.width && (e.body.view.translation.x = .5 * t.width), 0 !== t.height && (e.body.view.translation.y = .5 * t.height);
        }), this.body.emitter.on("setSize", Hn(t = this.setSize).call(t, this)), this.body.emitter.on("destroy", function () {
          e.hammerFrame.destroy(), e.hammer.destroy(), e._cleanUp();
        });
      }
    }, {
      key: "setOptions",
      value: function value(t) {
        var e = this;
        if (void 0 !== t) {
          pb(["width", "height", "autoResize"], this.options, t);
        }
        if (this._cleanUp(), !0 === this.options.autoResize) {
          var i;
          if (window.ResizeObserver) {
            var n = new ResizeObserver(function () {
                !0 === e.setSize() && e.body.emitter.emit("_requestRedraw");
              }),
              o = this.frame;
            n.observe(o), this._cleanupCallbacks.push(function () {
              n.unobserve(o);
            });
          } else {
            var r = TI(function () {
              !0 === e.setSize() && e.body.emitter.emit("_requestRedraw");
            }, 1e3);
            this._cleanupCallbacks.push(function () {
              clearInterval(r);
            });
          }
          var s = Hn(i = this._onResize).call(i, this);
          window.addEventListener("resize", s), this._cleanupCallbacks.push(function () {
            window.removeEventListener("resize", s);
          });
        }
      }
    }, {
      key: "_cleanUp",
      value: function value() {
        var t, e, i;
        op(t = vp(e = Ap(i = this._cleanupCallbacks).call(i, 0)).call(e)).call(t, function (t) {
          try {
            t();
          } catch (t) {
            console.error(t);
          }
        });
      }
    }, {
      key: "_onResize",
      value: function value() {
        this.setSize(), this.body.emitter.emit("_redraw");
      }
    }, {
      key: "_getCameraState",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.pixelRatio;
        !0 === this.initialized && (this.cameraState.previousWidth = this.frame.canvas.width / t, this.cameraState.previousHeight = this.frame.canvas.height / t, this.cameraState.scale = this.body.view.scale, this.cameraState.position = this.DOMtoCanvas({
          x: .5 * this.frame.canvas.width / t,
          y: .5 * this.frame.canvas.height / t
        }));
      }
    }, {
      key: "_setCameraState",
      value: function value() {
        if (void 0 !== this.cameraState.scale && 0 !== this.frame.canvas.clientWidth && 0 !== this.frame.canvas.clientHeight && 0 !== this.pixelRatio && this.cameraState.previousWidth > 0 && this.cameraState.previousHeight > 0) {
          var t = this.frame.canvas.width / this.pixelRatio / this.cameraState.previousWidth,
            e = this.frame.canvas.height / this.pixelRatio / this.cameraState.previousHeight,
            i = this.cameraState.scale;
          1 != t && 1 != e ? i = .5 * this.cameraState.scale * (t + e) : 1 != t ? i = this.cameraState.scale * t : 1 != e && (i = this.cameraState.scale * e), this.body.view.scale = i;
          var n = this.DOMtoCanvas({
              x: .5 * this.frame.canvas.clientWidth,
              y: .5 * this.frame.canvas.clientHeight
            }),
            o = {
              x: n.x - this.cameraState.position.x,
              y: n.y - this.cameraState.position.y
            };
          this.body.view.translation.x += o.x * this.body.view.scale, this.body.view.translation.y += o.y * this.body.view.scale;
        }
      }
    }, {
      key: "_prepareValue",
      value: function value(t) {
        if ("number" == typeof t) return t + "px";
        if ("string" == typeof t) {
          if (-1 !== lg(t).call(t, "%") || -1 !== lg(t).call(t, "px")) return t;
          if (-1 === lg(t).call(t, "%")) return t + "px";
        }
        throw new Error("Could not use the value supplied for width or height:" + t);
      }
    }, {
      key: "_create",
      value: function value() {
        for (; this.body.container.hasChildNodes();) this.body.container.removeChild(this.body.container.firstChild);
        if (this.frame = document.createElement("div"), this.frame.className = "vis-network", this.frame.style.position = "relative", this.frame.style.overflow = "hidden", this.frame.tabIndex = 0, this.frame.canvas = document.createElement("canvas"), this.frame.canvas.style.position = "relative", this.frame.appendChild(this.frame.canvas), this.frame.canvas.getContext) this._setPixelRatio(), this.setTransform();else {
          var t = document.createElement("DIV");
          t.style.color = "red", t.style.fontWeight = "bold", t.style.padding = "10px", t.innerText = "Error: your browser does not support HTML canvas", this.frame.canvas.appendChild(t);
        }
        this.body.container.appendChild(this.frame), this.body.view.scale = 1, this.body.view.translation = {
          x: .5 * this.frame.canvas.clientWidth,
          y: .5 * this.frame.canvas.clientHeight
        }, this._bindHammer();
      }
    }, {
      key: "_bindHammer",
      value: function value() {
        var t = this;
        void 0 !== this.hammer && this.hammer.destroy(), this.drag = {}, this.pinch = {}, this.hammer = new Qb(this.frame.canvas), this.hammer.get("pinch").set({
          enable: !0
        }), this.hammer.get("pan").set({
          threshold: 5,
          direction: Qb.DIRECTION_ALL
        }), MI(this.hammer, function (e) {
          t.body.eventListeners.onTouch(e);
        }), this.hammer.on("tap", function (e) {
          t.body.eventListeners.onTap(e);
        }), this.hammer.on("doubletap", function (e) {
          t.body.eventListeners.onDoubleTap(e);
        }), this.hammer.on("press", function (e) {
          t.body.eventListeners.onHold(e);
        }), this.hammer.on("panstart", function (e) {
          t.body.eventListeners.onDragStart(e);
        }), this.hammer.on("panmove", function (e) {
          t.body.eventListeners.onDrag(e);
        }), this.hammer.on("panend", function (e) {
          t.body.eventListeners.onDragEnd(e);
        }), this.hammer.on("pinch", function (e) {
          t.body.eventListeners.onPinch(e);
        }), this.frame.canvas.addEventListener("wheel", function (e) {
          t.body.eventListeners.onMouseWheel(e);
        }), this.frame.canvas.addEventListener("mousemove", function (e) {
          t.body.eventListeners.onMouseMove(e);
        }), this.frame.canvas.addEventListener("contextmenu", function (e) {
          t.body.eventListeners.onContext(e);
        }), this.hammerFrame = new Qb(this.frame), PI(this.hammerFrame, function (e) {
          t.body.eventListeners.onRelease(e);
        });
      }
    }, {
      key: "setSize",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.options.width,
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.options.height;
        t = this._prepareValue(t), e = this._prepareValue(e);
        var i = !1,
          n = this.frame.canvas.width,
          o = this.frame.canvas.height,
          r = this.pixelRatio;
        if (this._setPixelRatio(), t != this.options.width || e != this.options.height || this.frame.style.width != t || this.frame.style.height != e) this._getCameraState(r), this.frame.style.width = t, this.frame.style.height = e, this.frame.canvas.style.width = "100%", this.frame.canvas.style.height = "100%", this.frame.canvas.width = Math.round(this.frame.canvas.clientWidth * this.pixelRatio), this.frame.canvas.height = Math.round(this.frame.canvas.clientHeight * this.pixelRatio), this.options.width = t, this.options.height = e, this.canvasViewCenter = {
          x: .5 * this.frame.clientWidth,
          y: .5 * this.frame.clientHeight
        }, i = !0;else {
          var s = Math.round(this.frame.canvas.clientWidth * this.pixelRatio),
            a = Math.round(this.frame.canvas.clientHeight * this.pixelRatio);
          this.frame.canvas.width === s && this.frame.canvas.height === a || this._getCameraState(r), this.frame.canvas.width !== s && (this.frame.canvas.width = s, i = !0), this.frame.canvas.height !== a && (this.frame.canvas.height = a, i = !0);
        }
        return !0 === i && (this.body.emitter.emit("resize", {
          width: Math.round(this.frame.canvas.width / this.pixelRatio),
          height: Math.round(this.frame.canvas.height / this.pixelRatio),
          oldWidth: Math.round(n / this.pixelRatio),
          oldHeight: Math.round(o / this.pixelRatio)
        }), this._setCameraState()), this.initialized = !0, i;
      }
    }, {
      key: "getContext",
      value: function value() {
        return this.frame.canvas.getContext("2d");
      }
    }, {
      key: "_determinePixelRatio",
      value: function value() {
        var t = this.getContext();
        if (void 0 === t) throw new Error("Could not get canvax context");
        var e = 1;
        return "undefined" != typeof window && (e = window.devicePixelRatio || 1), e / (t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1);
      }
    }, {
      key: "_setPixelRatio",
      value: function value() {
        this.pixelRatio = this._determinePixelRatio();
      }
    }, {
      key: "setTransform",
      value: function value() {
        var t = this.getContext();
        if (void 0 === t) throw new Error("Could not get canvax context");
        t.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      }
    }, {
      key: "_XconvertDOMtoCanvas",
      value: function value(t) {
        return (t - this.body.view.translation.x) / this.body.view.scale;
      }
    }, {
      key: "_XconvertCanvasToDOM",
      value: function value(t) {
        return t * this.body.view.scale + this.body.view.translation.x;
      }
    }, {
      key: "_YconvertDOMtoCanvas",
      value: function value(t) {
        return (t - this.body.view.translation.y) / this.body.view.scale;
      }
    }, {
      key: "_YconvertCanvasToDOM",
      value: function value(t) {
        return t * this.body.view.scale + this.body.view.translation.y;
      }
    }, {
      key: "canvasToDOM",
      value: function value(t) {
        return {
          x: this._XconvertCanvasToDOM(t.x),
          y: this._YconvertCanvasToDOM(t.y)
        };
      }
    }, {
      key: "DOMtoCanvas",
      value: function value(t) {
        return {
          x: this._XconvertDOMtoCanvas(t.x),
          y: this._YconvertDOMtoCanvas(t.y)
        };
      }
    }]), t;
  }();
  var II = function () {
    function t(e, i) {
      var n,
        o,
        r = this;
      ph(this, t), this.body = e, this.canvas = i, this.animationSpeed = 1 / this.renderRefreshRate, this.animationEasingFunction = "easeInOutQuint", this.easingTime = 0, this.sourceScale = 0, this.targetScale = 0, this.sourceTranslation = 0, this.targetTranslation = 0, this.lockedOnNodeId = void 0, this.lockedOnNodeOffset = void 0, this.touchTime = 0, this.viewFunction = void 0, this.body.emitter.on("fit", Hn(n = this.fit).call(n, this)), this.body.emitter.on("animationFinished", function () {
        r.body.emitter.emit("_stopRendering");
      }), this.body.emitter.on("unlockNode", Hn(o = this.releaseNode).call(o, this));
    }
    return xu(t, [{
      key: "setOptions",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        this.options = t;
      }
    }, {
      key: "fit",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        t = function (t, e) {
          var i = bn({
            nodes: e,
            minZoomLevel: Number.MIN_VALUE,
            maxZoomLevel: 1
          }, null != t ? t : {});
          if (!Df(i.nodes)) throw new TypeError("Nodes has to be an array of ids.");
          if (0 === i.nodes.length && (i.nodes = e), !("number" == typeof i.minZoomLevel && i.minZoomLevel > 0)) throw new TypeError("Min zoom level has to be a number higher than zero.");
          if (!("number" == typeof i.maxZoomLevel && i.minZoomLevel <= i.maxZoomLevel)) throw new TypeError("Max zoom level has to be a number higher than min zoom level.");
          return i;
        }(t, this.body.nodeIndices);
        var i,
          n,
          o = this.canvas.frame.canvas.clientWidth,
          r = this.canvas.frame.canvas.clientHeight;
        if (0 === o || 0 === r) n = 1, i = xI.getRange(this.body.nodes, t.nodes);else if (!0 === e) {
          var s = 0;
          for (var a in this.body.nodes) {
            if (Object.prototype.hasOwnProperty.call(this.body.nodes, a)) !0 === this.body.nodes[a].predefinedPosition && (s += 1);
          }
          if (s > .5 * this.body.nodeIndices.length) return void this.fit(t, !1);
          i = xI.getRange(this.body.nodes, t.nodes), n = 12.662 / (this.body.nodeIndices.length + 7.4147) + .0964822, n *= Math.min(o / 600, r / 600);
        } else {
          this.body.emitter.emit("_resizeNodes"), i = xI.getRange(this.body.nodes, t.nodes);
          var h = o / (1.1 * Math.abs(i.maxX - i.minX)),
            l = r / (1.1 * Math.abs(i.maxY - i.minY));
          n = h <= l ? h : l;
        }
        n > t.maxZoomLevel ? n = t.maxZoomLevel : n < t.minZoomLevel && (n = t.minZoomLevel);
        var d = {
          position: xI.findCenter(i),
          scale: n,
          animation: t.animation
        };
        this.moveTo(d);
      }
    }, {
      key: "focus",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (void 0 !== this.body.nodes[t]) {
          var i = {
            x: this.body.nodes[t].x,
            y: this.body.nodes[t].y
          };
          e.position = i, e.lockedOnNode = t, this.moveTo(e);
        } else console.error("Node: " + t + " cannot be found.");
      }
    }, {
      key: "moveTo",
      value: function value(t) {
        if (void 0 !== t) {
          if (null != t.offset) {
            if (null != t.offset.x) {
              if (t.offset.x = +t.offset.x, !g_(t.offset.x)) throw new TypeError('The option "offset.x" has to be a finite number.');
            } else t.offset.x = 0;
            if (null != t.offset.y) {
              if (t.offset.y = +t.offset.y, !g_(t.offset.y)) throw new TypeError('The option "offset.y" has to be a finite number.');
            } else t.offset.x = 0;
          } else t.offset = {
            x: 0,
            y: 0
          };
          if (null != t.position) {
            if (null != t.position.x) {
              if (t.position.x = +t.position.x, !g_(t.position.x)) throw new TypeError('The option "position.x" has to be a finite number.');
            } else t.position.x = 0;
            if (null != t.position.y) {
              if (t.position.y = +t.position.y, !g_(t.position.y)) throw new TypeError('The option "position.y" has to be a finite number.');
            } else t.position.x = 0;
          } else t.position = this.getViewPosition();
          if (null != t.scale) {
            if (t.scale = +t.scale, !(t.scale > 0)) throw new TypeError('The option "scale" has to be a number greater than zero.');
          } else t.scale = this.body.view.scale;
          void 0 === t.animation && (t.animation = {
            duration: 0
          }), !1 === t.animation && (t.animation = {
            duration: 0
          }), !0 === t.animation && (t.animation = {}), void 0 === t.animation.duration && (t.animation.duration = 1e3), void 0 === t.animation.easingFunction && (t.animation.easingFunction = "easeInOutQuad"), this.animateView(t);
        } else t = {};
      }
    }, {
      key: "animateView",
      value: function value(t) {
        if (void 0 !== t) {
          this.animationEasingFunction = t.animation.easingFunction, this.releaseNode(), !0 === t.locked && (this.lockedOnNodeId = t.lockedOnNode, this.lockedOnNodeOffset = t.offset), 0 != this.easingTime && this._transitionRedraw(!0), this.sourceScale = this.body.view.scale, this.sourceTranslation = this.body.view.translation, this.targetScale = t.scale, this.body.view.scale = this.targetScale;
          var e,
            i,
            n = this.canvas.DOMtoCanvas({
              x: .5 * this.canvas.frame.canvas.clientWidth,
              y: .5 * this.canvas.frame.canvas.clientHeight
            }),
            o = n.x - t.position.x,
            r = n.y - t.position.y;
          if (this.targetTranslation = {
            x: this.sourceTranslation.x + o * this.targetScale + t.offset.x,
            y: this.sourceTranslation.y + r * this.targetScale + t.offset.y
          }, 0 === t.animation.duration) {
            if (null != this.lockedOnNodeId) this.viewFunction = Hn(e = this._lockedRedraw).call(e, this), this.body.emitter.on("initRedraw", this.viewFunction);else this.body.view.scale = this.targetScale, this.body.view.translation = this.targetTranslation, this.body.emitter.emit("_requestRedraw");
          } else this.animationSpeed = 1 / (60 * t.animation.duration * .001) || 1 / 60, this.animationEasingFunction = t.animation.easingFunction, this.viewFunction = Hn(i = this._transitionRedraw).call(i, this), this.body.emitter.on("initRedraw", this.viewFunction), this.body.emitter.emit("_startRendering");
        }
      }
    }, {
      key: "_lockedRedraw",
      value: function value() {
        var t = this.body.nodes[this.lockedOnNodeId].x,
          e = this.body.nodes[this.lockedOnNodeId].y,
          i = this.canvas.DOMtoCanvas({
            x: .5 * this.canvas.frame.canvas.clientWidth,
            y: .5 * this.canvas.frame.canvas.clientHeight
          }),
          n = i.x - t,
          o = i.y - e,
          r = this.body.view.translation,
          s = {
            x: r.x + n * this.body.view.scale + this.lockedOnNodeOffset.x,
            y: r.y + o * this.body.view.scale + this.lockedOnNodeOffset.y
          };
        this.body.view.translation = s;
      }
    }, {
      key: "releaseNode",
      value: function value() {
        void 0 !== this.lockedOnNodeId && void 0 !== this.viewFunction && (this.body.emitter.off("initRedraw", this.viewFunction), this.lockedOnNodeId = void 0, this.lockedOnNodeOffset = void 0);
      }
    }, {
      key: "_transitionRedraw",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.easingTime += this.animationSpeed, this.easingTime = !0 === t ? 1 : this.easingTime;
        var e = jb[this.animationEasingFunction](this.easingTime);
        if (this.body.view.scale = this.sourceScale + (this.targetScale - this.sourceScale) * e, this.body.view.translation = {
          x: this.sourceTranslation.x + (this.targetTranslation.x - this.sourceTranslation.x) * e,
          y: this.sourceTranslation.y + (this.targetTranslation.y - this.sourceTranslation.y) * e
        }, this.easingTime >= 1) {
          var i;
          if (this.body.emitter.off("initRedraw", this.viewFunction), this.easingTime = 0, null != this.lockedOnNodeId) this.viewFunction = Hn(i = this._lockedRedraw).call(i, this), this.body.emitter.on("initRedraw", this.viewFunction);
          this.body.emitter.emit("animationFinished");
        }
      }
    }, {
      key: "getScale",
      value: function value() {
        return this.body.view.scale;
      }
    }, {
      key: "getViewPosition",
      value: function value() {
        return this.canvas.DOMtoCanvas({
          x: .5 * this.canvas.frame.canvas.clientWidth,
          y: .5 * this.canvas.frame.canvas.clientHeight
        });
      }
    }]), t;
  }();
  function BI(t) {
    var e,
      i = t && t.preventDefault || !1,
      n = t && t.container || window,
      o = {},
      r = {
        keydown: {},
        keyup: {}
      },
      s = {};
    for (e = 97; e <= 122; e++) s[String.fromCharCode(e)] = {
      code: e - 97 + 65,
      shift: !1
    };
    for (e = 65; e <= 90; e++) s[String.fromCharCode(e)] = {
      code: e,
      shift: !0
    };
    for (e = 0; e <= 9; e++) s["" + e] = {
      code: 48 + e,
      shift: !1
    };
    for (e = 1; e <= 12; e++) s["F" + e] = {
      code: 111 + e,
      shift: !1
    };
    for (e = 0; e <= 9; e++) s["num" + e] = {
      code: 96 + e,
      shift: !1
    };
    s["num*"] = {
      code: 106,
      shift: !1
    }, s["num+"] = {
      code: 107,
      shift: !1
    }, s["num-"] = {
      code: 109,
      shift: !1
    }, s["num/"] = {
      code: 111,
      shift: !1
    }, s["num."] = {
      code: 110,
      shift: !1
    }, s.left = {
      code: 37,
      shift: !1
    }, s.up = {
      code: 38,
      shift: !1
    }, s.right = {
      code: 39,
      shift: !1
    }, s.down = {
      code: 40,
      shift: !1
    }, s.space = {
      code: 32,
      shift: !1
    }, s.enter = {
      code: 13,
      shift: !1
    }, s.shift = {
      code: 16,
      shift: void 0
    }, s.esc = {
      code: 27,
      shift: !1
    }, s.backspace = {
      code: 8,
      shift: !1
    }, s.tab = {
      code: 9,
      shift: !1
    }, s.ctrl = {
      code: 17,
      shift: !1
    }, s.alt = {
      code: 18,
      shift: !1
    }, s["delete"] = {
      code: 46,
      shift: !1
    }, s.pageup = {
      code: 33,
      shift: !1
    }, s.pagedown = {
      code: 34,
      shift: !1
    }, s["="] = {
      code: 187,
      shift: !1
    }, s["-"] = {
      code: 189,
      shift: !1
    }, s["]"] = {
      code: 221,
      shift: !1
    }, s["["] = {
      code: 219,
      shift: !1
    };
    var a = function a(t) {
        l(t, "keydown");
      },
      h = function h(t) {
        l(t, "keyup");
      },
      l = function l(t, e) {
        if (void 0 !== r[e][t.keyCode]) {
          for (var n = r[e][t.keyCode], o = 0; o < n.length; o++) (void 0 === n[o].shift || 1 == n[o].shift && 1 == t.shiftKey || 0 == n[o].shift && 0 == t.shiftKey) && n[o].fn(t);
          1 == i && t.preventDefault();
        }
      };
    return o.bind = function (t, e, i) {
      if (void 0 === i && (i = "keydown"), void 0 === s[t]) throw new Error("unsupported key: " + t);
      void 0 === r[i][s[t].code] && (r[i][s[t].code] = []), r[i][s[t].code].push({
        fn: e,
        shift: s[t].shift
      });
    }, o.bindAll = function (t, e) {
      for (var i in void 0 === e && (e = "keydown"), s) s.hasOwnProperty(i) && o.bind(i, t, e);
    }, o.getKey = function (t) {
      for (var e in s) if (s.hasOwnProperty(e)) {
        if (1 == t.shiftKey && 1 == s[e].shift && t.keyCode == s[e].code) return e;
        if (0 == t.shiftKey && 0 == s[e].shift && t.keyCode == s[e].code) return e;
        if (t.keyCode == s[e].code && "shift" == e) return e;
      }
      return "unknown key, currently not supported";
    }, o.unbind = function (t, e, i) {
      if (void 0 === i && (i = "keydown"), void 0 === s[t]) throw new Error("unsupported key: " + t);
      if (void 0 !== e) {
        var n = [],
          o = r[i][s[t].code];
        if (void 0 !== o) for (var a = 0; a < o.length; a++) o[a].fn == e && o[a].shift == s[t].shift || n.push(r[i][s[t].code][a]);
        r[i][s[t].code] = n;
      } else r[i][s[t].code] = [];
    }, o.reset = function () {
      r = {
        keydown: {},
        keyup: {}
      };
    }, o.destroy = function () {
      r = {
        keydown: {},
        keyup: {}
      }, n.removeEventListener("keydown", a, !0), n.removeEventListener("keyup", h, !0);
    }, n.addEventListener("keydown", a, !0), n.addEventListener("keyup", h, !0), o;
  }
  var NI = Object.freeze({
      __proto__: null,
      "default": BI
    }),
    FI = function () {
      function t(e, i) {
        var n = this;
        ph(this, t), this.body = e, this.canvas = i, this.iconsCreated = !1, this.navigationHammers = [], this.boundFunctions = {}, this.touchTime = 0, this.activated = !1, this.body.emitter.on("activate", function () {
          n.activated = !0, n.configureKeyboardBindings();
        }), this.body.emitter.on("deactivate", function () {
          n.activated = !1, n.configureKeyboardBindings();
        }), this.body.emitter.on("destroy", function () {
          void 0 !== n.keycharm && n.keycharm.destroy();
        }), this.options = {};
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          void 0 !== t && (this.options = t, this.create());
        }
      }, {
        key: "create",
        value: function value() {
          !0 === this.options.navigationButtons ? !1 === this.iconsCreated && this.loadNavigationElements() : !0 === this.iconsCreated && this.cleanNavigation(), this.configureKeyboardBindings();
        }
      }, {
        key: "cleanNavigation",
        value: function value() {
          if (0 != this.navigationHammers.length) {
            for (var t = 0; t < this.navigationHammers.length; t++) this.navigationHammers[t].destroy();
            this.navigationHammers = [];
          }
          this.navigationDOM && this.navigationDOM.wrapper && this.navigationDOM.wrapper.parentNode && this.navigationDOM.wrapper.parentNode.removeChild(this.navigationDOM.wrapper), this.iconsCreated = !1;
        }
      }, {
        key: "loadNavigationElements",
        value: function value() {
          var t = this;
          this.cleanNavigation(), this.navigationDOM = {};
          var e = ["up", "down", "left", "right", "zoomIn", "zoomOut", "zoomExtends"],
            i = ["_moveUp", "_moveDown", "_moveLeft", "_moveRight", "_zoomIn", "_zoomOut", "_fit"];
          this.navigationDOM.wrapper = document.createElement("div"), this.navigationDOM.wrapper.className = "vis-navigation", this.canvas.frame.appendChild(this.navigationDOM.wrapper);
          for (var n = 0; n < e.length; n++) {
            this.navigationDOM[e[n]] = document.createElement("div"), this.navigationDOM[e[n]].className = "vis-button vis-" + e[n], this.navigationDOM.wrapper.appendChild(this.navigationDOM[e[n]]);
            var o,
              r,
              s = new Qb(this.navigationDOM[e[n]]);
            if ("_fit" === i[n]) MI(s, Hn(o = this._fit).call(o, this));else MI(s, Hn(r = this.bindToRedraw).call(r, this, i[n]));
            this.navigationHammers.push(s);
          }
          var a = new Qb(this.canvas.frame);
          PI(a, function () {
            t._stopMovement();
          }), this.navigationHammers.push(a), this.iconsCreated = !0;
        }
      }, {
        key: "bindToRedraw",
        value: function value(t) {
          var e;
          void 0 === this.boundFunctions[t] && (this.boundFunctions[t] = Hn(e = this[t]).call(e, this), this.body.emitter.on("initRedraw", this.boundFunctions[t]), this.body.emitter.emit("_startRendering"));
        }
      }, {
        key: "unbindFromRedraw",
        value: function value(t) {
          void 0 !== this.boundFunctions[t] && (this.body.emitter.off("initRedraw", this.boundFunctions[t]), this.body.emitter.emit("_stopRendering"), delete this.boundFunctions[t]);
        }
      }, {
        key: "_fit",
        value: function value() {
          new Date().valueOf() - this.touchTime > 700 && (this.body.emitter.emit("fit", {
            duration: 700
          }), this.touchTime = new Date().valueOf());
        }
      }, {
        key: "_stopMovement",
        value: function value() {
          for (var t in this.boundFunctions) Object.prototype.hasOwnProperty.call(this.boundFunctions, t) && (this.body.emitter.off("initRedraw", this.boundFunctions[t]), this.body.emitter.emit("_stopRendering"));
          this.boundFunctions = {};
        }
      }, {
        key: "_moveUp",
        value: function value() {
          this.body.view.translation.y += this.options.keyboard.speed.y;
        }
      }, {
        key: "_moveDown",
        value: function value() {
          this.body.view.translation.y -= this.options.keyboard.speed.y;
        }
      }, {
        key: "_moveLeft",
        value: function value() {
          this.body.view.translation.x += this.options.keyboard.speed.x;
        }
      }, {
        key: "_moveRight",
        value: function value() {
          this.body.view.translation.x -= this.options.keyboard.speed.x;
        }
      }, {
        key: "_zoomIn",
        value: function value() {
          var t = this.body.view.scale,
            e = this.body.view.scale * (1 + this.options.keyboard.speed.zoom),
            i = this.body.view.translation,
            n = e / t,
            o = (1 - n) * this.canvas.canvasViewCenter.x + i.x * n,
            r = (1 - n) * this.canvas.canvasViewCenter.y + i.y * n;
          this.body.view.scale = e, this.body.view.translation = {
            x: o,
            y: r
          }, this.body.emitter.emit("zoom", {
            direction: "+",
            scale: this.body.view.scale,
            pointer: null
          });
        }
      }, {
        key: "_zoomOut",
        value: function value() {
          var t = this.body.view.scale,
            e = this.body.view.scale / (1 + this.options.keyboard.speed.zoom),
            i = this.body.view.translation,
            n = e / t,
            o = (1 - n) * this.canvas.canvasViewCenter.x + i.x * n,
            r = (1 - n) * this.canvas.canvasViewCenter.y + i.y * n;
          this.body.view.scale = e, this.body.view.translation = {
            x: o,
            y: r
          }, this.body.emitter.emit("zoom", {
            direction: "-",
            scale: this.body.view.scale,
            pointer: null
          });
        }
      }, {
        key: "configureKeyboardBindings",
        value: function value() {
          var t,
            e,
            i,
            n,
            o,
            r,
            s,
            a,
            h,
            l,
            d,
            c,
            u,
            f,
            p,
            v,
            g,
            y,
            m,
            b,
            w,
            k,
            _,
            x,
            E = this;
          (void 0 !== this.keycharm && this.keycharm.destroy(), !0 === this.options.keyboard.enabled) && (!0 === this.options.keyboard.bindToWindow ? this.keycharm = BI({
            container: window,
            preventDefault: !0
          }) : this.keycharm = BI({
            container: this.canvas.frame,
            preventDefault: !0
          }), this.keycharm.reset(), !0 === this.activated && (Hn(t = this.keycharm).call(t, "up", function () {
            E.bindToRedraw("_moveUp");
          }, "keydown"), Hn(e = this.keycharm).call(e, "down", function () {
            E.bindToRedraw("_moveDown");
          }, "keydown"), Hn(i = this.keycharm).call(i, "left", function () {
            E.bindToRedraw("_moveLeft");
          }, "keydown"), Hn(n = this.keycharm).call(n, "right", function () {
            E.bindToRedraw("_moveRight");
          }, "keydown"), Hn(o = this.keycharm).call(o, "=", function () {
            E.bindToRedraw("_zoomIn");
          }, "keydown"), Hn(r = this.keycharm).call(r, "num+", function () {
            E.bindToRedraw("_zoomIn");
          }, "keydown"), Hn(s = this.keycharm).call(s, "num-", function () {
            E.bindToRedraw("_zoomOut");
          }, "keydown"), Hn(a = this.keycharm).call(a, "-", function () {
            E.bindToRedraw("_zoomOut");
          }, "keydown"), Hn(h = this.keycharm).call(h, "[", function () {
            E.bindToRedraw("_zoomOut");
          }, "keydown"), Hn(l = this.keycharm).call(l, "]", function () {
            E.bindToRedraw("_zoomIn");
          }, "keydown"), Hn(d = this.keycharm).call(d, "pageup", function () {
            E.bindToRedraw("_zoomIn");
          }, "keydown"), Hn(c = this.keycharm).call(c, "pagedown", function () {
            E.bindToRedraw("_zoomOut");
          }, "keydown"), Hn(u = this.keycharm).call(u, "up", function () {
            E.unbindFromRedraw("_moveUp");
          }, "keyup"), Hn(f = this.keycharm).call(f, "down", function () {
            E.unbindFromRedraw("_moveDown");
          }, "keyup"), Hn(p = this.keycharm).call(p, "left", function () {
            E.unbindFromRedraw("_moveLeft");
          }, "keyup"), Hn(v = this.keycharm).call(v, "right", function () {
            E.unbindFromRedraw("_moveRight");
          }, "keyup"), Hn(g = this.keycharm).call(g, "=", function () {
            E.unbindFromRedraw("_zoomIn");
          }, "keyup"), Hn(y = this.keycharm).call(y, "num+", function () {
            E.unbindFromRedraw("_zoomIn");
          }, "keyup"), Hn(m = this.keycharm).call(m, "num-", function () {
            E.unbindFromRedraw("_zoomOut");
          }, "keyup"), Hn(b = this.keycharm).call(b, "-", function () {
            E.unbindFromRedraw("_zoomOut");
          }, "keyup"), Hn(w = this.keycharm).call(w, "[", function () {
            E.unbindFromRedraw("_zoomOut");
          }, "keyup"), Hn(k = this.keycharm).call(k, "]", function () {
            E.unbindFromRedraw("_zoomIn");
          }, "keyup"), Hn(_ = this.keycharm).call(_, "pageup", function () {
            E.unbindFromRedraw("_zoomIn");
          }, "keyup"), Hn(x = this.keycharm).call(x, "pagedown", function () {
            E.unbindFromRedraw("_zoomOut");
          }, "keyup")));
        }
      }]), t;
    }();
  function zI(t, e) {
    var i = void 0 !== gf && fh(t) || t["@@iterator"];
    if (!i) {
      if (Df(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return AI(t, e);
        var n = xf(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Ya(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AI(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);
        var _n5 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n5 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n5++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r,
      s = !0,
      a = !1;
    return {
      s: function s() {
        i = i.call(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i["return"] || i["return"]();
        } finally {
          if (a) throw r;
        }
      }
    };
  }
  function AI(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
    return n;
  }
  var jI = function () {
      function t(e, i, n) {
        var o, r, s, a, h, l, d, c, u, f, p, v, g;
        ph(this, t), this.body = e, this.canvas = i, this.selectionHandler = n, this.navigationHandler = new FI(e, i), this.body.eventListeners.onTap = Hn(o = this.onTap).call(o, this), this.body.eventListeners.onTouch = Hn(r = this.onTouch).call(r, this), this.body.eventListeners.onDoubleTap = Hn(s = this.onDoubleTap).call(s, this), this.body.eventListeners.onHold = Hn(a = this.onHold).call(a, this), this.body.eventListeners.onDragStart = Hn(h = this.onDragStart).call(h, this), this.body.eventListeners.onDrag = Hn(l = this.onDrag).call(l, this), this.body.eventListeners.onDragEnd = Hn(d = this.onDragEnd).call(d, this), this.body.eventListeners.onMouseWheel = Hn(c = this.onMouseWheel).call(c, this), this.body.eventListeners.onPinch = Hn(u = this.onPinch).call(u, this), this.body.eventListeners.onMouseMove = Hn(f = this.onMouseMove).call(f, this), this.body.eventListeners.onRelease = Hn(p = this.onRelease).call(p, this), this.body.eventListeners.onContext = Hn(v = this.onContext).call(v, this), this.touchTime = 0, this.drag = {}, this.pinch = {}, this.popup = void 0, this.popupObj = void 0, this.popupTimer = void 0, this.body.functions.getPointer = Hn(g = this.getPointer).call(g, this), this.options = {}, this.defaultOptions = {
          dragNodes: !0,
          dragView: !0,
          hover: !1,
          keyboard: {
            enabled: !1,
            speed: {
              x: 10,
              y: 10,
              zoom: .02
            },
            bindToWindow: !0,
            autoFocus: !0
          },
          navigationButtons: !1,
          tooltipDelay: 300,
          zoomView: !0,
          zoomSpeed: 1
        }, bn(this.options, this.defaultOptions), this.bindEventListeners();
      }
      return xu(t, [{
        key: "bindEventListeners",
        value: function value() {
          var t = this;
          this.body.emitter.on("destroy", function () {
            clearTimeout(t.popupTimer), delete t.body.functions.getPointer;
          });
        }
      }, {
        key: "setOptions",
        value: function value(t) {
          if (void 0 !== t) {
            vb(["hideEdgesOnDrag", "hideEdgesOnZoom", "hideNodesOnDrag", "keyboard", "multiselect", "selectable", "selectConnectedEdges"], this.options, t), Ab(this.options, t, "keyboard"), t.tooltip && (bn(this.options.tooltip, t.tooltip), t.tooltip.color && (this.options.tooltip.color = Sb(t.tooltip.color)));
          }
          this.navigationHandler.setOptions(this.options);
        }
      }, {
        key: "getPointer",
        value: function value(t) {
          return {
            x: t.x - bb(this.canvas.frame.canvas),
            y: t.y - wb(this.canvas.frame.canvas)
          };
        }
      }, {
        key: "onTouch",
        value: function value(t) {
          new Date().valueOf() - this.touchTime > 50 && (this.drag.pointer = this.getPointer(t.center), this.drag.pinched = !1, this.pinch.scale = this.body.view.scale, this.touchTime = new Date().valueOf());
        }
      }, {
        key: "onTap",
        value: function value(t) {
          var e = this.getPointer(t.center),
            i = this.selectionHandler.options.multiselect && (t.changedPointers[0].ctrlKey || t.changedPointers[0].metaKey);
          this.checkSelectionChanges(e, i), this.selectionHandler.commitAndEmit(e, t), this.selectionHandler.generateClickEvent("click", t, e);
        }
      }, {
        key: "onDoubleTap",
        value: function value(t) {
          var e = this.getPointer(t.center);
          this.selectionHandler.generateClickEvent("doubleClick", t, e);
        }
      }, {
        key: "onHold",
        value: function value(t) {
          var e = this.getPointer(t.center),
            i = this.selectionHandler.options.multiselect;
          this.checkSelectionChanges(e, i), this.selectionHandler.commitAndEmit(e, t), this.selectionHandler.generateClickEvent("click", t, e), this.selectionHandler.generateClickEvent("hold", t, e);
        }
      }, {
        key: "onRelease",
        value: function value(t) {
          if (new Date().valueOf() - this.touchTime > 10) {
            var e = this.getPointer(t.center);
            this.selectionHandler.generateClickEvent("release", t, e), this.touchTime = new Date().valueOf();
          }
        }
      }, {
        key: "onContext",
        value: function value(t) {
          var e = this.getPointer({
            x: t.clientX,
            y: t.clientY
          });
          this.selectionHandler.generateClickEvent("oncontext", t, e);
        }
      }, {
        key: "checkSelectionChanges",
        value: function value(t) {
          !0 === (arguments.length > 1 && void 0 !== arguments[1] && arguments[1]) ? this.selectionHandler.selectAdditionalOnPoint(t) : this.selectionHandler.selectOnPoint(t);
        }
      }, {
        key: "_determineDifference",
        value: function value(t, e) {
          var i = function i(t, e) {
            for (var i = [], n = 0; n < t.length; n++) {
              var o = t[n];
              -1 === lg(e).call(e, o) && i.push(o);
            }
            return i;
          };
          return {
            nodes: i(t.nodes, e.nodes),
            edges: i(t.edges, e.edges)
          };
        }
      }, {
        key: "onDragStart",
        value: function value(t) {
          if (!this.drag.dragging) {
            void 0 === this.drag.pointer && this.onTouch(t);
            var e = this.selectionHandler.getNodeAt(this.drag.pointer);
            if (this.drag.dragging = !0, this.drag.selection = [], this.drag.translation = bn({}, this.body.view.translation), this.drag.nodeId = void 0, t.srcEvent.shiftKey) {
              this.body.selectionBox.show = !0;
              var i = this.getPointer(t.center);
              this.body.selectionBox.position.start = {
                x: this.canvas._XconvertDOMtoCanvas(i.x),
                y: this.canvas._YconvertDOMtoCanvas(i.y)
              }, this.body.selectionBox.position.end = {
                x: this.canvas._XconvertDOMtoCanvas(i.x),
                y: this.canvas._YconvertDOMtoCanvas(i.y)
              };
            } else if (void 0 !== e && !0 === this.options.dragNodes) {
              this.drag.nodeId = e.id, !1 === e.isSelected() && this.selectionHandler.setSelection({
                nodes: [e.id]
              }), this.selectionHandler.generateClickEvent("dragStart", t, this.drag.pointer);
              var n,
                o = zI(this.selectionHandler.getSelectedNodes());
              try {
                for (o.s(); !(n = o.n()).done;) {
                  var r = n.value,
                    s = {
                      id: r.id,
                      node: r,
                      x: r.x,
                      y: r.y,
                      xFixed: r.options.fixed.x,
                      yFixed: r.options.fixed.y
                    };
                  r.options.fixed.x = !0, r.options.fixed.y = !0, this.drag.selection.push(s);
                }
              } catch (t) {
                o.e(t);
              } finally {
                o.f();
              }
            } else this.selectionHandler.generateClickEvent("dragStart", t, this.drag.pointer, void 0, !0);
          }
        }
      }, {
        key: "onDrag",
        value: function value(t) {
          var e = this;
          if (!0 !== this.drag.pinched) {
            this.body.emitter.emit("unlockNode");
            var i = this.getPointer(t.center),
              n = this.drag.selection;
            if (n && n.length && !0 === this.options.dragNodes) {
              this.selectionHandler.generateClickEvent("dragging", t, i);
              var o = i.x - this.drag.pointer.x,
                r = i.y - this.drag.pointer.y;
              op(n).call(n, function (t) {
                var i = t.node;
                !1 === t.xFixed && (i.x = e.canvas._XconvertDOMtoCanvas(e.canvas._XconvertCanvasToDOM(t.x) + o)), !1 === t.yFixed && (i.y = e.canvas._YconvertDOMtoCanvas(e.canvas._YconvertCanvasToDOM(t.y) + r));
              }), this.body.emitter.emit("startSimulation");
            } else {
              if (t.srcEvent.shiftKey) {
                if (this.selectionHandler.generateClickEvent("dragging", t, i, void 0, !0), void 0 === this.drag.pointer) return void this.onDragStart(t);
                this.body.selectionBox.position.end = {
                  x: this.canvas._XconvertDOMtoCanvas(i.x),
                  y: this.canvas._YconvertDOMtoCanvas(i.y)
                }, this.body.emitter.emit("_requestRedraw");
              }
              if (!0 === this.options.dragView && !t.srcEvent.shiftKey) {
                if (this.selectionHandler.generateClickEvent("dragging", t, i, void 0, !0), void 0 === this.drag.pointer) return void this.onDragStart(t);
                var s = i.x - this.drag.pointer.x,
                  a = i.y - this.drag.pointer.y;
                this.body.view.translation = {
                  x: this.drag.translation.x + s,
                  y: this.drag.translation.y + a
                }, this.body.emitter.emit("_requestRedraw");
              }
            }
          }
        }
      }, {
        key: "onDragEnd",
        value: function value(t) {
          var e = this;
          if (this.drag.dragging = !1, this.body.selectionBox.show) {
            var i;
            this.body.selectionBox.show = !1;
            var n = this.body.selectionBox.position,
              o = {
                minX: Math.min(n.start.x, n.end.x),
                minY: Math.min(n.start.y, n.end.y),
                maxX: Math.max(n.start.x, n.end.x),
                maxY: Math.max(n.start.y, n.end.y)
              },
              r = yv(i = this.body.nodeIndices).call(i, function (t) {
                var i = e.body.nodes[t];
                return i.x >= o.minX && i.x <= o.maxX && i.y >= o.minY && i.y <= o.maxY;
              });
            op(r).call(r, function (t) {
              return e.selectionHandler.selectObject(e.body.nodes[t]);
            });
            var s = this.getPointer(t.center);
            this.selectionHandler.commitAndEmit(s, t), this.selectionHandler.generateClickEvent("dragEnd", t, this.getPointer(t.center), void 0, !0), this.body.emitter.emit("_requestRedraw");
          } else {
            var a = this.drag.selection;
            a && a.length ? (op(a).call(a, function (t) {
              t.node.options.fixed.x = t.xFixed, t.node.options.fixed.y = t.yFixed;
            }), this.selectionHandler.generateClickEvent("dragEnd", t, this.getPointer(t.center)), this.body.emitter.emit("startSimulation")) : (this.selectionHandler.generateClickEvent("dragEnd", t, this.getPointer(t.center), void 0, !0), this.body.emitter.emit("_requestRedraw"));
          }
        }
      }, {
        key: "onPinch",
        value: function value(t) {
          var e = this.getPointer(t.center);
          this.drag.pinched = !0, void 0 === this.pinch.scale && (this.pinch.scale = 1);
          var i = this.pinch.scale * t.scale;
          this.zoom(i, e);
        }
      }, {
        key: "zoom",
        value: function value(t, e) {
          if (!0 === this.options.zoomView) {
            var i = this.body.view.scale;
            t < 1e-5 && (t = 1e-5), t > 10 && (t = 10);
            var n = void 0;
            void 0 !== this.drag && !0 === this.drag.dragging && (n = this.canvas.DOMtoCanvas(this.drag.pointer));
            var o = this.body.view.translation,
              r = t / i,
              s = (1 - r) * e.x + o.x * r,
              a = (1 - r) * e.y + o.y * r;
            if (this.body.view.scale = t, this.body.view.translation = {
              x: s,
              y: a
            }, null != n) {
              var h = this.canvas.canvasToDOM(n);
              this.drag.pointer.x = h.x, this.drag.pointer.y = h.y;
            }
            this.body.emitter.emit("_requestRedraw"), i < t ? this.body.emitter.emit("zoom", {
              direction: "+",
              scale: this.body.view.scale,
              pointer: e
            }) : this.body.emitter.emit("zoom", {
              direction: "-",
              scale: this.body.view.scale,
              pointer: e
            });
          }
        }
      }, {
        key: "onMouseWheel",
        value: function value(t) {
          if (!0 === this.options.zoomView) {
            if (0 !== t.deltaY) {
              var e = this.body.view.scale;
              e *= 1 + (t.deltaY < 0 ? 1 : -1) * (.1 * this.options.zoomSpeed);
              var i = this.getPointer({
                x: t.clientX,
                y: t.clientY
              });
              this.zoom(e, i);
            }
            t.preventDefault();
          }
        }
      }, {
        key: "onMouseMove",
        value: function value(t) {
          var e = this,
            i = this.getPointer({
              x: t.clientX,
              y: t.clientY
            }),
            n = !1;
          void 0 !== this.popup && (!1 === this.popup.hidden && this._checkHidePopup(i), !1 === this.popup.hidden && (n = !0, this.popup.setPosition(i.x + 3, i.y - 5), this.popup.show())), this.options.keyboard.autoFocus && !1 === this.options.keyboard.bindToWindow && !0 === this.options.keyboard.enabled && this.canvas.frame.focus(), !1 === n && (void 0 !== this.popupTimer && (clearInterval(this.popupTimer), this.popupTimer = void 0), this.drag.dragging || (this.popupTimer = jg(function () {
            return e._checkShowPopup(i);
          }, this.options.tooltipDelay))), !0 === this.options.hover && this.selectionHandler.hoverObject(t, i);
        }
      }, {
        key: "_checkShowPopup",
        value: function value(t) {
          var e = this.canvas._XconvertDOMtoCanvas(t.x),
            i = this.canvas._YconvertDOMtoCanvas(t.y),
            n = {
              left: e,
              top: i,
              right: e,
              bottom: i
            },
            o = void 0 === this.popupObj ? void 0 : this.popupObj.id,
            r = !1,
            s = "node";
          if (void 0 === this.popupObj) {
            for (var a, h = this.body.nodeIndices, l = this.body.nodes, d = [], c = 0; c < h.length; c++) !0 === (a = l[h[c]]).isOverlappingWith(n) && (r = !0, void 0 !== a.getTitle() && d.push(h[c]));
            d.length > 0 && (this.popupObj = l[d[d.length - 1]], r = !0);
          }
          if (void 0 === this.popupObj && !1 === r) {
            for (var u, f = this.body.edgeIndices, p = this.body.edges, v = [], g = 0; g < f.length; g++) !0 === (u = p[f[g]]).isOverlappingWith(n) && !0 === u.connected && void 0 !== u.getTitle() && v.push(f[g]);
            v.length > 0 && (this.popupObj = p[v[v.length - 1]], s = "edge");
          }
          void 0 !== this.popupObj ? this.popupObj.id !== o && (void 0 === this.popup && (this.popup = new Jb(this.canvas.frame)), this.popup.popupTargetType = s, this.popup.popupTargetId = this.popupObj.id, this.popup.setPosition(t.x + 3, t.y - 5), this.popup.setText(this.popupObj.getTitle()), this.popup.show(), this.body.emitter.emit("showPopup", this.popupObj.id)) : void 0 !== this.popup && (this.popup.hide(), this.body.emitter.emit("hidePopup"));
        }
      }, {
        key: "_checkHidePopup",
        value: function value(t) {
          var e = this.selectionHandler._pointerToPositionObject(t),
            i = !1;
          if ("node" === this.popup.popupTargetType) {
            if (void 0 !== this.body.nodes[this.popup.popupTargetId] && !0 === (i = this.body.nodes[this.popup.popupTargetId].isOverlappingWith(e))) {
              var n = this.selectionHandler.getNodeAt(t);
              i = void 0 !== n && n.id === this.popup.popupTargetId;
            }
          } else void 0 === this.selectionHandler.getNodeAt(t) && void 0 !== this.body.edges[this.popup.popupTargetId] && (i = this.body.edges[this.popup.popupTargetId].isOverlappingWith(e));
          !1 === i && (this.popupObj = void 0, this.popup.hide(), this.body.emitter.emit("hidePopup"));
        }
      }]), t;
    }(),
    RI = g,
    LI = Vk,
    HI = hk.getWeakData,
    WI = Ok,
    qI = ii,
    VI = U,
    UI = tt,
    YI = _k,
    XI = Qt,
    GI = Lo.set,
    KI = Lo.getterFor,
    $I = Fl.find,
    ZI = Fl.findIndex,
    QI = RI([].splice),
    JI = 0,
    tB = function tB(t) {
      return t.frozen || (t.frozen = new eB());
    },
    eB = function eB() {
      this.entries = [];
    },
    iB = function iB(t, e) {
      return $I(t.entries, function (t) {
        return t[0] === e;
      });
    };
  eB.prototype = {
    get: function get(t) {
      var e = iB(this, t);
      if (e) return e[1];
    },
    has: function has(t) {
      return !!iB(this, t);
    },
    set: function set(t, e) {
      var i = iB(this, t);
      i ? i[1] = e : this.entries.push([t, e]);
    },
    "delete": function _delete(t) {
      var e = ZI(this.entries, function (e) {
        return e[0] === t;
      });
      return ~e && QI(this.entries, e, 1), !!~e;
    }
  };
  var nB,
    oB = {
      getConstructor: function getConstructor(t, e, i, n) {
        var o = t(function (t, o) {
            WI(t, r), GI(t, {
              type: e,
              id: JI++,
              frozen: void 0
            }), VI(o) || YI(o, t[n], {
              that: t,
              AS_ENTRIES: i
            });
          }),
          r = o.prototype,
          s = KI(e),
          a = function a(t, e, i) {
            var n = s(t),
              o = HI(qI(e), !0);
            return !0 === o ? tB(n).set(e, i) : o[n.id] = i, t;
          };
        return LI(r, {
          "delete": function _delete(t) {
            var e = s(this);
            if (!UI(t)) return !1;
            var i = HI(t);
            return !0 === i ? tB(e)["delete"](t) : i && XI(i, e.id) && delete i[e.id];
          },
          has: function has(t) {
            var e = s(this);
            if (!UI(t)) return !1;
            var i = HI(t);
            return !0 === i ? tB(e).has(t) : i && XI(i, e.id);
          }
        }), LI(r, i ? {
          get: function get(t) {
            var e = s(this);
            if (UI(t)) {
              var i = HI(t);
              return !0 === i ? tB(e).get(t) : i ? i[e.id] : void 0;
            }
          },
          set: function set(t, e) {
            return a(this, t, e);
          }
        } : {
          add: function add(t) {
            return a(this, t, !0);
          }
        }), o;
      }
    },
    rB = Yw,
    sB = o,
    aB = g,
    hB = Vk,
    lB = hk,
    dB = Wk,
    cB = oB,
    uB = tt,
    fB = Lo.enforce,
    pB = r,
    vB = xo,
    gB = Object,
    yB = Array.isArray,
    mB = gB.isExtensible,
    bB = gB.isFrozen,
    wB = gB.isSealed,
    kB = gB.freeze,
    _B = gB.seal,
    xB = {},
    EB = {},
    OB = !sB.ActiveXObject && "ActiveXObject" in sB,
    CB = function CB(t) {
      return function () {
        return t(this, arguments.length ? arguments[0] : void 0);
      };
    },
    SB = dB("WeakMap", CB, cB),
    TB = SB.prototype,
    MB = aB(TB.set);
  if (vB) if (OB) {
    nB = cB.getConstructor(CB, "WeakMap", !0), lB.enable();
    var PB = aB(TB["delete"]),
      DB = aB(TB.has),
      IB = aB(TB.get);
    hB(TB, {
      "delete": function _delete(t) {
        if (uB(t) && !mB(t)) {
          var e = fB(this);
          return e.frozen || (e.frozen = new nB()), PB(this, t) || e.frozen["delete"](t);
        }
        return PB(this, t);
      },
      has: function has(t) {
        if (uB(t) && !mB(t)) {
          var e = fB(this);
          return e.frozen || (e.frozen = new nB()), DB(this, t) || e.frozen.has(t);
        }
        return DB(this, t);
      },
      get: function get(t) {
        if (uB(t) && !mB(t)) {
          var e = fB(this);
          return e.frozen || (e.frozen = new nB()), DB(this, t) ? IB(this, t) : e.frozen.get(t);
        }
        return IB(this, t);
      },
      set: function set(t, e) {
        if (uB(t) && !mB(t)) {
          var i = fB(this);
          i.frozen || (i.frozen = new nB()), DB(this, t) ? MB(this, t, e) : i.frozen.set(t, e);
        } else MB(this, t, e);
        return this;
      }
    });
  } else rB && pB(function () {
    var t = kB([]);
    return MB(new SB(), t, 1), !bB(t);
  }) && hB(TB, {
    set: function set(t, e) {
      var i;
      return yB(t) && (bB(t) ? i = xB : wB(t) && (i = EB)), MB(this, t, e), i === xB && kB(t), i === EB && _B(t), this;
    }
  });
  var BB,
    NB,
    FB,
    zB,
    AB,
    jB = i(et.WeakMap);
  function RB(t, e, i, n) {
    if ("a" === i && !n) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof e ? t !== e || !n : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === i ? n : "a" === i ? n.call(t) : n ? n.value : e.get(t);
  }
  function LB(t, e, i, n, o) {
    if ("m" === n) throw new TypeError("Private method is not writable");
    if ("a" === n && !o) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof e ? t !== e || !o : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === n ? o.call(t, i) : o ? o.value = i : e.set(t, i), i;
  }
  function HB(t, e) {
    var i = void 0 !== gf && fh(t) || t["@@iterator"];
    if (!i) {
      if (Df(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return WB(t, e);
        var n = xf(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Ya(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return WB(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);
        var _n6 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n6 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n6++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r,
      s = !0,
      a = !1;
    return {
      s: function s() {
        i = i.call(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i["return"] || i["return"]();
        } finally {
          if (a) throw r;
        }
      }
    };
  }
  function WB(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
    return n;
  }
  function qB(t, e) {
    var i,
      n = new DS(),
      o = HB(e);
    try {
      for (o.s(); !(i = o.n()).done;) {
        var r = i.value;
        t.has(r) || n.add(r);
      }
    } catch (t) {
      o.e(t);
    } finally {
      o.f();
    }
    return n;
  }
  "function" == typeof SuppressedError && SuppressedError;
  var VB = function () {
    function t() {
      ph(this, t), BB.set(this, new DS()), NB.set(this, new DS());
    }
    return xu(t, [{
      key: "size",
      get: function get() {
        return RB(this, NB, "f").size;
      }
    }, {
      key: "add",
      value: function value() {
        for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
        for (var n = 0, o = e; n < o.length; n++) {
          var r = o[n];
          RB(this, NB, "f").add(r);
        }
      }
    }, {
      key: "delete",
      value: function value() {
        for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
        for (var n = 0, o = e; n < o.length; n++) {
          var r = o[n];
          RB(this, NB, "f")["delete"](r);
        }
      }
    }, {
      key: "clear",
      value: function value() {
        RB(this, NB, "f").clear();
      }
    }, {
      key: "getSelection",
      value: function value() {
        return vf(RB(this, NB, "f"));
      }
    }, {
      key: "getChanges",
      value: function value() {
        return {
          added: vf(qB(RB(this, BB, "f"), RB(this, NB, "f"))),
          deleted: vf(qB(RB(this, NB, "f"), RB(this, BB, "f"))),
          previous: vf(new DS(RB(this, BB, "f"))),
          current: vf(new DS(RB(this, NB, "f")))
        };
      }
    }, {
      key: "commit",
      value: function value() {
        var t = this.getChanges();
        LB(this, BB, RB(this, NB, "f"), "f"), LB(this, NB, new DS(RB(this, BB, "f")), "f");
        var e,
          i = HB(t.added);
        try {
          for (i.s(); !(e = i.n()).done;) {
            e.value.select();
          }
        } catch (t) {
          i.e(t);
        } finally {
          i.f();
        }
        var n,
          o = HB(t.deleted);
        try {
          for (o.s(); !(n = o.n()).done;) {
            n.value.unselect();
          }
        } catch (t) {
          o.e(t);
        } finally {
          o.f();
        }
        return t;
      }
    }]), t;
  }();
  BB = new jB(), NB = new jB();
  var UB = function () {
    function t() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function () {};
      ph(this, t), FB.set(this, new VB()), zB.set(this, new VB()), AB.set(this, void 0), LB(this, AB, e, "f");
    }
    return xu(t, [{
      key: "sizeNodes",
      get: function get() {
        return RB(this, FB, "f").size;
      }
    }, {
      key: "sizeEdges",
      get: function get() {
        return RB(this, zB, "f").size;
      }
    }, {
      key: "getNodes",
      value: function value() {
        return RB(this, FB, "f").getSelection();
      }
    }, {
      key: "getEdges",
      value: function value() {
        return RB(this, zB, "f").getSelection();
      }
    }, {
      key: "addNodes",
      value: function value() {
        var t;
        (t = RB(this, FB, "f")).add.apply(t, arguments);
      }
    }, {
      key: "addEdges",
      value: function value() {
        var t;
        (t = RB(this, zB, "f")).add.apply(t, arguments);
      }
    }, {
      key: "deleteNodes",
      value: function value(t) {
        RB(this, FB, "f")["delete"](t);
      }
    }, {
      key: "deleteEdges",
      value: function value(t) {
        RB(this, zB, "f")["delete"](t);
      }
    }, {
      key: "clear",
      value: function value() {
        RB(this, FB, "f").clear(), RB(this, zB, "f").clear();
      }
    }, {
      key: "commit",
      value: function value() {
        for (var t, e, i = {
            nodes: RB(this, FB, "f").commit(),
            edges: RB(this, zB, "f").commit()
          }, n = arguments.length, o = new Array(n), r = 0; r < n; r++) o[r] = arguments[r];
        return (t = RB(this, AB, "f")).call.apply(t, _f(e = [this, i]).call(e, o)), i;
      }
    }]), t;
  }();
  function YB(t, e) {
    var i = void 0 !== gf && fh(t) || t["@@iterator"];
    if (!i) {
      if (Df(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return XB(t, e);
        var n = xf(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Ya(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return XB(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);
        var _n7 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n7 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n7++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r,
      s = !0,
      a = !1;
    return {
      s: function s() {
        i = i.call(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i["return"] || i["return"]();
        } finally {
          if (a) throw r;
        }
      }
    };
  }
  function XB(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
    return n;
  }
  FB = new jB(), zB = new jB(), AB = new jB();
  var GB = function () {
    function t(e, i) {
      var n = this;
      ph(this, t), this.body = e, this.canvas = i, this._selectionAccumulator = new UB(), this.hoverObj = {
        nodes: {},
        edges: {}
      }, this.options = {}, this.defaultOptions = {
        multiselect: !1,
        selectable: !0,
        selectConnectedEdges: !0,
        hoverConnectedEdges: !0
      }, bn(this.options, this.defaultOptions), this.body.emitter.on("_dataChanged", function () {
        n.updateSelection();
      });
    }
    return xu(t, [{
      key: "setOptions",
      value: function value(t) {
        if (void 0 !== t) {
          pb(["multiselect", "hoverConnectedEdges", "selectable", "selectConnectedEdges"], this.options, t);
        }
      }
    }, {
      key: "selectOnPoint",
      value: function value(t) {
        var e = !1;
        if (!0 === this.options.selectable) {
          var i = this.getNodeAt(t) || this.getEdgeAt(t);
          this.unselectAll(), void 0 !== i && (e = this.selectObject(i)), this.body.emitter.emit("_requestRedraw");
        }
        return e;
      }
    }, {
      key: "selectAdditionalOnPoint",
      value: function value(t) {
        var e = !1;
        if (!0 === this.options.selectable) {
          var i = this.getNodeAt(t) || this.getEdgeAt(t);
          void 0 !== i && (e = !0, !0 === i.isSelected() ? this.deselectObject(i) : this.selectObject(i), this.body.emitter.emit("_requestRedraw"));
        }
        return e;
      }
    }, {
      key: "_initBaseEvent",
      value: function value(t, e) {
        var i = {};
        return i.pointer = {
          DOM: {
            x: e.x,
            y: e.y
          },
          canvas: this.canvas.DOMtoCanvas(e)
        }, i.event = t, i;
      }
    }, {
      key: "generateClickEvent",
      value: function value(t, e, i, n) {
        var o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
          r = this._initBaseEvent(e, i);
        if (!0 === o) r.nodes = [], r.edges = [];else {
          var s = this.getSelection();
          r.nodes = s.nodes, r.edges = s.edges;
        }
        void 0 !== n && (r.previousSelection = n), "click" == t && (r.items = this.getClickedItems(i)), void 0 !== e.controlEdge && (r.controlEdge = e.controlEdge), this.body.emitter.emit(t, r);
      }
    }, {
      key: "selectObject",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.options.selectConnectedEdges;
        if (void 0 !== t) {
          if (t instanceof fD) {
            var i;
            if (!0 === e) (i = this._selectionAccumulator).addEdges.apply(i, vf(t.edges));
            this._selectionAccumulator.addNodes(t);
          } else this._selectionAccumulator.addEdges(t);
          return !0;
        }
        return !1;
      }
    }, {
      key: "deselectObject",
      value: function value(t) {
        !0 === t.isSelected() && (t.selected = !1, this._removeFromSelection(t));
      }
    }, {
      key: "_getAllNodesOverlappingWith",
      value: function value(t) {
        for (var e = [], i = this.body.nodes, n = 0; n < this.body.nodeIndices.length; n++) {
          var o = this.body.nodeIndices[n];
          i[o].isOverlappingWith(t) && e.push(o);
        }
        return e;
      }
    }, {
      key: "_pointerToPositionObject",
      value: function value(t) {
        var e = this.canvas.DOMtoCanvas(t);
        return {
          left: e.x - 1,
          top: e.y + 1,
          right: e.x + 1,
          bottom: e.y - 1
        };
      }
    }, {
      key: "getNodeAt",
      value: function value(t) {
        var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
          i = this._pointerToPositionObject(t),
          n = this._getAllNodesOverlappingWith(i);
        return n.length > 0 ? !0 === e ? this.body.nodes[n[n.length - 1]] : n[n.length - 1] : void 0;
      }
    }, {
      key: "_getEdgesOverlappingWith",
      value: function value(t, e) {
        for (var i = this.body.edges, n = 0; n < this.body.edgeIndices.length; n++) {
          var o = this.body.edgeIndices[n];
          i[o].isOverlappingWith(t) && e.push(o);
        }
      }
    }, {
      key: "_getAllEdgesOverlappingWith",
      value: function value(t) {
        var e = [];
        return this._getEdgesOverlappingWith(t, e), e;
      }
    }, {
      key: "getEdgeAt",
      value: function value(t) {
        for (var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this.canvas.DOMtoCanvas(t), n = 10, o = null, r = this.body.edges, s = 0; s < this.body.edgeIndices.length; s++) {
          var a = this.body.edgeIndices[s],
            h = r[a];
          if (h.connected) {
            var l = h.from.x,
              d = h.from.y,
              c = h.to.x,
              u = h.to.y,
              f = h.edgeType.getDistanceToEdge(l, d, c, u, i.x, i.y);
            f < n && (o = a, n = f);
          }
        }
        return null !== o ? !0 === e ? this.body.edges[o] : o : void 0;
      }
    }, {
      key: "_addToHover",
      value: function value(t) {
        t instanceof fD ? this.hoverObj.nodes[t.id] = t : this.hoverObj.edges[t.id] = t;
      }
    }, {
      key: "_removeFromSelection",
      value: function value(t) {
        var e;
        t instanceof fD ? (this._selectionAccumulator.deleteNodes(t), (e = this._selectionAccumulator).deleteEdges.apply(e, vf(t.edges))) : this._selectionAccumulator.deleteEdges(t);
      }
    }, {
      key: "unselectAll",
      value: function value() {
        this._selectionAccumulator.clear();
      }
    }, {
      key: "getSelectedNodeCount",
      value: function value() {
        return this._selectionAccumulator.sizeNodes;
      }
    }, {
      key: "getSelectedEdgeCount",
      value: function value() {
        return this._selectionAccumulator.sizeEdges;
      }
    }, {
      key: "_hoverConnectedEdges",
      value: function value(t) {
        for (var e = 0; e < t.edges.length; e++) {
          var i = t.edges[e];
          i.hover = !0, this._addToHover(i);
        }
      }
    }, {
      key: "emitBlurEvent",
      value: function value(t, e, i) {
        var n = this._initBaseEvent(t, e);
        !0 === i.hover && (i.hover = !1, i instanceof fD ? (n.node = i.id, this.body.emitter.emit("blurNode", n)) : (n.edge = i.id, this.body.emitter.emit("blurEdge", n)));
      }
    }, {
      key: "emitHoverEvent",
      value: function value(t, e, i) {
        var n = this._initBaseEvent(t, e),
          o = !1;
        return !1 === i.hover && (i.hover = !0, this._addToHover(i), o = !0, i instanceof fD ? (n.node = i.id, this.body.emitter.emit("hoverNode", n)) : (n.edge = i.id, this.body.emitter.emit("hoverEdge", n))), o;
      }
    }, {
      key: "hoverObject",
      value: function value(t, e) {
        var i = this.getNodeAt(e);
        void 0 === i && (i = this.getEdgeAt(e));
        var n = !1;
        for (var o in this.hoverObj.nodes) Object.prototype.hasOwnProperty.call(this.hoverObj.nodes, o) && (void 0 === i || i instanceof fD && i.id != o || i instanceof dI) && (this.emitBlurEvent(t, e, this.hoverObj.nodes[o]), delete this.hoverObj.nodes[o], n = !0);
        for (var r in this.hoverObj.edges) Object.prototype.hasOwnProperty.call(this.hoverObj.edges, r) && (!0 === n ? (this.hoverObj.edges[r].hover = !1, delete this.hoverObj.edges[r]) : (void 0 === i || i instanceof dI && i.id != r || i instanceof fD && !i.hover) && (this.emitBlurEvent(t, e, this.hoverObj.edges[r]), delete this.hoverObj.edges[r], n = !0));
        if (void 0 !== i) {
          var s = Hf(this.hoverObj.edges).length,
            a = Hf(this.hoverObj.nodes).length;
          (n || i instanceof dI && 0 === s && 0 === a || i instanceof fD && 0 === s && 0 === a) && (n = this.emitHoverEvent(t, e, i)), i instanceof fD && !0 === this.options.hoverConnectedEdges && this._hoverConnectedEdges(i);
        }
        !0 === n && this.body.emitter.emit("_requestRedraw");
      }
    }, {
      key: "commitWithoutEmitting",
      value: function value() {
        this._selectionAccumulator.commit();
      }
    }, {
      key: "commitAndEmit",
      value: function value(t, e) {
        var i = !1,
          n = this._selectionAccumulator.commit(),
          o = {
            nodes: n.nodes.previous,
            edges: n.edges.previous
          };
        n.edges.deleted.length > 0 && (this.generateClickEvent("deselectEdge", e, t, o), i = !0), n.nodes.deleted.length > 0 && (this.generateClickEvent("deselectNode", e, t, o), i = !0), n.nodes.added.length > 0 && (this.generateClickEvent("selectNode", e, t), i = !0), n.edges.added.length > 0 && (this.generateClickEvent("selectEdge", e, t), i = !0), !0 === i && this.generateClickEvent("select", e, t);
      }
    }, {
      key: "getSelection",
      value: function value() {
        return {
          nodes: this.getSelectedNodeIds(),
          edges: this.getSelectedEdgeIds()
        };
      }
    }, {
      key: "getSelectedNodes",
      value: function value() {
        return this._selectionAccumulator.getNodes();
      }
    }, {
      key: "getSelectedEdges",
      value: function value() {
        return this._selectionAccumulator.getEdges();
      }
    }, {
      key: "getSelectedNodeIds",
      value: function value() {
        var t;
        return jf(t = this._selectionAccumulator.getNodes()).call(t, function (t) {
          return t.id;
        });
      }
    }, {
      key: "getSelectedEdgeIds",
      value: function value() {
        var t;
        return jf(t = this._selectionAccumulator.getEdges()).call(t, function (t) {
          return t.id;
        });
      }
    }, {
      key: "setSelection",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!t || !t.nodes && !t.edges) throw new TypeError("Selection must be an object with nodes and/or edges properties");
        if ((e.unselectAll || void 0 === e.unselectAll) && this.unselectAll(), t.nodes) {
          var i,
            n = YB(t.nodes);
          try {
            for (n.s(); !(i = n.n()).done;) {
              var o = i.value,
                r = this.body.nodes[o];
              if (!r) throw new RangeError('Node with id "' + o + '" not found');
              this.selectObject(r, e.highlightEdges);
            }
          } catch (t) {
            n.e(t);
          } finally {
            n.f();
          }
        }
        if (t.edges) {
          var s,
            a = YB(t.edges);
          try {
            for (a.s(); !(s = a.n()).done;) {
              var h = s.value,
                l = this.body.edges[h];
              if (!l) throw new RangeError('Edge with id "' + h + '" not found');
              this.selectObject(l);
            }
          } catch (t) {
            a.e(t);
          } finally {
            a.f();
          }
        }
        this.body.emitter.emit("_requestRedraw"), this._selectionAccumulator.commit();
      }
    }, {
      key: "selectNodes",
      value: function value(t) {
        var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        if (!t || void 0 === t.length) throw "Selection must be an array with ids";
        this.setSelection({
          nodes: t
        }, {
          highlightEdges: e
        });
      }
    }, {
      key: "selectEdges",
      value: function value(t) {
        if (!t || void 0 === t.length) throw "Selection must be an array with ids";
        this.setSelection({
          edges: t
        });
      }
    }, {
      key: "updateSelection",
      value: function value() {
        for (var t in this._selectionAccumulator.getNodes()) Object.prototype.hasOwnProperty.call(this.body.nodes, t.id) || this._selectionAccumulator.deleteNodes(t);
        for (var e in this._selectionAccumulator.getEdges()) Object.prototype.hasOwnProperty.call(this.body.edges, e.id) || this._selectionAccumulator.deleteEdges(e);
      }
    }, {
      key: "getClickedItems",
      value: function value(t) {
        for (var e = this.canvas.DOMtoCanvas(t), i = [], n = this.body.nodeIndices, o = this.body.nodes, r = n.length - 1; r >= 0; r--) {
          var s = o[n[r]].getItemsOnPoint(e);
          i.push.apply(i, s);
        }
        for (var a = this.body.edgeIndices, h = this.body.edges, l = a.length - 1; l >= 0; l--) {
          var d = h[a[l]].getItemsOnPoint(e);
          i.push.apply(i, d);
        }
        return i;
      }
    }]), t;
  }();
  function KB(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !sM) return !1;
      if (sM.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(sM(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var i,
        n = F_(t);
      if (e) {
        var o = F_(this).constructor;
        i = sM(n, arguments, o);
      } else i = n.apply(this, arguments);
      return I_(this, i);
    };
  }
  var $B = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, [{
        key: "abstract",
        value: function value() {
          throw new Error("Can't instantiate abstract class!");
        }
      }, {
        key: "fake_use",
        value: function value() {}
      }, {
        key: "curveType",
        value: function value() {
          return this["abstract"]();
        }
      }, {
        key: "getPosition",
        value: function value(t) {
          return this.fake_use(t), this["abstract"]();
        }
      }, {
        key: "setPosition",
        value: function value(t, e) {
          var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
          this.fake_use(t, e, i), this["abstract"]();
        }
      }, {
        key: "getTreeSize",
        value: function value(t) {
          return this.fake_use(t), this["abstract"]();
        }
      }, {
        key: "sort",
        value: function value(t) {
          this.fake_use(t), this["abstract"]();
        }
      }, {
        key: "fix",
        value: function value(t, e) {
          this.fake_use(t, e), this["abstract"]();
        }
      }, {
        key: "shift",
        value: function value(t, e) {
          this.fake_use(t, e), this["abstract"]();
        }
      }]), t;
    }(),
    ZB = function (t) {
      D_(i, t);
      var e = KB(i);
      function i(t) {
        var n;
        return ph(this, i), (n = e.call(this)).layout = t, n;
      }
      return xu(i, [{
        key: "curveType",
        value: function value() {
          return "horizontal";
        }
      }, {
        key: "getPosition",
        value: function value(t) {
          return t.x;
        }
      }, {
        key: "setPosition",
        value: function value(t, e) {
          var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
          void 0 !== i && this.layout.hierarchical.addToOrdering(t, i), t.x = e;
        }
      }, {
        key: "getTreeSize",
        value: function value(t) {
          var e = this.layout.hierarchical.getTreeSize(this.layout.body.nodes, t);
          return {
            min: e.min_x,
            max: e.max_x
          };
        }
      }, {
        key: "sort",
        value: function value(t) {
          yT(t).call(t, function (t, e) {
            return t.x - e.x;
          });
        }
      }, {
        key: "fix",
        value: function value(t, e) {
          t.y = this.layout.options.hierarchical.levelSeparation * e, t.options.fixed.y = !0;
        }
      }, {
        key: "shift",
        value: function value(t, e) {
          this.layout.body.nodes[t].x += e;
        }
      }]), i;
    }($B),
    QB = function (t) {
      D_(i, t);
      var e = KB(i);
      function i(t) {
        var n;
        return ph(this, i), (n = e.call(this)).layout = t, n;
      }
      return xu(i, [{
        key: "curveType",
        value: function value() {
          return "vertical";
        }
      }, {
        key: "getPosition",
        value: function value(t) {
          return t.y;
        }
      }, {
        key: "setPosition",
        value: function value(t, e) {
          var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
          void 0 !== i && this.layout.hierarchical.addToOrdering(t, i), t.y = e;
        }
      }, {
        key: "getTreeSize",
        value: function value(t) {
          var e = this.layout.hierarchical.getTreeSize(this.layout.body.nodes, t);
          return {
            min: e.min_y,
            max: e.max_y
          };
        }
      }, {
        key: "sort",
        value: function value(t) {
          yT(t).call(t, function (t, e) {
            return t.y - e.y;
          });
        }
      }, {
        key: "fix",
        value: function value(t, e) {
          t.x = this.layout.options.hierarchical.levelSeparation * e, t.options.fixed.x = !0;
        }
      }, {
        key: "shift",
        value: function value(t, e) {
          this.layout.body.nodes[t].y += e;
        }
      }]), i;
    }($B),
    JB = Fl.every;
  Ti({
    target: "Array",
    proto: !0,
    forced: !Xf("every")
  }, {
    every: function every(t) {
      return JB(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var tN = Nn("Array").every,
    eN = at,
    iN = tN,
    nN = Array.prototype,
    oN = function oN(t) {
      var e = t.every;
      return t === nN || eN(nN, t) && e === nN.every ? iN : e;
    },
    rN = i(oN);
  function sN(t, e) {
    var i = void 0 !== gf && fh(t) || t["@@iterator"];
    if (!i) {
      if (Df(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return aN(t, e);
        var n = xf(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Ya(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return aN(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);
        var _n8 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n8 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n8++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r,
      s = !0,
      a = !1;
    return {
      s: function s() {
        i = i.call(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i["return"] || i["return"]();
        } finally {
          if (a) throw r;
        }
      }
    };
  }
  function aN(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
    return n;
  }
  function hN(t, e) {
    var i = new DS();
    return op(t).call(t, function (t) {
      var e;
      op(e = t.edges).call(e, function (t) {
        t.connected && i.add(t);
      });
    }), op(i).call(i, function (t) {
      var i = t.from.id,
        n = t.to.id;
      null == e[i] && (e[i] = 0), (null == e[n] || e[i] >= e[n]) && (e[n] = e[i] + 1);
    }), e;
  }
  function lN(t, e, i, n) {
    var o,
      r,
      s = pg(null),
      a = pS(o = vf(FT(n).call(n))).call(o, function (t, e) {
        return t + 1 + e.edges.length;
      }, 0),
      h = i + "Id",
      l = "to" === i ? 1 : -1,
      d = sN(n);
    try {
      var c,
        u = function u() {
          var o = pf(r.value, 2),
            d = o[0],
            c = o[1];
          if (!n.has(d) || !t(c)) return 0;
          s[d] = 0;
          for (var u, f, p = [c], v = 0, g = function g() {
              var t, o;
              if (!n.has(d)) return 0;
              var r = s[u.id] + l;
              if (op(t = yv(o = u.edges).call(o, function (t) {
                return t.connected && t.to !== t.from && t[i] !== u && n.has(t.toId) && n.has(t.fromId);
              })).call(t, function (t) {
                var n = t[h],
                  o = s[n];
                (null == o || e(r, o)) && (s[n] = r, p.push(t[i]));
              }), v > a) return {
                v: {
                  v: hN(n, s)
                }
              };
              ++v;
            }; u = p.pop();) if (0 !== (f = g()) && f) return f.v;
        };
      for (d.s(); !(r = d.n()).done;) if (0 !== (c = u()) && c) return c.v;
    } catch (t) {
      d.e(t);
    } finally {
      d.f();
    }
    return s;
  }
  var dN = function () {
      function t() {
        ph(this, t), this.childrenReference = {}, this.parentReference = {}, this.trees = {}, this.distributionOrdering = {}, this.levels = {}, this.distributionIndex = {}, this.isTree = !1, this.treeIndex = -1;
      }
      return xu(t, [{
        key: "addRelation",
        value: function value(t, e) {
          void 0 === this.childrenReference[t] && (this.childrenReference[t] = []), this.childrenReference[t].push(e), void 0 === this.parentReference[e] && (this.parentReference[e] = []), this.parentReference[e].push(t);
        }
      }, {
        key: "checkIfTree",
        value: function value() {
          for (var t in this.parentReference) if (this.parentReference[t].length > 1) return void (this.isTree = !1);
          this.isTree = !0;
        }
      }, {
        key: "numTrees",
        value: function value() {
          return this.treeIndex + 1;
        }
      }, {
        key: "setTreeIndex",
        value: function value(t, e) {
          void 0 !== e && void 0 === this.trees[t.id] && (this.trees[t.id] = e, this.treeIndex = Math.max(e, this.treeIndex));
        }
      }, {
        key: "ensureLevel",
        value: function value(t) {
          void 0 === this.levels[t] && (this.levels[t] = 0);
        }
      }, {
        key: "getMaxLevel",
        value: function value(t) {
          var e = this,
            i = {};
          return function t(n) {
            if (void 0 !== i[n]) return i[n];
            var o = e.levels[n];
            if (e.childrenReference[n]) {
              var r = e.childrenReference[n];
              if (r.length > 0) for (var s = 0; s < r.length; s++) o = Math.max(o, t(r[s]));
            }
            return i[n] = o, o;
          }(t);
        }
      }, {
        key: "levelDownstream",
        value: function value(t, e) {
          void 0 === this.levels[e.id] && (void 0 === this.levels[t.id] && (this.levels[t.id] = 0), this.levels[e.id] = this.levels[t.id] + 1);
        }
      }, {
        key: "setMinLevelToZero",
        value: function value(t) {
          var e = 1e9;
          for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && void 0 !== this.levels[i] && (e = Math.min(this.levels[i], e));
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && void 0 !== this.levels[n] && (this.levels[n] -= e);
        }
      }, {
        key: "getTreeSize",
        value: function value(t, e) {
          var i = 1e9,
            n = -1e9,
            o = 1e9,
            r = -1e9;
          for (var s in this.trees) if (Object.prototype.hasOwnProperty.call(this.trees, s) && this.trees[s] === e) {
            var a = t[s];
            i = Math.min(a.x, i), n = Math.max(a.x, n), o = Math.min(a.y, o), r = Math.max(a.y, r);
          }
          return {
            min_x: i,
            max_x: n,
            min_y: o,
            max_y: r
          };
        }
      }, {
        key: "hasSameParent",
        value: function value(t, e) {
          var i = this.parentReference[t.id],
            n = this.parentReference[e.id];
          if (void 0 === i || void 0 === n) return !1;
          for (var o = 0; o < i.length; o++) for (var r = 0; r < n.length; r++) if (i[o] == n[r]) return !0;
          return !1;
        }
      }, {
        key: "inSameSubNetwork",
        value: function value(t, e) {
          return this.trees[t.id] === this.trees[e.id];
        }
      }, {
        key: "getLevels",
        value: function value() {
          return Hf(this.distributionOrdering);
        }
      }, {
        key: "addToOrdering",
        value: function value(t, e) {
          void 0 === this.distributionOrdering[e] && (this.distributionOrdering[e] = []);
          var i = !1,
            n = this.distributionOrdering[e];
          for (var o in n) if (n[o] === t) {
            i = !0;
            break;
          }
          i || (this.distributionOrdering[e].push(t), this.distributionIndex[t.id] = this.distributionOrdering[e].length - 1);
        }
      }]), t;
    }(),
    cN = function () {
      function t(e) {
        ph(this, t), this.body = e, this._resetRNG(Math.random() + ":" + Uf()), this.setPhysics = !1, this.options = {}, this.optionsBackup = {
          physics: {}
        }, this.defaultOptions = {
          randomSeed: void 0,
          improvedLayout: !0,
          clusterThreshold: 150,
          hierarchical: {
            enabled: !1,
            levelSeparation: 150,
            nodeSpacing: 100,
            treeSpacing: 200,
            blockShifting: !0,
            edgeMinimization: !0,
            parentCentralization: !0,
            direction: "UD",
            sortMethod: "hubsize"
          }
        }, bn(this.options, this.defaultOptions), this.bindEventListeners();
      }
      return xu(t, [{
        key: "bindEventListeners",
        value: function value() {
          var t = this;
          this.body.emitter.on("_dataChanged", function () {
            t.setupHierarchicalLayout();
          }), this.body.emitter.on("_dataLoaded", function () {
            t.layoutNetwork();
          }), this.body.emitter.on("_resetHierarchicalLayout", function () {
            t.setupHierarchicalLayout();
          }), this.body.emitter.on("_adjustEdgesForHierarchicalLayout", function () {
            if (!0 === t.options.hierarchical.enabled) {
              var e = t.direction.curveType();
              t.body.emitter.emit("_forceDisableDynamicCurves", e, !1);
            }
          });
        }
      }, {
        key: "setOptions",
        value: function value(t, e) {
          if (void 0 !== t) {
            var i = this.options.hierarchical,
              n = i.enabled;
            if (pb(["randomSeed", "improvedLayout", "clusterThreshold"], this.options, t), Ab(this.options, t, "hierarchical"), void 0 !== t.randomSeed && this._resetRNG(t.randomSeed), !0 === i.enabled) return !0 === n && this.body.emitter.emit("refresh", !0), "RL" === i.direction || "DU" === i.direction ? i.levelSeparation > 0 && (i.levelSeparation *= -1) : i.levelSeparation < 0 && (i.levelSeparation *= -1), this.setDirectionStrategy(), this.body.emitter.emit("_resetHierarchicalLayout"), this.adaptAllOptionsForHierarchicalLayout(e);
            if (!0 === n) return this.body.emitter.emit("refresh"), gb(e, this.optionsBackup);
          }
          return e;
        }
      }, {
        key: "_resetRNG",
        value: function value(t) {
          this.initialRandomSeed = t, this._rng = Jm(this.initialRandomSeed);
        }
      }, {
        key: "adaptAllOptionsForHierarchicalLayout",
        value: function value(t) {
          if (!0 === this.options.hierarchical.enabled) {
            var e = this.optionsBackup.physics;
            void 0 === t.physics || !0 === t.physics ? (t.physics = {
              enabled: void 0 === e.enabled || e.enabled,
              solver: "hierarchicalRepulsion"
            }, e.enabled = void 0 === e.enabled || e.enabled, e.solver = e.solver || "barnesHut") : "object" === bu(t.physics) ? (e.enabled = void 0 === t.physics.enabled || t.physics.enabled, e.solver = t.physics.solver || "barnesHut", t.physics.solver = "hierarchicalRepulsion") : !1 !== t.physics && (e.solver = "barnesHut", t.physics = {
              solver: "hierarchicalRepulsion"
            });
            var i = this.direction.curveType();
            if (void 0 === t.edges) this.optionsBackup.edges = {
              smooth: {
                enabled: !0,
                type: "dynamic"
              }
            }, t.edges = {
              smooth: !1
            };else if (void 0 === t.edges.smooth) this.optionsBackup.edges = {
              smooth: {
                enabled: !0,
                type: "dynamic"
              }
            }, t.edges.smooth = !1;else if ("boolean" == typeof t.edges.smooth) this.optionsBackup.edges = {
              smooth: t.edges.smooth
            }, t.edges.smooth = {
              enabled: t.edges.smooth,
              type: i
            };else {
              var n = t.edges.smooth;
              void 0 !== n.type && "dynamic" !== n.type && (i = n.type), this.optionsBackup.edges = {
                smooth: {
                  enabled: void 0 === n.enabled || n.enabled,
                  type: void 0 === n.type ? "dynamic" : n.type,
                  roundness: void 0 === n.roundness ? .5 : n.roundness,
                  forceDirection: void 0 !== n.forceDirection && n.forceDirection
                }
              }, t.edges.smooth = {
                enabled: void 0 === n.enabled || n.enabled,
                type: i,
                roundness: void 0 === n.roundness ? .5 : n.roundness,
                forceDirection: void 0 !== n.forceDirection && n.forceDirection
              };
            }
            this.body.emitter.emit("_forceDisableDynamicCurves", i);
          }
          return t;
        }
      }, {
        key: "positionInitially",
        value: function value(t) {
          if (!0 !== this.options.hierarchical.enabled) {
            this._resetRNG(this.initialRandomSeed);
            for (var e = t.length + 50, i = 0; i < t.length; i++) {
              var n = t[i],
                o = 2 * Math.PI * this._rng();
              void 0 === n.x && (n.x = e * Math.cos(o)), void 0 === n.y && (n.y = e * Math.sin(o));
            }
          }
        }
      }, {
        key: "layoutNetwork",
        value: function value() {
          if (!0 !== this.options.hierarchical.enabled && !0 === this.options.improvedLayout) {
            for (var t = this.body.nodeIndices, e = 0, i = 0; i < t.length; i++) {
              !0 === this.body.nodes[t[i]].predefinedPosition && (e += 1);
            }
            if (e < .5 * t.length) {
              var n = 0,
                o = this.options.clusterThreshold,
                r = {
                  clusterNodeProperties: {
                    shape: "ellipse",
                    label: "",
                    group: "",
                    font: {
                      multi: !1
                    }
                  },
                  clusterEdgeProperties: {
                    label: "",
                    font: {
                      multi: !1
                    },
                    smooth: {
                      enabled: !1
                    }
                  }
                };
              if (t.length > o) {
                for (var s = t.length; t.length > o && n <= 10;) {
                  n += 1;
                  var a = t.length;
                  if (n % 3 == 0 ? this.body.modules.clustering.clusterBridges(r) : this.body.modules.clustering.clusterOutliers(r), a == t.length && n % 3 != 0) return this._declusterAll(), this.body.emitter.emit("_layoutFailed"), void console.info("This network could not be positioned by this version of the improved layout algorithm. Please disable improvedLayout for better performance.");
                }
                this.body.modules.kamadaKawai.setOptions({
                  springLength: Math.max(150, 2 * s)
                });
              }
              n > 10 && console.info("The clustering didn't succeed within the amount of interations allowed, progressing with partial result."), this.body.modules.kamadaKawai.solve(t, this.body.edgeIndices, !0), this._shiftToCenter();
              for (var h = 0; h < t.length; h++) {
                var l = this.body.nodes[t[h]];
                !1 === l.predefinedPosition && (l.x += 70 * (.5 - this._rng()), l.y += 70 * (.5 - this._rng()));
              }
              this._declusterAll(), this.body.emitter.emit("_repositionBezierNodes");
            }
          }
        }
      }, {
        key: "_shiftToCenter",
        value: function value() {
          for (var t = xI.getRangeCore(this.body.nodes, this.body.nodeIndices), e = xI.findCenter(t), i = 0; i < this.body.nodeIndices.length; i++) {
            var n = this.body.nodes[this.body.nodeIndices[i]];
            n.x -= e.x, n.y -= e.y;
          }
        }
      }, {
        key: "_declusterAll",
        value: function value() {
          for (var t = !0; !0 === t;) {
            t = !1;
            for (var e = 0; e < this.body.nodeIndices.length; e++) !0 === this.body.nodes[this.body.nodeIndices[e]].isCluster && (t = !0, this.body.modules.clustering.openCluster(this.body.nodeIndices[e], {}, !1));
            !0 === t && this.body.emitter.emit("_dataChanged");
          }
        }
      }, {
        key: "getSeed",
        value: function value() {
          return this.initialRandomSeed;
        }
      }, {
        key: "setupHierarchicalLayout",
        value: function value() {
          if (!0 === this.options.hierarchical.enabled && this.body.nodeIndices.length > 0) {
            var t,
              e,
              i = !1,
              n = !1;
            for (e in this.lastNodeOnLevel = {}, this.hierarchical = new dN(), this.body.nodes) Object.prototype.hasOwnProperty.call(this.body.nodes, e) && (void 0 !== (t = this.body.nodes[e]).options.level ? (i = !0, this.hierarchical.levels[e] = t.options.level) : n = !0);
            if (!0 === n && !0 === i) throw new Error("To use the hierarchical layout, nodes require either no predefined levels or levels have to be defined for all nodes.");
            if (!0 === n) {
              var o = this.options.hierarchical.sortMethod;
              "hubsize" === o ? this._determineLevelsByHubsize() : "directed" === o ? this._determineLevelsDirected() : "custom" === o && this._determineLevelsCustomCallback();
            }
            for (var r in this.body.nodes) Object.prototype.hasOwnProperty.call(this.body.nodes, r) && this.hierarchical.ensureLevel(r);
            var s = this._getDistribution();
            this._generateMap(), this._placeNodesByHierarchy(s), this._condenseHierarchy(), this._shiftToCenter();
          }
        }
      }, {
        key: "_condenseHierarchy",
        value: function value() {
          var t = this,
            e = !1,
            i = {},
            n = function n(e, i) {
              var n = t.hierarchical.trees;
              for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && n[o] === e && t.direction.shift(o, i);
            },
            o = function o() {
              for (var e = [], i = 0; i < t.hierarchical.numTrees(); i++) e.push(t.direction.getTreeSize(i));
              return e;
            },
            r = function e(i, n) {
              if (!n[i.id] && (n[i.id] = !0, t.hierarchical.childrenReference[i.id])) {
                var o = t.hierarchical.childrenReference[i.id];
                if (o.length > 0) for (var r = 0; r < o.length; r++) e(t.body.nodes[o[r]], n);
              }
            },
            s = function s(e) {
              var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e9,
                n = 1e9,
                o = 1e9,
                r = 1e9,
                s = -1e9;
              for (var a in e) if (Object.prototype.hasOwnProperty.call(e, a)) {
                var h = t.body.nodes[a],
                  l = t.hierarchical.levels[h.id],
                  d = t.direction.getPosition(h),
                  c = pf(t._getSpaceAroundNode(h, e), 2),
                  u = c[0],
                  f = c[1];
                n = Math.min(u, n), o = Math.min(f, o), l <= i && (r = Math.min(d, r), s = Math.max(d, s));
              }
              return [r, s, n, o];
            },
            a = function a(e, i, n) {
              for (var o = t.hierarchical, r = 0; r < i.length; r++) {
                var s = i[r],
                  a = o.distributionOrdering[s];
                if (a.length > 1) for (var h = 0; h < a.length - 1; h++) {
                  var l = a[h],
                    d = a[h + 1];
                  o.hasSameParent(l, d) && o.inSameSubNetwork(l, d) && e(l, d, n);
                }
              }
            },
            h = function h(i, n) {
              var o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                a = t.direction.getPosition(i),
                h = t.direction.getPosition(n),
                l = Math.abs(h - a),
                d = t.options.hierarchical.nodeSpacing;
              if (l > d) {
                var c = {},
                  u = {};
                r(i, c), r(n, u);
                var f = function (e, i) {
                    var n = t.hierarchical.getMaxLevel(e.id),
                      o = t.hierarchical.getMaxLevel(i.id);
                    return Math.min(n, o);
                  }(i, n),
                  p = s(c, f),
                  v = s(u, f),
                  g = p[1],
                  y = v[0],
                  m = v[2];
                if (Math.abs(g - y) > d) {
                  var b = g - y + d;
                  b < -m + d && (b = -m + d), b < 0 && (t._shiftBlock(n.id, b), e = !0, !0 === o && t._centerParent(n));
                }
              }
            },
            l = function l(n, o) {
              for (var a = o.id, h = o.edges, l = t.hierarchical.levels[o.id], d = t.options.hierarchical.levelSeparation * t.options.hierarchical.levelSeparation, c = {}, u = [], f = 0; f < h.length; f++) {
                var p = h[f];
                if (p.toId != p.fromId) {
                  var v = p.toId == a ? p.from : p.to;
                  c[h[f].id] = v, t.hierarchical.levels[v.id] < l && u.push(p);
                }
              }
              var g = function g(e, i) {
                  for (var n = 0, o = 0; o < i.length; o++) if (void 0 !== c[i[o].id]) {
                    var r = t.direction.getPosition(c[i[o].id]) - e;
                    n += r / Math.sqrt(r * r + d);
                  }
                  return n;
                },
                y = function y(e, i) {
                  for (var n = 0, o = 0; o < i.length; o++) if (void 0 !== c[i[o].id]) {
                    var r = t.direction.getPosition(c[i[o].id]) - e;
                    n -= d * Math.pow(r * r + d, -1.5);
                  }
                  return n;
                },
                m = function m(e, i) {
                  for (var n = t.direction.getPosition(o), r = {}, s = 0; s < e; s++) {
                    var a = g(n, i),
                      h = y(n, i);
                    if (void 0 !== r[n -= Math.max(-40, Math.min(40, Math.round(a / h)))]) break;
                    r[n] = s;
                  }
                  return n;
                },
                b = m(n, u);
              !function (n) {
                var a = t.direction.getPosition(o);
                if (void 0 === i[o.id]) {
                  var h = {};
                  r(o, h), i[o.id] = h;
                }
                var l = s(i[o.id]),
                  d = l[2],
                  c = l[3],
                  u = n - a,
                  f = 0;
                u > 0 ? f = Math.min(u, c - t.options.hierarchical.nodeSpacing) : u < 0 && (f = -Math.min(-u, d - t.options.hierarchical.nodeSpacing)), 0 != f && (t._shiftBlock(o.id, f), e = !0);
              }(b), function (i) {
                var n = t.direction.getPosition(o),
                  r = pf(t._getSpaceAroundNode(o), 2),
                  s = r[0],
                  a = r[1],
                  h = i - n,
                  l = n;
                h > 0 ? l = Math.min(n + (a - t.options.hierarchical.nodeSpacing), i) : h < 0 && (l = Math.max(n - (s - t.options.hierarchical.nodeSpacing), i)), l !== n && (t.direction.setPosition(o, l), e = !0);
              }(b = m(n, h));
            };
          !0 === this.options.hierarchical.blockShifting && (function (i) {
            var n = t.hierarchical.getLevels();
            n = vp(n).call(n);
            for (var o = 0; o < i && (e = !1, a(h, n, !0), !0 === e); o++);
          }(5), function () {
            for (var e in t.body.nodes) Object.prototype.hasOwnProperty.call(t.body.nodes, e) && t._centerParent(t.body.nodes[e]);
          }()), !0 === this.options.hierarchical.edgeMinimization && function (i) {
            var n = t.hierarchical.getLevels();
            n = vp(n).call(n);
            for (var o = 0; o < i; o++) {
              e = !1;
              for (var r = 0; r < n.length; r++) for (var s = n[r], a = t.hierarchical.distributionOrdering[s], h = 0; h < a.length; h++) l(1e3, a[h]);
              if (!0 !== e) break;
            }
          }(20), !0 === this.options.hierarchical.parentCentralization && function () {
            var e = t.hierarchical.getLevels();
            e = vp(e).call(e);
            for (var i = 0; i < e.length; i++) for (var n = e[i], o = t.hierarchical.distributionOrdering[n], r = 0; r < o.length; r++) t._centerParent(o[r]);
          }(), function () {
            for (var e = o(), i = 0, r = 0; r < e.length - 1; r++) {
              i += e[r].max - e[r + 1].min + t.options.hierarchical.treeSpacing, n(r + 1, i);
            }
          }();
        }
      }, {
        key: "_getSpaceAroundNode",
        value: function value(t, e) {
          var i = !0;
          void 0 === e && (i = !1);
          var n = this.hierarchical.levels[t.id];
          if (void 0 !== n) {
            var o = this.hierarchical.distributionIndex[t.id],
              r = this.direction.getPosition(t),
              s = this.hierarchical.distributionOrdering[n],
              a = 1e9,
              h = 1e9;
            if (0 !== o) {
              var l = s[o - 1];
              if (!0 === i && void 0 === e[l.id] || !1 === i) a = r - this.direction.getPosition(l);
            }
            if (o != s.length - 1) {
              var d = s[o + 1];
              if (!0 === i && void 0 === e[d.id] || !1 === i) {
                var c = this.direction.getPosition(d);
                h = Math.min(h, c - r);
              }
            }
            return [a, h];
          }
          return [0, 0];
        }
      }, {
        key: "_centerParent",
        value: function value(t) {
          if (this.hierarchical.parentReference[t.id]) for (var e = this.hierarchical.parentReference[t.id], i = 0; i < e.length; i++) {
            var n = e[i],
              o = this.body.nodes[n],
              r = this.hierarchical.childrenReference[n];
            if (void 0 !== r) {
              var s = this._getCenterPosition(r),
                a = this.direction.getPosition(o),
                h = pf(this._getSpaceAroundNode(o), 2),
                l = h[0],
                d = h[1],
                c = a - s;
              (c < 0 && Math.abs(c) < d - this.options.hierarchical.nodeSpacing || c > 0 && Math.abs(c) < l - this.options.hierarchical.nodeSpacing) && this.direction.setPosition(o, s);
            }
          }
        }
      }, {
        key: "_placeNodesByHierarchy",
        value: function value(t) {
          for (var e in this.positionedNodes = {}, t) if (Object.prototype.hasOwnProperty.call(t, e)) {
            var i,
              n = Hf(t[e]);
            n = this._indexArrayToNodes(n), yT(i = this.direction).call(i, n);
            for (var o = 0, r = 0; r < n.length; r++) {
              var s = n[r];
              if (void 0 === this.positionedNodes[s.id]) {
                var a = this.options.hierarchical.nodeSpacing,
                  h = a * o;
                o > 0 && (h = this.direction.getPosition(n[r - 1]) + a), this.direction.setPosition(s, h, e), this._validatePositionAndContinue(s, e, h), o++;
              }
            }
          }
        }
      }, {
        key: "_placeBranchNodes",
        value: function value(t, e) {
          var i,
            n = this.hierarchical.childrenReference[t];
          if (void 0 !== n) {
            for (var o = [], r = 0; r < n.length; r++) o.push(this.body.nodes[n[r]]);
            yT(i = this.direction).call(i, o);
            for (var s = 0; s < o.length; s++) {
              var a = o[s],
                h = this.hierarchical.levels[a.id];
              if (!(h > e && void 0 === this.positionedNodes[a.id])) return;
              var l = this.options.hierarchical.nodeSpacing,
                d = void 0;
              d = 0 === s ? this.direction.getPosition(this.body.nodes[t]) : this.direction.getPosition(o[s - 1]) + l, this.direction.setPosition(a, d, h), this._validatePositionAndContinue(a, h, d);
            }
            var c = this._getCenterPosition(o);
            this.direction.setPosition(this.body.nodes[t], c, e);
          }
        }
      }, {
        key: "_validatePositionAndContinue",
        value: function value(t, e, i) {
          if (this.hierarchical.isTree) {
            if (void 0 !== this.lastNodeOnLevel[e]) {
              var n = this.direction.getPosition(this.body.nodes[this.lastNodeOnLevel[e]]);
              if (i - n < this.options.hierarchical.nodeSpacing) {
                var o = n + this.options.hierarchical.nodeSpacing - i,
                  r = this._findCommonParent(this.lastNodeOnLevel[e], t.id);
                this._shiftBlock(r.withChild, o);
              }
            }
            this.lastNodeOnLevel[e] = t.id, this.positionedNodes[t.id] = !0, this._placeBranchNodes(t.id, e);
          }
        }
      }, {
        key: "_indexArrayToNodes",
        value: function value(t) {
          for (var e = [], i = 0; i < t.length; i++) e.push(this.body.nodes[t[i]]);
          return e;
        }
      }, {
        key: "_getDistribution",
        value: function value() {
          var t,
            e,
            i = {};
          for (t in this.body.nodes) if (Object.prototype.hasOwnProperty.call(this.body.nodes, t)) {
            e = this.body.nodes[t];
            var n = void 0 === this.hierarchical.levels[t] ? 0 : this.hierarchical.levels[t];
            this.direction.fix(e, n), void 0 === i[n] && (i[n] = {}), i[n][t] = e;
          }
          return i;
        }
      }, {
        key: "_getActiveEdges",
        value: function value(t) {
          var e = this,
            i = [];
          return kb(t.edges, function (t) {
            var n;
            -1 !== lg(n = e.body.edgeIndices).call(n, t.id) && i.push(t);
          }), i;
        }
      }, {
        key: "_getHubSizes",
        value: function value() {
          var t = this,
            e = {};
          kb(this.body.nodeIndices, function (i) {
            var n = t.body.nodes[i],
              o = t._getActiveEdges(n).length;
            e[o] = !0;
          });
          var i = [];
          return kb(e, function (t) {
            i.push(Number(t));
          }), yT(i).call(i, function (t, e) {
            return e - t;
          }), i;
        }
      }, {
        key: "_determineLevelsByHubsize",
        value: function value() {
          for (var t = this, e = function e(_e2, i) {
              t.hierarchical.levelDownstream(_e2, i);
            }, i = this._getHubSizes(), n = function n() {
              var n = i[o];
              if (0 === n) return 1;
              kb(t.body.nodeIndices, function (i) {
                var o = t.body.nodes[i];
                n === t._getActiveEdges(o).length && t._crawlNetwork(e, i);
              });
            }, o = 0; o < i.length && !n(); ++o);
        }
      }, {
        key: "_determineLevelsCustomCallback",
        value: function value() {
          var t = this;
          this._crawlNetwork(function (e, i, n) {
            var o = t.hierarchical.levels[e.id];
            void 0 === o && (o = t.hierarchical.levels[e.id] = 1e5);
            var r = (xI.cloneOptions(e, "node"), xI.cloneOptions(i, "node"), void xI.cloneOptions(n, "edge"));
            t.hierarchical.levels[i.id] = o + r;
          }), this.hierarchical.setMinLevelToZero(this.body.nodes);
        }
      }, {
        key: "_determineLevelsDirected",
        value: function value() {
          var t,
            e = this,
            i = pS(t = this.body.nodeIndices).call(t, function (t, i) {
              return t.set(i, e.body.nodes[i]), t;
            }, new c_());
          "roots" === this.options.hierarchical.shakeTowards ? this.hierarchical.levels = function (t) {
            return lN(function (e) {
              var i, n;
              return rN(i = yv(n = e.edges).call(n, function (e) {
                return t.has(e.toId);
              })).call(i, function (t) {
                return t.from === e;
              });
            }, function (t, e) {
              return e < t;
            }, "to", t);
          }(i) : this.hierarchical.levels = function (t) {
            return lN(function (e) {
              var i, n;
              return rN(i = yv(n = e.edges).call(n, function (e) {
                return t.has(e.toId);
              })).call(i, function (t) {
                return t.to === e;
              });
            }, function (t, e) {
              return e > t;
            }, "from", t);
          }(i), this.hierarchical.setMinLevelToZero(this.body.nodes);
        }
      }, {
        key: "_generateMap",
        value: function value() {
          var t = this;
          this._crawlNetwork(function (e, i) {
            t.hierarchical.levels[i.id] > t.hierarchical.levels[e.id] && t.hierarchical.addRelation(e.id, i.id);
          }), this.hierarchical.checkIfTree();
        }
      }, {
        key: "_crawlNetwork",
        value: function value() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function () {},
            i = arguments.length > 1 ? arguments[1] : void 0,
            n = {},
            o = function i(o, r) {
              if (void 0 === n[o.id]) {
                var s;
                t.hierarchical.setTreeIndex(o, r), n[o.id] = !0;
                for (var a = t._getActiveEdges(o), h = 0; h < a.length; h++) {
                  var l = a[h];
                  !0 === l.connected && (s = l.toId == o.id ? l.from : l.to, o.id != s.id && (e(o, s, l), i(s, r)));
                }
              }
            };
          if (void 0 === i) for (var r = 0, s = 0; s < this.body.nodeIndices.length; s++) {
            var a = this.body.nodeIndices[s];
            if (void 0 === n[a]) o(this.body.nodes[a], r), r += 1;
          } else {
            var h = this.body.nodes[i];
            if (void 0 === h) return void console.error("Node not found:", i);
            o(h);
          }
        }
      }, {
        key: "_shiftBlock",
        value: function value(t, e) {
          var i = this,
            n = {};
          !function t(o) {
            if (!n[o]) {
              n[o] = !0, i.direction.shift(o, e);
              var r = i.hierarchical.childrenReference[o];
              if (void 0 !== r) for (var s = 0; s < r.length; s++) t(r[s]);
            }
          }(t);
        }
      }, {
        key: "_findCommonParent",
        value: function value(t, e) {
          var i = this,
            n = {};
          return function t(e, n) {
            var o = i.hierarchical.parentReference[n];
            if (void 0 !== o) for (var r = 0; r < o.length; r++) {
              var s = o[r];
              e[s] = !0, t(e, s);
            }
          }(n, t), function t(e, n) {
            var o = i.hierarchical.parentReference[n];
            if (void 0 !== o) for (var r = 0; r < o.length; r++) {
              var s = o[r];
              if (void 0 !== e[s]) return {
                foundParent: s,
                withChild: n
              };
              var a = t(e, s);
              if (null !== a.foundParent) return a;
            }
            return {
              foundParent: null,
              withChild: n
            };
          }(n, e);
        }
      }, {
        key: "setDirectionStrategy",
        value: function value() {
          var t = "UD" === this.options.hierarchical.direction || "DU" === this.options.hierarchical.direction;
          this.direction = t ? new ZB(this) : new QB(this);
        }
      }, {
        key: "_getCenterPosition",
        value: function value(t) {
          for (var e = 1e9, i = -1e9, n = 0; n < t.length; n++) {
            var o = void 0;
            if (void 0 !== t[n].id) o = t[n];else {
              var r = t[n];
              o = this.body.nodes[r];
            }
            var s = this.direction.getPosition(o);
            e = Math.min(e, s), i = Math.max(i, s);
          }
          return .5 * (e + i);
        }
      }]), t;
    }();
  function uN(t, e) {
    var i = void 0 !== gf && fh(t) || t["@@iterator"];
    if (!i) {
      if (Df(t) || (i = function (t, e) {
        var i;
        if (!t) return;
        if ("string" == typeof t) return fN(t, e);
        var n = xf(i = Object.prototype.toString.call(t)).call(i, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Ya(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fN(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        i && (t = i);
        var _n9 = 0,
          o = function o() {};
        return {
          s: o,
          n: function n() {
            return _n9 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n9++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r,
      s = !0,
      a = !1;
    return {
      s: function s() {
        i = i.call(t);
      },
      n: function n() {
        var t = i.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, r = t;
      },
      f: function f() {
        try {
          s || null == i["return"] || i["return"]();
        } finally {
          if (a) throw r;
        }
      }
    };
  }
  function fN(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
    return n;
  }
  var pN = function () {
      function t(e, i, n, o) {
        var r,
          s,
          a = this;
        ph(this, t), this.body = e, this.canvas = i, this.selectionHandler = n, this.interactionHandler = o, this.editMode = !1, this.manipulationDiv = void 0, this.editModeDiv = void 0, this.closeDiv = void 0, this._domEventListenerCleanupQueue = [], this.temporaryUIFunctions = {}, this.temporaryEventFunctions = [], this.touchTime = 0, this.temporaryIds = {
          nodes: [],
          edges: []
        }, this.guiEnabled = !1, this.inMode = !1, this.selectedControlNode = void 0, this.options = {}, this.defaultOptions = {
          enabled: !1,
          initiallyActive: !1,
          addNode: !0,
          addEdge: !0,
          editNode: void 0,
          editEdge: !0,
          deleteNode: !0,
          deleteEdge: !0,
          controlNodeStyle: {
            shape: "dot",
            size: 6,
            color: {
              background: "#ff0000",
              border: "#3c3c3c",
              highlight: {
                background: "#07f968",
                border: "#3c3c3c"
              }
            },
            borderWidth: 2,
            borderWidthSelected: 2
          }
        }, bn(this.options, this.defaultOptions), this.body.emitter.on("destroy", function () {
          a._clean();
        }), this.body.emitter.on("_dataChanged", Hn(r = this._restore).call(r, this)), this.body.emitter.on("_resetData", Hn(s = this._restore).call(s, this));
      }
      return xu(t, [{
        key: "_restore",
        value: function value() {
          !1 !== this.inMode && (!0 === this.options.initiallyActive ? this.enableEditMode() : this.disableEditMode());
        }
      }, {
        key: "setOptions",
        value: function value(t, e, i) {
          void 0 !== e && (void 0 !== e.locale ? this.options.locale = e.locale : this.options.locale = i.locale, void 0 !== e.locales ? this.options.locales = e.locales : this.options.locales = i.locales), void 0 !== t && ("boolean" == typeof t ? this.options.enabled = t : (this.options.enabled = !0, gb(this.options, t)), !0 === this.options.initiallyActive && (this.editMode = !0), this._setup());
        }
      }, {
        key: "toggleEditMode",
        value: function value() {
          !0 === this.editMode ? this.disableEditMode() : this.enableEditMode();
        }
      }, {
        key: "enableEditMode",
        value: function value() {
          this.editMode = !0, this._clean(), !0 === this.guiEnabled && (this.manipulationDiv.style.display = "block", this.closeDiv.style.display = "block", this.editModeDiv.style.display = "none", this.showManipulatorToolbar());
        }
      }, {
        key: "disableEditMode",
        value: function value() {
          this.editMode = !1, this._clean(), !0 === this.guiEnabled && (this.manipulationDiv.style.display = "none", this.closeDiv.style.display = "none", this.editModeDiv.style.display = "block", this._createEditButton());
        }
      }, {
        key: "showManipulatorToolbar",
        value: function value() {
          if (this._clean(), this.manipulationDOM = {}, !0 === this.guiEnabled) {
            var t, e;
            this.editMode = !0, this.manipulationDiv.style.display = "block", this.closeDiv.style.display = "block";
            var i = this.selectionHandler.getSelectedNodeCount(),
              n = this.selectionHandler.getSelectedEdgeCount(),
              o = i + n,
              r = this.options.locales[this.options.locale],
              s = !1;
            !1 !== this.options.addNode && (this._createAddNodeButton(r), s = !0), !1 !== this.options.addEdge && (!0 === s ? this._createSeperator(1) : s = !0, this._createAddEdgeButton(r)), 1 === i && "function" == typeof this.options.editNode ? (!0 === s ? this._createSeperator(2) : s = !0, this._createEditNodeButton(r)) : 1 === n && 0 === i && !1 !== this.options.editEdge && (!0 === s ? this._createSeperator(3) : s = !0, this._createEditEdgeButton(r)), 0 !== o && (i > 0 && !1 !== this.options.deleteNode || 0 === i && !1 !== this.options.deleteEdge) && (!0 === s && this._createSeperator(4), this._createDeleteButton(r)), this._bindElementEvents(this.closeDiv, Hn(t = this.toggleEditMode).call(t, this)), this._temporaryBindEvent("select", Hn(e = this.showManipulatorToolbar).call(e, this));
          }
          this.body.emitter.emit("_redraw");
        }
      }, {
        key: "addNodeMode",
        value: function value() {
          var t;
          if (!0 !== this.editMode && this.enableEditMode(), this._clean(), this.inMode = "addNode", !0 === this.guiEnabled) {
            var e,
              i = this.options.locales[this.options.locale];
            this.manipulationDOM = {}, this._createBackButton(i), this._createSeperator(), this._createDescription(i.addDescription || this.options.locales.en.addDescription), this._bindElementEvents(this.closeDiv, Hn(e = this.toggleEditMode).call(e, this));
          }
          this._temporaryBindEvent("click", Hn(t = this._performAddNode).call(t, this));
        }
      }, {
        key: "editNode",
        value: function value() {
          var t = this;
          !0 !== this.editMode && this.enableEditMode(), this._clean();
          var e = this.selectionHandler.getSelectedNodes()[0];
          if (void 0 !== e) {
            if (this.inMode = "editNode", "function" != typeof this.options.editNode) throw new Error("No function has been configured to handle the editing of nodes.");
            if (!0 !== e.isCluster) {
              var i = gb({}, e.options, !1);
              if (i.x = e.x, i.y = e.y, 2 !== this.options.editNode.length) throw new Error("The function for edit does not support two arguments (data, callback)");
              this.options.editNode(i, function (e) {
                null != e && "editNode" === t.inMode && t.body.data.nodes.getDataSet().update(e), t.showManipulatorToolbar();
              });
            } else alert(this.options.locales[this.options.locale].editClusterError || this.options.locales.en.editClusterError);
          } else this.showManipulatorToolbar();
        }
      }, {
        key: "addEdgeMode",
        value: function value() {
          var t, e, i, n, o;
          if (!0 !== this.editMode && this.enableEditMode(), this._clean(), this.inMode = "addEdge", !0 === this.guiEnabled) {
            var r,
              s = this.options.locales[this.options.locale];
            this.manipulationDOM = {}, this._createBackButton(s), this._createSeperator(), this._createDescription(s.edgeDescription || this.options.locales.en.edgeDescription), this._bindElementEvents(this.closeDiv, Hn(r = this.toggleEditMode).call(r, this));
          }
          this._temporaryBindUI("onTouch", Hn(t = this._handleConnect).call(t, this)), this._temporaryBindUI("onDragEnd", Hn(e = this._finishConnect).call(e, this)), this._temporaryBindUI("onDrag", Hn(i = this._dragControlNode).call(i, this)), this._temporaryBindUI("onRelease", Hn(n = this._finishConnect).call(n, this)), this._temporaryBindUI("onDragStart", Hn(o = this._dragStartEdge).call(o, this)), this._temporaryBindUI("onHold", function () {});
        }
      }, {
        key: "editEdgeMode",
        value: function value() {
          if (!0 !== this.editMode && this.enableEditMode(), this._clean(), this.inMode = "editEdge", "object" !== bu(this.options.editEdge) || "function" != typeof this.options.editEdge.editWithoutDrag || (this.edgeBeingEditedId = this.selectionHandler.getSelectedEdgeIds()[0], void 0 === this.edgeBeingEditedId)) {
            if (!0 === this.guiEnabled) {
              var t,
                e = this.options.locales[this.options.locale];
              this.manipulationDOM = {}, this._createBackButton(e), this._createSeperator(), this._createDescription(e.editEdgeDescription || this.options.locales.en.editEdgeDescription), this._bindElementEvents(this.closeDiv, Hn(t = this.toggleEditMode).call(t, this));
            }
            if (this.edgeBeingEditedId = this.selectionHandler.getSelectedEdgeIds()[0], void 0 !== this.edgeBeingEditedId) {
              var i,
                n,
                o,
                r,
                s = this.body.edges[this.edgeBeingEditedId],
                a = this._getNewTargetNode(s.from.x, s.from.y),
                h = this._getNewTargetNode(s.to.x, s.to.y);
              this.temporaryIds.nodes.push(a.id), this.temporaryIds.nodes.push(h.id), this.body.nodes[a.id] = a, this.body.nodeIndices.push(a.id), this.body.nodes[h.id] = h, this.body.nodeIndices.push(h.id), this._temporaryBindUI("onTouch", Hn(i = this._controlNodeTouch).call(i, this)), this._temporaryBindUI("onTap", function () {}), this._temporaryBindUI("onHold", function () {}), this._temporaryBindUI("onDragStart", Hn(n = this._controlNodeDragStart).call(n, this)), this._temporaryBindUI("onDrag", Hn(o = this._controlNodeDrag).call(o, this)), this._temporaryBindUI("onDragEnd", Hn(r = this._controlNodeDragEnd).call(r, this)), this._temporaryBindUI("onMouseMove", function () {}), this._temporaryBindEvent("beforeDrawing", function (t) {
                var e = s.edgeType.findBorderPositions(t);
                !1 === a.selected && (a.x = e.from.x, a.y = e.from.y), !1 === h.selected && (h.x = e.to.x, h.y = e.to.y);
              }), this.body.emitter.emit("_redraw");
            } else this.showManipulatorToolbar();
          } else {
            var l = this.body.edges[this.edgeBeingEditedId];
            this._performEditEdge(l.from.id, l.to.id);
          }
        }
      }, {
        key: "deleteSelected",
        value: function value() {
          var t = this;
          !0 !== this.editMode && this.enableEditMode(), this._clean(), this.inMode = "delete";
          var e = this.selectionHandler.getSelectedNodeIds(),
            i = this.selectionHandler.getSelectedEdgeIds(),
            n = void 0;
          if (e.length > 0) {
            for (var o = 0; o < e.length; o++) if (!0 === this.body.nodes[e[o]].isCluster) return void alert(this.options.locales[this.options.locale].deleteClusterError || this.options.locales.en.deleteClusterError);
            "function" == typeof this.options.deleteNode && (n = this.options.deleteNode);
          } else i.length > 0 && "function" == typeof this.options.deleteEdge && (n = this.options.deleteEdge);
          if ("function" == typeof n) {
            var r = {
              nodes: e,
              edges: i
            };
            if (2 !== n.length) throw new Error("The function for delete does not support two arguments (data, callback)");
            n(r, function (e) {
              null != e && "delete" === t.inMode ? (t.body.data.edges.getDataSet().remove(e.edges), t.body.data.nodes.getDataSet().remove(e.nodes), t.body.emitter.emit("startSimulation"), t.showManipulatorToolbar()) : (t.body.emitter.emit("startSimulation"), t.showManipulatorToolbar());
            });
          } else this.body.data.edges.getDataSet().remove(i), this.body.data.nodes.getDataSet().remove(e), this.body.emitter.emit("startSimulation"), this.showManipulatorToolbar();
        }
      }, {
        key: "_setup",
        value: function value() {
          !0 === this.options.enabled ? (this.guiEnabled = !0, this._createWrappers(), !1 === this.editMode ? this._createEditButton() : this.showManipulatorToolbar()) : (this._removeManipulationDOM(), this.guiEnabled = !1);
        }
      }, {
        key: "_createWrappers",
        value: function value() {
          var t, e;
          (void 0 === this.manipulationDiv && (this.manipulationDiv = document.createElement("div"), this.manipulationDiv.className = "vis-manipulation", !0 === this.editMode ? this.manipulationDiv.style.display = "block" : this.manipulationDiv.style.display = "none", this.canvas.frame.appendChild(this.manipulationDiv)), void 0 === this.editModeDiv && (this.editModeDiv = document.createElement("div"), this.editModeDiv.className = "vis-edit-mode", !0 === this.editMode ? this.editModeDiv.style.display = "none" : this.editModeDiv.style.display = "block", this.canvas.frame.appendChild(this.editModeDiv)), void 0 === this.closeDiv) && (this.closeDiv = document.createElement("button"), this.closeDiv.className = "vis-close", this.closeDiv.setAttribute("aria-label", null !== (t = null === (e = this.options.locales[this.options.locale]) || void 0 === e ? void 0 : e.close) && void 0 !== t ? t : this.options.locales.en.close), this.closeDiv.style.display = this.manipulationDiv.style.display, this.canvas.frame.appendChild(this.closeDiv));
        }
      }, {
        key: "_getNewTargetNode",
        value: function value(t, e) {
          var i = gb({}, this.options.controlNodeStyle);
          i.id = "targetNode" + zM(), i.hidden = !1, i.physics = !1, i.x = t, i.y = e;
          var n = this.body.functions.createNode(i);
          return n.shape.boundingBox = {
            left: t,
            right: t,
            top: e,
            bottom: e
          }, n;
        }
      }, {
        key: "_createEditButton",
        value: function value() {
          var t;
          this._clean(), this.manipulationDOM = {}, hb(this.editModeDiv);
          var e = this.options.locales[this.options.locale],
            i = this._createButton("editMode", "vis-edit vis-edit-mode", e.edit || this.options.locales.en.edit);
          this.editModeDiv.appendChild(i), this._bindElementEvents(i, Hn(t = this.toggleEditMode).call(t, this));
        }
      }, {
        key: "_clean",
        value: function value() {
          this.inMode = !1, !0 === this.guiEnabled && (hb(this.editModeDiv), hb(this.manipulationDiv), this._cleanupDOMEventListeners()), this._cleanupTemporaryNodesAndEdges(), this._unbindTemporaryUIs(), this._unbindTemporaryEvents(), this.body.emitter.emit("restorePhysics");
        }
      }, {
        key: "_cleanupDOMEventListeners",
        value: function value() {
          var t,
            e,
            i = uN(Ap(t = this._domEventListenerCleanupQueue).call(t, 0));
          try {
            for (i.s(); !(e = i.n()).done;) {
              (0, e.value)();
            }
          } catch (t) {
            i.e(t);
          } finally {
            i.f();
          }
        }
      }, {
        key: "_removeManipulationDOM",
        value: function value() {
          this._clean(), hb(this.manipulationDiv), hb(this.editModeDiv), hb(this.closeDiv), this.manipulationDiv && this.canvas.frame.removeChild(this.manipulationDiv), this.editModeDiv && this.canvas.frame.removeChild(this.editModeDiv), this.closeDiv && this.canvas.frame.removeChild(this.closeDiv), this.manipulationDiv = void 0, this.editModeDiv = void 0, this.closeDiv = void 0;
        }
      }, {
        key: "_createSeperator",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
          this.manipulationDOM["seperatorLineDiv" + t] = document.createElement("div"), this.manipulationDOM["seperatorLineDiv" + t].className = "vis-separator-line", this.manipulationDiv.appendChild(this.manipulationDOM["seperatorLineDiv" + t]);
        }
      }, {
        key: "_createAddNodeButton",
        value: function value(t) {
          var e,
            i = this._createButton("addNode", "vis-add", t.addNode || this.options.locales.en.addNode);
          this.manipulationDiv.appendChild(i), this._bindElementEvents(i, Hn(e = this.addNodeMode).call(e, this));
        }
      }, {
        key: "_createAddEdgeButton",
        value: function value(t) {
          var e,
            i = this._createButton("addEdge", "vis-connect", t.addEdge || this.options.locales.en.addEdge);
          this.manipulationDiv.appendChild(i), this._bindElementEvents(i, Hn(e = this.addEdgeMode).call(e, this));
        }
      }, {
        key: "_createEditNodeButton",
        value: function value(t) {
          var e,
            i = this._createButton("editNode", "vis-edit", t.editNode || this.options.locales.en.editNode);
          this.manipulationDiv.appendChild(i), this._bindElementEvents(i, Hn(e = this.editNode).call(e, this));
        }
      }, {
        key: "_createEditEdgeButton",
        value: function value(t) {
          var e,
            i = this._createButton("editEdge", "vis-edit", t.editEdge || this.options.locales.en.editEdge);
          this.manipulationDiv.appendChild(i), this._bindElementEvents(i, Hn(e = this.editEdgeMode).call(e, this));
        }
      }, {
        key: "_createDeleteButton",
        value: function value(t) {
          var e, i;
          i = this.options.rtl ? "vis-delete-rtl" : "vis-delete";
          var n = this._createButton("delete", i, t.del || this.options.locales.en.del);
          this.manipulationDiv.appendChild(n), this._bindElementEvents(n, Hn(e = this.deleteSelected).call(e, this));
        }
      }, {
        key: "_createBackButton",
        value: function value(t) {
          var e,
            i = this._createButton("back", "vis-back", t.back || this.options.locales.en.back);
          this.manipulationDiv.appendChild(i), this._bindElementEvents(i, Hn(e = this.showManipulatorToolbar).call(e, this));
        }
      }, {
        key: "_createButton",
        value: function value(t, e, i) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "vis-label";
          return this.manipulationDOM[t + "Div"] = document.createElement("button"), this.manipulationDOM[t + "Div"].className = "vis-button " + e, this.manipulationDOM[t + "Label"] = document.createElement("div"), this.manipulationDOM[t + "Label"].className = n, this.manipulationDOM[t + "Label"].innerText = i, this.manipulationDOM[t + "Div"].appendChild(this.manipulationDOM[t + "Label"]), this.manipulationDOM[t + "Div"];
        }
      }, {
        key: "_createDescription",
        value: function value(t) {
          this.manipulationDOM.descriptionLabel = document.createElement("div"), this.manipulationDOM.descriptionLabel.className = "vis-none", this.manipulationDOM.descriptionLabel.innerText = t, this.manipulationDiv.appendChild(this.manipulationDOM.descriptionLabel);
        }
      }, {
        key: "_temporaryBindEvent",
        value: function value(t, e) {
          this.temporaryEventFunctions.push({
            event: t,
            boundFunction: e
          }), this.body.emitter.on(t, e);
        }
      }, {
        key: "_temporaryBindUI",
        value: function value(t, e) {
          if (void 0 === this.body.eventListeners[t]) throw new Error("This UI function does not exist. Typo? You tried: " + t + " possible are: " + mg(Hf(this.body.eventListeners)));
          this.temporaryUIFunctions[t] = this.body.eventListeners[t], this.body.eventListeners[t] = e;
        }
      }, {
        key: "_unbindTemporaryUIs",
        value: function value() {
          for (var t in this.temporaryUIFunctions) Object.prototype.hasOwnProperty.call(this.temporaryUIFunctions, t) && (this.body.eventListeners[t] = this.temporaryUIFunctions[t], delete this.temporaryUIFunctions[t]);
          this.temporaryUIFunctions = {};
        }
      }, {
        key: "_unbindTemporaryEvents",
        value: function value() {
          for (var t = 0; t < this.temporaryEventFunctions.length; t++) {
            var e = this.temporaryEventFunctions[t].event,
              i = this.temporaryEventFunctions[t].boundFunction;
            this.body.emitter.off(e, i);
          }
          this.temporaryEventFunctions = [];
        }
      }, {
        key: "_bindElementEvents",
        value: function value(t, e) {
          var i = new Qb(t, {});
          MI(i, e), this._domEventListenerCleanupQueue.push(function () {
            i.destroy();
          });
          var n = function n(t) {
            var i = t.keyCode,
              n = t.key;
            "Enter" !== n && " " !== n && 13 !== i && 32 !== i || e();
          };
          t.addEventListener("keyup", n, !1), this._domEventListenerCleanupQueue.push(function () {
            t.removeEventListener("keyup", n, !1);
          });
        }
      }, {
        key: "_cleanupTemporaryNodesAndEdges",
        value: function value() {
          for (var t = 0; t < this.temporaryIds.edges.length; t++) {
            var e;
            this.body.edges[this.temporaryIds.edges[t]].disconnect(), delete this.body.edges[this.temporaryIds.edges[t]];
            var i,
              n = lg(e = this.body.edgeIndices).call(e, this.temporaryIds.edges[t]);
            if (-1 !== n) Ap(i = this.body.edgeIndices).call(i, n, 1);
          }
          for (var o = 0; o < this.temporaryIds.nodes.length; o++) {
            var r;
            delete this.body.nodes[this.temporaryIds.nodes[o]];
            var s,
              a = lg(r = this.body.nodeIndices).call(r, this.temporaryIds.nodes[o]);
            if (-1 !== a) Ap(s = this.body.nodeIndices).call(s, a, 1);
          }
          this.temporaryIds = {
            nodes: [],
            edges: []
          };
        }
      }, {
        key: "_controlNodeTouch",
        value: function value(t) {
          this.selectionHandler.unselectAll(), this.lastTouch = this.body.functions.getPointer(t.center), this.lastTouch.translation = bn({}, this.body.view.translation);
        }
      }, {
        key: "_controlNodeDragStart",
        value: function value() {
          var t = this.lastTouch,
            e = this.selectionHandler._pointerToPositionObject(t),
            i = this.body.nodes[this.temporaryIds.nodes[0]],
            n = this.body.nodes[this.temporaryIds.nodes[1]],
            o = this.body.edges[this.edgeBeingEditedId];
          this.selectedControlNode = void 0;
          var r = i.isOverlappingWith(e),
            s = n.isOverlappingWith(e);
          !0 === r ? (this.selectedControlNode = i, o.edgeType.from = i) : !0 === s && (this.selectedControlNode = n, o.edgeType.to = n), void 0 !== this.selectedControlNode && this.selectionHandler.selectObject(this.selectedControlNode), this.body.emitter.emit("_redraw");
        }
      }, {
        key: "_controlNodeDrag",
        value: function value(t) {
          this.body.emitter.emit("disablePhysics");
          var e = this.body.functions.getPointer(t.center),
            i = this.canvas.DOMtoCanvas(e);
          void 0 !== this.selectedControlNode ? (this.selectedControlNode.x = i.x, this.selectedControlNode.y = i.y) : this.interactionHandler.onDrag(t), this.body.emitter.emit("_redraw");
        }
      }, {
        key: "_controlNodeDragEnd",
        value: function value(t) {
          var e = this.body.functions.getPointer(t.center),
            i = this.selectionHandler._pointerToPositionObject(e),
            n = this.body.edges[this.edgeBeingEditedId];
          if (void 0 !== this.selectedControlNode) {
            this.selectionHandler.unselectAll();
            for (var o = this.selectionHandler._getAllNodesOverlappingWith(i), r = void 0, s = o.length - 1; s >= 0; s--) if (o[s] !== this.selectedControlNode.id) {
              r = this.body.nodes[o[s]];
              break;
            }
            if (void 0 !== r && void 0 !== this.selectedControlNode) {
              if (!0 === r.isCluster) alert(this.options.locales[this.options.locale].createEdgeError || this.options.locales.en.createEdgeError);else {
                var a = this.body.nodes[this.temporaryIds.nodes[0]];
                this.selectedControlNode.id === a.id ? this._performEditEdge(r.id, n.to.id) : this._performEditEdge(n.from.id, r.id);
              }
            } else n.updateEdgeType(), this.body.emitter.emit("restorePhysics");
            this.body.emitter.emit("_redraw");
          }
        }
      }, {
        key: "_handleConnect",
        value: function value(t) {
          if (new Date().valueOf() - this.touchTime > 100) {
            this.lastTouch = this.body.functions.getPointer(t.center), this.lastTouch.translation = bn({}, this.body.view.translation), this.interactionHandler.drag.pointer = this.lastTouch, this.interactionHandler.drag.translation = this.lastTouch.translation;
            var e = this.lastTouch,
              i = this.selectionHandler.getNodeAt(e);
            if (void 0 !== i) if (!0 === i.isCluster) alert(this.options.locales[this.options.locale].createEdgeError || this.options.locales.en.createEdgeError);else {
              var n = this._getNewTargetNode(i.x, i.y);
              this.body.nodes[n.id] = n, this.body.nodeIndices.push(n.id);
              var o = this.body.functions.createEdge({
                id: "connectionEdge" + zM(),
                from: i.id,
                to: n.id,
                physics: !1,
                smooth: {
                  enabled: !0,
                  type: "continuous",
                  roundness: .5
                }
              });
              this.body.edges[o.id] = o, this.body.edgeIndices.push(o.id), this.temporaryIds.nodes.push(n.id), this.temporaryIds.edges.push(o.id);
            }
            this.touchTime = new Date().valueOf();
          }
        }
      }, {
        key: "_dragControlNode",
        value: function value(t) {
          var e = this.body.functions.getPointer(t.center),
            i = this.selectionHandler._pointerToPositionObject(e),
            n = void 0;
          void 0 !== this.temporaryIds.edges[0] && (n = this.body.edges[this.temporaryIds.edges[0]].fromId);
          for (var o = this.selectionHandler._getAllNodesOverlappingWith(i), r = void 0, s = o.length - 1; s >= 0; s--) {
            var a;
            if (-1 === lg(a = this.temporaryIds.nodes).call(a, o[s])) {
              r = this.body.nodes[o[s]];
              break;
            }
          }
          if (t.controlEdge = {
            from: n,
            to: r ? r.id : void 0
          }, this.selectionHandler.generateClickEvent("controlNodeDragging", t, e), void 0 !== this.temporaryIds.nodes[0]) {
            var h = this.body.nodes[this.temporaryIds.nodes[0]];
            h.x = this.canvas._XconvertDOMtoCanvas(e.x), h.y = this.canvas._YconvertDOMtoCanvas(e.y), this.body.emitter.emit("_redraw");
          } else this.interactionHandler.onDrag(t);
        }
      }, {
        key: "_finishConnect",
        value: function value(t) {
          var e = this.body.functions.getPointer(t.center),
            i = this.selectionHandler._pointerToPositionObject(e),
            n = void 0;
          void 0 !== this.temporaryIds.edges[0] && (n = this.body.edges[this.temporaryIds.edges[0]].fromId);
          for (var o = this.selectionHandler._getAllNodesOverlappingWith(i), r = void 0, s = o.length - 1; s >= 0; s--) {
            var a;
            if (-1 === lg(a = this.temporaryIds.nodes).call(a, o[s])) {
              r = this.body.nodes[o[s]];
              break;
            }
          }
          this._cleanupTemporaryNodesAndEdges(), void 0 !== r && (!0 === r.isCluster ? alert(this.options.locales[this.options.locale].createEdgeError || this.options.locales.en.createEdgeError) : void 0 !== this.body.nodes[n] && void 0 !== this.body.nodes[r.id] && this._performAddEdge(n, r.id)), t.controlEdge = {
            from: n,
            to: r ? r.id : void 0
          }, this.selectionHandler.generateClickEvent("controlNodeDragEnd", t, e), this.body.emitter.emit("_redraw");
        }
      }, {
        key: "_dragStartEdge",
        value: function value(t) {
          var e = this.lastTouch;
          this.selectionHandler.generateClickEvent("dragStart", t, e, void 0, !0);
        }
      }, {
        key: "_performAddNode",
        value: function value(t) {
          var e = this,
            i = {
              id: zM(),
              x: t.pointer.canvas.x,
              y: t.pointer.canvas.y,
              label: "new"
            };
          if ("function" == typeof this.options.addNode) {
            if (2 !== this.options.addNode.length) throw this.showManipulatorToolbar(), new Error("The function for add does not support two arguments (data,callback)");
            this.options.addNode(i, function (t) {
              null != t && "addNode" === e.inMode && e.body.data.nodes.getDataSet().add(t), e.showManipulatorToolbar();
            });
          } else this.body.data.nodes.getDataSet().add(i), this.showManipulatorToolbar();
        }
      }, {
        key: "_performAddEdge",
        value: function value(t, e) {
          var i = this,
            n = {
              from: t,
              to: e
            };
          if ("function" == typeof this.options.addEdge) {
            if (2 !== this.options.addEdge.length) throw new Error("The function for connect does not support two arguments (data,callback)");
            this.options.addEdge(n, function (t) {
              null != t && "addEdge" === i.inMode && (i.body.data.edges.getDataSet().add(t), i.selectionHandler.unselectAll(), i.showManipulatorToolbar());
            });
          } else this.body.data.edges.getDataSet().add(n), this.selectionHandler.unselectAll(), this.showManipulatorToolbar();
        }
      }, {
        key: "_performEditEdge",
        value: function value(t, e) {
          var i = this,
            n = {
              id: this.edgeBeingEditedId,
              from: t,
              to: e,
              label: this.body.data.edges.get(this.edgeBeingEditedId).label
            },
            o = this.options.editEdge;
          if ("object" === bu(o) && (o = o.editWithoutDrag), "function" == typeof o) {
            if (2 !== o.length) throw new Error("The function for edit does not support two arguments (data, callback)");
            o(n, function (t) {
              null == t || "editEdge" !== i.inMode ? (i.body.edges[n.id].updateEdgeType(), i.body.emitter.emit("_redraw"), i.showManipulatorToolbar()) : (i.body.data.edges.getDataSet().update(t), i.selectionHandler.unselectAll(), i.showManipulatorToolbar());
            });
          } else this.body.data.edges.getDataSet().update(n), this.selectionHandler.unselectAll(), this.showManipulatorToolbar();
        }
      }]), t;
    }(),
    vN = "string",
    gN = "boolean",
    yN = "number",
    mN = "array",
    bN = "object",
    wN = ["arrow", "bar", "box", "circle", "crow", "curve", "diamond", "image", "inv_curve", "inv_triangle", "triangle", "vee"],
    kN = {
      borderWidth: {
        number: yN
      },
      borderWidthSelected: {
        number: yN,
        undefined: "undefined"
      },
      brokenImage: {
        string: vN,
        undefined: "undefined"
      },
      chosen: {
        label: {
          "boolean": gN,
          "function": "function"
        },
        node: {
          "boolean": gN,
          "function": "function"
        },
        __type__: {
          object: bN,
          "boolean": gN
        }
      },
      color: {
        border: {
          string: vN
        },
        background: {
          string: vN
        },
        highlight: {
          border: {
            string: vN
          },
          background: {
            string: vN
          },
          __type__: {
            object: bN,
            string: vN
          }
        },
        hover: {
          border: {
            string: vN
          },
          background: {
            string: vN
          },
          __type__: {
            object: bN,
            string: vN
          }
        },
        __type__: {
          object: bN,
          string: vN
        }
      },
      opacity: {
        number: yN,
        undefined: "undefined"
      },
      fixed: {
        x: {
          "boolean": gN
        },
        y: {
          "boolean": gN
        },
        __type__: {
          object: bN,
          "boolean": gN
        }
      },
      font: {
        align: {
          string: vN
        },
        color: {
          string: vN
        },
        size: {
          number: yN
        },
        face: {
          string: vN
        },
        background: {
          string: vN
        },
        strokeWidth: {
          number: yN
        },
        strokeColor: {
          string: vN
        },
        vadjust: {
          number: yN
        },
        multi: {
          "boolean": gN,
          string: vN
        },
        bold: {
          color: {
            string: vN
          },
          size: {
            number: yN
          },
          face: {
            string: vN
          },
          mod: {
            string: vN
          },
          vadjust: {
            number: yN
          },
          __type__: {
            object: bN,
            string: vN
          }
        },
        boldital: {
          color: {
            string: vN
          },
          size: {
            number: yN
          },
          face: {
            string: vN
          },
          mod: {
            string: vN
          },
          vadjust: {
            number: yN
          },
          __type__: {
            object: bN,
            string: vN
          }
        },
        ital: {
          color: {
            string: vN
          },
          size: {
            number: yN
          },
          face: {
            string: vN
          },
          mod: {
            string: vN
          },
          vadjust: {
            number: yN
          },
          __type__: {
            object: bN,
            string: vN
          }
        },
        mono: {
          color: {
            string: vN
          },
          size: {
            number: yN
          },
          face: {
            string: vN
          },
          mod: {
            string: vN
          },
          vadjust: {
            number: yN
          },
          __type__: {
            object: bN,
            string: vN
          }
        },
        __type__: {
          object: bN,
          string: vN
        }
      },
      group: {
        string: vN,
        number: yN,
        undefined: "undefined"
      },
      heightConstraint: {
        minimum: {
          number: yN
        },
        valign: {
          string: vN
        },
        __type__: {
          object: bN,
          "boolean": gN,
          number: yN
        }
      },
      hidden: {
        "boolean": gN
      },
      icon: {
        face: {
          string: vN
        },
        code: {
          string: vN
        },
        size: {
          number: yN
        },
        color: {
          string: vN
        },
        weight: {
          string: vN,
          number: yN
        },
        __type__: {
          object: bN
        }
      },
      id: {
        string: vN,
        number: yN
      },
      image: {
        selected: {
          string: vN,
          undefined: "undefined"
        },
        unselected: {
          string: vN,
          undefined: "undefined"
        },
        __type__: {
          object: bN,
          string: vN
        }
      },
      imagePadding: {
        top: {
          number: yN
        },
        right: {
          number: yN
        },
        bottom: {
          number: yN
        },
        left: {
          number: yN
        },
        __type__: {
          object: bN,
          number: yN
        }
      },
      label: {
        string: vN,
        undefined: "undefined"
      },
      labelHighlightBold: {
        "boolean": gN
      },
      level: {
        number: yN,
        undefined: "undefined"
      },
      margin: {
        top: {
          number: yN
        },
        right: {
          number: yN
        },
        bottom: {
          number: yN
        },
        left: {
          number: yN
        },
        __type__: {
          object: bN,
          number: yN
        }
      },
      mass: {
        number: yN
      },
      physics: {
        "boolean": gN
      },
      scaling: {
        min: {
          number: yN
        },
        max: {
          number: yN
        },
        label: {
          enabled: {
            "boolean": gN
          },
          min: {
            number: yN
          },
          max: {
            number: yN
          },
          maxVisible: {
            number: yN
          },
          drawThreshold: {
            number: yN
          },
          __type__: {
            object: bN,
            "boolean": gN
          }
        },
        customScalingFunction: {
          "function": "function"
        },
        __type__: {
          object: bN
        }
      },
      shadow: {
        enabled: {
          "boolean": gN
        },
        color: {
          string: vN
        },
        size: {
          number: yN
        },
        x: {
          number: yN
        },
        y: {
          number: yN
        },
        __type__: {
          object: bN,
          "boolean": gN
        }
      },
      shape: {
        string: ["custom", "ellipse", "circle", "database", "box", "text", "image", "circularImage", "diamond", "dot", "star", "triangle", "triangleDown", "square", "icon", "hexagon"]
      },
      ctxRenderer: {
        "function": "function"
      },
      shapeProperties: {
        borderDashes: {
          "boolean": gN,
          array: mN
        },
        borderRadius: {
          number: yN
        },
        interpolation: {
          "boolean": gN
        },
        useImageSize: {
          "boolean": gN
        },
        useBorderWithImage: {
          "boolean": gN
        },
        coordinateOrigin: {
          string: ["center", "top-left"]
        },
        __type__: {
          object: bN
        }
      },
      size: {
        number: yN
      },
      title: {
        string: vN,
        dom: "dom",
        undefined: "undefined"
      },
      value: {
        number: yN,
        undefined: "undefined"
      },
      widthConstraint: {
        minimum: {
          number: yN
        },
        maximum: {
          number: yN
        },
        __type__: {
          object: bN,
          "boolean": gN,
          number: yN
        }
      },
      x: {
        number: yN
      },
      y: {
        number: yN
      },
      __type__: {
        object: bN
      }
    },
    _N = {
      configure: {
        enabled: {
          "boolean": gN
        },
        filter: {
          "boolean": gN,
          string: vN,
          array: mN,
          "function": "function"
        },
        container: {
          dom: "dom"
        },
        showButton: {
          "boolean": gN
        },
        __type__: {
          object: bN,
          "boolean": gN,
          string: vN,
          array: mN,
          "function": "function"
        }
      },
      edges: {
        arrows: {
          to: {
            enabled: {
              "boolean": gN
            },
            scaleFactor: {
              number: yN
            },
            type: {
              string: wN
            },
            imageHeight: {
              number: yN
            },
            imageWidth: {
              number: yN
            },
            src: {
              string: vN
            },
            __type__: {
              object: bN,
              "boolean": gN
            }
          },
          middle: {
            enabled: {
              "boolean": gN
            },
            scaleFactor: {
              number: yN
            },
            type: {
              string: wN
            },
            imageWidth: {
              number: yN
            },
            imageHeight: {
              number: yN
            },
            src: {
              string: vN
            },
            __type__: {
              object: bN,
              "boolean": gN
            }
          },
          from: {
            enabled: {
              "boolean": gN
            },
            scaleFactor: {
              number: yN
            },
            type: {
              string: wN
            },
            imageWidth: {
              number: yN
            },
            imageHeight: {
              number: yN
            },
            src: {
              string: vN
            },
            __type__: {
              object: bN,
              "boolean": gN
            }
          },
          __type__: {
            string: ["from", "to", "middle"],
            object: bN
          }
        },
        endPointOffset: {
          from: {
            number: yN
          },
          to: {
            number: yN
          },
          __type__: {
            object: bN,
            number: yN
          }
        },
        arrowStrikethrough: {
          "boolean": gN
        },
        background: {
          enabled: {
            "boolean": gN
          },
          color: {
            string: vN
          },
          size: {
            number: yN
          },
          dashes: {
            "boolean": gN,
            array: mN
          },
          __type__: {
            object: bN,
            "boolean": gN
          }
        },
        chosen: {
          label: {
            "boolean": gN,
            "function": "function"
          },
          edge: {
            "boolean": gN,
            "function": "function"
          },
          __type__: {
            object: bN,
            "boolean": gN
          }
        },
        color: {
          color: {
            string: vN
          },
          highlight: {
            string: vN
          },
          hover: {
            string: vN
          },
          inherit: {
            string: ["from", "to", "both"],
            "boolean": gN
          },
          opacity: {
            number: yN
          },
          __type__: {
            object: bN,
            string: vN
          }
        },
        dashes: {
          "boolean": gN,
          array: mN
        },
        font: {
          color: {
            string: vN
          },
          size: {
            number: yN
          },
          face: {
            string: vN
          },
          background: {
            string: vN
          },
          strokeWidth: {
            number: yN
          },
          strokeColor: {
            string: vN
          },
          align: {
            string: ["horizontal", "top", "middle", "bottom"]
          },
          vadjust: {
            number: yN
          },
          multi: {
            "boolean": gN,
            string: vN
          },
          bold: {
            color: {
              string: vN
            },
            size: {
              number: yN
            },
            face: {
              string: vN
            },
            mod: {
              string: vN
            },
            vadjust: {
              number: yN
            },
            __type__: {
              object: bN,
              string: vN
            }
          },
          boldital: {
            color: {
              string: vN
            },
            size: {
              number: yN
            },
            face: {
              string: vN
            },
            mod: {
              string: vN
            },
            vadjust: {
              number: yN
            },
            __type__: {
              object: bN,
              string: vN
            }
          },
          ital: {
            color: {
              string: vN
            },
            size: {
              number: yN
            },
            face: {
              string: vN
            },
            mod: {
              string: vN
            },
            vadjust: {
              number: yN
            },
            __type__: {
              object: bN,
              string: vN
            }
          },
          mono: {
            color: {
              string: vN
            },
            size: {
              number: yN
            },
            face: {
              string: vN
            },
            mod: {
              string: vN
            },
            vadjust: {
              number: yN
            },
            __type__: {
              object: bN,
              string: vN
            }
          },
          __type__: {
            object: bN,
            string: vN
          }
        },
        hidden: {
          "boolean": gN
        },
        hoverWidth: {
          "function": "function",
          number: yN
        },
        label: {
          string: vN,
          undefined: "undefined"
        },
        labelHighlightBold: {
          "boolean": gN
        },
        length: {
          number: yN,
          undefined: "undefined"
        },
        physics: {
          "boolean": gN
        },
        scaling: {
          min: {
            number: yN
          },
          max: {
            number: yN
          },
          label: {
            enabled: {
              "boolean": gN
            },
            min: {
              number: yN
            },
            max: {
              number: yN
            },
            maxVisible: {
              number: yN
            },
            drawThreshold: {
              number: yN
            },
            __type__: {
              object: bN,
              "boolean": gN
            }
          },
          customScalingFunction: {
            "function": "function"
          },
          __type__: {
            object: bN
          }
        },
        selectionWidth: {
          "function": "function",
          number: yN
        },
        selfReferenceSize: {
          number: yN
        },
        selfReference: {
          size: {
            number: yN
          },
          angle: {
            number: yN
          },
          renderBehindTheNode: {
            "boolean": gN
          },
          __type__: {
            object: bN
          }
        },
        shadow: {
          enabled: {
            "boolean": gN
          },
          color: {
            string: vN
          },
          size: {
            number: yN
          },
          x: {
            number: yN
          },
          y: {
            number: yN
          },
          __type__: {
            object: bN,
            "boolean": gN
          }
        },
        smooth: {
          enabled: {
            "boolean": gN
          },
          type: {
            string: ["dynamic", "continuous", "discrete", "diagonalCross", "straightCross", "horizontal", "vertical", "curvedCW", "curvedCCW", "cubicBezier"]
          },
          roundness: {
            number: yN
          },
          forceDirection: {
            string: ["horizontal", "vertical", "none"],
            "boolean": gN
          },
          __type__: {
            object: bN,
            "boolean": gN
          }
        },
        title: {
          string: vN,
          undefined: "undefined"
        },
        width: {
          number: yN
        },
        widthConstraint: {
          maximum: {
            number: yN
          },
          __type__: {
            object: bN,
            "boolean": gN,
            number: yN
          }
        },
        value: {
          number: yN,
          undefined: "undefined"
        },
        __type__: {
          object: bN
        }
      },
      groups: {
        useDefaultGroups: {
          "boolean": gN
        },
        __any__: kN,
        __type__: {
          object: bN
        }
      },
      interaction: {
        dragNodes: {
          "boolean": gN
        },
        dragView: {
          "boolean": gN
        },
        hideEdgesOnDrag: {
          "boolean": gN
        },
        hideEdgesOnZoom: {
          "boolean": gN
        },
        hideNodesOnDrag: {
          "boolean": gN
        },
        hover: {
          "boolean": gN
        },
        keyboard: {
          enabled: {
            "boolean": gN
          },
          speed: {
            x: {
              number: yN
            },
            y: {
              number: yN
            },
            zoom: {
              number: yN
            },
            __type__: {
              object: bN
            }
          },
          bindToWindow: {
            "boolean": gN
          },
          autoFocus: {
            "boolean": gN
          },
          __type__: {
            object: bN,
            "boolean": gN
          }
        },
        multiselect: {
          "boolean": gN
        },
        navigationButtons: {
          "boolean": gN
        },
        selectable: {
          "boolean": gN
        },
        selectConnectedEdges: {
          "boolean": gN
        },
        hoverConnectedEdges: {
          "boolean": gN
        },
        tooltipDelay: {
          number: yN
        },
        zoomView: {
          "boolean": gN
        },
        zoomSpeed: {
          number: yN
        },
        __type__: {
          object: bN
        }
      },
      layout: {
        randomSeed: {
          undefined: "undefined",
          number: yN,
          string: vN
        },
        improvedLayout: {
          "boolean": gN
        },
        clusterThreshold: {
          number: yN
        },
        hierarchical: {
          enabled: {
            "boolean": gN
          },
          levelSeparation: {
            number: yN
          },
          nodeSpacing: {
            number: yN
          },
          treeSpacing: {
            number: yN
          },
          blockShifting: {
            "boolean": gN
          },
          edgeMinimization: {
            "boolean": gN
          },
          parentCentralization: {
            "boolean": gN
          },
          direction: {
            string: ["UD", "DU", "LR", "RL"]
          },
          sortMethod: {
            string: ["hubsize", "directed"]
          },
          shakeTowards: {
            string: ["leaves", "roots"]
          },
          __type__: {
            object: bN,
            "boolean": gN
          }
        },
        __type__: {
          object: bN
        }
      },
      manipulation: {
        enabled: {
          "boolean": gN
        },
        initiallyActive: {
          "boolean": gN
        },
        addNode: {
          "boolean": gN,
          "function": "function"
        },
        addEdge: {
          "boolean": gN,
          "function": "function"
        },
        editNode: {
          "function": "function"
        },
        editEdge: {
          editWithoutDrag: {
            "function": "function"
          },
          __type__: {
            object: bN,
            "boolean": gN,
            "function": "function"
          }
        },
        deleteNode: {
          "boolean": gN,
          "function": "function"
        },
        deleteEdge: {
          "boolean": gN,
          "function": "function"
        },
        controlNodeStyle: kN,
        __type__: {
          object: bN,
          "boolean": gN
        }
      },
      nodes: kN,
      physics: {
        enabled: {
          "boolean": gN
        },
        barnesHut: {
          theta: {
            number: yN
          },
          gravitationalConstant: {
            number: yN
          },
          centralGravity: {
            number: yN
          },
          springLength: {
            number: yN
          },
          springConstant: {
            number: yN
          },
          damping: {
            number: yN
          },
          avoidOverlap: {
            number: yN
          },
          __type__: {
            object: bN
          }
        },
        forceAtlas2Based: {
          theta: {
            number: yN
          },
          gravitationalConstant: {
            number: yN
          },
          centralGravity: {
            number: yN
          },
          springLength: {
            number: yN
          },
          springConstant: {
            number: yN
          },
          damping: {
            number: yN
          },
          avoidOverlap: {
            number: yN
          },
          __type__: {
            object: bN
          }
        },
        repulsion: {
          centralGravity: {
            number: yN
          },
          springLength: {
            number: yN
          },
          springConstant: {
            number: yN
          },
          nodeDistance: {
            number: yN
          },
          damping: {
            number: yN
          },
          __type__: {
            object: bN
          }
        },
        hierarchicalRepulsion: {
          centralGravity: {
            number: yN
          },
          springLength: {
            number: yN
          },
          springConstant: {
            number: yN
          },
          nodeDistance: {
            number: yN
          },
          damping: {
            number: yN
          },
          avoidOverlap: {
            number: yN
          },
          __type__: {
            object: bN
          }
        },
        maxVelocity: {
          number: yN
        },
        minVelocity: {
          number: yN
        },
        solver: {
          string: ["barnesHut", "repulsion", "hierarchicalRepulsion", "forceAtlas2Based"]
        },
        stabilization: {
          enabled: {
            "boolean": gN
          },
          iterations: {
            number: yN
          },
          updateInterval: {
            number: yN
          },
          onlyDynamicEdges: {
            "boolean": gN
          },
          fit: {
            "boolean": gN
          },
          __type__: {
            object: bN,
            "boolean": gN
          }
        },
        timestep: {
          number: yN
        },
        adaptiveTimestep: {
          "boolean": gN
        },
        wind: {
          x: {
            number: yN
          },
          y: {
            number: yN
          },
          __type__: {
            object: bN
          }
        },
        __type__: {
          object: bN,
          "boolean": gN
        }
      },
      autoResize: {
        "boolean": gN
      },
      clickToUse: {
        "boolean": gN
      },
      locale: {
        string: vN
      },
      locales: {
        __any__: {
          any: "any"
        },
        __type__: {
          object: bN
        }
      },
      height: {
        string: vN
      },
      width: {
        string: vN
      },
      __type__: {
        object: bN
      }
    },
    xN = {
      nodes: {
        borderWidth: [1, 0, 10, 1],
        borderWidthSelected: [2, 0, 10, 1],
        color: {
          border: ["color", "#2B7CE9"],
          background: ["color", "#97C2FC"],
          highlight: {
            border: ["color", "#2B7CE9"],
            background: ["color", "#D2E5FF"]
          },
          hover: {
            border: ["color", "#2B7CE9"],
            background: ["color", "#D2E5FF"]
          }
        },
        opacity: [0, 0, 1, .1],
        fixed: {
          x: !1,
          y: !1
        },
        font: {
          color: ["color", "#343434"],
          size: [14, 0, 100, 1],
          face: ["arial", "verdana", "tahoma"],
          background: ["color", "none"],
          strokeWidth: [0, 0, 50, 1],
          strokeColor: ["color", "#ffffff"]
        },
        hidden: !1,
        labelHighlightBold: !0,
        physics: !0,
        scaling: {
          min: [10, 0, 200, 1],
          max: [30, 0, 200, 1],
          label: {
            enabled: !1,
            min: [14, 0, 200, 1],
            max: [30, 0, 200, 1],
            maxVisible: [30, 0, 200, 1],
            drawThreshold: [5, 0, 20, 1]
          }
        },
        shadow: {
          enabled: !1,
          color: "rgba(0,0,0,0.5)",
          size: [10, 0, 20, 1],
          x: [5, -30, 30, 1],
          y: [5, -30, 30, 1]
        },
        shape: ["ellipse", "box", "circle", "database", "diamond", "dot", "square", "star", "text", "triangle", "triangleDown", "hexagon"],
        shapeProperties: {
          borderDashes: !1,
          borderRadius: [6, 0, 20, 1],
          interpolation: !0,
          useImageSize: !1
        },
        size: [25, 0, 200, 1]
      },
      edges: {
        arrows: {
          to: {
            enabled: !1,
            scaleFactor: [1, 0, 3, .05],
            type: "arrow"
          },
          middle: {
            enabled: !1,
            scaleFactor: [1, 0, 3, .05],
            type: "arrow"
          },
          from: {
            enabled: !1,
            scaleFactor: [1, 0, 3, .05],
            type: "arrow"
          }
        },
        endPointOffset: {
          from: [0, -10, 10, 1],
          to: [0, -10, 10, 1]
        },
        arrowStrikethrough: !0,
        color: {
          color: ["color", "#848484"],
          highlight: ["color", "#848484"],
          hover: ["color", "#848484"],
          inherit: ["from", "to", "both", !0, !1],
          opacity: [1, 0, 1, .05]
        },
        dashes: !1,
        font: {
          color: ["color", "#343434"],
          size: [14, 0, 100, 1],
          face: ["arial", "verdana", "tahoma"],
          background: ["color", "none"],
          strokeWidth: [2, 0, 50, 1],
          strokeColor: ["color", "#ffffff"],
          align: ["horizontal", "top", "middle", "bottom"]
        },
        hidden: !1,
        hoverWidth: [1.5, 0, 5, .1],
        labelHighlightBold: !0,
        physics: !0,
        scaling: {
          min: [1, 0, 100, 1],
          max: [15, 0, 100, 1],
          label: {
            enabled: !0,
            min: [14, 0, 200, 1],
            max: [30, 0, 200, 1],
            maxVisible: [30, 0, 200, 1],
            drawThreshold: [5, 0, 20, 1]
          }
        },
        selectionWidth: [1.5, 0, 5, .1],
        selfReferenceSize: [20, 0, 200, 1],
        selfReference: {
          size: [20, 0, 200, 1],
          angle: [Math.PI / 2, -6 * Math.PI, 6 * Math.PI, Math.PI / 8],
          renderBehindTheNode: !0
        },
        shadow: {
          enabled: !1,
          color: "rgba(0,0,0,0.5)",
          size: [10, 0, 20, 1],
          x: [5, -30, 30, 1],
          y: [5, -30, 30, 1]
        },
        smooth: {
          enabled: !0,
          type: ["dynamic", "continuous", "discrete", "diagonalCross", "straightCross", "horizontal", "vertical", "curvedCW", "curvedCCW", "cubicBezier"],
          forceDirection: ["horizontal", "vertical", "none"],
          roundness: [.5, 0, 1, .05]
        },
        width: [1, 0, 30, 1]
      },
      layout: {
        hierarchical: {
          enabled: !1,
          levelSeparation: [150, 20, 500, 5],
          nodeSpacing: [100, 20, 500, 5],
          treeSpacing: [200, 20, 500, 5],
          blockShifting: !0,
          edgeMinimization: !0,
          parentCentralization: !0,
          direction: ["UD", "DU", "LR", "RL"],
          sortMethod: ["hubsize", "directed"],
          shakeTowards: ["leaves", "roots"]
        }
      },
      interaction: {
        dragNodes: !0,
        dragView: !0,
        hideEdgesOnDrag: !1,
        hideEdgesOnZoom: !1,
        hideNodesOnDrag: !1,
        hover: !1,
        keyboard: {
          enabled: !1,
          speed: {
            x: [10, 0, 40, 1],
            y: [10, 0, 40, 1],
            zoom: [.02, 0, .1, .005]
          },
          bindToWindow: !0,
          autoFocus: !0
        },
        multiselect: !1,
        navigationButtons: !1,
        selectable: !0,
        selectConnectedEdges: !0,
        hoverConnectedEdges: !0,
        tooltipDelay: [300, 0, 1e3, 25],
        zoomView: !0,
        zoomSpeed: [1, .1, 2, .1]
      },
      manipulation: {
        enabled: !1,
        initiallyActive: !1
      },
      physics: {
        enabled: !0,
        barnesHut: {
          theta: [.5, .1, 1, .05],
          gravitationalConstant: [-2e3, -3e4, 0, 50],
          centralGravity: [.3, 0, 10, .05],
          springLength: [95, 0, 500, 5],
          springConstant: [.04, 0, 1.2, .005],
          damping: [.09, 0, 1, .01],
          avoidOverlap: [0, 0, 1, .01]
        },
        forceAtlas2Based: {
          theta: [.5, .1, 1, .05],
          gravitationalConstant: [-50, -500, 0, 1],
          centralGravity: [.01, 0, 1, .005],
          springLength: [95, 0, 500, 5],
          springConstant: [.08, 0, 1.2, .005],
          damping: [.4, 0, 1, .01],
          avoidOverlap: [0, 0, 1, .01]
        },
        repulsion: {
          centralGravity: [.2, 0, 10, .05],
          springLength: [200, 0, 500, 5],
          springConstant: [.05, 0, 1.2, .005],
          nodeDistance: [100, 0, 500, 5],
          damping: [.09, 0, 1, .01]
        },
        hierarchicalRepulsion: {
          centralGravity: [.2, 0, 10, .05],
          springLength: [100, 0, 500, 5],
          springConstant: [.01, 0, 1.2, .005],
          nodeDistance: [120, 0, 500, 5],
          damping: [.09, 0, 1, .01],
          avoidOverlap: [0, 0, 1, .01]
        },
        maxVelocity: [50, 0, 150, 1],
        minVelocity: [.1, .01, .5, .01],
        solver: ["barnesHut", "forceAtlas2Based", "repulsion", "hierarchicalRepulsion"],
        timestep: [.5, .01, 1, .01],
        wind: {
          x: [0, -10, 10, .1],
          y: [0, -10, 10, .1]
        }
      }
    },
    EN = function EN(t, e, i) {
      var n;
      return !(!rv(t).call(t, "physics") || !rv(n = xN.physics.solver).call(n, e) || i.physics.solver === e || "wind" === e);
    },
    ON = Object.freeze({
      __proto__: null,
      allOptions: _N,
      configuratorHideOption: EN,
      configureOptions: xN
    }),
    CN = function () {
      function t() {
        ph(this, t);
      }
      return xu(t, [{
        key: "getDistances",
        value: function value(t, e, i) {
          for (var n = {}, o = t.edges, r = 0; r < e.length; r++) {
            var s = {};
            n[e[r]] = s;
            for (var a = 0; a < e.length; a++) s[e[a]] = r == a ? 0 : 1e9;
          }
          for (var h = 0; h < i.length; h++) {
            var l = o[i[h]];
            !0 === l.connected && void 0 !== n[l.fromId] && void 0 !== n[l.toId] && (n[l.fromId][l.toId] = 1, n[l.toId][l.fromId] = 1);
          }
          for (var d = e.length, c = 0; c < d; c++) for (var u = e[c], f = n[u], p = 0; p < d - 1; p++) for (var v = e[p], g = n[v], y = p + 1; y < d; y++) {
            var m = e[y],
              b = n[m],
              w = Math.min(g[m], g[u] + f[m]);
            g[m] = w, b[v] = w;
          }
          return n;
        }
      }]), t;
    }(),
    SN = function () {
      function t(e, i, n) {
        ph(this, t), this.body = e, this.springLength = i, this.springConstant = n, this.distanceSolver = new CN();
      }
      return xu(t, [{
        key: "setOptions",
        value: function value(t) {
          t && (t.springLength && (this.springLength = t.springLength), t.springConstant && (this.springConstant = t.springConstant));
        }
      }, {
        key: "solve",
        value: function value(t, e) {
          var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            n = this.distanceSolver.getDistances(this.body, t, e);
          this._createL_matrix(n), this._createK_matrix(n), this._createE_matrix();
          for (var o = 0, r = Math.max(1e3, Math.min(10 * this.body.nodeIndices.length, 6e3)), s = 1e9, a = 0, h = 0, l = 0, d = 0, c = 0; s > .01 && o < r;) {
            o += 1;
            var u = pf(this._getHighestEnergyNode(i), 4);
            for (a = u[0], s = u[1], h = u[2], l = u[3], d = s, c = 0; d > 1 && c < 5;) {
              c += 1, this._moveNode(a, h, l);
              var f = pf(this._getEnergy(a), 3);
              d = f[0], h = f[1], l = f[2];
            }
          }
        }
      }, {
        key: "_getHighestEnergyNode",
        value: function value(t) {
          for (var e = this.body.nodeIndices, i = this.body.nodes, n = 0, o = e[0], r = 0, s = 0, a = 0; a < e.length; a++) {
            var h = e[a];
            if (!0 !== i[h].predefinedPosition || !0 === i[h].isCluster && !0 === t || !0 !== i[h].options.fixed.x || !0 !== i[h].options.fixed.y) {
              var l = pf(this._getEnergy(h), 3),
                d = l[0],
                c = l[1],
                u = l[2];
              n < d && (n = d, o = h, r = c, s = u);
            }
          }
          return [o, n, r, s];
        }
      }, {
        key: "_getEnergy",
        value: function value(t) {
          var e = pf(this.E_sums[t], 2),
            i = e[0],
            n = e[1];
          return [Math.sqrt(Math.pow(i, 2) + Math.pow(n, 2)), i, n];
        }
      }, {
        key: "_moveNode",
        value: function value(t, e, i) {
          for (var n = this.body.nodeIndices, o = this.body.nodes, r = 0, s = 0, a = 0, h = o[t].x, l = o[t].y, d = this.K_matrix[t], c = this.L_matrix[t], u = 0; u < n.length; u++) {
            var f = n[u];
            if (f !== t) {
              var p = o[f].x,
                v = o[f].y,
                g = d[f],
                y = c[f],
                m = 1 / Math.pow(Math.pow(h - p, 2) + Math.pow(l - v, 2), 1.5);
              r += g * (1 - y * Math.pow(l - v, 2) * m), s += g * (y * (h - p) * (l - v) * m), a += g * (1 - y * Math.pow(h - p, 2) * m);
            }
          }
          var b = (e / r + i / s) / (s / r - a / s),
            w = -(s * b + e) / r;
          o[t].x += w, o[t].y += b, this._updateE_matrix(t);
        }
      }, {
        key: "_createL_matrix",
        value: function value(t) {
          var e = this.body.nodeIndices,
            i = this.springLength;
          this.L_matrix = [];
          for (var n = 0; n < e.length; n++) {
            this.L_matrix[e[n]] = {};
            for (var o = 0; o < e.length; o++) this.L_matrix[e[n]][e[o]] = i * t[e[n]][e[o]];
          }
        }
      }, {
        key: "_createK_matrix",
        value: function value(t) {
          var e = this.body.nodeIndices,
            i = this.springConstant;
          this.K_matrix = [];
          for (var n = 0; n < e.length; n++) {
            this.K_matrix[e[n]] = {};
            for (var o = 0; o < e.length; o++) this.K_matrix[e[n]][e[o]] = i * Math.pow(t[e[n]][e[o]], -2);
          }
        }
      }, {
        key: "_createE_matrix",
        value: function value() {
          var t = this.body.nodeIndices,
            e = this.body.nodes;
          this.E_matrix = {}, this.E_sums = {};
          for (var i = 0; i < t.length; i++) this.E_matrix[t[i]] = [];
          for (var n = 0; n < t.length; n++) {
            for (var o = t[n], r = e[o].x, s = e[o].y, a = 0, h = 0, l = n; l < t.length; l++) {
              var d = t[l];
              if (d !== o) {
                var c = e[d].x,
                  u = e[d].y,
                  f = 1 / Math.sqrt(Math.pow(r - c, 2) + Math.pow(s - u, 2));
                this.E_matrix[o][l] = [this.K_matrix[o][d] * (r - c - this.L_matrix[o][d] * (r - c) * f), this.K_matrix[o][d] * (s - u - this.L_matrix[o][d] * (s - u) * f)], this.E_matrix[d][n] = this.E_matrix[o][l], a += this.E_matrix[o][l][0], h += this.E_matrix[o][l][1];
              }
            }
            this.E_sums[o] = [a, h];
          }
        }
      }, {
        key: "_updateE_matrix",
        value: function value(t) {
          for (var e = this.body.nodeIndices, i = this.body.nodes, n = this.E_matrix[t], o = this.K_matrix[t], r = this.L_matrix[t], s = i[t].x, a = i[t].y, h = 0, l = 0, d = 0; d < e.length; d++) {
            var c = e[d];
            if (c !== t) {
              var u = n[d],
                f = u[0],
                p = u[1],
                v = i[c].x,
                g = i[c].y,
                y = 1 / Math.sqrt(Math.pow(s - v, 2) + Math.pow(a - g, 2)),
                m = o[c] * (s - v - r[c] * (s - v) * y),
                b = o[c] * (a - g - r[c] * (a - g) * y);
              n[d] = [m, b], h += m, l += b;
              var w = this.E_sums[c];
              w[0] += m - f, w[1] += b - p;
            }
          }
          this.E_sums[t] = [h, l];
        }
      }]), t;
    }();
  function TN(t, e, i) {
    var n,
      o,
      r,
      s,
      a = this;
    if (!(this instanceof TN)) throw new SyntaxError("Constructor must be called with the new operator");
    this.options = {}, this.defaultOptions = {
      locale: "en",
      locales: Fw,
      clickToUse: !1
    }, bn(this.options, this.defaultOptions), this.body = {
      container: t,
      nodes: {},
      nodeIndices: [],
      edges: {},
      edgeIndices: [],
      emitter: {
        on: Hn(n = this.on).call(n, this),
        off: Hn(o = this.off).call(o, this),
        emit: Hn(r = this.emit).call(r, this),
        once: Hn(s = this.once).call(s, this)
      },
      eventListeners: {
        onTap: function onTap() {},
        onTouch: function onTouch() {},
        onDoubleTap: function onDoubleTap() {},
        onHold: function onHold() {},
        onDragStart: function onDragStart() {},
        onDrag: function onDrag() {},
        onDragEnd: function onDragEnd() {},
        onMouseWheel: function onMouseWheel() {},
        onPinch: function onPinch() {},
        onMouseMove: function onMouseMove() {},
        onRelease: function onRelease() {},
        onContext: function onContext() {}
      },
      data: {
        nodes: null,
        edges: null
      },
      functions: {
        createNode: function createNode() {},
        createEdge: function createEdge() {},
        getPointer: function getPointer() {}
      },
      modules: {},
      view: {
        scale: 1,
        translation: {
          x: 0,
          y: 0
        }
      },
      selectionBox: {
        show: !1,
        position: {
          start: {
            x: 0,
            y: 0
          },
          end: {
            x: 0,
            y: 0
          }
        }
      }
    }, this.bindEventListeners(), this.images = new Aw(function () {
      return a.body.emitter.emit("_requestRedraw");
    }), this.groups = new u_(), this.canvas = new DI(this.body), this.selectionHandler = new GB(this.body, this.canvas), this.interactionHandler = new jI(this.body, this.canvas, this.selectionHandler), this.view = new II(this.body, this.canvas), this.renderer = new SI(this.body, this.canvas), this.physics = new _I(this.body), this.layoutEngine = new cN(this.body), this.clustering = new CI(this.body), this.manipulation = new pN(this.body, this.canvas, this.selectionHandler, this.interactionHandler), this.nodesHandler = new gD(this.body, this.images, this.groups, this.layoutEngine), this.edgesHandler = new cI(this.body, this.images, this.groups), this.body.modules.kamadaKawai = new SN(this.body, 150, .05), this.body.modules.clustering = this.clustering, this.canvas._create(), this.setOptions(i), this.setData(e);
  }
  function MN(t) {
    for (var e in t) Object.prototype.hasOwnProperty.call(t, e) && (t[e].redundant = t[e].used, t[e].used = []);
  }
  function PN(t) {
    for (var e in t) if (Object.prototype.hasOwnProperty.call(t, e) && t[e].redundant) {
      for (var i = 0; i < t[e].redundant.length; i++) t[e].redundant[i].parentNode.removeChild(t[e].redundant[i]);
      t[e].redundant = [];
    }
  }
  function DN(t, e, i) {
    var n;
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t].redundant.length > 0 ? (n = e[t].redundant[0], e[t].redundant.shift()) : (n = document.createElementNS("http://www.w3.org/2000/svg", t), i.appendChild(n)) : (n = document.createElementNS("http://www.w3.org/2000/svg", t), e[t] = {
      used: [],
      redundant: []
    }, i.appendChild(n)), e[t].used.push(n), n;
  }
  Kn(TN.prototype), TN.prototype.setOptions = function (t) {
    var e = this;
    if (null === t && (t = void 0), void 0 !== t) {
      !0 === ew.validate(t, _N) && console.error("%cErrors have been found in the supplied options object.", tw);
      if (pb(["locale", "locales", "clickToUse"], this.options, t), void 0 !== t.locale && (t.locale = function (t, e) {
        try {
          var i = pf(e.split(/[-_ /]/, 2), 2),
            n = i[0],
            o = i[1],
            r = null != n ? n.toLowerCase() : null,
            s = null != o ? o.toUpperCase() : null;
          if (r && s) {
            var a,
              h = r + "-" + s;
            if (Object.prototype.hasOwnProperty.call(t, h)) return h;
            console.warn(_f(a = "Unknown variant ".concat(s, " of language ")).call(a, r, "."));
          }
          if (r) {
            var l = r;
            if (Object.prototype.hasOwnProperty.call(t, l)) return l;
            console.warn("Unknown language ".concat(r));
          }
          return console.warn("Unknown locale ".concat(e, ", falling back to English.")), "en";
        } catch (t) {
          return console.error(t), console.warn("Unexpected error while normalizing locale ".concat(e, ", falling back to English.")), "en";
        }
      }(t.locales || this.options.locales, t.locale)), t = this.layoutEngine.setOptions(t.layout, t), this.canvas.setOptions(t), this.groups.setOptions(t.groups), this.nodesHandler.setOptions(t.nodes), this.edgesHandler.setOptions(t.edges), this.physics.setOptions(t.physics), this.manipulation.setOptions(t.manipulation, t, this.options), this.interactionHandler.setOptions(t.interaction), this.renderer.setOptions(t.interaction), this.selectionHandler.setOptions(t.interaction), void 0 !== t.groups && this.body.emitter.emit("refreshNodes"), "configure" in t && (this.configurator || (this.configurator = new Zb(this, this.body.container, xN, this.canvas.pixelRatio, EN)), this.configurator.setOptions(t.configure)), this.configurator && !0 === this.configurator.options.enabled) {
        var i = {
          nodes: {},
          edges: {},
          layout: {},
          interaction: {},
          manipulation: {},
          physics: {},
          global: {}
        };
        gb(i.nodes, this.nodesHandler.options), gb(i.edges, this.edgesHandler.options), gb(i.layout, this.layoutEngine.options), gb(i.interaction, this.selectionHandler.options), gb(i.interaction, this.renderer.options), gb(i.interaction, this.interactionHandler.options), gb(i.manipulation, this.manipulation.options), gb(i.physics, this.physics.options), gb(i.global, this.canvas.options), gb(i.global, this.options), this.configurator.setModuleOptions(i);
      }
      void 0 !== t.clickToUse ? !0 === t.clickToUse ? void 0 === this.activator && (this.activator = new Kb(this.canvas.frame), this.activator.on("change", function () {
        e.body.emitter.emit("activate");
      })) : (void 0 !== this.activator && (this.activator.destroy(), delete this.activator), this.body.emitter.emit("activate")) : this.body.emitter.emit("activate"), this.canvas.setSize(), this.body.emitter.emit("startSimulation");
    }
  }, TN.prototype._updateVisibleIndices = function () {
    var t = this.body.nodes,
      e = this.body.edges;
    for (var i in this.body.nodeIndices = [], this.body.edgeIndices = [], t) Object.prototype.hasOwnProperty.call(t, i) && (this.clustering._isClusteredNode(i) || !1 !== t[i].options.hidden || this.body.nodeIndices.push(t[i].id));
    for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n)) {
      var o = e[n],
        r = t[o.fromId],
        s = t[o.toId],
        a = void 0 !== r && void 0 !== s;
      !this.clustering._isClusteredEdge(n) && !1 === o.options.hidden && a && !1 === r.options.hidden && !1 === s.options.hidden && this.body.edgeIndices.push(o.id);
    }
  }, TN.prototype.bindEventListeners = function () {
    var t = this;
    this.body.emitter.on("_dataChanged", function () {
      t.edgesHandler._updateState(), t.body.emitter.emit("_dataUpdated");
    }), this.body.emitter.on("_dataUpdated", function () {
      t.clustering._updateState(), t._updateVisibleIndices(), t._updateValueRange(t.body.nodes), t._updateValueRange(t.body.edges), t.body.emitter.emit("startSimulation"), t.body.emitter.emit("_requestRedraw");
    });
  }, TN.prototype.setData = function (t) {
    if (this.body.emitter.emit("resetPhysics"), this.body.emitter.emit("_resetData"), this.selectionHandler.unselectAll(), t && t.dot && (t.nodes || t.edges)) throw new SyntaxError('Data must contain either parameter "dot" or  parameter pair "nodes" and "edges", but not both.');
    if (this.setOptions(t && t.options), t && t.dot) {
      console.warn("The dot property has been deprecated. Please use the static convertDot method to convert DOT into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertDot(dotString);");
      var e = Dw(t.dot);
      this.setData(e);
    } else if (t && t.gephi) {
      console.warn("The gephi property has been deprecated. Please use the static convertGephi method to convert gephi into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertGephi(gephiJson);");
      var i = Bw(t.gephi);
      this.setData(i);
    } else this.nodesHandler.setData(t && t.nodes, !0), this.edgesHandler.setData(t && t.edges, !0), this.body.emitter.emit("_dataChanged"), this.body.emitter.emit("_dataLoaded"), this.body.emitter.emit("initPhysics");
  }, TN.prototype.destroy = function () {
    for (var t in this.body.emitter.emit("destroy"), this.body.emitter.off(), this.off(), delete this.groups, delete this.canvas, delete this.selectionHandler, delete this.interactionHandler, delete this.view, delete this.renderer, delete this.physics, delete this.layoutEngine, delete this.clustering, delete this.manipulation, delete this.nodesHandler, delete this.edgesHandler, delete this.configurator, delete this.images, this.body.nodes) Object.prototype.hasOwnProperty.call(this.body.nodes, t) && delete this.body.nodes[t];
    for (var e in this.body.edges) Object.prototype.hasOwnProperty.call(this.body.edges, e) && delete this.body.edges[e];
    hb(this.body.container);
  }, TN.prototype._updateValueRange = function (t) {
    var e,
      i = void 0,
      n = void 0,
      o = 0;
    for (e in t) if (Object.prototype.hasOwnProperty.call(t, e)) {
      var r = t[e].getValue();
      void 0 !== r && (i = void 0 === i ? r : Math.min(r, i), n = void 0 === n ? r : Math.max(r, n), o += r);
    }
    if (void 0 !== i && void 0 !== n) for (e in t) Object.prototype.hasOwnProperty.call(t, e) && t[e].setValueRange(i, n, o);
  }, TN.prototype.isActive = function () {
    return !this.activator || this.activator.active;
  }, TN.prototype.setSize = function () {
    return this.canvas.setSize.apply(this.canvas, arguments);
  }, TN.prototype.canvasToDOM = function () {
    return this.canvas.canvasToDOM.apply(this.canvas, arguments);
  }, TN.prototype.DOMtoCanvas = function () {
    return this.canvas.DOMtoCanvas.apply(this.canvas, arguments);
  }, TN.prototype.findNode = function () {
    return this.clustering.findNode.apply(this.clustering, arguments);
  }, TN.prototype.isCluster = function () {
    return this.clustering.isCluster.apply(this.clustering, arguments);
  }, TN.prototype.openCluster = function () {
    return this.clustering.openCluster.apply(this.clustering, arguments);
  }, TN.prototype.cluster = function () {
    return this.clustering.cluster.apply(this.clustering, arguments);
  }, TN.prototype.getNodesInCluster = function () {
    return this.clustering.getNodesInCluster.apply(this.clustering, arguments);
  }, TN.prototype.clusterByConnection = function () {
    return this.clustering.clusterByConnection.apply(this.clustering, arguments);
  }, TN.prototype.clusterByHubsize = function () {
    return this.clustering.clusterByHubsize.apply(this.clustering, arguments);
  }, TN.prototype.updateClusteredNode = function () {
    return this.clustering.updateClusteredNode.apply(this.clustering, arguments);
  }, TN.prototype.getClusteredEdges = function () {
    return this.clustering.getClusteredEdges.apply(this.clustering, arguments);
  }, TN.prototype.getBaseEdge = function () {
    return this.clustering.getBaseEdge.apply(this.clustering, arguments);
  }, TN.prototype.getBaseEdges = function () {
    return this.clustering.getBaseEdges.apply(this.clustering, arguments);
  }, TN.prototype.updateEdge = function () {
    return this.clustering.updateEdge.apply(this.clustering, arguments);
  }, TN.prototype.clusterOutliers = function () {
    return this.clustering.clusterOutliers.apply(this.clustering, arguments);
  }, TN.prototype.getSeed = function () {
    return this.layoutEngine.getSeed.apply(this.layoutEngine, arguments);
  }, TN.prototype.enableEditMode = function () {
    return this.manipulation.enableEditMode.apply(this.manipulation, arguments);
  }, TN.prototype.disableEditMode = function () {
    return this.manipulation.disableEditMode.apply(this.manipulation, arguments);
  }, TN.prototype.addNodeMode = function () {
    return this.manipulation.addNodeMode.apply(this.manipulation, arguments);
  }, TN.prototype.editNode = function () {
    return this.manipulation.editNode.apply(this.manipulation, arguments);
  }, TN.prototype.editNodeMode = function () {
    return console.warn("Deprecated: Please use editNode instead of editNodeMode."), this.manipulation.editNode.apply(this.manipulation, arguments);
  }, TN.prototype.addEdgeMode = function () {
    return this.manipulation.addEdgeMode.apply(this.manipulation, arguments);
  }, TN.prototype.editEdgeMode = function () {
    return this.manipulation.editEdgeMode.apply(this.manipulation, arguments);
  }, TN.prototype.deleteSelected = function () {
    return this.manipulation.deleteSelected.apply(this.manipulation, arguments);
  }, TN.prototype.getPositions = function () {
    return this.nodesHandler.getPositions.apply(this.nodesHandler, arguments);
  }, TN.prototype.getPosition = function () {
    return this.nodesHandler.getPosition.apply(this.nodesHandler, arguments);
  }, TN.prototype.storePositions = function () {
    return this.nodesHandler.storePositions.apply(this.nodesHandler, arguments);
  }, TN.prototype.moveNode = function () {
    return this.nodesHandler.moveNode.apply(this.nodesHandler, arguments);
  }, TN.prototype.getBoundingBox = function () {
    return this.nodesHandler.getBoundingBox.apply(this.nodesHandler, arguments);
  }, TN.prototype.getConnectedNodes = function (t) {
    return void 0 !== this.body.nodes[t] ? this.nodesHandler.getConnectedNodes.apply(this.nodesHandler, arguments) : this.edgesHandler.getConnectedNodes.apply(this.edgesHandler, arguments);
  }, TN.prototype.getConnectedEdges = function () {
    return this.nodesHandler.getConnectedEdges.apply(this.nodesHandler, arguments);
  }, TN.prototype.startSimulation = function () {
    return this.physics.startSimulation.apply(this.physics, arguments);
  }, TN.prototype.stopSimulation = function () {
    return this.physics.stopSimulation.apply(this.physics, arguments);
  }, TN.prototype.stabilize = function () {
    return this.physics.stabilize.apply(this.physics, arguments);
  }, TN.prototype.getSelection = function () {
    return this.selectionHandler.getSelection.apply(this.selectionHandler, arguments);
  }, TN.prototype.setSelection = function () {
    return this.selectionHandler.setSelection.apply(this.selectionHandler, arguments);
  }, TN.prototype.getSelectedNodes = function () {
    return this.selectionHandler.getSelectedNodeIds.apply(this.selectionHandler, arguments);
  }, TN.prototype.getSelectedEdges = function () {
    return this.selectionHandler.getSelectedEdgeIds.apply(this.selectionHandler, arguments);
  }, TN.prototype.getNodeAt = function () {
    var t = this.selectionHandler.getNodeAt.apply(this.selectionHandler, arguments);
    return void 0 !== t && void 0 !== t.id ? t.id : t;
  }, TN.prototype.getEdgeAt = function () {
    var t = this.selectionHandler.getEdgeAt.apply(this.selectionHandler, arguments);
    return void 0 !== t && void 0 !== t.id ? t.id : t;
  }, TN.prototype.selectNodes = function () {
    return this.selectionHandler.selectNodes.apply(this.selectionHandler, arguments);
  }, TN.prototype.selectEdges = function () {
    return this.selectionHandler.selectEdges.apply(this.selectionHandler, arguments);
  }, TN.prototype.unselectAll = function () {
    this.selectionHandler.unselectAll.apply(this.selectionHandler, arguments), this.selectionHandler.commitWithoutEmitting.apply(this.selectionHandler), this.redraw();
  }, TN.prototype.redraw = function () {
    return this.renderer.redraw.apply(this.renderer, arguments);
  }, TN.prototype.getScale = function () {
    return this.view.getScale.apply(this.view, arguments);
  }, TN.prototype.getViewPosition = function () {
    return this.view.getViewPosition.apply(this.view, arguments);
  }, TN.prototype.fit = function () {
    return this.view.fit.apply(this.view, arguments);
  }, TN.prototype.moveTo = function () {
    return this.view.moveTo.apply(this.view, arguments);
  }, TN.prototype.focus = function () {
    return this.view.focus.apply(this.view, arguments);
  }, TN.prototype.releaseNode = function () {
    return this.view.releaseNode.apply(this.view, arguments);
  }, TN.prototype.getOptionsFromConfigurator = function () {
    var t = {};
    return this.configurator && (t = this.configurator.getOptions.apply(this.configurator)), t;
  };
  var IN = Object.freeze({
      __proto__: null,
      cleanupElements: PN,
      drawBar: function drawBar(t, e, i, n, o, r, s, a) {
        if (0 != n) {
          n < 0 && (e -= n *= -1);
          var h = DN("rect", r, s);
          h.setAttributeNS(null, "x", t - .5 * i), h.setAttributeNS(null, "y", e), h.setAttributeNS(null, "width", i), h.setAttributeNS(null, "height", n), h.setAttributeNS(null, "class", o), a && h.setAttributeNS(null, "style", a);
        }
      },
      drawPoint: function drawPoint(t, e, i, n, o, r) {
        var s;
        if ("circle" == i.style ? ((s = DN("circle", n, o)).setAttributeNS(null, "cx", t), s.setAttributeNS(null, "cy", e), s.setAttributeNS(null, "r", .5 * i.size)) : ((s = DN("rect", n, o)).setAttributeNS(null, "x", t - .5 * i.size), s.setAttributeNS(null, "y", e - .5 * i.size), s.setAttributeNS(null, "width", i.size), s.setAttributeNS(null, "height", i.size)), void 0 !== i.styles && s.setAttributeNS(null, "style", i.styles), s.setAttributeNS(null, "class", i.className + " vis-point"), r) {
          var a = DN("text", n, o);
          r.xOffset && (t += r.xOffset), r.yOffset && (e += r.yOffset), r.content && (a.textContent = r.content), r.className && a.setAttributeNS(null, "class", r.className + " vis-label"), a.setAttributeNS(null, "x", t), a.setAttributeNS(null, "y", e);
        }
        return s;
      },
      getDOMElement: function getDOMElement(t, e, i, n) {
        var o;
        return Object.prototype.hasOwnProperty.call(e, t) ? e[t].redundant.length > 0 ? (o = e[t].redundant[0], e[t].redundant.shift()) : (o = document.createElement(t), void 0 !== n ? i.insertBefore(o, n) : i.appendChild(o)) : (o = document.createElement(t), e[t] = {
          used: [],
          redundant: []
        }, void 0 !== n ? i.insertBefore(o, n) : i.appendChild(o)), e[t].used.push(o), o;
      },
      getSVGElement: DN,
      prepareElements: MN,
      resetElements: function resetElements(t) {
        MN(t), PN(t), MN(t);
      }
    }),
    BN = {
      Images: Aw,
      dotparser: Iw,
      gephiParser: Nw,
      allOptions: ON,
      convertDot: Dw,
      convertGephi: Bw
    },
    NN = Object.freeze({
      __proto__: null,
      DOMutil: IN,
      DataSet: GM,
      DataView: KM,
      Hammer: Qb,
      Network: TN,
      Queue: UM,
      data: QM,
      keycharm: NI,
      network: BN,
      util: iw
    });
  t.DOMutil = IN, t.DataSet = GM, t.DataView = KM, t.Hammer = Qb, t.Network = TN, t.Queue = UM, t.data = QM, t["default"] = NN, t.keycharm = NI, t.network = BN, t.util = iw, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});